//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.16.1.0 (NJsonSchema v10.7.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class AccidentAnalysisClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<AccidentAnalysisViewModel> {
        let url_ = this.baseUrl + "/api/accident-analysis/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AccidentAnalysisViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccidentAnalysisViewModel.fromJS(resultData200);
            return Promise.resolve<AccidentAnalysisViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccidentAnalysisViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/accident-analysis/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    post(model: AccidentAnalysis , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/accident-analysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: AccidentAnalysis , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/accident-analysis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    query(startDate: string | undefined, endDate: string | undefined, costCenter: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfAccidentAnalysisViewModel> {
        let url_ = this.baseUrl + "/api/accident-analysis/query?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (costCenter !== undefined && costCenter !== null)
            url_ += "CostCenter=" + encodeURIComponent("" + costCenter) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfAccidentAnalysisViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfAccidentAnalysisViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfAccidentAnalysisViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfAccidentAnalysisViewModel>(null as any);
    }
}

export class AccidentAttachmentsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<AccidentAttachmentViewModel> {
        let url_ = this.baseUrl + "/api/AccidentAttachments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AccidentAttachmentViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccidentAttachmentViewModel.fromJS(resultData200);
            return Promise.resolve<AccidentAttachmentViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccidentAttachmentViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AccidentAttachments/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    upSert(id: number | undefined, accidentAnalysisId: number | undefined, name: string | null | undefined, picture: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<AccidentAttachmentViewModel> {
        let url_ = this.baseUrl + "/api/AccidentAttachments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (accidentAnalysisId === null || accidentAnalysisId === undefined)
            throw new Error("The parameter 'accidentAnalysisId' cannot be null.");
        else
            content_.append("AccidentAnalysisId", accidentAnalysisId.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (picture !== null && picture !== undefined)
            content_.append("Picture", picture.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpSert(_response);
        });
    }

    protected processUpSert(response: AxiosResponse): Promise<AccidentAttachmentViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AccidentAttachmentViewModel.fromJS(resultData200);
            return Promise.resolve<AccidentAttachmentViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AccidentAttachmentViewModel>(null as any);
    }
}

export class ActivityLogCategoriesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    findActivityLogCategories(query: ActivityLogCategoryQuery , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfActivityLogCategoryViewModel> {
        let url_ = this.baseUrl + "/api/ActivityLogCategories/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindActivityLogCategories(_response);
        });
    }

    protected processFindActivityLogCategories(response: AxiosResponse): Promise<QueryResultsOfActivityLogCategoryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfActivityLogCategoryViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfActivityLogCategoryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfActivityLogCategoryViewModel>(null as any);
    }
}

export class ActivityLogsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    createActivityLog(item: ActivityLog , cancelToken?: CancelToken | undefined): Promise<ActivityLog> {
        let url_ = this.baseUrl + "/api/activitylogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(item);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateActivityLog(_response);
        });
    }

    protected processCreateActivityLog(response: AxiosResponse): Promise<ActivityLog> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ActivityLog.fromJS(resultData200);
            return Promise.resolve<ActivityLog>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ActivityLog>(null as any);
    }
}

export class ApiInfoClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    version(  cancelToken?: CancelToken | undefined): Promise<AppInfo> {
        let url_ = this.baseUrl + "/api/version";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processVersion(_response);
        });
    }

    protected processVersion(response: AxiosResponse): Promise<AppInfo> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AppInfo.fromJS(resultData200);
            return Promise.resolve<AppInfo>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AppInfo>(null as any);
    }
}

export class ApplicationEEODataSheetsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    createApplicationReferralSources(dataSheet: ApplicationEEODataSheet , cancelToken?: CancelToken | undefined): Promise<ApplicationEEODataSheetViewModel> {
        let url_ = this.baseUrl + "/api/ApplicationEEODataSheets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dataSheet);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateApplicationReferralSources(_response);
        });
    }

    protected processCreateApplicationReferralSources(response: AxiosResponse): Promise<ApplicationEEODataSheetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationEEODataSheetViewModel.fromJS(resultData200);
            return Promise.resolve<ApplicationEEODataSheetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationEEODataSheetViewModel>(null as any);
    }

    getPositionAppliedForPickupList(searchText: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/ApplicationEEODataSheets/position-applied-for?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPositionAppliedForPickupList(_response);
        });
    }

    protected processGetPositionAppliedForPickupList(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ApplicationEthnicCodesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getEthnicCodes(  cancelToken?: CancelToken | undefined): Promise<ApplicationEthnicCodeViewModel[]> {
        let url_ = this.baseUrl + "/api/ApplicationEthnicCodes";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEthnicCodes(_response);
        });
    }

    protected processGetEthnicCodes(response: AxiosResponse): Promise<ApplicationEthnicCodeViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApplicationEthnicCodeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ApplicationEthnicCodeViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationEthnicCodeViewModel[]>(null as any);
    }

    findEthnicCodes(query: ApplicationEthnicCodeQuery , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfApplicationEthnicCodeViewModel> {
        let url_ = this.baseUrl + "/api/ApplicationEthnicCodes/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindEthnicCodes(_response);
        });
    }

    protected processFindEthnicCodes(response: AxiosResponse): Promise<QueryResultsOfApplicationEthnicCodeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfApplicationEthnicCodeViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfApplicationEthnicCodeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfApplicationEthnicCodeViewModel>(null as any);
    }
}

export class ApplicationFlowLogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getApplicationFlowLogList(enteredDate: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfApplicationFlowLogViewModel> {
        let url_ = this.baseUrl + "/api/applicationFlowLog?";
        if (enteredDate !== undefined && enteredDate !== null)
            url_ += "EnteredDate=" + encodeURIComponent("" + enteredDate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationFlowLogList(_response);
        });
    }

    protected processGetApplicationFlowLogList(response: AxiosResponse): Promise<QueryResultsOfApplicationFlowLogViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfApplicationFlowLogViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfApplicationFlowLogViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfApplicationFlowLogViewModel>(null as any);
    }

    saveApplicationFlowLog(model: ApplicationFlowLogViewModel , cancelToken?: CancelToken | undefined): Promise<ApplicationFlowLogViewModel> {
        let url_ = this.baseUrl + "/api/applicationFlowLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveApplicationFlowLog(_response);
        });
    }

    protected processSaveApplicationFlowLog(response: AxiosResponse): Promise<ApplicationFlowLogViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationFlowLogViewModel.fromJS(resultData200);
            return Promise.resolve<ApplicationFlowLogViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationFlowLogViewModel>(null as any);
    }

    updateApplicationFlowLog(model: ApplicationFlowLog , cancelToken?: CancelToken | undefined): Promise<ApplicationFlowLogViewModel> {
        let url_ = this.baseUrl + "/api/applicationFlowLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateApplicationFlowLog(_response);
        });
    }

    protected processUpdateApplicationFlowLog(response: AxiosResponse): Promise<ApplicationFlowLogViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationFlowLogViewModel.fromJS(resultData200);
            return Promise.resolve<ApplicationFlowLogViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationFlowLogViewModel>(null as any);
    }

    getApplicationFlowLog(id: number , cancelToken?: CancelToken | undefined): Promise<ApplicationFlowLogViewModel> {
        let url_ = this.baseUrl + "/api/applicationFlowLog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApplicationFlowLog(_response);
        });
    }

    protected processGetApplicationFlowLog(response: AxiosResponse): Promise<ApplicationFlowLogViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApplicationFlowLogViewModel.fromJS(resultData200);
            return Promise.resolve<ApplicationFlowLogViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApplicationFlowLogViewModel>(null as any);
    }
}

export class ApplicationReferralSourcesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    findApplicationReferralSources(query: ApplicationReferralSourceQuery , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfApplicationReferralSourceViewModel> {
        let url_ = this.baseUrl + "/api/ApplicationReferralSources/find";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindApplicationReferralSources(_response);
        });
    }

    protected processFindApplicationReferralSources(response: AxiosResponse): Promise<QueryResultsOfApplicationReferralSourceViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfApplicationReferralSourceViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfApplicationReferralSourceViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfApplicationReferralSourceViewModel>(null as any);
    }
}

export class AssetTypesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<AssetTypeViewModel> {
        let url_ = this.baseUrl + "/api/AssetTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AssetTypeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetTypeViewModel.fromJS(resultData200);
            return Promise.resolve<AssetTypeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetTypeViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AssetTypes/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfAssetTypeViewModel> {
        let url_ = this.baseUrl + "/api/AssetTypes/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfAssetTypeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfAssetTypeViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfAssetTypeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfAssetTypeViewModel>(null as any);
    }

    queryNoAuthorize(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfAssetTypeViewModel> {
        let url_ = this.baseUrl + "/api/AssetTypes/queryNoAuthorize?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryNoAuthorize(_response);
        });
    }

    protected processQueryNoAuthorize(response: AxiosResponse): Promise<QueryResultsOfAssetTypeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfAssetTypeViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfAssetTypeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfAssetTypeViewModel>(null as any);
    }

    upSert(request: AssetType , cancelToken?: CancelToken | undefined): Promise<AssetTypeViewModel> {
        let url_ = this.baseUrl + "/api/AssetTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpSert(_response);
        });
    }

    protected processUpSert(response: AxiosResponse): Promise<AssetTypeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AssetTypeViewModel.fromJS(resultData200);
            return Promise.resolve<AssetTypeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AssetTypeViewModel>(null as any);
    }
}

export class AuditLogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getAuditLogs(itemId: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfAuditLog> {
        let url_ = this.baseUrl + "/api/e-commerce-audit-log?";
        if (itemId !== undefined && itemId !== null)
            url_ += "ItemId=" + encodeURIComponent("" + itemId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAuditLogs(_response);
        });
    }

    protected processGetAuditLogs(response: AxiosResponse): Promise<QueryResultsOfAuditLog> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfAuditLog.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfAuditLog>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfAuditLog>(null as any);
    }
}

export class AuditRecordClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    queryAuditArea(storeId: string | null | undefined, isEven: boolean | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfAuditArea> {
        let url_ = this.baseUrl + "/api/AuditRecord/query-audit-area?";
        if (storeId !== undefined && storeId !== null)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&";
        if (isEven !== undefined && isEven !== null)
            url_ += "IsEven=" + encodeURIComponent("" + isEven) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAuditArea(_response);
        });
    }

    protected processQueryAuditArea(response: AxiosResponse): Promise<QueryResultsOfAuditArea> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfAuditArea.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfAuditArea>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfAuditArea>(null as any);
    }

    query(week: number | null | undefined, year: number | null | undefined, storeId: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfAuditRecord> {
        let url_ = this.baseUrl + "/api/AuditRecord/query?";
        if (week !== undefined && week !== null)
            url_ += "Week=" + encodeURIComponent("" + week) + "&";
        if (year !== undefined && year !== null)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (storeId !== undefined && storeId !== null)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfAuditRecord> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfAuditRecord.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfAuditRecord>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfAuditRecord>(null as any);
    }

    post(model: AuditRecord , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AuditRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: AuditRecord , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/AuditRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<AuditRecord> {
        let url_ = this.baseUrl + "/api/AuditRecord/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AuditRecord> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AuditRecord.fromJS(resultData200);
            return Promise.resolve<AuditRecord>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AuditRecord>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/AuditRecord/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class BodyPartsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfBodyPartViewModel> {
        let url_ = this.baseUrl + "/api/BodyParts/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfBodyPartViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfBodyPartViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfBodyPartViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfBodyPartViewModel>(null as any);
    }
}

export class CarDonationImageClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(vehicleId: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfImage> {
        let url_ = this.baseUrl + "/api/CarDonationImage/query?";
        if (vehicleId !== undefined && vehicleId !== null)
            url_ += "VehicleId=" + encodeURIComponent("" + vehicleId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfImage> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfImage.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfImage>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfImage>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<Image> {
        let url_ = this.baseUrl + "/api/CarDonationImage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<Image> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Image.fromJS(resultData200);
            return Promise.resolve<Image>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Image>(null as any);
    }

    deleteImage(id: number , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/CarDonationImage/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteImage(_response);
        });
    }

    protected processDeleteImage(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }

    save(model: Image , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CarDonationImage";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class CarDonationLocationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getCarDonationLocations(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfCarDonationLocationViewModel> {
        let url_ = this.baseUrl + "/api/CarDonationLocation/car-donation-locations?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCarDonationLocations(_response);
        });
    }

    protected processGetCarDonationLocations(response: AxiosResponse): Promise<QueryResultsOfCarDonationLocationViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfCarDonationLocationViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfCarDonationLocationViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfCarDonationLocationViewModel>(null as any);
    }
}

export class CarDonationsDonorVehicleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<VehicleViewModel> {
        let url_ = this.baseUrl + "/api/CarDonationsDonorVehicle/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<VehicleViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = VehicleViewModel.fromJS(resultData200);
            return Promise.resolve<VehicleViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<VehicleViewModel>(null as any);
    }

    saveAsnyc(model: Vehicle , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CarDonationsDonorVehicle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveAsnyc(_response);
        });
    }

    protected processSaveAsnyc(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    update(model: Vehicle , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CarDonationsDonorVehicle";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfVehicleViewModel> {
        let url_ = this.baseUrl + "/api/CarDonationsDonorVehicle/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfVehicleViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfVehicleViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfVehicleViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfVehicleViewModel>(null as any);
    }
}

export class CareClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    post(model: GWCA , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/care";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: GWCA , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/care";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<GWCA> {
        let url_ = this.baseUrl + "/api/care/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<GWCA> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GWCA.fromJS(resultData200);
            return Promise.resolve<GWCA>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GWCA>(null as any);
    }
}

export class CaseManagementClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(participantId: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfCaseManagementViewModel> {
        let url_ = this.baseUrl + "/api/CaseManagement/query?";
        if (participantId === null)
            throw new Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "ParticipantId=" + encodeURIComponent("" + participantId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfCaseManagementViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfCaseManagementViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfCaseManagementViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfCaseManagementViewModel>(null as any);
    }

    queryCategory(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfCaseManagementCategory> {
        let url_ = this.baseUrl + "/api/CaseManagement/query-category?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryCategory(_response);
        });
    }

    protected processQueryCategory(response: AxiosResponse): Promise<QueryResultsOfCaseManagementCategory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfCaseManagementCategory.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfCaseManagementCategory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfCaseManagementCategory>(null as any);
    }

    queryCategoryAsyncFromSproc(  cancelToken?: CancelToken | undefined): Promise<JCSCaseNoteCategoryOutputViewModel[]> {
        let url_ = this.baseUrl + "/api/CaseManagement/query-category-from-sproc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryCategoryAsyncFromSproc(_response);
        });
    }

    protected processQueryCategoryAsyncFromSproc(response: AxiosResponse): Promise<JCSCaseNoteCategoryOutputViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JCSCaseNoteCategoryOutputViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<JCSCaseNoteCategoryOutputViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JCSCaseNoteCategoryOutputViewModel[]>(null as any);
    }

    post(model: CaseManagement , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CaseManagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: CaseManagement , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/CaseManagement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<CaseManagementViewModel> {
        let url_ = this.baseUrl + "/api/CaseManagement/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CaseManagementViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CaseManagementViewModel.fromJS(resultData200);
            return Promise.resolve<CaseManagementViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CaseManagementViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/CaseManagement/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class CashCountsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    queryCashCounts(cashCountId: number | null | undefined, startDate: string | undefined, endDate: string | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfCashCountViewModel> {
        let url_ = this.baseUrl + "/api/cashcounts?";
        if (cashCountId !== undefined && cashCountId !== null)
            url_ += "CashCountId=" + encodeURIComponent("" + cashCountId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryCashCounts(_response);
        });
    }

    protected processQueryCashCounts(response: AxiosResponse): Promise<QueryResultsOfCashCountViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfCashCountViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfCashCountViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfCashCountViewModel>(null as any);
    }

    saveCashCount(model: CashCountSavingModel , cancelToken?: CancelToken | undefined): Promise<CashCountViewModel> {
        let url_ = this.baseUrl + "/api/cashcounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCashCount(_response);
        });
    }

    protected processSaveCashCount(response: AxiosResponse): Promise<CashCountViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CashCountViewModel.fromJS(resultData200);
            return Promise.resolve<CashCountViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CashCountViewModel>(null as any);
    }

    updateCashCount(model: CashCountSavingModel , cancelToken?: CancelToken | undefined): Promise<CashCountViewModel> {
        let url_ = this.baseUrl + "/api/cashcounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCashCount(_response);
        });
    }

    protected processUpdateCashCount(response: AxiosResponse): Promise<CashCountViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CashCountViewModel.fromJS(resultData200);
            return Promise.resolve<CashCountViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CashCountViewModel>(null as any);
    }

    getCashCount(id: number , cancelToken?: CancelToken | undefined): Promise<CashCountViewModel> {
        let url_ = this.baseUrl + "/api/cashcounts/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCashCount(_response);
        });
    }

    protected processGetCashCount(response: AxiosResponse): Promise<CashCountViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CashCountViewModel.fromJS(resultData200);
            return Promise.resolve<CashCountViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CashCountViewModel>(null as any);
    }
}

export class CashierVariancesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    saveCashierVariance(request: CashierVariance , cancelToken?: CancelToken | undefined): Promise<CashierVarianceViewModel> {
        let url_ = this.baseUrl + "/api/cashierVariances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCashierVariance(_response);
        });
    }

    protected processSaveCashierVariance(response: AxiosResponse): Promise<CashierVarianceViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CashierVarianceViewModel.fromJS(resultData200);
            return Promise.resolve<CashierVarianceViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CashierVarianceViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<CashierVarianceViewModel> {
        let url_ = this.baseUrl + "/api/cashierVariances/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<CashierVarianceViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CashierVarianceViewModel.fromJS(resultData200);
            return Promise.resolve<CashierVarianceViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CashierVarianceViewModel>(null as any);
    }

    query(id: number | null | undefined, startDate: string | undefined, endDate: string | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfCashierVarianceViewModel> {
        let url_ = this.baseUrl + "/api/cashierVariances/query?";
        if (id !== undefined && id !== null)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfCashierVarianceViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfCashierVarianceViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfCashierVarianceViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfCashierVarianceViewModel>(null as any);
    }

    getEmployeeName(employeeNumber: string | null , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/cashierVariances/getEmployeeName/{employeeNumber}";
        if (employeeNumber === undefined || employeeNumber === null)
            throw new Error("The parameter 'employeeNumber' must be defined.");
        url_ = url_.replace("{employeeNumber}", encodeURIComponent("" + employeeNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeName(_response);
        });
    }

    protected processGetEmployeeName(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class ChristmasBudgetsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<ChristmasBudgetViewModel> {
        let url_ = this.baseUrl + "/api/ChristmasBudgets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ChristmasBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChristmasBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<ChristmasBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChristmasBudgetViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ChristmasBudgets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfChristmasBudgetViewModel> {
        let url_ = this.baseUrl + "/api/ChristmasBudgets/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfChristmasBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfChristmasBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfChristmasBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfChristmasBudgetViewModel>(null as any);
    }

    upSert(request: ChristmasBudget , cancelToken?: CancelToken | undefined): Promise<ChristmasBudgetViewModel> {
        let url_ = this.baseUrl + "/api/ChristmasBudgets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpSert(_response);
        });
    }

    protected processUpSert(response: AxiosResponse): Promise<ChristmasBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ChristmasBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<ChristmasBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ChristmasBudgetViewModel>(null as any);
    }
}

export class CommunicationLogsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getCommunicationLog(id: number , cancelToken?: CancelToken | undefined): Promise<CommunicationLogViewModel> {
        let url_ = this.baseUrl + "/api/communication-log/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommunicationLog(_response);
        });
    }

    protected processGetCommunicationLog(response: AxiosResponse): Promise<CommunicationLogViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommunicationLogViewModel.fromJS(resultData200);
            return Promise.resolve<CommunicationLogViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunicationLogViewModel>(null as any);
    }

    getCommunicationLogs(query: CommunicationLogQuery , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfCommunicationLogViewModel> {
        let url_ = this.baseUrl + "/api/communication-log/getCommunicationLogs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCommunicationLogs(_response);
        });
    }

    protected processGetCommunicationLogs(response: AxiosResponse): Promise<QueryResultsOfCommunicationLogViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfCommunicationLogViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfCommunicationLogViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfCommunicationLogViewModel>(null as any);
    }

    saveCommunicationLog(request: CommunicationLogSavingRequest , cancelToken?: CancelToken | undefined): Promise<CommunicationLogViewModel> {
        let url_ = this.baseUrl + "/api/communication-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveCommunicationLog(_response);
        });
    }

    protected processSaveCommunicationLog(response: AxiosResponse): Promise<CommunicationLogViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommunicationLogViewModel.fromJS(resultData200);
            return Promise.resolve<CommunicationLogViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunicationLogViewModel>(null as any);
    }

    updateCommunicationLog(request: CommunicationLogUpdatingRequest , cancelToken?: CancelToken | undefined): Promise<CommunicationLogViewModel> {
        let url_ = this.baseUrl + "/api/communication-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateCommunicationLog(_response);
        });
    }

    protected processUpdateCommunicationLog(response: AxiosResponse): Promise<CommunicationLogViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CommunicationLogViewModel.fromJS(resultData200);
            return Promise.resolve<CommunicationLogViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CommunicationLogViewModel>(null as any);
    }
}

export class ContainerAuditClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<ContainerAudit> {
        let url_ = this.baseUrl + "/api/container-audit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ContainerAudit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContainerAudit.fromJS(resultData200);
            return Promise.resolve<ContainerAudit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContainerAudit>(null as any);
    }

    save(model: ContainerAudit , cancelToken?: CancelToken | undefined): Promise<ContainerAudit> {
        let url_ = this.baseUrl + "/api/container-audit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ContainerAudit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContainerAudit.fromJS(resultData200);
            return Promise.resolve<ContainerAudit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContainerAudit>(null as any);
    }

    getTblClassNames(containerType: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfContainerAudit> {
        let url_ = this.baseUrl + "/api/container-audit?";
        if (containerType !== undefined && containerType !== null)
            url_ += "ContainerType=" + encodeURIComponent("" + containerType) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTblClassNames(_response);
        });
    }

    protected processGetTblClassNames(response: AxiosResponse): Promise<QueryResultsOfContainerAudit> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfContainerAudit.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfContainerAudit>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfContainerAudit>(null as any);
    }
}

export class ContainerClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: Container , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/e-commerce-container";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    get(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfContainerViewModel> {
        let url_ = this.baseUrl + "/api/e-commerce-container?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<QueryResultsOfContainerViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfContainerViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfContainerViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfContainerViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<ContainerViewModel> {
        let url_ = this.baseUrl + "/api/e-commerce-container/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ContainerViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ContainerViewModel.fromJS(resultData200);
            return Promise.resolve<ContainerViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ContainerViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/e-commerce-container/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class ContainerIssueClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: ContainerIssue , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/e-commerce-container-issue";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getContainerIssues(containerId: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfContainerIssue> {
        let url_ = this.baseUrl + "/api/e-commerce-container-issue?";
        if (containerId !== undefined && containerId !== null)
            url_ += "ContainerId=" + encodeURIComponent("" + containerId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetContainerIssues(_response);
        });
    }

    protected processGetContainerIssues(response: AxiosResponse): Promise<QueryResultsOfContainerIssue> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfContainerIssue.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfContainerIssue>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfContainerIssue>(null as any);
    }

    deleteContainerIssue(id: number, requestBody: ContainerIssue , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/e-commerce-container-issue/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteContainerIssue(_response);
        });
    }

    protected processDeleteContainerIssue(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class CostCentersClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(costCenterNumber: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfCostCenterViewModel> {
        let url_ = this.baseUrl + "/api/CostCenters/query?";
        if (costCenterNumber !== undefined && costCenterNumber !== null)
            url_ += "CostCenterNumber=" + encodeURIComponent("" + costCenterNumber) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfCostCenterViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfCostCenterViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfCostCenterViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfCostCenterViewModel>(null as any);
    }

    queryNoAuthorize(costCenterNumber: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfCostCenterViewModel> {
        let url_ = this.baseUrl + "/api/CostCenters/queryNoAuthorize?";
        if (costCenterNumber !== undefined && costCenterNumber !== null)
            url_ += "CostCenterNumber=" + encodeURIComponent("" + costCenterNumber) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryNoAuthorize(_response);
        });
    }

    protected processQueryNoAuthorize(response: AxiosResponse): Promise<QueryResultsOfCostCenterViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfCostCenterViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfCostCenterViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfCostCenterViewModel>(null as any);
    }

    getbyId(id: number , cancelToken?: CancelToken | undefined): Promise<CostCenterSavingModel> {
        let url_ = this.baseUrl + "/api/CostCenters/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyId(_response);
        });
    }

    protected processGetbyId(response: AxiosResponse): Promise<CostCenterSavingModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CostCenterSavingModel.fromJS(resultData200);
            return Promise.resolve<CostCenterSavingModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterSavingModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/CostCenters/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }

    save(model: CostCenterSavingModel , cancelToken?: CancelToken | undefined): Promise<CostCenterViewModel> {
        let url_ = this.baseUrl + "/api/CostCenters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<CostCenterViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CostCenterViewModel.fromJS(resultData200);
            return Promise.resolve<CostCenterViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CostCenterViewModel>(null as any);
    }

    hrQuery(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfCostCenter> {
        let url_ = this.baseUrl + "/api/CostCenters/hr/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processHrQuery(_response);
        });
    }

    protected processHrQuery(response: AxiosResponse): Promise<QueryResultsOfCostCenter> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfCostCenter.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfCostCenter>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfCostCenter>(null as any);
    }
}

export class DailyActivityLogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<DailyActivityLog> {
        let url_ = this.baseUrl + "/api/daily-activity-log/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DailyActivityLog> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DailyActivityLog.fromJS(resultData200);
            return Promise.resolve<DailyActivityLog>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DailyActivityLog>(null as any);
    }

    save(model: DailyActivityLog , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/daily-activity-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class DepositRecordsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    upSert(model: DepositRecord , cancelToken?: CancelToken | undefined): Promise<DepositRecordViewModel> {
        let url_ = this.baseUrl + "/api/DepositRecords";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpSert(_response);
        });
    }

    protected processUpSert(response: AxiosResponse): Promise<DepositRecordViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DepositRecordViewModel.fromJS(resultData200);
            return Promise.resolve<DepositRecordViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DepositRecordViewModel>(null as any);
    }

    query(startDate: string | undefined, endDate: string | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfDepositRecordViewModel> {
        let url_ = this.baseUrl + "/api/DepositRecords/query?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfDepositRecordViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfDepositRecordViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfDepositRecordViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfDepositRecordViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<DepositRecordViewModel> {
        let url_ = this.baseUrl + "/api/DepositRecords/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DepositRecordViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DepositRecordViewModel.fromJS(resultData200);
            return Promise.resolve<DepositRecordViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DepositRecordViewModel>(null as any);
    }
}

export class DisabilsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(type: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfDisabilViewModel> {
        let url_ = this.baseUrl + "/api/disabils/query?";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfDisabilViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfDisabilViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfDisabilViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfDisabilViewModel>(null as any);
    }
}

export class DMAuditClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    post(model: DMAuditRecord , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/dm-audit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: DMAuditRecord , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/dm-audit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<DMAuditRecord> {
        let url_ = this.baseUrl + "/api/dm-audit/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DMAuditRecord> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DMAuditRecord.fromJS(resultData200);
            return Promise.resolve<DMAuditRecord>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DMAuditRecord>(null as any);
    }

    getInitialDMAuditDetails(  cancelToken?: CancelToken | undefined): Promise<DMAuditDetail[]> {
        let url_ = this.baseUrl + "/api/dm-audit/initialDMAuditDetails";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetInitialDMAuditDetails(_response);
        });
    }

    protected processGetInitialDMAuditDetails(response: AxiosResponse): Promise<DMAuditDetail[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(DMAuditDetail.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<DMAuditDetail[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DMAuditDetail[]>(null as any);
    }
}

export class DonationBudgetsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfDonationBudgetViewModel> {
        let url_ = this.baseUrl + "/api/donation-budgets?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<QueryResultsOfDonationBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfDonationBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfDonationBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfDonationBudgetViewModel>(null as any);
    }

    upSertDonationBudget(request: DonationBudget , cancelToken?: CancelToken | undefined): Promise<DonationBudgetViewModel> {
        let url_ = this.baseUrl + "/api/donation-budgets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpSertDonationBudget(_response);
        });
    }

    protected processUpSertDonationBudget(response: AxiosResponse): Promise<DonationBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DonationBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<DonationBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DonationBudgetViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<DonationBudgetViewModel> {
        let url_ = this.baseUrl + "/api/donation-budgets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DonationBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DonationBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<DonationBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DonationBudgetViewModel>(null as any);
    }

    deleteById(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/donation-budgets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteById(_response);
        });
    }

    protected processDeleteById(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class DonationInErrorClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: DonationInError , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DonationInError";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<DonationInErrorEditViewModel> {
        let url_ = this.baseUrl + "/api/DonationInError/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DonationInErrorEditViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DonationInErrorEditViewModel.fromJS(resultData200);
            return Promise.resolve<DonationInErrorEditViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DonationInErrorEditViewModel>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfDonationInError> {
        let url_ = this.baseUrl + "/api/DonationInError/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfDonationInError> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfDonationInError.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfDonationInError>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfDonationInError>(null as any);
    }
}

export class DonationInErrorDetailClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: DonationInErrorDetail , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DonationInErrorDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<DonationInErrorDetail> {
        let url_ = this.baseUrl + "/api/DonationInErrorDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DonationInErrorDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DonationInErrorDetail.fromJS(resultData200);
            return Promise.resolve<DonationInErrorDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DonationInErrorDetail>(null as any);
    }

    deleteDonationInErrorDetail(id: number , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DonationInErrorDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDonationInErrorDetail(_response);
        });
    }

    protected processDeleteDonationInErrorDetail(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }

    query(donationInErrorId: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfDonationInErrorDetail> {
        let url_ = this.baseUrl + "/api/DonationInErrorDetail/query?";
        if (donationInErrorId !== undefined && donationInErrorId !== null)
            url_ += "DonationInErrorId=" + encodeURIComponent("" + donationInErrorId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfDonationInErrorDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfDonationInErrorDetail.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfDonationInErrorDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfDonationInErrorDetail>(null as any);
    }
}

export class DonationInErrorPictureClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(donationInErrorId: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfDonationInErrorPicture> {
        let url_ = this.baseUrl + "/api/DonationInErrorPicture/query?";
        if (donationInErrorId !== undefined && donationInErrorId !== null)
            url_ += "DonationInErrorId=" + encodeURIComponent("" + donationInErrorId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfDonationInErrorPicture> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfDonationInErrorPicture.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfDonationInErrorPicture>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfDonationInErrorPicture>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<DonationInErrorPicture> {
        let url_ = this.baseUrl + "/api/DonationInErrorPicture/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<DonationInErrorPicture> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DonationInErrorPicture.fromJS(resultData200);
            return Promise.resolve<DonationInErrorPicture>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DonationInErrorPicture>(null as any);
    }

    deleteDonationInErrorPicture(id: number , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/DonationInErrorPicture/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteDonationInErrorPicture(_response);
        });
    }

    protected processDeleteDonationInErrorPicture(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }

    save(request: DonationInErrorPicture2 , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/DonationInErrorPicture";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class DonorCountDailyClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getDonorCountDailies(entryType: string | null | undefined, startDate: string | undefined, endDate: string | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfDonorCountDailyViewModel> {
        let url_ = this.baseUrl + "/api/donor-count-dailies?";
        if (entryType !== undefined && entryType !== null)
            url_ += "EntryType=" + encodeURIComponent("" + entryType) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDonorCountDailies(_response);
        });
    }

    protected processGetDonorCountDailies(response: AxiosResponse): Promise<QueryResultsOfDonorCountDailyViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfDonorCountDailyViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfDonorCountDailyViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfDonorCountDailyViewModel>(null as any);
    }

    createDonor(request: DonorCountsDaily , cancelToken?: CancelToken | undefined): Promise<DonorCountDailyViewModel> {
        let url_ = this.baseUrl + "/api/donor-count-dailies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateDonor(_response);
        });
    }

    protected processCreateDonor(response: AxiosResponse): Promise<DonorCountDailyViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DonorCountDailyViewModel.fromJS(resultData200);
            return Promise.resolve<DonorCountDailyViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DonorCountDailyViewModel>(null as any);
    }

    updateDonor(request: DonorCountsDaily , cancelToken?: CancelToken | undefined): Promise<DonorCountDailyViewModel> {
        let url_ = this.baseUrl + "/api/donor-count-dailies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateDonor(_response);
        });
    }

    protected processUpdateDonor(response: AxiosResponse): Promise<DonorCountDailyViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DonorCountDailyViewModel.fromJS(resultData200);
            return Promise.resolve<DonorCountDailyViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DonorCountDailyViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfDonorCountDailyViewModel> {
        let url_ = this.baseUrl + "/api/donor-count-dailies/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<QueryResultsOfDonorCountDailyViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfDonorCountDailyViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfDonorCountDailyViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfDonorCountDailyViewModel>(null as any);
    }
}

export class ECEAncillaryServicesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(request: AncillaryService , cancelToken?: CancelToken | undefined): Promise<AncillaryService> {
        let url_ = this.baseUrl + "/api/ECEAncillaryServices";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<AncillaryService> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AncillaryService.fromJS(resultData200);
            return Promise.resolve<AncillaryService>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AncillaryService>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<AncillaryService> {
        let url_ = this.baseUrl + "/api/ECEAncillaryServices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<AncillaryService> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AncillaryService.fromJS(resultData200);
            return Promise.resolve<AncillaryService>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AncillaryService>(null as any);
    }

    deleteECEAncillaryService(id: number , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/ECEAncillaryServices/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteECEAncillaryService(_response);
        });
    }

    protected processDeleteECEAncillaryService(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfAncillaryService> {
        let url_ = this.baseUrl + "/api/ECEAncillaryServices/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfAncillaryService> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfAncillaryService.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfAncillaryService>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfAncillaryService>(null as any);
    }
}

export class ECEEmployeeClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: string | null , cancelToken?: CancelToken | undefined): Promise<TblECEEmployeeViewModel> {
        let url_ = this.baseUrl + "/api/ece-employee/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<TblECEEmployeeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TblECEEmployeeViewModel.fromJS(resultData200);
            return Promise.resolve<TblECEEmployeeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TblECEEmployeeViewModel>(null as any);
    }

    save(request: TblECEEmployeeSavingModel , cancelToken?: CancelToken | undefined): Promise<TblECEEmployeeViewModel> {
        let url_ = this.baseUrl + "/api/ece-employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<TblECEEmployeeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TblECEEmployeeViewModel.fromJS(resultData200);
            return Promise.resolve<TblECEEmployeeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TblECEEmployeeViewModel>(null as any);
    }

    checkEntityExistence(id: string | null , cancelToken?: CancelToken | undefined): Promise<boolean> {
        let url_ = this.baseUrl + "/api/ece-employee/check-entity-existence/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckEntityExistence(_response);
        });
    }

    protected processCheckEntityExistence(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
}

export class EcollectibleListingsQuickEntryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    post(model: EcollectibleListingsQuickEntry , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/EcollectibleListingsQuickEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    put(model: EcollectibleListingsQuickEntry , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/EcollectibleListingsQuickEntry";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

    getById(id: string , cancelToken?: CancelToken | undefined): Promise<EcollectibleListingsQuickEntry> {
        let url_ = this.baseUrl + "/api/EcollectibleListingsQuickEntry/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<EcollectibleListingsQuickEntry> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EcollectibleListingsQuickEntry.fromJS(resultData200);
            return Promise.resolve<EcollectibleListingsQuickEntry>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EcollectibleListingsQuickEntry>(null as any);
    }
}

export class EmployeeInjuryNoticeClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getEmployeeInjuryNotices(query: EmployeeInjuryNoticeQuery , cancelToken?: CancelToken | undefined): Promise<EmployeeInjuryNoticeViewModel[]> {
        let url_ = this.baseUrl + "/api/EmployeeInjuryNotice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "GET",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeInjuryNotices(_response);
        });
    }

    protected processGetEmployeeInjuryNotices(response: AxiosResponse): Promise<EmployeeInjuryNoticeViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeInjuryNoticeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmployeeInjuryNoticeViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeInjuryNoticeViewModel[]>(null as any);
    }

    createEmployeeInjuryNotice(employeeInjuryNotice: EmployeeInjuryNotice , cancelToken?: CancelToken | undefined): Promise<EmployeeInjuryNoticeViewModel> {
        let url_ = this.baseUrl + "/api/EmployeeInjuryNotice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employeeInjuryNotice);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateEmployeeInjuryNotice(_response);
        });
    }

    protected processCreateEmployeeInjuryNotice(response: AxiosResponse): Promise<EmployeeInjuryNoticeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeInjuryNoticeViewModel.fromJS(resultData200);
            return Promise.resolve<EmployeeInjuryNoticeViewModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeInjuryNoticeViewModel>(null as any);
    }

    findEmployeeInjuryNotice(employeeInjuryNoticeId: number | undefined, id: string , cancelToken?: CancelToken | undefined): Promise<EmployeeInjuryNoticeViewModel> {
        let url_ = this.baseUrl + "/api/EmployeeInjuryNotice/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (employeeInjuryNoticeId === null)
            throw new Error("The parameter 'employeeInjuryNoticeId' cannot be null.");
        else if (employeeInjuryNoticeId !== undefined)
            url_ += "employeeInjuryNoticeId=" + encodeURIComponent("" + employeeInjuryNoticeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindEmployeeInjuryNotice(_response);
        });
    }

    protected processFindEmployeeInjuryNotice(response: AxiosResponse): Promise<EmployeeInjuryNoticeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeInjuryNoticeViewModel.fromJS(resultData200);
            return Promise.resolve<EmployeeInjuryNoticeViewModel>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = ProblemDetails.fromJS(resultData404);
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);

        } else if (status === 500) {
            const _responseText = response.data;
            return throwException("A server side error occurred.", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeInjuryNoticeViewModel>(null as any);
    }
}

export class EmployeesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getEmployeeDetail(id: number , cancelToken?: CancelToken | undefined): Promise<EmployeeDetailViewModel> {
        let url_ = this.baseUrl + "/api/employees/{id}/detail";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeDetail(_response);
        });
    }

    protected processGetEmployeeDetail(response: AxiosResponse): Promise<EmployeeDetailViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeDetailViewModel.fromJS(resultData200);
            return Promise.resolve<EmployeeDetailViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeDetailViewModel>(null as any);
    }

    getOne(id: number , cancelToken?: CancelToken | undefined): Promise<EmployeeViewModel> {
        let url_ = this.baseUrl + "/api/employees/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetOne(_response);
        });
    }

    protected processGetOne(response: AxiosResponse): Promise<EmployeeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeViewModel.fromJS(resultData200);
            return Promise.resolve<EmployeeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeViewModel>(null as any);
    }

    getEmployees(storeId: string | null | undefined, employeeNumber: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfEmployeeViewModel> {
        let url_ = this.baseUrl + "/api/employees?";
        if (storeId !== undefined && storeId !== null)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&";
        if (employeeNumber !== undefined && employeeNumber !== null)
            url_ += "EmployeeNumber=" + encodeURIComponent("" + employeeNumber) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployees(_response);
        });
    }

    protected processGetEmployees(response: AxiosResponse): Promise<QueryResultsOfEmployeeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfEmployeeViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfEmployeeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfEmployeeViewModel>(null as any);
    }

    getECEEmployees(employeeNumber: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfECEEmployeeViewModel> {
        let url_ = this.baseUrl + "/api/employees/ece-employees?";
        if (employeeNumber !== undefined && employeeNumber !== null)
            url_ += "EmployeeNumber=" + encodeURIComponent("" + employeeNumber) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetECEEmployees(_response);
        });
    }

    protected processGetECEEmployees(response: AxiosResponse): Promise<QueryResultsOfECEEmployeeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfECEEmployeeViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfECEEmployeeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfECEEmployeeViewModel>(null as any);
    }

    getECommerceEmployees(storeId: string | null | undefined, employeeNumber: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfEmployeeViewModel> {
        let url_ = this.baseUrl + "/api/employees/ecommerce-employees?";
        if (storeId !== undefined && storeId !== null)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&";
        if (employeeNumber !== undefined && employeeNumber !== null)
            url_ += "EmployeeNumber=" + encodeURIComponent("" + employeeNumber) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetECommerceEmployees(_response);
        });
    }

    protected processGetECommerceEmployees(response: AxiosResponse): Promise<QueryResultsOfEmployeeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfEmployeeViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfEmployeeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfEmployeeViewModel>(null as any);
    }

    getPDXRehab05ActiveEmployees(employeeNumber: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfActiveEmployeeViewModel> {
        let url_ = this.baseUrl + "/api/employees/pdxRedhab05-active-employees?";
        if (employeeNumber !== undefined && employeeNumber !== null)
            url_ += "EmployeeNumber=" + encodeURIComponent("" + employeeNumber) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPDXRehab05ActiveEmployees(_response);
        });
    }

    protected processGetPDXRehab05ActiveEmployees(response: AxiosResponse): Promise<QueryResultsOfActiveEmployeeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfActiveEmployeeViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfActiveEmployeeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfActiveEmployeeViewModel>(null as any);
    }

    getGreOrthosEmployees(storeId: string | null | undefined, employeeNumber: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfEmployeeViewModel> {
        let url_ = this.baseUrl + "/api/employees/gre-orthos-employees?";
        if (storeId !== undefined && storeId !== null)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&";
        if (employeeNumber !== undefined && employeeNumber !== null)
            url_ += "EmployeeNumber=" + encodeURIComponent("" + employeeNumber) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGreOrthosEmployees(_response);
        });
    }

    protected processGetGreOrthosEmployees(response: AxiosResponse): Promise<QueryResultsOfEmployeeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfEmployeeViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfEmployeeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfEmployeeViewModel>(null as any);
    }

    getEmployeeActiveByLocation(storeId: string | null | undefined, employeeNumber: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfEmployeeViewModel> {
        let url_ = this.baseUrl + "/api/employees/pdxSqlOldHR-employees-active-by-location?";
        if (storeId !== undefined && storeId !== null)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&";
        if (employeeNumber !== undefined && employeeNumber !== null)
            url_ += "EmployeeNumber=" + encodeURIComponent("" + employeeNumber) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeActiveByLocation(_response);
        });
    }

    protected processGetEmployeeActiveByLocation(response: AxiosResponse): Promise<QueryResultsOfEmployeeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfEmployeeViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfEmployeeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfEmployeeViewModel>(null as any);
    }

    getHrEmployees(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfEmployee> {
        let url_ = this.baseUrl + "/api/employees/hr/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHrEmployees(_response);
        });
    }

    protected processGetHrEmployees(response: AxiosResponse): Promise<QueryResultsOfEmployee> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfEmployee.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfEmployee>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfEmployee>(null as any);
    }

    queryEmployeeBase(employeeNumber: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfEmployeeViewModel2> {
        let url_ = this.baseUrl + "/api/employees/pxdsqlGre/query?";
        if (employeeNumber !== undefined && employeeNumber !== null)
            url_ += "EmployeeNumber=" + encodeURIComponent("" + employeeNumber) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryEmployeeBase(_response);
        });
    }

    protected processQueryEmployeeBase(response: AxiosResponse): Promise<QueryResultsOfEmployeeViewModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfEmployeeViewModel2.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfEmployeeViewModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfEmployeeViewModel2>(null as any);
    }
}

export class EmploymentHistoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(request: EmploymentHistory , cancelToken?: CancelToken | undefined): Promise<EmploymentHistory> {
        let url_ = this.baseUrl + "/api/EmploymentHistory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<EmploymentHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmploymentHistory.fromJS(resultData200);
            return Promise.resolve<EmploymentHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmploymentHistory>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<EmploymentHistory> {
        let url_ = this.baseUrl + "/api/EmploymentHistory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<EmploymentHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmploymentHistory.fromJS(resultData200);
            return Promise.resolve<EmploymentHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmploymentHistory>(null as any);
    }

    deleteEmploymentHistory(id: number , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/EmploymentHistory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmploymentHistory(_response);
        });
    }

    protected processDeleteEmploymentHistory(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }

    query(gICWID: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfEmploymentHistory> {
        let url_ = this.baseUrl + "/api/EmploymentHistory/query?";
        if (gICWID === null)
            throw new Error("The parameter 'gICWID' cannot be null.");
        else if (gICWID !== undefined)
            url_ += "GICWID=" + encodeURIComponent("" + gICWID) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfEmploymentHistory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfEmploymentHistory.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfEmploymentHistory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfEmploymentHistory>(null as any);
    }
}

export class EquipmentInventoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    post(model: EquipmentInventory , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/EquipmentInventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: EquipmentInventory , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/EquipmentInventory";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<EquipmentInventory> {
        let url_ = this.baseUrl + "/api/EquipmentInventory/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<EquipmentInventory> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EquipmentInventory.fromJS(resultData200);
            return Promise.resolve<EquipmentInventory>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EquipmentInventory>(null as any);
    }

    query(storeId: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfEquipmentInventoryViewModel> {
        let url_ = this.baseUrl + "/api/EquipmentInventory/query?";
        if (storeId !== undefined && storeId !== null)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfEquipmentInventoryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfEquipmentInventoryViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfEquipmentInventoryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfEquipmentInventoryViewModel>(null as any);
    }
}

export class ESLCitizenshipsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<ESLCitizenshipViewModel> {
        let url_ = this.baseUrl + "/api/eslcitizenships/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ESLCitizenshipViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLCitizenshipViewModel.fromJS(resultData200);
            return Promise.resolve<ESLCitizenshipViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLCitizenshipViewModel>(null as any);
    }

    deleteById(id: number , cancelToken?: CancelToken | undefined): Promise<ESLCitizenshipViewModel> {
        let url_ = this.baseUrl + "/api/eslcitizenships/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteById(_response);
        });
    }

    protected processDeleteById(response: AxiosResponse): Promise<ESLCitizenshipViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLCitizenshipViewModel.fromJS(resultData200);
            return Promise.resolve<ESLCitizenshipViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLCitizenshipViewModel>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfESLCitizenshipViewModel> {
        let url_ = this.baseUrl + "/api/eslcitizenships/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfESLCitizenshipViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfESLCitizenshipViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfESLCitizenshipViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfESLCitizenshipViewModel>(null as any);
    }

    upSert(request: ESLCitizenship , cancelToken?: CancelToken | undefined): Promise<ESLCitizenshipViewModel> {
        let url_ = this.baseUrl + "/api/eslcitizenships";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpSert(_response);
        });
    }

    protected processUpSert(response: AxiosResponse): Promise<ESLCitizenshipViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLCitizenshipViewModel.fromJS(resultData200);
            return Promise.resolve<ESLCitizenshipViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLCitizenshipViewModel>(null as any);
    }
}

export class ESLClassClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(employeeId: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfESLClass> {
        let url_ = this.baseUrl + "/api/ESLClass/query?";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "EmployeeId=" + encodeURIComponent("" + employeeId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfESLClass> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfESLClass.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfESLClass>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfESLClass>(null as any);
    }
}

export class ESLClassTypeClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: ESLClassType , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/esl-class-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getTblClassNames(isActive: boolean | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfESLClassType> {
        let url_ = this.baseUrl + "/api/esl-class-type?";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTblClassNames(_response);
        });
    }

    protected processGetTblClassNames(response: AxiosResponse): Promise<QueryResultsOfESLClassType> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfESLClassType.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfESLClassType>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfESLClassType>(null as any);
    }

    deleteTblClassName(id: number, requestBody: ESLClassType , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/esl-class-type/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTblClassName(_response);
        });
    }

    protected processDeleteTblClassName(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class ESLGoalsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<ESLGoal> {
        let url_ = this.baseUrl + "/api/eslgoals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ESLGoal> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLGoal.fromJS(resultData200);
            return Promise.resolve<ESLGoal>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLGoal>(null as any);
    }

    deleteESLGoal(id: number, requestBody: ESLGoal , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/eslgoals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteESLGoal(_response);
        });
    }

    protected processDeleteESLGoal(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfESLGoal> {
        let url_ = this.baseUrl + "/api/eslgoals/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfESLGoal> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfESLGoal.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfESLGoal>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfESLGoal>(null as any);
    }

    save(request: ESLGoal , cancelToken?: CancelToken | undefined): Promise<ESLGoal> {
        let url_ = this.baseUrl + "/api/eslgoals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ESLGoal> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLGoal.fromJS(resultData200);
            return Promise.resolve<ESLGoal>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLGoal>(null as any);
    }
}

export class ESLInstructorsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<ESLInstructor> {
        let url_ = this.baseUrl + "/api/eslinstructors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ESLInstructor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLInstructor.fromJS(resultData200);
            return Promise.resolve<ESLInstructor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLInstructor>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<ESLInstructor> {
        let url_ = this.baseUrl + "/api/eslinstructors/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<ESLInstructor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLInstructor.fromJS(resultData200);
            return Promise.resolve<ESLInstructor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLInstructor>(null as any);
    }

    save(request: ESLInstructor , cancelToken?: CancelToken | undefined): Promise<ESLInstructor> {
        let url_ = this.baseUrl + "/api/eslinstructors";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ESLInstructor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLInstructor.fromJS(resultData200);
            return Promise.resolve<ESLInstructor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLInstructor>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfESLInstructor> {
        let url_ = this.baseUrl + "/api/eslinstructors/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfESLInstructor> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfESLInstructor.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfESLInstructor>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfESLInstructor>(null as any);
    }
}

export class ESLParticipantClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfESLParticipantViewModel> {
        let url_ = this.baseUrl + "/api/esl-participant?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<QueryResultsOfESLParticipantViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfESLParticipantViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfESLParticipantViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfESLParticipantViewModel>(null as any);
    }

    save(model: ESLParticipantSavingModel , cancelToken?: CancelToken | undefined): Promise<ESLParticipantViewModel> {
        let url_ = this.baseUrl + "/api/esl-participant";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ESLParticipantViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLParticipantViewModel.fromJS(resultData200);
            return Promise.resolve<ESLParticipantViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLParticipantViewModel>(null as any);
    }

    getbyId(id: string | null , cancelToken?: CancelToken | undefined): Promise<ESLParticipantViewModel> {
        let url_ = this.baseUrl + "/api/esl-participant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyId(_response);
        });
    }

    protected processGetbyId(response: AxiosResponse): Promise<ESLParticipantViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLParticipantViewModel.fromJS(resultData200);
            return Promise.resolve<ESLParticipantViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLParticipantViewModel>(null as any);
    }

    delete(id: string | null , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/esl-participant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    update(model: ESLParticipantSavingModel, id: string | null , cancelToken?: CancelToken | undefined): Promise<ESLParticipantViewModel> {
        let url_ = this.baseUrl + "/api/esl-participant/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ESLParticipantViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLParticipantViewModel.fromJS(resultData200);
            return Promise.resolve<ESLParticipantViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLParticipantViewModel>(null as any);
    }
}

export class ESLReferralSourceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: ESLReferralSource , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/esl-referral-source";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getESLReferralSources(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfESLReferralSource> {
        let url_ = this.baseUrl + "/api/esl-referral-source?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetESLReferralSources(_response);
        });
    }

    protected processGetESLReferralSources(response: AxiosResponse): Promise<QueryResultsOfESLReferralSource> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfESLReferralSource.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfESLReferralSource>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfESLReferralSource>(null as any);
    }

    deleteESLReferralSource(id: number, requestBody: ESLReferralSource , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/esl-referral-source/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteESLReferralSource(_response);
        });
    }

    protected processDeleteESLReferralSource(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class ESLTrainingSummariesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(startDate: string | undefined, endDate: string | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfESLTrainingSummaryViewModel> {
        let url_ = this.baseUrl + "/api/ESLTrainingSummaries/query?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfESLTrainingSummaryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfESLTrainingSummaryViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfESLTrainingSummaryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfESLTrainingSummaryViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<ESLTrainingSummaryViewModel> {
        let url_ = this.baseUrl + "/api/ESLTrainingSummaries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ESLTrainingSummaryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLTrainingSummaryViewModel.fromJS(resultData200);
            return Promise.resolve<ESLTrainingSummaryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLTrainingSummaryViewModel>(null as any);
    }

    update(id: number, request: ESLTrainingSummary , cancelToken?: CancelToken | undefined): Promise<ESLTrainingSummaryViewModel> {
        let url_ = this.baseUrl + "/api/ESLTrainingSummaries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<ESLTrainingSummaryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLTrainingSummaryViewModel.fromJS(resultData200);
            return Promise.resolve<ESLTrainingSummaryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLTrainingSummaryViewModel>(null as any);
    }

    save(request: ESLTrainingSummary , cancelToken?: CancelToken | undefined): Promise<ESLTrainingSummaryViewModel> {
        let url_ = this.baseUrl + "/api/ESLTrainingSummaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ESLTrainingSummaryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ESLTrainingSummaryViewModel.fromJS(resultData200);
            return Promise.resolve<ESLTrainingSummaryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ESLTrainingSummaryViewModel>(null as any);
    }
}

export class ExampleClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getCsv(  cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/examples/csv";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCsv(_response);
        });
    }

    protected processGetCsv(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    findEmployees(query: EmployeeQuery , cancelToken?: CancelToken | undefined): Promise<EmployeeViewModel[]> {
        let url_ = this.baseUrl + "/api/examples/findemployees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFindEmployees(_response);
        });
    }

    protected processFindEmployees(response: AxiosResponse): Promise<EmployeeViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EmployeeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EmployeeViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeViewModel[]>(null as any);
    }

    getPDF(query: EmployeeQuery , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/examples/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPDF(_response);
        });
    }

    protected processGetPDF(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    emailTest(query: EmployeeQuery , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/examples/email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(query);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEmailTest(_response);
        });
    }

    protected processEmailTest(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getEmployee(employeeId: number , cancelToken?: CancelToken | undefined): Promise<Employee2> {
        let url_ = this.baseUrl + "/api/examples/employee/{employeeId}";
        if (employeeId === undefined || employeeId === null)
            throw new Error("The parameter 'employeeId' must be defined.");
        url_ = url_.replace("{employeeId}", encodeURIComponent("" + employeeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployee(_response);
        });
    }

    protected processGetEmployee(response: AxiosResponse): Promise<Employee2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Employee2.fromJS(resultData200);
            return Promise.resolve<Employee2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Employee2>(null as any);
    }

    saveEmployee(employee: Employee2 , cancelToken?: CancelToken | undefined): Promise<Employee2> {
        let url_ = this.baseUrl + "/api/examples/employee";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(employee);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveEmployee(_response);
        });
    }

    protected processSaveEmployee(response: AxiosResponse): Promise<Employee2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Employee2.fromJS(resultData200);
            return Promise.resolve<Employee2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Employee2>(null as any);
    }

    getStorePickList(  cancelToken?: CancelToken | undefined): Promise<PicklistOption[]> {
        let url_ = this.baseUrl + "/api/examples/storepicks";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStorePickList(_response);
        });
    }

    protected processGetStorePickList(response: AxiosResponse): Promise<PicklistOption[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PicklistOption.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PicklistOption[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PicklistOption[]>(null as any);
    }

    getEmployees(args: EmployeeQuery , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfEmployeeViewModel> {
        let url_ = this.baseUrl + "/api/examples/employees";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(args);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployees(_response);
        });
    }

    protected processGetEmployees(response: AxiosResponse): Promise<QueryResultsOfEmployeeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfEmployeeViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfEmployeeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfEmployeeViewModel>(null as any);
    }
}

export class FeedbackLogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: Issue , cancelToken?: CancelToken | undefined): Promise<IssueViewModel> {
        let url_ = this.baseUrl + "/api/FeedbackLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<IssueViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueViewModel.fromJS(resultData200);
            return Promise.resolve<IssueViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueViewModel>(null as any);
    }

    getAllTaskTypes(  cancelToken?: CancelToken | undefined): Promise<TaskTypeViewModel[]> {
        let url_ = this.baseUrl + "/api/FeedbackLog/task-types";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAllTaskTypes(_response);
        });
    }

    protected processGetAllTaskTypes(response: AxiosResponse): Promise<TaskTypeViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TaskTypeViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TaskTypeViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TaskTypeViewModel[]>(null as any);
    }

    queryIssueTypes(type: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfIssueTypeViewModel> {
        let url_ = this.baseUrl + "/api/FeedbackLog/issue-types?";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryIssueTypes(_response);
        });
    }

    protected processQueryIssueTypes(response: AxiosResponse): Promise<QueryResultsOfIssueTypeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfIssueTypeViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfIssueTypeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfIssueTypeViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<IssueViewModel> {
        let url_ = this.baseUrl + "/api/FeedbackLog/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<IssueViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IssueViewModel.fromJS(resultData200);
            return Promise.resolve<IssueViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IssueViewModel>(null as any);
    }
}

export class FileClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    create(caption: string | null | undefined, description: string | null | undefined, file: FileParameter | null | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (caption !== null && caption !== undefined)
            content_.append("Caption", caption.toString());
        if (description !== null && description !== undefined)
            content_.append("Description", description.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class FixedAssetsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: FixedAsset2 , cancelToken?: CancelToken | undefined): Promise<FixedAssetViewModel> {
        let url_ = this.baseUrl + "/api/FixedAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<FixedAssetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FixedAssetViewModel.fromJS(resultData200);
            return Promise.resolve<FixedAssetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FixedAssetViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<FixedAssetViewModel> {
        let url_ = this.baseUrl + "/api/FixedAssets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<FixedAssetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FixedAssetViewModel.fromJS(resultData200);
            return Promise.resolve<FixedAssetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FixedAssetViewModel>(null as any);
    }

    query(fixedAssetNumber: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfFixedAssetViewModel> {
        let url_ = this.baseUrl + "/api/FixedAssets/query?";
        if (fixedAssetNumber !== undefined && fixedAssetNumber !== null)
            url_ += "FixedAssetNumber=" + encodeURIComponent("" + fixedAssetNumber) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfFixedAssetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfFixedAssetViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfFixedAssetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfFixedAssetViewModel>(null as any);
    }
}

export class GeneralInventoryDetailClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: GeneralInventoryDetail , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/general-inventory-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getGeneralInventoryDetails(gisid: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfGeneralInventoryDetail> {
        let url_ = this.baseUrl + "/api/general-inventory-details?";
        if (gisid !== undefined && gisid !== null)
            url_ += "Gisid=" + encodeURIComponent("" + gisid) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeneralInventoryDetails(_response);
        });
    }

    protected processGetGeneralInventoryDetails(response: AxiosResponse): Promise<QueryResultsOfGeneralInventoryDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfGeneralInventoryDetail.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfGeneralInventoryDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfGeneralInventoryDetail>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<GeneralInventoryDetail> {
        let url_ = this.baseUrl + "/api/general-inventory-details/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<GeneralInventoryDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneralInventoryDetail.fromJS(resultData200);
            return Promise.resolve<GeneralInventoryDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInventoryDetail>(null as any);
    }

    deleteGeneralInventoryDetail(id: number, requestBody: GeneralInventoryDetail , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/general-inventory-details/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteGeneralInventoryDetail(_response);
        });
    }

    protected processDeleteGeneralInventoryDetail(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class GeneralInventoryItemsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<GeneralInventoryItemViewModel> {
        let url_ = this.baseUrl + "/api/GeneralInventoryItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<GeneralInventoryItemViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneralInventoryItemViewModel.fromJS(resultData200);
            return Promise.resolve<GeneralInventoryItemViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInventoryItemViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/GeneralInventoryItems/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    upSert(request: GeneralInventoryItem , cancelToken?: CancelToken | undefined): Promise<GeneralInventoryItemViewModel> {
        let url_ = this.baseUrl + "/api/GeneralInventoryItems";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpSert(_response);
        });
    }

    protected processUpSert(response: AxiosResponse): Promise<GeneralInventoryItemViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneralInventoryItemViewModel.fromJS(resultData200);
            return Promise.resolve<GeneralInventoryItemViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInventoryItemViewModel>(null as any);
    }

    query(active: boolean | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfGeneralInventoryItemViewModel> {
        let url_ = this.baseUrl + "/api/GeneralInventoryItems/query?";
        if (active !== undefined && active !== null)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfGeneralInventoryItemViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfGeneralInventoryItemViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfGeneralInventoryItemViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfGeneralInventoryItemViewModel>(null as any);
    }

    queryNoAuthorize(active: boolean | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfGeneralInventoryItemViewModel> {
        let url_ = this.baseUrl + "/api/GeneralInventoryItems/queryNoAuthorize?";
        if (active !== undefined && active !== null)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryNoAuthorize(_response);
        });
    }

    protected processQueryNoAuthorize(response: AxiosResponse): Promise<QueryResultsOfGeneralInventoryItemViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfGeneralInventoryItemViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfGeneralInventoryItemViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfGeneralInventoryItemViewModel>(null as any);
    }
}

export class GeneralInventorySummaryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: GeneralInventorySummary , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/general-inventory-summaries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getGeneralInventorySummaries(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfGeneralInventorySummary> {
        let url_ = this.baseUrl + "/api/general-inventory-summaries?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetGeneralInventorySummaries(_response);
        });
    }

    protected processGetGeneralInventorySummaries(response: AxiosResponse): Promise<QueryResultsOfGeneralInventorySummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfGeneralInventorySummary.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfGeneralInventorySummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfGeneralInventorySummary>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<GeneralInventorySummary> {
        let url_ = this.baseUrl + "/api/general-inventory-summaries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<GeneralInventorySummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GeneralInventorySummary.fromJS(resultData200);
            return Promise.resolve<GeneralInventorySummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeneralInventorySummary>(null as any);
    }
}

export class HalloweenBudgetsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<HalloweenBudgetViewModel> {
        let url_ = this.baseUrl + "/api/HalloweenBudgets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<HalloweenBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HalloweenBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<HalloweenBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HalloweenBudgetViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/HalloweenBudgets/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfHalloweenBudgetViewModel> {
        let url_ = this.baseUrl + "/api/HalloweenBudgets/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfHalloweenBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfHalloweenBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfHalloweenBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfHalloweenBudgetViewModel>(null as any);
    }

    upSert(request: HalloweenBudget , cancelToken?: CancelToken | undefined): Promise<HalloweenBudgetViewModel> {
        let url_ = this.baseUrl + "/api/HalloweenBudgets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpSert(_response);
        });
    }

    protected processUpSert(response: AxiosResponse): Promise<HalloweenBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = HalloweenBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<HalloweenBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HalloweenBudgetViewModel>(null as any);
    }
}

export class HistoricalPreservationBoxClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: Box , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/HistoricalPreservationBox";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<Box> {
        let url_ = this.baseUrl + "/api/HistoricalPreservationBox/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<Box> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Box.fromJS(resultData200);
            return Promise.resolve<Box>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Box>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfBox> {
        let url_ = this.baseUrl + "/api/HistoricalPreservationBox/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfBox> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfBox.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfBox>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfBox>(null as any);
    }
}

export class HistoricalPreservationItemClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(boxId: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfItem> {
        let url_ = this.baseUrl + "/api/HistoricalPreservationItem/query?";
        if (boxId !== undefined && boxId !== null)
            url_ += "BoxId=" + encodeURIComponent("" + boxId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfItem> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfItem.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfItem>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfItem>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<Item> {
        let url_ = this.baseUrl + "/api/HistoricalPreservationItem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<Item> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Item.fromJS(resultData200);
            return Promise.resolve<Item>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Item>(null as any);
    }

    deleteItem(id: number , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/HistoricalPreservationItem/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteItem(_response);
        });
    }

    protected processDeleteItem(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }

    save(model: Item , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/HistoricalPreservationItem";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class IDsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getByDecryptionId(id: number , cancelToken?: CancelToken | undefined): Promise<IDViewModel> {
        let url_ = this.baseUrl + "/d/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetByDecryptionId(_response);
        });
    }

    protected processGetByDecryptionId(response: AxiosResponse): Promise<IDViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDViewModel.fromJS(resultData200);
            return Promise.resolve<IDViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<IDViewModel> {
        let url_ = this.baseUrl + "/api/ids/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<IDViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDViewModel.fromJS(resultData200);
            return Promise.resolve<IDViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDViewModel>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfIDViewModel> {
        let url_ = this.baseUrl + "/api/ids/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfIDViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfIDViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfIDViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfIDViewModel>(null as any);
    }

    saveDecryption(request: ID , cancelToken?: CancelToken | undefined): Promise<IDViewModel> {
        let url_ = this.baseUrl + "/api/ids/decryption";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveDecryption(_response);
        });
    }

    protected processSaveDecryption(response: AxiosResponse): Promise<IDViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDViewModel.fromJS(resultData200);
            return Promise.resolve<IDViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDViewModel>(null as any);
    }

    save(request: ID , cancelToken?: CancelToken | undefined): Promise<IDViewModel> {
        let url_ = this.baseUrl + "/api/ids";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<IDViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDViewModel.fromJS(resultData200);
            return Promise.resolve<IDViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDViewModel>(null as any);
    }

    saveVocationalGoals(request: ID , cancelToken?: CancelToken | undefined): Promise<IDViewModel> {
        let url_ = this.baseUrl + "/api/ids/save-vocational-goals";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveVocationalGoals(_response);
        });
    }

    protected processSaveVocationalGoals(response: AxiosResponse): Promise<IDViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDViewModel.fromJS(resultData200);
            return Promise.resolve<IDViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDViewModel>(null as any);
    }

    saveBarriers(request: ID , cancelToken?: CancelToken | undefined): Promise<IDViewModel> {
        let url_ = this.baseUrl + "/api/ids/barriers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveBarriers(_response);
        });
    }

    protected processSaveBarriers(response: AxiosResponse): Promise<IDViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDViewModel.fromJS(resultData200);
            return Promise.resolve<IDViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDViewModel>(null as any);
    }

    saveStatisticalInformation(request: ID , cancelToken?: CancelToken | undefined): Promise<IDViewModel> {
        let url_ = this.baseUrl + "/api/ids/statistical-information";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveStatisticalInformation(_response);
        });
    }

    protected processSaveStatisticalInformation(response: AxiosResponse): Promise<IDViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDViewModel.fromJS(resultData200);
            return Promise.resolve<IDViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDViewModel>(null as any);
    }

    saveEducation(request: ID , cancelToken?: CancelToken | undefined): Promise<IDViewModel> {
        let url_ = this.baseUrl + "/api/ids/save-education";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSaveEducation(_response);
        });
    }

    protected processSaveEducation(response: AxiosResponse): Promise<IDViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IDViewModel.fromJS(resultData200);
            return Promise.resolve<IDViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IDViewModel>(null as any);
    }
}

export class IncidentDetailsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    deleteById(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/IncidentDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteById(_response);
        });
    }

    protected processDeleteById(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class IncidentLocationsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(active: boolean | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfIncidentLocationViewModel> {
        let url_ = this.baseUrl + "/api/IncidentLocations/query?";
        if (active === null)
            throw new Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfIncidentLocationViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfIncidentLocationViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfIncidentLocationViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfIncidentLocationViewModel>(null as any);
    }
}

export class IncidentPicturesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<IncidentPictureViewModel> {
        let url_ = this.baseUrl + "/api/IncidentPictures/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<IncidentPictureViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidentPictureViewModel.fromJS(resultData200);
            return Promise.resolve<IncidentPictureViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentPictureViewModel>(null as any);
    }

    deleteById(id: number , cancelToken?: CancelToken | undefined): Promise<IncidentPictureViewModel> {
        let url_ = this.baseUrl + "/api/IncidentPictures/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteById(_response);
        });
    }

    protected processDeleteById(response: AxiosResponse): Promise<IncidentPictureViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidentPictureViewModel.fromJS(resultData200);
            return Promise.resolve<IncidentPictureViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentPictureViewModel>(null as any);
    }

    upsert(id: number | undefined, incidentSummaryId: number | undefined, picture: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<IncidentPictureViewModel> {
        let url_ = this.baseUrl + "/api/IncidentPictures";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (incidentSummaryId === null || incidentSummaryId === undefined)
            throw new Error("The parameter 'incidentSummaryId' cannot be null.");
        else
            content_.append("IncidentSummaryId", incidentSummaryId.toString());
        if (picture !== null && picture !== undefined)
            content_.append("Picture", picture.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpsert(_response);
        });
    }

    protected processUpsert(response: AxiosResponse): Promise<IncidentPictureViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidentPictureViewModel.fromJS(resultData200);
            return Promise.resolve<IncidentPictureViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentPictureViewModel>(null as any);
    }
}

export class IncidentReportClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getUserInfo(  cancelToken?: CancelToken | undefined): Promise<EmployeeViewModel> {
        let url_ = this.baseUrl + "/api/incident-report/user-info";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetUserInfo(_response);
        });
    }

    protected processGetUserInfo(response: AxiosResponse): Promise<EmployeeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EmployeeViewModel.fromJS(resultData200);
            return Promise.resolve<EmployeeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EmployeeViewModel>(null as any);
    }

    getIncidentTypes(active: boolean | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfIncidentTypeViewModel> {
        let url_ = this.baseUrl + "/api/incident-report/incident-types?";
        if (active !== undefined && active !== null)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetIncidentTypes(_response);
        });
    }

    protected processGetIncidentTypes(response: AxiosResponse): Promise<QueryResultsOfIncidentTypeViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfIncidentTypeViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfIncidentTypeViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfIncidentTypeViewModel>(null as any);
    }

    post(request: IncidentSummary , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/incident-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(request: IncidentSummary , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/incident-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<IncidentSummaryViewModel> {
        let url_ = this.baseUrl + "/api/incident-report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<IncidentSummaryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidentSummaryViewModel.fromJS(resultData200);
            return Promise.resolve<IncidentSummaryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentSummaryViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<IncidentSummaryViewModel> {
        let url_ = this.baseUrl + "/api/incident-report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<IncidentSummaryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidentSummaryViewModel.fromJS(resultData200);
            return Promise.resolve<IncidentSummaryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentSummaryViewModel>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<IncidentSummaryViewModel> {
        let url_ = this.baseUrl + "/api/incident-report/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<IncidentSummaryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = IncidentSummaryViewModel.fromJS(resultData200);
            return Promise.resolve<IncidentSummaryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<IncidentSummaryViewModel>(null as any);
    }
}

export class JccertificationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(participantId: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfJccertification> {
        let url_ = this.baseUrl + "/api/Jccertification/query?";
        if (participantId === null)
            throw new Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "ParticipantId=" + encodeURIComponent("" + participantId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfJccertification> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfJccertification.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfJccertification>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfJccertification>(null as any);
    }

    post(model: Jccertification , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Jccertification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: Jccertification , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Jccertification";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<Jccertification> {
        let url_ = this.baseUrl + "/api/Jccertification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<Jccertification> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Jccertification.fromJS(resultData200);
            return Promise.resolve<Jccertification>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Jccertification>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Jccertification/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class JccontactLogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    queryJccontactLogs(contactId: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfJccontactLog> {
        let url_ = this.baseUrl + "/api/JccontactLog/queryJccontactLogs?";
        if (contactId === null)
            throw new Error("The parameter 'contactId' cannot be null.");
        else if (contactId !== undefined)
            url_ += "ContactId=" + encodeURIComponent("" + contactId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryJccontactLogs(_response);
        });
    }

    protected processQueryJccontactLogs(response: AxiosResponse): Promise<QueryResultsOfJccontactLog> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfJccontactLog.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfJccontactLog>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfJccontactLog>(null as any);
    }

    save(model: JccontactLog , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/JccontactLog";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class JcdegreeClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(participantId: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfJcdegree> {
        let url_ = this.baseUrl + "/api/Jcdegree/query?";
        if (participantId === null)
            throw new Error("The parameter 'participantId' cannot be null.");
        else if (participantId !== undefined)
            url_ += "ParticipantId=" + encodeURIComponent("" + participantId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfJcdegree> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfJcdegree.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfJcdegree>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfJcdegree>(null as any);
    }

    post(model: Jcdegree , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Jcdegree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: Jcdegree , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Jcdegree";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<Jcdegree> {
        let url_ = this.baseUrl + "/api/Jcdegree/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<Jcdegree> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Jcdegree.fromJS(resultData200);
            return Promise.resolve<Jcdegree>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Jcdegree>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Jcdegree/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class JcentityContactClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    queryJcentityContacts(entityLocationId: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfJcentityContact> {
        let url_ = this.baseUrl + "/api/jc-entity-contact/queryJcentityContacts?";
        if (entityLocationId === null)
            throw new Error("The parameter 'entityLocationId' cannot be null.");
        else if (entityLocationId !== undefined)
            url_ += "EntityLocationId=" + encodeURIComponent("" + entityLocationId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryJcentityContacts(_response);
        });
    }

    protected processQueryJcentityContacts(response: AxiosResponse): Promise<QueryResultsOfJcentityContact> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfJcentityContact.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfJcentityContact>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfJcentityContact>(null as any);
    }

    save(model: JcentityContact , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/jc-entity-contact";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class JcentityClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: Jcentity2 , cancelToken?: CancelToken | undefined): Promise<JcentityViewModel> {
        let url_ = this.baseUrl + "/api/Jcentity";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<JcentityViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JcentityViewModel.fromJS(resultData200);
            return Promise.resolve<JcentityViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JcentityViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<JcentityViewModel> {
        let url_ = this.baseUrl + "/api/Jcentity/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<JcentityViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JcentityViewModel.fromJS(resultData200);
            return Promise.resolve<JcentityViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JcentityViewModel>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfJcentityViewModel> {
        let url_ = this.baseUrl + "/api/Jcentity/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfJcentityViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfJcentityViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfJcentityViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfJcentityViewModel>(null as any);
    }
}

export class JCEntityEventClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<JCEntityEventViewModel> {
        let url_ = this.baseUrl + "/api/JCEntityEvent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<JCEntityEventViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JCEntityEventViewModel.fromJS(resultData200);
            return Promise.resolve<JCEntityEventViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JCEntityEventViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/JCEntityEvent/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    query(entityId: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfJCEntityEventViewModel> {
        let url_ = this.baseUrl + "/api/JCEntityEvent/query?";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfJCEntityEventViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfJCEntityEventViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfJCEntityEventViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfJCEntityEventViewModel>(null as any);
    }

    upSert(request: JCEntityEvent , cancelToken?: CancelToken | undefined): Promise<JCEntityEventViewModel> {
        let url_ = this.baseUrl + "/api/JCEntityEvent";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpSert(_response);
        });
    }

    protected processUpSert(response: AxiosResponse): Promise<JCEntityEventViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JCEntityEventViewModel.fromJS(resultData200);
            return Promise.resolve<JCEntityEventViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JCEntityEventViewModel>(null as any);
    }
}

export class JCEntityEventDetailsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<JCEntityEventDetailViewModel> {
        let url_ = this.baseUrl + "/api/JCEntityEventDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<JCEntityEventDetailViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JCEntityEventDetailViewModel.fromJS(resultData200);
            return Promise.resolve<JCEntityEventDetailViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JCEntityEventDetailViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/JCEntityEventDetails/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    query(jCEntityEventId: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfJCEntityEventDetailViewModel> {
        let url_ = this.baseUrl + "/api/JCEntityEventDetails/query?";
        if (jCEntityEventId !== undefined && jCEntityEventId !== null)
            url_ += "JCEntityEventId=" + encodeURIComponent("" + jCEntityEventId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfJCEntityEventDetailViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfJCEntityEventDetailViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfJCEntityEventDetailViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfJCEntityEventDetailViewModel>(null as any);
    }

    upSert(request: JCEntityEventDetail , cancelToken?: CancelToken | undefined): Promise<JCEntityEventViewModel> {
        let url_ = this.baseUrl + "/api/JCEntityEventDetails";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpSert(_response);
        });
    }

    protected processUpSert(response: AxiosResponse): Promise<JCEntityEventViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JCEntityEventViewModel.fromJS(resultData200);
            return Promise.resolve<JCEntityEventViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JCEntityEventViewModel>(null as any);
    }
}

export class JCEntityEventsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<JCEntityEventViewModel> {
        let url_ = this.baseUrl + "/api/JCEntityEvents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<JCEntityEventViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JCEntityEventViewModel.fromJS(resultData200);
            return Promise.resolve<JCEntityEventViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JCEntityEventViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/JCEntityEvents/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    query(entityId: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfJCEntityEventViewModel> {
        let url_ = this.baseUrl + "/api/JCEntityEvents/query?";
        if (entityId !== undefined && entityId !== null)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfJCEntityEventViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfJCEntityEventViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfJCEntityEventViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfJCEntityEventViewModel>(null as any);
    }

    upSert(request: JCEntityEvent , cancelToken?: CancelToken | undefined): Promise<JCEntityEventViewModel> {
        let url_ = this.baseUrl + "/api/JCEntityEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpSert(_response);
        });
    }

    protected processUpSert(response: AxiosResponse): Promise<JCEntityEventViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JCEntityEventViewModel.fromJS(resultData200);
            return Promise.resolve<JCEntityEventViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JCEntityEventViewModel>(null as any);
    }
}

export class JcentityLocationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    queryAMPJcentityLocations(entityId: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfAMPJcentityLocationViewModel> {
        let url_ = this.baseUrl + "/api/jc-entity-location/queryAMPJcentityLocations?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryAMPJcentityLocations(_response);
        });
    }

    protected processQueryAMPJcentityLocations(response: AxiosResponse): Promise<QueryResultsOfAMPJcentityLocationViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfAMPJcentityLocationViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfAMPJcentityLocationViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfAMPJcentityLocationViewModel>(null as any);
    }

    save(request: JcentityLocation , cancelToken?: CancelToken | undefined): Promise<JcentityLocation> {
        let url_ = this.baseUrl + "/api/jc-entity-location";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<JcentityLocation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JcentityLocation.fromJS(resultData200);
            return Promise.resolve<JcentityLocation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JcentityLocation>(null as any);
    }

    getJcentityLocations(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfJcentityLocationViewModel> {
        let url_ = this.baseUrl + "/api/jc-entity-location?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJcentityLocations(_response);
        });
    }

    protected processGetJcentityLocations(response: AxiosResponse): Promise<QueryResultsOfJcentityLocationViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfJcentityLocationViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfJcentityLocationViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfJcentityLocationViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<JcentityLocation> {
        let url_ = this.baseUrl + "/api/jc-entity-location/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<JcentityLocation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JcentityLocation.fromJS(resultData200);
            return Promise.resolve<JcentityLocation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JcentityLocation>(null as any);
    }

    getJcentityLocationsFromSproc(  cancelToken?: CancelToken | undefined): Promise<JCEntityLocationOutputViewModel[]> {
        let url_ = this.baseUrl + "/api/jc-entity-location/jcentityLocationsFromSproc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJcentityLocationsFromSproc(_response);
        });
    }

    protected processGetJcentityLocationsFromSproc(response: AxiosResponse): Promise<JCEntityLocationOutputViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(JCEntityLocationOutputViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<JCEntityLocationOutputViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JCEntityLocationOutputViewModel[]>(null as any);
    }
}

export class JCParticipantsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(sSN: string | null | undefined, searchable: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined, type: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfJCParticipantViewModel> {
        let url_ = this.baseUrl + "/api/jc-participants?";
        if (sSN !== undefined && sSN !== null)
            url_ += "SSN=" + encodeURIComponent("" + sSN) + "&";
        if (searchable !== undefined && searchable !== null)
            url_ += "Searchable=" + encodeURIComponent("" + searchable) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (type !== undefined && type !== null)
            url_ += "type=" + encodeURIComponent("" + type) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<QueryResultsOfJCParticipantViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfJCParticipantViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfJCParticipantViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfJCParticipantViewModel>(null as any);
    }
}

export class JobConnectionAMPHistoryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getJobConnectionAMPHistoryFromSproc(entityId: number | undefined, historyAll: boolean | undefined , cancelToken?: CancelToken | undefined): Promise<EntityHistoryByIDOutputViewModel[]> {
        let url_ = this.baseUrl + "/api/JobConnectionAMPHistory/jobConnectionAMPHistoryFromSproc?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (historyAll === null)
            throw new Error("The parameter 'historyAll' cannot be null.");
        else if (historyAll !== undefined)
            url_ += "HistoryAll=" + encodeURIComponent("" + historyAll) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetJobConnectionAMPHistoryFromSproc(_response);
        });
    }

    protected processGetJobConnectionAMPHistoryFromSproc(response: AxiosResponse): Promise<EntityHistoryByIDOutputViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntityHistoryByIDOutputViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EntityHistoryByIDOutputViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntityHistoryByIDOutputViewModel[]>(null as any);
    }
}

export class JobConnectionAMPJobLeadClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    queryJCEntityJobLeads(entityId: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfJCEntityJobLeadViewModel> {
        let url_ = this.baseUrl + "/api/JobConnectionAMPJobLead/queryJCEntityJobLeads?";
        if (entityId === null)
            throw new Error("The parameter 'entityId' cannot be null.");
        else if (entityId !== undefined)
            url_ += "EntityId=" + encodeURIComponent("" + entityId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryJCEntityJobLeads(_response);
        });
    }

    protected processQueryJCEntityJobLeads(response: AxiosResponse): Promise<QueryResultsOfJCEntityJobLeadViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfJCEntityJobLeadViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfJCEntityJobLeadViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfJCEntityJobLeadViewModel>(null as any);
    }

    save(request: JCEntityJobLead , cancelToken?: CancelToken | undefined): Promise<JCEntityJobLead> {
        let url_ = this.baseUrl + "/api/JobConnectionAMPJobLead";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<JCEntityJobLead> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JCEntityJobLead.fromJS(resultData200);
            return Promise.resolve<JCEntityJobLead>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JCEntityJobLead>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<JCEntityJobLead> {
        let url_ = this.baseUrl + "/api/JobConnectionAMPJobLead/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<JCEntityJobLead> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = JCEntityJobLead.fromJS(resultData200);
            return Promise.resolve<JCEntityJobLead>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<JCEntityJobLead>(null as any);
    }
}

export class JobListClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    queryJobLists(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfApplicationJobListViewModel> {
        let url_ = this.baseUrl + "/api/joblists?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryJobLists(_response);
        });
    }

    protected processQueryJobLists(response: AxiosResponse): Promise<QueryResultsOfApplicationJobListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfApplicationJobListViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfApplicationJobListViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfApplicationJobListViewModel>(null as any);
    }
}

export class KaizenSuggestionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    post(model: KaizenSuggestion , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/kaizen-suggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: KaizenSuggestion , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/kaizen-suggestion";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<KaizenSuggestion> {
        let url_ = this.baseUrl + "/api/kaizen-suggestion/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<KaizenSuggestion> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KaizenSuggestion.fromJS(resultData200);
            return Promise.resolve<KaizenSuggestion>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KaizenSuggestion>(null as any);
    }
}

export class LaborHourBudgetClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(year: number | undefined, month: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfLaborHourBudget> {
        let url_ = this.baseUrl + "/api/LaborHourBudget/query?";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (month === null)
            throw new Error("The parameter 'month' cannot be null.");
        else if (month !== undefined)
            url_ += "Month=" + encodeURIComponent("" + month) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfLaborHourBudget> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfLaborHourBudget.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfLaborHourBudget>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfLaborHourBudget>(null as any);
    }

    post(model: LaborHourBudget , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/LaborHourBudget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: LaborHourBudget , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/LaborHourBudget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<LaborHourBudget> {
        let url_ = this.baseUrl + "/api/LaborHourBudget/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<LaborHourBudget> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LaborHourBudget.fromJS(resultData200);
            return Promise.resolve<LaborHourBudget>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LaborHourBudget>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/LaborHourBudget/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LocationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    queryLocations(type: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfApplicationFlowLogRouteToViewModel> {
        let url_ = this.baseUrl + "/api/locations?";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryLocations(_response);
        });
    }

    protected processQueryLocations(response: AxiosResponse): Promise<QueryResultsOfApplicationFlowLogRouteToViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfApplicationFlowLogRouteToViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfApplicationFlowLogRouteToViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfApplicationFlowLogRouteToViewModel>(null as any);
    }

    post(model: Location , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: Location , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/locations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    pDXRehab05Query(types: string[] | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfLocationViewModel> {
        let url_ = this.baseUrl + "/api/locations/PDXRehab05Query?";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPDXRehab05Query(_response);
        });
    }

    protected processPDXRehab05Query(response: AxiosResponse): Promise<QueryResultsOfLocationViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfLocationViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfLocationViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfLocationViewModel>(null as any);
    }

    query(type: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfLocation> {
        let url_ = this.baseUrl + "/api/locations/query?";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfLocation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfLocation.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfLocation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfLocation>(null as any);
    }

    getLocationsJCS(type: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfLocation> {
        let url_ = this.baseUrl + "/api/locations/locationsJCS?";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationsJCS(_response);
        });
    }

    protected processGetLocationsJCS(response: AxiosResponse): Promise<QueryResultsOfLocation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfLocation.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfLocation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfLocation>(null as any);
    }

    getLocationsJCSFromSproc(  cancelToken?: CancelToken | undefined): Promise<LocationsJCSOutputViewModel[]> {
        let url_ = this.baseUrl + "/api/locations/locationsJCSFromSproc";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationsJCSFromSproc(_response);
        });
    }

    protected processGetLocationsJCSFromSproc(response: AxiosResponse): Promise<LocationsJCSOutputViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(LocationsJCSOutputViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<LocationsJCSOutputViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LocationsJCSOutputViewModel[]>(null as any);
    }

    queryJobConnectionLocations(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfLocation> {
        let url_ = this.baseUrl + "/api/locations/query-job-connection-locations?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryJobConnectionLocations(_response);
        });
    }

    protected processQueryJobConnectionLocations(response: AxiosResponse): Promise<QueryResultsOfLocation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfLocation.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfLocation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfLocation>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<Location> {
        let url_ = this.baseUrl + "/api/locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<Location> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Location.fromJS(resultData200);
            return Promise.resolve<Location>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Location>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/locations/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class LossControlReviewsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(request: LossControlReview , cancelToken?: CancelToken | undefined): Promise<LossControlReviewViewModel> {
        let url_ = this.baseUrl + "/api/LossControlReviews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<LossControlReviewViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LossControlReviewViewModel.fromJS(resultData200);
            return Promise.resolve<LossControlReviewViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LossControlReviewViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<LossControlReviewViewModel> {
        let url_ = this.baseUrl + "/api/LossControlReviews/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<LossControlReviewViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = LossControlReviewViewModel.fromJS(resultData200);
            return Promise.resolve<LossControlReviewViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<LossControlReviewViewModel>(null as any);
    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfLossControlReviewViewModel> {
        let url_ = this.baseUrl + "/api/LossControlReviews/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfLossControlReviewViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfLossControlReviewViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfLossControlReviewViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfLossControlReviewViewModel>(null as any);
    }
}

export class NewAuditDetailClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/newAuditDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class PhotosClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    uploadSharePoint(fileName: string | null | undefined, fileBytes: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<string> {
        let url_ = this.baseUrl + "/api/Photos";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());
        if (fileBytes !== null && fileBytes !== undefined)
            content_.append("FileBytes", fileBytes.toString());

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadSharePoint(_response);
        });
    }

    protected processUploadSharePoint(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }
}

export class PlaceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: Place , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/place";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getPlaceNames(gICWID: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfPlaceViewModel> {
        let url_ = this.baseUrl + "/api/place?";
        if (gICWID !== undefined && gICWID !== null)
            url_ += "GICWID=" + encodeURIComponent("" + gICWID) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPlaceNames(_response);
        });
    }

    protected processGetPlaceNames(response: AxiosResponse): Promise<QueryResultsOfPlaceViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfPlaceViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfPlaceViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfPlaceViewModel>(null as any);
    }

    deletePlace(id: number, requestBody: Place , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/place/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePlace(_response);
        });
    }

    protected processDeletePlace(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class ProductClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: Product , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/e-commerce-product";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getProducts(containerId: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfProduct> {
        let url_ = this.baseUrl + "/api/e-commerce-product?";
        if (containerId !== undefined && containerId !== null)
            url_ += "ContainerId=" + encodeURIComponent("" + containerId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProducts(_response);
        });
    }

    protected processGetProducts(response: AxiosResponse): Promise<QueryResultsOfProduct> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfProduct.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfProduct>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfProduct>(null as any);
    }

    getProducts2(id: number , cancelToken?: CancelToken | undefined): Promise<Product> {
        let url_ = this.baseUrl + "/api/e-commerce-product/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetProducts2(_response);
        });
    }

    protected processGetProducts2(response: AxiosResponse): Promise<Product> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Product.fromJS(resultData200);
            return Promise.resolve<Product>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Product>(null as any);
    }
}

export class ProductionBudgetClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getbyId(id: number , cancelToken?: CancelToken | undefined): Promise<ProductionBudgetViewModel> {
        let url_ = this.baseUrl + "/api/production-budget/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyId(_response);
        });
    }

    protected processGetbyId(response: AxiosResponse): Promise<ProductionBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductionBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<ProductionBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductionBudgetViewModel>(null as any);
    }

    get(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfProductionBudgetViewModel> {
        let url_ = this.baseUrl + "/api/production-budget?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<QueryResultsOfProductionBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfProductionBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfProductionBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfProductionBudgetViewModel>(null as any);
    }

    save(model: ProductionBudgetSavingModel , cancelToken?: CancelToken | undefined): Promise<ProductionBudgetViewModel> {
        let url_ = this.baseUrl + "/api/production-budget";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ProductionBudgetViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ProductionBudgetViewModel.fromJS(resultData200);
            return Promise.resolve<ProductionBudgetViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProductionBudgetViewModel>(null as any);
    }
}

export class ReferralClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getReferrals(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfReferralViewModel> {
        let url_ = this.baseUrl + "/api/Referral/referrals?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetReferrals(_response);
        });
    }

    protected processGetReferrals(response: AxiosResponse): Promise<QueryResultsOfReferralViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfReferralViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfReferralViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfReferralViewModel>(null as any);
    }
}

export class ReserveFundLogClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    post(model: ReserveFundLog , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/reserve-fund-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: ReserveFundLog , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/reserve-fund-log";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getList(startDate: string | undefined, endDate: string | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfReserveFundLog> {
        let url_ = this.baseUrl + "/api/reserve-fund-log?";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<QueryResultsOfReserveFundLog> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfReserveFundLog.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfReserveFundLog>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfReserveFundLog>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<ReserveFundLog> {
        let url_ = this.baseUrl + "/api/reserve-fund-log/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ReserveFundLog> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ReserveFundLog.fromJS(resultData200);
            return Promise.resolve<ReserveFundLog>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ReserveFundLog>(null as any);
    }
}

export class SafetyAuditReportClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(storeId: string | null | undefined, startDate: string | undefined, endDate: string | undefined, entryType: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfSafetyAuditRecordViewModel> {
        let url_ = this.baseUrl + "/api/safety-audit-report/query?";
        if (storeId !== undefined && storeId !== null)
            url_ += "StoreId=" + encodeURIComponent("" + storeId) + "&";
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "StartDate=" + encodeURIComponent("" + startDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (entryType !== undefined && entryType !== null)
            url_ += "EntryType=" + encodeURIComponent("" + entryType) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfSafetyAuditRecordViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfSafetyAuditRecordViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfSafetyAuditRecordViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfSafetyAuditRecordViewModel>(null as any);
    }

    post(model: SafetyAuditRecord , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/safety-audit-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: SafetyAuditRecord , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/safety-audit-report";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<SafetyAuditRecordViewModel> {
        let url_ = this.baseUrl + "/api/safety-audit-report/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<SafetyAuditRecordViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SafetyAuditRecordViewModel.fromJS(resultData200);
            return Promise.resolve<SafetyAuditRecordViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SafetyAuditRecordViewModel>(null as any);
    }

    getCategories(costCenterType: CostCenterType | undefined , cancelToken?: CancelToken | undefined): Promise<SafetyAuditAreaViewModel[]> {
        let url_ = this.baseUrl + "/api/safety-audit-report/categories?";
        if (costCenterType === null)
            throw new Error("The parameter 'costCenterType' cannot be null.");
        else if (costCenterType !== undefined)
            url_ += "costCenterType=" + encodeURIComponent("" + costCenterType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetCategories(_response);
        });
    }

    protected processGetCategories(response: AxiosResponse): Promise<SafetyAuditAreaViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(SafetyAuditAreaViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<SafetyAuditAreaViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SafetyAuditAreaViewModel[]>(null as any);
    }

    getDescriptions(type: CostCenterType | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfSafetyAuditAreaSort> {
        let url_ = this.baseUrl + "/api/safety-audit-report/descriptions?";
        if (type !== undefined && type !== null)
            url_ += "Type=" + encodeURIComponent("" + type) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDescriptions(_response);
        });
    }

    protected processGetDescriptions(response: AxiosResponse): Promise<QueryResultsOfSafetyAuditAreaSort> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfSafetyAuditAreaSort.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfSafetyAuditAreaSort>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfSafetyAuditAreaSort>(null as any);
    }
}

export class ServiceDescriptionClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(serviceType: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfServiceDescriptionViewModel> {
        let url_ = this.baseUrl + "/api/ServiceDescription/query?";
        if (serviceType !== undefined && serviceType !== null)
            url_ += "ServiceType=" + encodeURIComponent("" + serviceType) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfServiceDescriptionViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfServiceDescriptionViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfServiceDescriptionViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfServiceDescriptionViewModel>(null as any);
    }

    getServiceTypes(searchText: string | null | undefined , cancelToken?: CancelToken | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/ServiceDescription/service-types?";
        if (searchText !== undefined && searchText !== null)
            url_ += "searchText=" + encodeURIComponent("" + searchText) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetServiceTypes(_response);
        });
    }

    protected processGetServiceTypes(response: AxiosResponse): Promise<string[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<string[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string[]>(null as any);
    }
}

export class ServicePeriodClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getbyId(id: number , cancelToken?: CancelToken | undefined): Promise<ServicePeriodViewModel> {
        let url_ = this.baseUrl + "/api/service-period/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyId(_response);
        });
    }

    protected processGetbyId(response: AxiosResponse): Promise<ServicePeriodViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServicePeriodViewModel.fromJS(resultData200);
            return Promise.resolve<ServicePeriodViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServicePeriodViewModel>(null as any);
    }

    get(identityID: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfServicePeriodViewModel> {
        let url_ = this.baseUrl + "/api/service-period?";
        if (identityID === null)
            throw new Error("The parameter 'identityID' cannot be null.");
        else if (identityID !== undefined)
            url_ += "IdentityID=" + encodeURIComponent("" + identityID) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<QueryResultsOfServicePeriodViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfServicePeriodViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfServicePeriodViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfServicePeriodViewModel>(null as any);
    }

    save(model: ServicePeriodSavingModel , cancelToken?: CancelToken | undefined): Promise<ServicePeriodViewModel> {
        let url_ = this.baseUrl + "/api/service-period";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ServicePeriodViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServicePeriodViewModel.fromJS(resultData200);
            return Promise.resolve<ServicePeriodViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServicePeriodViewModel>(null as any);
    }

    getbyIdentity(identityID: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfServicePeriodViewModel2> {
        let url_ = this.baseUrl + "/api/service-period/byID?";
        if (identityID === null)
            throw new Error("The parameter 'identityID' cannot be null.");
        else if (identityID !== undefined)
            url_ += "IdentityID=" + encodeURIComponent("" + identityID) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetbyIdentity(_response);
        });
    }

    protected processGetbyIdentity(response: AxiosResponse): Promise<QueryResultsOfServicePeriodViewModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfServicePeriodViewModel2.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfServicePeriodViewModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfServicePeriodViewModel2>(null as any);
    }
}

export class ServiceProvidedClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: ServiceProvided2 , cancelToken?: CancelToken | undefined): Promise<ServiceProvidedViewModel> {
        let url_ = this.baseUrl + "/api/ServiceProvided";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<ServiceProvidedViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceProvidedViewModel.fromJS(resultData200);
            return Promise.resolve<ServiceProvidedViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceProvidedViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<ServiceProvidedViewModel> {
        let url_ = this.baseUrl + "/api/ServiceProvided/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ServiceProvidedViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ServiceProvidedViewModel.fromJS(resultData200);
            return Promise.resolve<ServiceProvidedViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ServiceProvidedViewModel>(null as any);
    }

    deleteEmploymentHistory(id: number , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/ServiceProvided/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteEmploymentHistory(_response);
        });
    }

    protected processDeleteEmploymentHistory(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }

    query(gicwId: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfServiceProvidedViewModel> {
        let url_ = this.baseUrl + "/api/ServiceProvided/query?";
        if (gicwId === null)
            throw new Error("The parameter 'gicwId' cannot be null.");
        else if (gicwId !== undefined)
            url_ += "GicwId=" + encodeURIComponent("" + gicwId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfServiceProvidedViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfServiceProvidedViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfServiceProvidedViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfServiceProvidedViewModel>(null as any);
    }
}

export class ShoplifterClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getList(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfShoplifterSummary> {
        let url_ = this.baseUrl + "/api/shoplifter?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetList(_response);
        });
    }

    protected processGetList(response: AxiosResponse): Promise<QueryResultsOfShoplifterSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfShoplifterSummary.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfShoplifterSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfShoplifterSummary>(null as any);
    }

    post(model: ShoplifterSummary , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/shoplifter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: ShoplifterSummary , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/shoplifter";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<ShoplifterSummary> {
        let url_ = this.baseUrl + "/api/shoplifter/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<ShoplifterSummary> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ShoplifterSummary.fromJS(resultData200);
            return Promise.resolve<ShoplifterSummary>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ShoplifterSummary>(null as any);
    }
}

export class ShoplifterDetailClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(gICWCaseNumber: number | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfShoplifterDetail> {
        let url_ = this.baseUrl + "/api/shoplifterDetail/query?";
        if (gICWCaseNumber === null)
            throw new Error("The parameter 'gICWCaseNumber' cannot be null.");
        else if (gICWCaseNumber !== undefined)
            url_ += "GICWCaseNumber=" + encodeURIComponent("" + gICWCaseNumber) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfShoplifterDetail> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfShoplifterDetail.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfShoplifterDetail>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfShoplifterDetail>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/shoplifterDetail/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class ShoplifterItemTakenClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/shoplifterItemTaken/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class SitesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    queryPickup(costCenterType: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfSiteViewModel> {
        let url_ = this.baseUrl + "/api/Sites/query-pickup?";
        if (costCenterType !== undefined && costCenterType !== null)
            url_ += "CostCenterType=" + encodeURIComponent("" + costCenterType) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQueryPickup(_response);
        });
    }

    protected processQueryPickup(response: AxiosResponse): Promise<QueryResultsOfSiteViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfSiteViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfSiteViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfSiteViewModel>(null as any);
    }

    query(types: string[] | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfSiteViewModel2> {
        let url_ = this.baseUrl + "/api/Sites/query?";
        if (types !== undefined && types !== null)
            types && types.forEach(item => { url_ += "Types=" + encodeURIComponent("" + item) + "&"; });
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfSiteViewModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfSiteViewModel2.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfSiteViewModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfSiteViewModel2>(null as any);
    }

    salvageQuery(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfSite> {
        let url_ = this.baseUrl + "/api/Sites/SalvageQuery?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSalvageQuery(_response);
        });
    }

    protected processSalvageQuery(response: AxiosResponse): Promise<QueryResultsOfSite> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfSite.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfSite>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfSite>(null as any);
    }

    save(model: Site2 , cancelToken?: CancelToken | undefined): Promise<SiteViewModel2> {
        let url_ = this.baseUrl + "/api/Sites";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<SiteViewModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SiteViewModel2.fromJS(resultData200);
            return Promise.resolve<SiteViewModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteViewModel2>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<SiteViewModel2> {
        let url_ = this.baseUrl + "/api/Sites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<SiteViewModel2> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SiteViewModel2.fromJS(resultData200);
            return Promise.resolve<SiteViewModel2>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SiteViewModel2>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Sites/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class StaffClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(request: Staff , cancelToken?: CancelToken | undefined): Promise<Staff> {
        let url_ = this.baseUrl + "/api/Staff";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<Staff> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Staff.fromJS(resultData200);
            return Promise.resolve<Staff>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Staff>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<Staff> {
        let url_ = this.baseUrl + "/api/Staff/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<Staff> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Staff.fromJS(resultData200);
            return Promise.resolve<Staff>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Staff>(null as any);
    }

    deleteStaff(id: number , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/Staff/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "PUT",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteStaff(_response);
        });
    }

    protected processDeleteStaff(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }

    query(isActive: BooleanEnum | null | undefined, isEmploymentSpecialist: BooleanEnum | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfStaff> {
        let url_ = this.baseUrl + "/api/Staff/query?";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (isEmploymentSpecialist !== undefined && isEmploymentSpecialist !== null)
            url_ += "IsEmploymentSpecialist=" + encodeURIComponent("" + isEmploymentSpecialist) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfStaff> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfStaff.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfStaff>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfStaff>(null as any);
    }

    getEmployeeProvidingServices(active: boolean | null | undefined, employmentSpecialist: boolean | null | undefined, lts: boolean | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfStaff> {
        let url_ = this.baseUrl + "/api/Staff/employeeProvidingServices?";
        if (active !== undefined && active !== null)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (employmentSpecialist !== undefined && employmentSpecialist !== null)
            url_ += "EmploymentSpecialist=" + encodeURIComponent("" + employmentSpecialist) + "&";
        if (lts !== undefined && lts !== null)
            url_ += "Lts=" + encodeURIComponent("" + lts) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeProvidingServices(_response);
        });
    }

    protected processGetEmployeeProvidingServices(response: AxiosResponse): Promise<QueryResultsOfStaff> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfStaff.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfStaff>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfStaff>(null as any);
    }

    getEmployeeProvidingServicesFromSproc(active: boolean | null | undefined, employmentSpecialist: boolean | null | undefined, lts: boolean | null | undefined , cancelToken?: CancelToken | undefined): Promise<FindStaffOutputViewModel[]> {
        let url_ = this.baseUrl + "/api/Staff/employeeProvidingServicesFromSproc?";
        if (active !== undefined && active !== null)
            url_ += "Active=" + encodeURIComponent("" + active) + "&";
        if (employmentSpecialist !== undefined && employmentSpecialist !== null)
            url_ += "EmploymentSpecialist=" + encodeURIComponent("" + employmentSpecialist) + "&";
        if (lts !== undefined && lts !== null)
            url_ += "Lts=" + encodeURIComponent("" + lts) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeProvidingServicesFromSproc(_response);
        });
    }

    protected processGetEmployeeProvidingServicesFromSproc(response: AxiosResponse): Promise<FindStaffOutputViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FindStaffOutputViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FindStaffOutputViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FindStaffOutputViewModel[]>(null as any);
    }
}

export class StaffGoalsClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfStaffGoalViewModel> {
        let url_ = this.baseUrl + "/api/StaffGoals?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<QueryResultsOfStaffGoalViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfStaffGoalViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfStaffGoalViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfStaffGoalViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<StaffGoalViewModel> {
        let url_ = this.baseUrl + "/api/StaffGoals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<StaffGoalViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StaffGoalViewModel.fromJS(resultData200);
            return Promise.resolve<StaffGoalViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffGoalViewModel>(null as any);
    }

    save(staffGoal: StaffGoalSavingModel, id: string , cancelToken?: CancelToken | undefined): Promise<StaffGoalViewModel> {
        let url_ = this.baseUrl + "/api/StaffGoals/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(staffGoal);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<StaffGoalViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StaffGoalViewModel.fromJS(resultData200);
            return Promise.resolve<StaffGoalViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StaffGoalViewModel>(null as any);
    }

    getEmployeeNames(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfEmployeeNameViewModel> {
        let url_ = this.baseUrl + "/api/StaffGoals/employeeNames?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetEmployeeNames(_response);
        });
    }

    protected processGetEmployeeNames(response: AxiosResponse): Promise<QueryResultsOfEmployeeNameViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfEmployeeNameViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfEmployeeNameViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfEmployeeNameViewModel>(null as any);
    }
}

export class StateClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfState> {
        let url_ = this.baseUrl + "/api/State/query?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfState> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfState.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfState>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfState>(null as any);
    }
}

export class StatusClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getStatus(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfStatus> {
        let url_ = this.baseUrl + "/api/statuses?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStatus(_response);
        });
    }

    protected processGetStatus(response: AxiosResponse): Promise<QueryResultsOfStatus> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfStatus.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfStatus>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfStatus>(null as any);
    }
}

export class StoreMessageClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getStoreMessage(id: number , cancelToken?: CancelToken | undefined): Promise<StoreMessageViewModel> {
        let url_ = this.baseUrl + "/api/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStoreMessage(_response);
        });
    }

    protected processGetStoreMessage(response: AxiosResponse): Promise<StoreMessageViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StoreMessageViewModel.fromJS(resultData200);
            return Promise.resolve<StoreMessageViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StoreMessageViewModel>(null as any);
    }

    getStoreMessages(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfStoreMessageViewModel> {
        let url_ = this.baseUrl + "/api/getStoreMessages?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStoreMessages(_response);
        });
    }

    protected processGetStoreMessages(response: AxiosResponse): Promise<QueryResultsOfStoreMessageViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfStoreMessageViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfStoreMessageViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfStoreMessageViewModel>(null as any);
    }

    updateStoreMessage(request: StoreMessageUpdatingRequest , cancelToken?: CancelToken | undefined): Promise<StoreMessageViewModel> {
        let url_ = this.baseUrl + "/api";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateStoreMessage(_response);
        });
    }

    protected processUpdateStoreMessage(response: AxiosResponse): Promise<StoreMessageViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StoreMessageViewModel.fromJS(resultData200);
            return Promise.resolve<StoreMessageViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StoreMessageViewModel>(null as any);
    }

    testQueryFromSproc(  cancelToken?: CancelToken | undefined): Promise<UspStoreMessages_ViewModel[]> {
        let url_ = this.baseUrl + "/api/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTestQueryFromSproc(_response);
        });
    }

    protected processTestQueryFromSproc(response: AxiosResponse): Promise<UspStoreMessages_ViewModel[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UspStoreMessages_ViewModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UspStoreMessages_ViewModel[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UspStoreMessages_ViewModel[]>(null as any);
    }
}

export class StoresClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    getStores(locationId: number | null | undefined, isGRERunning: boolean | null | undefined, gLNumber: number | null | undefined, storeLogins: string[] | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfStoreViewModel> {
        let url_ = this.baseUrl + "/api/stores?";
        if (locationId !== undefined && locationId !== null)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (isGRERunning !== undefined && isGRERunning !== null)
            url_ += "isGRERunning=" + encodeURIComponent("" + isGRERunning) + "&";
        if (gLNumber !== undefined && gLNumber !== null)
            url_ += "GLNumber=" + encodeURIComponent("" + gLNumber) + "&";
        if (storeLogins !== undefined && storeLogins !== null)
            storeLogins && storeLogins.forEach(item => { url_ += "storeLogins=" + encodeURIComponent("" + item) + "&"; });
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetStores(_response);
        });
    }

    protected processGetStores(response: AxiosResponse): Promise<QueryResultsOfStoreViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfStoreViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfStoreViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfStoreViewModel>(null as any);
    }

    save(model: StoreViewModel , cancelToken?: CancelToken | undefined): Promise<StoreViewModel4> {
        let url_ = this.baseUrl + "/api/stores";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<StoreViewModel4> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StoreViewModel4.fromJS(resultData200);
            return Promise.resolve<StoreViewModel4>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StoreViewModel4>(null as any);
    }

    getDonationSites(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfStoreGroupedViewModel> {
        let url_ = this.baseUrl + "/api/stores/donation-sites?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetDonationSites(_response);
        });
    }

    protected processGetDonationSites(response: AxiosResponse): Promise<QueryResultsOfStoreGroupedViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfStoreGroupedViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfStoreGroupedViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfStoreGroupedViewModel>(null as any);
    }

    getSiteList(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfSiteListViewModel> {
        let url_ = this.baseUrl + "/api/stores/salvage-site-list?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSiteList(_response);
        });
    }

    protected processGetSiteList(response: AxiosResponse): Promise<QueryResultsOfSiteListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfSiteListViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfSiteListViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfSiteListViewModel>(null as any);
    }

    getLocationList(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfSiteListViewModel> {
        let url_ = this.baseUrl + "/api/stores/salvage-location-list?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetLocationList(_response);
        });
    }

    protected processGetLocationList(response: AxiosResponse): Promise<QueryResultsOfSiteListViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfSiteListViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfSiteListViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfSiteListViewModel>(null as any);
    }

    salvageQuery(locationId: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfStore> {
        let url_ = this.baseUrl + "/api/stores/SalvageQuery?";
        if (locationId !== undefined && locationId !== null)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSalvageQuery(_response);
        });
    }

    protected processSalvageQuery(response: AxiosResponse): Promise<QueryResultsOfStore> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfStore.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfStore>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfStore>(null as any);
    }

    fixedAssetsQuery(locationId: number | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfStore> {
        let url_ = this.baseUrl + "/api/stores/FixedAssetsQuery?";
        if (locationId !== undefined && locationId !== null)
            url_ += "LocationId=" + encodeURIComponent("" + locationId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFixedAssetsQuery(_response);
        });
    }

    protected processFixedAssetsQuery(response: AxiosResponse): Promise<QueryResultsOfStore> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfStore.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfStore>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfStore>(null as any);
    }

    lossControlQuery(fromStoreId: string | null | undefined, toStoreId: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfStore> {
        let url_ = this.baseUrl + "/api/stores/LossControlQuery?";
        if (fromStoreId !== undefined && fromStoreId !== null)
            url_ += "FromStoreId=" + encodeURIComponent("" + fromStoreId) + "&";
        if (toStoreId !== undefined && toStoreId !== null)
            url_ += "ToStoreId=" + encodeURIComponent("" + toStoreId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLossControlQuery(_response);
        });
    }

    protected processLossControlQuery(response: AxiosResponse): Promise<QueryResultsOfStore> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfStore.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfStore>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfStore>(null as any);
    }

    kaizenQuery(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfStore> {
        let url_ = this.baseUrl + "/api/stores/KaizenQuery?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processKaizenQuery(_response);
        });
    }

    protected processKaizenQuery(response: AxiosResponse): Promise<QueryResultsOfStore> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfStore.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfStore>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfStore>(null as any);
    }
}

export class TargetInvoiceClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: TargetInvoice , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/target-invoice";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getTargetInvoices(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfTargetInvoice> {
        let url_ = this.baseUrl + "/api/target-invoice?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTargetInvoices(_response);
        });
    }

    protected processGetTargetInvoices(response: AxiosResponse): Promise<QueryResultsOfTargetInvoice> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfTargetInvoice.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfTargetInvoice>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfTargetInvoice>(null as any);
    }
}

export class TargetReceivedClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: TargetReceived , cancelToken?: CancelToken | undefined): Promise<TargetReceived> {
        let url_ = this.baseUrl + "/api/target-received";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<TargetReceived> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TargetReceived.fromJS(resultData200);
            return Promise.resolve<TargetReceived>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TargetReceived>(null as any);
    }

    getTargetReceipts(date: string | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfTargetReceived> {
        let url_ = this.baseUrl + "/api/target-received?";
        if (date === null)
            throw new Error("The parameter 'date' cannot be null.");
        else if (date !== undefined)
            url_ += "Date=" + encodeURIComponent("" + date) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTargetReceipts(_response);
        });
    }

    protected processGetTargetReceipts(response: AxiosResponse): Promise<QueryResultsOfTargetReceived> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfTargetReceived.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfTargetReceived>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfTargetReceived>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfTargetReceived> {
        let url_ = this.baseUrl + "/api/target-received/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<QueryResultsOfTargetReceived> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfTargetReceived.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfTargetReceived>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfTargetReceived>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfTargetReceived> {
        let url_ = this.baseUrl + "/api/target-received/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<QueryResultsOfTargetReceived> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfTargetReceived.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfTargetReceived>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfTargetReceived>(null as any);
    }
}

export class TargetRotationClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: TargetRotation , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/target-rotation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getTargetRotations(searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfTargetRotation> {
        let url_ = this.baseUrl + "/api/target-rotation?";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTargetRotations(_response);
        });
    }

    protected processGetTargetRotations(response: AxiosResponse): Promise<QueryResultsOfTargetRotation> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfTargetRotation.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfTargetRotation>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfTargetRotation>(null as any);
    }

    deleteTargetRotation(id: number, requestBody: TargetRotation , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/target-rotation/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTargetRotation(_response);
        });
    }

    protected processDeleteTargetRotation(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }
}

export class TblClassNameClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    save(model: TblClassName , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/ece-class";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getTblClassNames(isActive: boolean | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfTblClassName> {
        let url_ = this.baseUrl + "/api/ece-class?";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTblClassNames(_response);
        });
    }

    protected processGetTblClassNames(response: AxiosResponse): Promise<QueryResultsOfTblClassName> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfTblClassName.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfTblClassName>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfTblClassName>(null as any);
    }

    deleteTblClassName(id: number, requestBody: TblClassName , cancelToken?: CancelToken | undefined): Promise<Result> {
        let url_ = this.baseUrl + "/api/ece-class/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(requestBody);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTblClassName(_response);
        });
    }

    protected processDeleteTblClassName(response: AxiosResponse): Promise<Result> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Result.fromJS(resultData200);
            return Promise.resolve<Result>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Result>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<TblClassName> {
        let url_ = this.baseUrl + "/api/ece-class/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<TblClassName> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TblClassName.fromJS(resultData200);
            return Promise.resolve<TblClassName>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TblClassName>(null as any);
    }
}

export class TeacherClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    query(isActive: boolean | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfTeacher> {
        let url_ = this.baseUrl + "/api/Teacher/query?";
        if (isActive !== undefined && isActive !== null)
            url_ += "IsActive=" + encodeURIComponent("" + isActive) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processQuery(_response);
        });
    }

    protected processQuery(response: AxiosResponse): Promise<QueryResultsOfTeacher> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfTeacher.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfTeacher>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfTeacher>(null as any);
    }

    post(model: Teacher , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Teacher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPost(_response);
        });
    }

    protected processPost(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    put(model: Teacher , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/Teacher";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPut(_response);
        });
    }

    protected processPut(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<Teacher> {
        let url_ = this.baseUrl + "/api/Teacher/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<Teacher> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = Teacher.fromJS(resultData200);
            return Promise.resolve<Teacher>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<Teacher>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<void> {
        let url_ = this.baseUrl + "/api/Teacher/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class TraineesClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(traineeId: string | null | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfTraineeNameViewModel> {
        let url_ = this.baseUrl + "/api/Trainees?";
        if (traineeId !== undefined && traineeId !== null)
            url_ += "TraineeId=" + encodeURIComponent("" + traineeId) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<QueryResultsOfTraineeNameViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfTraineeNameViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfTraineeNameViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfTraineeNameViewModel>(null as any);
    }
}

export class TrainingSummaryClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    get(fromDate: string | undefined, endDate: string | undefined, searchText: string | null | undefined, sortCriteria: SortCriterion[] | null | undefined, pageSize: number | undefined, pageNumber: number | undefined , cancelToken?: CancelToken | undefined): Promise<QueryResultsOfTrainingSummaryViewModel> {
        let url_ = this.baseUrl + "/api/training-summary?";
        if (fromDate === null)
            throw new Error("The parameter 'fromDate' cannot be null.");
        else if (fromDate !== undefined)
            url_ += "FromDate=" + encodeURIComponent("" + fromDate) + "&";
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "EndDate=" + encodeURIComponent("" + endDate) + "&";
        if (searchText !== undefined && searchText !== null)
            url_ += "SearchText=" + encodeURIComponent("" + searchText) + "&";
        if (sortCriteria !== undefined && sortCriteria !== null)
            sortCriteria && sortCriteria.forEach((item, index) => {
                for (let attr in item)
        			if (item.hasOwnProperty(attr)) {
        				url_ += "SortCriteria[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
        			}
            });
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<QueryResultsOfTrainingSummaryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = QueryResultsOfTrainingSummaryViewModel.fromJS(resultData200);
            return Promise.resolve<QueryResultsOfTrainingSummaryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<QueryResultsOfTrainingSummaryViewModel>(null as any);
    }

    save(model: TrainingSummarySavingModel , cancelToken?: CancelToken | undefined): Promise<TrainingSummaryViewModel> {
        let url_ = this.baseUrl + "/api/training-summary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSave(_response);
        });
    }

    protected processSave(response: AxiosResponse): Promise<TrainingSummaryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrainingSummaryViewModel.fromJS(resultData200);
            return Promise.resolve<TrainingSummaryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingSummaryViewModel>(null as any);
    }

    getById(id: number , cancelToken?: CancelToken | undefined): Promise<TrainingSummaryViewModel> {
        let url_ = this.baseUrl + "/api/training-summary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<TrainingSummaryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrainingSummaryViewModel.fromJS(resultData200);
            return Promise.resolve<TrainingSummaryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingSummaryViewModel>(null as any);
    }

    update(model: TrainingSummarySavingModel, id: number , cancelToken?: CancelToken | undefined): Promise<TrainingSummaryViewModel> {
        let url_ = this.baseUrl + "/api/training-summary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<TrainingSummaryViewModel> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = TrainingSummaryViewModel.fromJS(resultData200);
            return Promise.resolve<TrainingSummaryViewModel>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TrainingSummaryViewModel>(null as any);
    }

    delete(id: number , cancelToken?: CancelToken | undefined): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/training-summary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export class TransferRequestClient {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";

    }

    create(model: TransferRequestSavingModel , cancelToken?: CancelToken | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/transfer-request";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreate(_response);
        });
    }

    protected processCreate(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }
}

export class AccidentAnalysisViewModel implements IAccidentAnalysisViewModel {
    id!: number;
    accidentType?: string | undefined;
    entryDate!: string;
    witness1?: string | undefined;
    witness2?: string | undefined;
    accidentDate!: string;
    dateReported!: string;
    costCenter?: string | undefined;
    location?: string | undefined;
    equipment?: string | undefined;
    eventsPrior?: string | undefined;
    event?: string | undefined;
    eventsAfter?: string | undefined;
    surfaceCause?: string | undefined;
    rootCause?: string | undefined;
    correctiveAction?: string | undefined;
    fullSystemRecommendation?: string | undefined;
    correctiveActionTaken1?: string | undefined;
    responsibleIndividual1?: string | undefined;
    dateClosed1?: string | undefined;
    correctiveActionTaken2?: string | undefined;
    responsibleIndividual2?: string | undefined;
    dateClosed2?: string | undefined;
    analysisConductedBy?: string | undefined;
    reviewedByManager?: string | undefined;
    dateReviewedByManager?: string | undefined;
    reviewedByHR?: string | undefined;
    dateReviewedByHR?: string | undefined;
    dateReviewedBySafetyCommittee?: string | undefined;
    attachments?: AccidentAttachmentViewModel[] | undefined;

    constructor(data?: IAccidentAnalysisViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accidentType = _data["accidentType"];
            this.entryDate = _data["entryDate"];
            this.witness1 = _data["witness1"];
            this.witness2 = _data["witness2"];
            this.accidentDate = _data["accidentDate"];
            this.dateReported = _data["dateReported"];
            this.costCenter = _data["costCenter"];
            this.location = _data["location"];
            this.equipment = _data["equipment"];
            this.eventsPrior = _data["eventsPrior"];
            this.event = _data["event"];
            this.eventsAfter = _data["eventsAfter"];
            this.surfaceCause = _data["surfaceCause"];
            this.rootCause = _data["rootCause"];
            this.correctiveAction = _data["correctiveAction"];
            this.fullSystemRecommendation = _data["fullSystemRecommendation"];
            this.correctiveActionTaken1 = _data["correctiveActionTaken1"];
            this.responsibleIndividual1 = _data["responsibleIndividual1"];
            this.dateClosed1 = _data["dateClosed1"];
            this.correctiveActionTaken2 = _data["correctiveActionTaken2"];
            this.responsibleIndividual2 = _data["responsibleIndividual2"];
            this.dateClosed2 = _data["dateClosed2"];
            this.analysisConductedBy = _data["analysisConductedBy"];
            this.reviewedByManager = _data["reviewedByManager"];
            this.dateReviewedByManager = _data["dateReviewedByManager"];
            this.reviewedByHR = _data["reviewedByHR"];
            this.dateReviewedByHR = _data["dateReviewedByHR"];
            this.dateReviewedBySafetyCommittee = _data["dateReviewedBySafetyCommittee"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AccidentAttachmentViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccidentAnalysisViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccidentAnalysisViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accidentType"] = this.accidentType;
        data["entryDate"] = this.entryDate;
        data["witness1"] = this.witness1;
        data["witness2"] = this.witness2;
        data["accidentDate"] = this.accidentDate;
        data["dateReported"] = this.dateReported;
        data["costCenter"] = this.costCenter;
        data["location"] = this.location;
        data["equipment"] = this.equipment;
        data["eventsPrior"] = this.eventsPrior;
        data["event"] = this.event;
        data["eventsAfter"] = this.eventsAfter;
        data["surfaceCause"] = this.surfaceCause;
        data["rootCause"] = this.rootCause;
        data["correctiveAction"] = this.correctiveAction;
        data["fullSystemRecommendation"] = this.fullSystemRecommendation;
        data["correctiveActionTaken1"] = this.correctiveActionTaken1;
        data["responsibleIndividual1"] = this.responsibleIndividual1;
        data["dateClosed1"] = this.dateClosed1;
        data["correctiveActionTaken2"] = this.correctiveActionTaken2;
        data["responsibleIndividual2"] = this.responsibleIndividual2;
        data["dateClosed2"] = this.dateClosed2;
        data["analysisConductedBy"] = this.analysisConductedBy;
        data["reviewedByManager"] = this.reviewedByManager;
        data["dateReviewedByManager"] = this.dateReviewedByManager;
        data["reviewedByHR"] = this.reviewedByHR;
        data["dateReviewedByHR"] = this.dateReviewedByHR;
        data["dateReviewedBySafetyCommittee"] = this.dateReviewedBySafetyCommittee;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccidentAnalysisViewModel {
    id: number;
    accidentType?: string | undefined;
    entryDate: string;
    witness1?: string | undefined;
    witness2?: string | undefined;
    accidentDate: string;
    dateReported: string;
    costCenter?: string | undefined;
    location?: string | undefined;
    equipment?: string | undefined;
    eventsPrior?: string | undefined;
    event?: string | undefined;
    eventsAfter?: string | undefined;
    surfaceCause?: string | undefined;
    rootCause?: string | undefined;
    correctiveAction?: string | undefined;
    fullSystemRecommendation?: string | undefined;
    correctiveActionTaken1?: string | undefined;
    responsibleIndividual1?: string | undefined;
    dateClosed1?: string | undefined;
    correctiveActionTaken2?: string | undefined;
    responsibleIndividual2?: string | undefined;
    dateClosed2?: string | undefined;
    analysisConductedBy?: string | undefined;
    reviewedByManager?: string | undefined;
    dateReviewedByManager?: string | undefined;
    reviewedByHR?: string | undefined;
    dateReviewedByHR?: string | undefined;
    dateReviewedBySafetyCommittee?: string | undefined;
    attachments?: AccidentAttachmentViewModel[] | undefined;
}

export class AccidentAttachmentViewModel implements IAccidentAttachmentViewModel {
    id!: number;
    accidentAnalysisId!: number;
    name?: string | undefined;
    picture?: string | undefined;

    constructor(data?: IAccidentAttachmentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accidentAnalysisId = _data["accidentAnalysisId"];
            this.name = _data["name"];
            this.picture = _data["picture"];
        }
    }

    static fromJS(data: any): AccidentAttachmentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccidentAttachmentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accidentAnalysisId"] = this.accidentAnalysisId;
        data["name"] = this.name;
        data["picture"] = this.picture;
        return data;
    }
}

export interface IAccidentAttachmentViewModel {
    id: number;
    accidentAnalysisId: number;
    name?: string | undefined;
    picture?: string | undefined;
}

export class AccidentAnalysis implements IAccidentAnalysis {
    id!: number;
    accidentType?: string | undefined;
    entryDate!: string;
    witness1?: string | undefined;
    witness2?: string | undefined;
    accidentDate!: string;
    dateReported!: string;
    costCenter?: string | undefined;
    location?: string | undefined;
    equipment?: string | undefined;
    eventsPrior?: string | undefined;
    event?: string | undefined;
    eventsAfter?: string | undefined;
    surfaceCause?: string | undefined;
    rootCause?: string | undefined;
    correctiveAction?: string | undefined;
    fullSystemRecommendation?: string | undefined;
    correctiveActionTaken1?: string | undefined;
    responsibleIndividual1?: string | undefined;
    dateClosed1?: string | undefined;
    correctiveActionTaken2?: string | undefined;
    responsibleIndividual2?: string | undefined;
    dateClosed2?: string | undefined;
    analysisConductedBy?: string | undefined;
    reviewedByManager?: string | undefined;
    dateReviewedByManager?: string | undefined;
    reviewedByHR?: string | undefined;
    dateReviewedByHR?: string | undefined;
    dateReviewedBySafetyCommittee?: string | undefined;
    attachments?: AccidentAttachment[] | undefined;

    constructor(data?: IAccidentAnalysis) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accidentType = _data["accidentType"];
            this.entryDate = _data["entryDate"];
            this.witness1 = _data["witness1"];
            this.witness2 = _data["witness2"];
            this.accidentDate = _data["accidentDate"];
            this.dateReported = _data["dateReported"];
            this.costCenter = _data["costCenter"];
            this.location = _data["location"];
            this.equipment = _data["equipment"];
            this.eventsPrior = _data["eventsPrior"];
            this.event = _data["event"];
            this.eventsAfter = _data["eventsAfter"];
            this.surfaceCause = _data["surfaceCause"];
            this.rootCause = _data["rootCause"];
            this.correctiveAction = _data["correctiveAction"];
            this.fullSystemRecommendation = _data["fullSystemRecommendation"];
            this.correctiveActionTaken1 = _data["correctiveActionTaken1"];
            this.responsibleIndividual1 = _data["responsibleIndividual1"];
            this.dateClosed1 = _data["dateClosed1"];
            this.correctiveActionTaken2 = _data["correctiveActionTaken2"];
            this.responsibleIndividual2 = _data["responsibleIndividual2"];
            this.dateClosed2 = _data["dateClosed2"];
            this.analysisConductedBy = _data["analysisConductedBy"];
            this.reviewedByManager = _data["reviewedByManager"];
            this.dateReviewedByManager = _data["dateReviewedByManager"];
            this.reviewedByHR = _data["reviewedByHR"];
            this.dateReviewedByHR = _data["dateReviewedByHR"];
            this.dateReviewedBySafetyCommittee = _data["dateReviewedBySafetyCommittee"];
            if (Array.isArray(_data["attachments"])) {
                this.attachments = [] as any;
                for (let item of _data["attachments"])
                    this.attachments!.push(AccidentAttachment.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AccidentAnalysis {
        data = typeof data === 'object' ? data : {};
        let result = new AccidentAnalysis();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accidentType"] = this.accidentType;
        data["entryDate"] = this.entryDate;
        data["witness1"] = this.witness1;
        data["witness2"] = this.witness2;
        data["accidentDate"] = this.accidentDate;
        data["dateReported"] = this.dateReported;
        data["costCenter"] = this.costCenter;
        data["location"] = this.location;
        data["equipment"] = this.equipment;
        data["eventsPrior"] = this.eventsPrior;
        data["event"] = this.event;
        data["eventsAfter"] = this.eventsAfter;
        data["surfaceCause"] = this.surfaceCause;
        data["rootCause"] = this.rootCause;
        data["correctiveAction"] = this.correctiveAction;
        data["fullSystemRecommendation"] = this.fullSystemRecommendation;
        data["correctiveActionTaken1"] = this.correctiveActionTaken1;
        data["responsibleIndividual1"] = this.responsibleIndividual1;
        data["dateClosed1"] = this.dateClosed1;
        data["correctiveActionTaken2"] = this.correctiveActionTaken2;
        data["responsibleIndividual2"] = this.responsibleIndividual2;
        data["dateClosed2"] = this.dateClosed2;
        data["analysisConductedBy"] = this.analysisConductedBy;
        data["reviewedByManager"] = this.reviewedByManager;
        data["dateReviewedByManager"] = this.dateReviewedByManager;
        data["reviewedByHR"] = this.reviewedByHR;
        data["dateReviewedByHR"] = this.dateReviewedByHR;
        data["dateReviewedBySafetyCommittee"] = this.dateReviewedBySafetyCommittee;
        if (Array.isArray(this.attachments)) {
            data["attachments"] = [];
            for (let item of this.attachments)
                data["attachments"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAccidentAnalysis {
    id: number;
    accidentType?: string | undefined;
    entryDate: string;
    witness1?: string | undefined;
    witness2?: string | undefined;
    accidentDate: string;
    dateReported: string;
    costCenter?: string | undefined;
    location?: string | undefined;
    equipment?: string | undefined;
    eventsPrior?: string | undefined;
    event?: string | undefined;
    eventsAfter?: string | undefined;
    surfaceCause?: string | undefined;
    rootCause?: string | undefined;
    correctiveAction?: string | undefined;
    fullSystemRecommendation?: string | undefined;
    correctiveActionTaken1?: string | undefined;
    responsibleIndividual1?: string | undefined;
    dateClosed1?: string | undefined;
    correctiveActionTaken2?: string | undefined;
    responsibleIndividual2?: string | undefined;
    dateClosed2?: string | undefined;
    analysisConductedBy?: string | undefined;
    reviewedByManager?: string | undefined;
    dateReviewedByManager?: string | undefined;
    reviewedByHR?: string | undefined;
    dateReviewedByHR?: string | undefined;
    dateReviewedBySafetyCommittee?: string | undefined;
    attachments?: AccidentAttachment[] | undefined;
}

export class AccidentAttachment implements IAccidentAttachment {
    id!: number;
    accidentAnalysisId!: number;
    name?: string | undefined;
    picture?: string | undefined;

    constructor(data?: IAccidentAttachment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.accidentAnalysisId = _data["accidentAnalysisId"];
            this.name = _data["name"];
            this.picture = _data["picture"];
        }
    }

    static fromJS(data: any): AccidentAttachment {
        data = typeof data === 'object' ? data : {};
        let result = new AccidentAttachment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["accidentAnalysisId"] = this.accidentAnalysisId;
        data["name"] = this.name;
        data["picture"] = this.picture;
        return data;
    }
}

export interface IAccidentAttachment {
    id: number;
    accidentAnalysisId: number;
    name?: string | undefined;
    picture?: string | undefined;
}

export class QueryResultsOfAccidentAnalysisViewModel implements IQueryResultsOfAccidentAnalysisViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: AccidentAnalysisViewModel[] | undefined;

    constructor(data?: IQueryResultsOfAccidentAnalysisViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AccidentAnalysisViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfAccidentAnalysisViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfAccidentAnalysisViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfAccidentAnalysisViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: AccidentAnalysisViewModel[] | undefined;
}

export class SortCriterion implements ISortCriterion {
    sortKey?: string | undefined;
    isDescending!: boolean;

    constructor(data?: ISortCriterion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortKey = _data["sortKey"];
            this.isDescending = _data["isDescending"];
        }
    }

    static fromJS(data: any): SortCriterion {
        data = typeof data === 'object' ? data : {};
        let result = new SortCriterion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortKey"] = this.sortKey;
        data["isDescending"] = this.isDescending;
        return data;
    }
}

export interface ISortCriterion {
    sortKey?: string | undefined;
    isDescending: boolean;
}

export class QueryResultsOfActivityLogCategoryViewModel implements IQueryResultsOfActivityLogCategoryViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ActivityLogCategoryViewModel[] | undefined;

    constructor(data?: IQueryResultsOfActivityLogCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ActivityLogCategoryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfActivityLogCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfActivityLogCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfActivityLogCategoryViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ActivityLogCategoryViewModel[] | undefined;
}

export class ActivityLogCategoryViewModel implements IActivityLogCategoryViewModel {
    id!: number;
    category?: string | undefined;

    constructor(data?: IActivityLogCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): ActivityLogCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        return data;
    }
}

export interface IActivityLogCategoryViewModel {
    id: number;
    category?: string | undefined;
}

export class Query implements IQuery {
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize!: number;
    pageNumber!: number;

    constructor(data?: IQuery) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchText = _data["searchText"];
            if (Array.isArray(_data["sortCriteria"])) {
                this.sortCriteria = [] as any;
                for (let item of _data["sortCriteria"])
                    this.sortCriteria!.push(SortCriterion.fromJS(item));
            }
            this.pageSize = _data["pageSize"];
            this.pageNumber = _data["pageNumber"];
        }
    }

    static fromJS(data: any): Query {
        data = typeof data === 'object' ? data : {};
        let result = new Query();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchText"] = this.searchText;
        if (Array.isArray(this.sortCriteria)) {
            data["sortCriteria"] = [];
            for (let item of this.sortCriteria)
                data["sortCriteria"].push(item.toJSON());
        }
        data["pageSize"] = this.pageSize;
        data["pageNumber"] = this.pageNumber;
        return data;
    }
}

export interface IQuery {
    searchText?: string | undefined;
    sortCriteria?: SortCriterion[] | undefined;
    pageSize: number;
    pageNumber: number;
}

export class ActivityLogCategoryQuery extends Query implements IActivityLogCategoryQuery {
    id?: number | undefined;
    active?: boolean | undefined;

    constructor(data?: IActivityLogCategoryQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ActivityLogCategoryQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogCategoryQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["active"] = this.active;
        super.toJSON(data);
        return data;
    }
}

export interface IActivityLogCategoryQuery extends IQuery {
    id?: number | undefined;
    active?: boolean | undefined;
}

export class ActivityLog implements IActivityLog {
    id!: number;
    employeeNumber?: string | undefined;
    dateOfEvent!: string;
    category!: number;
    narrative?: string | undefined;
    dateOfEntry!: string;
    enteredBy?: string | undefined;
    activityLogCategory?: ActivityLogCategory | undefined;

    constructor(data?: IActivityLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeNumber = _data["employeeNumber"];
            this.dateOfEvent = _data["dateOfEvent"];
            this.category = _data["category"];
            this.narrative = _data["narrative"];
            this.dateOfEntry = _data["dateOfEntry"];
            this.enteredBy = _data["enteredBy"];
            this.activityLogCategory = _data["activityLogCategory"] ? ActivityLogCategory.fromJS(_data["activityLogCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ActivityLog {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeNumber"] = this.employeeNumber;
        data["dateOfEvent"] = this.dateOfEvent;
        data["category"] = this.category;
        data["narrative"] = this.narrative;
        data["dateOfEntry"] = this.dateOfEntry;
        data["enteredBy"] = this.enteredBy;
        data["activityLogCategory"] = this.activityLogCategory ? this.activityLogCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface IActivityLog {
    id: number;
    employeeNumber?: string | undefined;
    dateOfEvent: string;
    category: number;
    narrative?: string | undefined;
    dateOfEntry: string;
    enteredBy?: string | undefined;
    activityLogCategory?: ActivityLogCategory | undefined;
}

export class ActivityLogCategory implements IActivityLogCategory {
    id!: number;
    category?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: IActivityLogCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ActivityLogCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ActivityLogCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["active"] = this.active;
        return data;
    }
}

export interface IActivityLogCategory {
    id: number;
    category?: string | undefined;
    active?: boolean | undefined;
}

export class AppInfo implements IAppInfo {
    companyName?: string | undefined;
    copyrightYear!: number;
    informationalVersion?: string | undefined;
    productName?: string | undefined;
    versionNumber?: string | undefined;
    versionNumberWithBuildNumber?: string | undefined;

    constructor(data?: IAppInfo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.companyName = _data["companyName"];
            this.copyrightYear = _data["copyrightYear"];
            this.informationalVersion = _data["informationalVersion"];
            this.productName = _data["productName"];
            this.versionNumber = _data["versionNumber"];
            this.versionNumberWithBuildNumber = _data["versionNumberWithBuildNumber"];
        }
    }

    static fromJS(data: any): AppInfo {
        data = typeof data === 'object' ? data : {};
        let result = new AppInfo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["companyName"] = this.companyName;
        data["copyrightYear"] = this.copyrightYear;
        data["informationalVersion"] = this.informationalVersion;
        data["productName"] = this.productName;
        data["versionNumber"] = this.versionNumber;
        data["versionNumberWithBuildNumber"] = this.versionNumberWithBuildNumber;
        return data;
    }
}

export interface IAppInfo {
    companyName?: string | undefined;
    copyrightYear: number;
    informationalVersion?: string | undefined;
    productName?: string | undefined;
    versionNumber?: string | undefined;
    versionNumberWithBuildNumber?: string | undefined;
}

export class ApplicationEEODataSheetViewModel implements IApplicationEEODataSheetViewModel {
    applicationDate!: string;
    positionAppliedFor?: string | undefined;
    gender?: string | undefined;
    ethnicCode!: number;
    referralSource!: number;
    applicationEthnicCode?: ApplicationEthnicCodeViewModel | undefined;
    applicationReferralSource?: ApplicationReferralSourceViewModel | undefined;

    constructor(data?: IApplicationEEODataSheetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationDate = _data["applicationDate"];
            this.positionAppliedFor = _data["positionAppliedFor"];
            this.gender = _data["gender"];
            this.ethnicCode = _data["ethnicCode"];
            this.referralSource = _data["referralSource"];
            this.applicationEthnicCode = _data["applicationEthnicCode"] ? ApplicationEthnicCodeViewModel.fromJS(_data["applicationEthnicCode"]) : <any>undefined;
            this.applicationReferralSource = _data["applicationReferralSource"] ? ApplicationReferralSourceViewModel.fromJS(_data["applicationReferralSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationEEODataSheetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationEEODataSheetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationDate"] = this.applicationDate;
        data["positionAppliedFor"] = this.positionAppliedFor;
        data["gender"] = this.gender;
        data["ethnicCode"] = this.ethnicCode;
        data["referralSource"] = this.referralSource;
        data["applicationEthnicCode"] = this.applicationEthnicCode ? this.applicationEthnicCode.toJSON() : <any>undefined;
        data["applicationReferralSource"] = this.applicationReferralSource ? this.applicationReferralSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApplicationEEODataSheetViewModel {
    applicationDate: string;
    positionAppliedFor?: string | undefined;
    gender?: string | undefined;
    ethnicCode: number;
    referralSource: number;
    applicationEthnicCode?: ApplicationEthnicCodeViewModel | undefined;
    applicationReferralSource?: ApplicationReferralSourceViewModel | undefined;
}

export class ApplicationEthnicCodeViewModel implements IApplicationEthnicCodeViewModel {
    id!: number;
    code?: string | undefined;

    constructor(data?: IApplicationEthnicCodeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.code = _data["code"];
        }
    }

    static fromJS(data: any): ApplicationEthnicCodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationEthnicCodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["code"] = this.code;
        return data;
    }
}

export interface IApplicationEthnicCodeViewModel {
    id: number;
    code?: string | undefined;
}

export class ApplicationReferralSourceViewModel implements IApplicationReferralSourceViewModel {
    id!: number;
    referralSource?: string | undefined;

    constructor(data?: IApplicationReferralSourceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referralSource = _data["referralSource"];
        }
    }

    static fromJS(data: any): ApplicationReferralSourceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationReferralSourceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referralSource"] = this.referralSource;
        return data;
    }
}

export interface IApplicationReferralSourceViewModel {
    id: number;
    referralSource?: string | undefined;
}

export class ApplicationEEODataSheet implements IApplicationEEODataSheet {
    id!: number;
    applicationDate!: string;
    positionAppliedFor?: string | undefined;
    gender?: string | undefined;
    ethnicCode!: number;
    referralSource!: number;
    applicationEthnicCode?: ApplicationEthnicCode | undefined;
    applicationReferralSource?: ApplicationReferralSource | undefined;

    constructor(data?: IApplicationEEODataSheet) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicationDate = _data["applicationDate"];
            this.positionAppliedFor = _data["positionAppliedFor"];
            this.gender = _data["gender"];
            this.ethnicCode = _data["ethnicCode"];
            this.referralSource = _data["referralSource"];
            this.applicationEthnicCode = _data["applicationEthnicCode"] ? ApplicationEthnicCode.fromJS(_data["applicationEthnicCode"]) : <any>undefined;
            this.applicationReferralSource = _data["applicationReferralSource"] ? ApplicationReferralSource.fromJS(_data["applicationReferralSource"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ApplicationEEODataSheet {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationEEODataSheet();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicationDate"] = this.applicationDate;
        data["positionAppliedFor"] = this.positionAppliedFor;
        data["gender"] = this.gender;
        data["ethnicCode"] = this.ethnicCode;
        data["referralSource"] = this.referralSource;
        data["applicationEthnicCode"] = this.applicationEthnicCode ? this.applicationEthnicCode.toJSON() : <any>undefined;
        data["applicationReferralSource"] = this.applicationReferralSource ? this.applicationReferralSource.toJSON() : <any>undefined;
        return data;
    }
}

export interface IApplicationEEODataSheet {
    id: number;
    applicationDate: string;
    positionAppliedFor?: string | undefined;
    gender?: string | undefined;
    ethnicCode: number;
    referralSource: number;
    applicationEthnicCode?: ApplicationEthnicCode | undefined;
    applicationReferralSource?: ApplicationReferralSource | undefined;
}

export class ApplicationEthnicCode implements IApplicationEthnicCode {
    id!: number;

    constructor(data?: IApplicationEthnicCode) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationEthnicCode {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationEthnicCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationEthnicCode {
    id: number;
}

export class ApplicationReferralSource implements IApplicationReferralSource {
    id!: number;

    constructor(data?: IApplicationReferralSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationReferralSource {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationReferralSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationReferralSource {
    id: number;
}

export class QueryResultsOfApplicationEthnicCodeViewModel implements IQueryResultsOfApplicationEthnicCodeViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ApplicationEthnicCodeViewModel[] | undefined;

    constructor(data?: IQueryResultsOfApplicationEthnicCodeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ApplicationEthnicCodeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfApplicationEthnicCodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfApplicationEthnicCodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfApplicationEthnicCodeViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ApplicationEthnicCodeViewModel[] | undefined;
}

export class ApplicationEthnicCodeQuery extends Query implements IApplicationEthnicCodeQuery {

    constructor(data?: IApplicationEthnicCodeQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApplicationEthnicCodeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationEthnicCodeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationEthnicCodeQuery extends IQuery {
}

export class QueryResultsOfApplicationFlowLogViewModel implements IQueryResultsOfApplicationFlowLogViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ApplicationFlowLogViewModel[] | undefined;

    constructor(data?: IQueryResultsOfApplicationFlowLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ApplicationFlowLogViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfApplicationFlowLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfApplicationFlowLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfApplicationFlowLogViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ApplicationFlowLogViewModel[] | undefined;
}

export class ApplicationFlowLogViewModel implements IApplicationFlowLogViewModel {
    id!: number;
    applicantName?: string | undefined;
    jobAppliedFor!: number;
    referredBy?: string | undefined;
    enteredBy!: string;
    enteredDate!: string;
    locationEnteredAtID!: number;
    applicationJobList?: ApplicationJobListViewModel | undefined;
    applicationFlowLogRouteTo?: ApplicationFlowLogRouteToViewModel | undefined;
    applicationFlowLogDetails?: ApplicationFlowLogDetailViewModel[] | undefined;

    constructor(data?: IApplicationFlowLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicantName = _data["applicantName"];
            this.jobAppliedFor = _data["jobAppliedFor"];
            this.referredBy = _data["referredBy"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.locationEnteredAtID = _data["locationEnteredAtID"];
            this.applicationJobList = _data["applicationJobList"] ? ApplicationJobListViewModel.fromJS(_data["applicationJobList"]) : <any>undefined;
            this.applicationFlowLogRouteTo = _data["applicationFlowLogRouteTo"] ? ApplicationFlowLogRouteToViewModel.fromJS(_data["applicationFlowLogRouteTo"]) : <any>undefined;
            if (Array.isArray(_data["applicationFlowLogDetails"])) {
                this.applicationFlowLogDetails = [] as any;
                for (let item of _data["applicationFlowLogDetails"])
                    this.applicationFlowLogDetails!.push(ApplicationFlowLogDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationFlowLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationFlowLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicantName"] = this.applicantName;
        data["jobAppliedFor"] = this.jobAppliedFor;
        data["referredBy"] = this.referredBy;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["locationEnteredAtID"] = this.locationEnteredAtID;
        data["applicationJobList"] = this.applicationJobList ? this.applicationJobList.toJSON() : <any>undefined;
        data["applicationFlowLogRouteTo"] = this.applicationFlowLogRouteTo ? this.applicationFlowLogRouteTo.toJSON() : <any>undefined;
        if (Array.isArray(this.applicationFlowLogDetails)) {
            data["applicationFlowLogDetails"] = [];
            for (let item of this.applicationFlowLogDetails)
                data["applicationFlowLogDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApplicationFlowLogViewModel {
    id: number;
    applicantName?: string | undefined;
    jobAppliedFor: number;
    referredBy?: string | undefined;
    enteredBy: string;
    enteredDate: string;
    locationEnteredAtID: number;
    applicationJobList?: ApplicationJobListViewModel | undefined;
    applicationFlowLogRouteTo?: ApplicationFlowLogRouteToViewModel | undefined;
    applicationFlowLogDetails?: ApplicationFlowLogDetailViewModel[] | undefined;
}

export class ApplicationJobListViewModel implements IApplicationJobListViewModel {
    id!: number;
    jobTitle?: string | undefined;
    eeoNumber!: number;
    email?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: IApplicationJobListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jobTitle = _data["jobTitle"];
            this.eeoNumber = _data["eeoNumber"];
            this.email = _data["email"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ApplicationJobListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationJobListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jobTitle"] = this.jobTitle;
        data["eeoNumber"] = this.eeoNumber;
        data["email"] = this.email;
        data["active"] = this.active;
        return data;
    }
}

export interface IApplicationJobListViewModel {
    id: number;
    jobTitle?: string | undefined;
    eeoNumber: number;
    email?: string | undefined;
    active?: boolean | undefined;
}

export class ApplicationFlowLogRouteToViewModel implements IApplicationFlowLogRouteToViewModel {
    id!: number;
    locationName?: string | undefined;

    constructor(data?: IApplicationFlowLogRouteToViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): ApplicationFlowLogRouteToViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationFlowLogRouteToViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IApplicationFlowLogRouteToViewModel {
    id: number;
    locationName?: string | undefined;
}

export class ApplicationFlowLogDetailViewModel implements IApplicationFlowLogDetailViewModel {
    id!: number;
    idafl!: number;
    routeToID!: number;
    routeTo?: ApplicationFlowLogRouteTo | undefined;
    dateRouted!: string;
    interviewed?: string | undefined;
    dateInterviewed?: string | undefined;
    contingentOffer?: string | undefined;

    constructor(data?: IApplicationFlowLogDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idafl = _data["idafl"];
            this.routeToID = _data["routeToID"];
            this.routeTo = _data["routeTo"] ? ApplicationFlowLogRouteTo.fromJS(_data["routeTo"]) : <any>undefined;
            this.dateRouted = _data["dateRouted"];
            this.interviewed = _data["interviewed"];
            this.dateInterviewed = _data["dateInterviewed"];
            this.contingentOffer = _data["contingentOffer"];
        }
    }

    static fromJS(data: any): ApplicationFlowLogDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationFlowLogDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idafl"] = this.idafl;
        data["routeToID"] = this.routeToID;
        data["routeTo"] = this.routeTo ? this.routeTo.toJSON() : <any>undefined;
        data["dateRouted"] = this.dateRouted;
        data["interviewed"] = this.interviewed;
        data["dateInterviewed"] = this.dateInterviewed;
        data["contingentOffer"] = this.contingentOffer;
        return data;
    }
}

export interface IApplicationFlowLogDetailViewModel {
    id: number;
    idafl: number;
    routeToID: number;
    routeTo?: ApplicationFlowLogRouteTo | undefined;
    dateRouted: string;
    interviewed?: string | undefined;
    dateInterviewed?: string | undefined;
    contingentOffer?: string | undefined;
}

export class ApplicationFlowLogRouteTo implements IApplicationFlowLogRouteTo {
    id!: number;
    locationName?: string | undefined;

    constructor(data?: IApplicationFlowLogRouteTo) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationName = _data["locationName"];
        }
    }

    static fromJS(data: any): ApplicationFlowLogRouteTo {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationFlowLogRouteTo();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationName"] = this.locationName;
        return data;
    }
}

export interface IApplicationFlowLogRouteTo {
    id: number;
    locationName?: string | undefined;
}

export class ApplicationFlowLog implements IApplicationFlowLog {
    id!: number;
    applicantName?: string | undefined;
    jobAppliedFor!: number;
    referredBy?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;
    locationEnteredAtID!: number;
    applicationJobList?: ApplicationJobList | undefined;
    applicationFlowLogRouteTo?: ApplicationFlowLogRouteTo2 | undefined;
    applicationFlowLogDetails?: ApplicationFlowLogDetail[] | undefined;

    constructor(data?: IApplicationFlowLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.applicantName = _data["applicantName"];
            this.jobAppliedFor = _data["jobAppliedFor"];
            this.referredBy = _data["referredBy"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.locationEnteredAtID = _data["locationEnteredAtID"];
            this.applicationJobList = _data["applicationJobList"] ? ApplicationJobList.fromJS(_data["applicationJobList"]) : <any>undefined;
            this.applicationFlowLogRouteTo = _data["applicationFlowLogRouteTo"] ? ApplicationFlowLogRouteTo2.fromJS(_data["applicationFlowLogRouteTo"]) : <any>undefined;
            if (Array.isArray(_data["applicationFlowLogDetails"])) {
                this.applicationFlowLogDetails = [] as any;
                for (let item of _data["applicationFlowLogDetails"])
                    this.applicationFlowLogDetails!.push(ApplicationFlowLogDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ApplicationFlowLog {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationFlowLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["applicantName"] = this.applicantName;
        data["jobAppliedFor"] = this.jobAppliedFor;
        data["referredBy"] = this.referredBy;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["locationEnteredAtID"] = this.locationEnteredAtID;
        data["applicationJobList"] = this.applicationJobList ? this.applicationJobList.toJSON() : <any>undefined;
        data["applicationFlowLogRouteTo"] = this.applicationFlowLogRouteTo ? this.applicationFlowLogRouteTo.toJSON() : <any>undefined;
        if (Array.isArray(this.applicationFlowLogDetails)) {
            data["applicationFlowLogDetails"] = [];
            for (let item of this.applicationFlowLogDetails)
                data["applicationFlowLogDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IApplicationFlowLog {
    id: number;
    applicantName?: string | undefined;
    jobAppliedFor: number;
    referredBy?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
    locationEnteredAtID: number;
    applicationJobList?: ApplicationJobList | undefined;
    applicationFlowLogRouteTo?: ApplicationFlowLogRouteTo2 | undefined;
    applicationFlowLogDetails?: ApplicationFlowLogDetail[] | undefined;
}

export class ApplicationJobList implements IApplicationJobList {
    id!: number;

    constructor(data?: IApplicationJobList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationJobList {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationJobList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationJobList {
    id: number;
}

export class ApplicationFlowLogRouteTo2 implements IApplicationFlowLogRouteTo2 {
    id!: number;

    constructor(data?: IApplicationFlowLogRouteTo2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): ApplicationFlowLogRouteTo2 {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationFlowLogRouteTo2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IApplicationFlowLogRouteTo2 {
    id: number;
}

export class ApplicationFlowLogDetail implements IApplicationFlowLogDetail {
    id!: number;
    idafl!: number;
    routeToID!: number;
    dateRouted!: string;
    interviewed?: string | undefined;
    dateInterviewed?: string | undefined;
    contingentOffer?: string | undefined;

    constructor(data?: IApplicationFlowLogDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.idafl = _data["idafl"];
            this.routeToID = _data["routeToID"];
            this.dateRouted = _data["dateRouted"];
            this.interviewed = _data["interviewed"];
            this.dateInterviewed = _data["dateInterviewed"];
            this.contingentOffer = _data["contingentOffer"];
        }
    }

    static fromJS(data: any): ApplicationFlowLogDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationFlowLogDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["idafl"] = this.idafl;
        data["routeToID"] = this.routeToID;
        data["dateRouted"] = this.dateRouted;
        data["interviewed"] = this.interviewed;
        data["dateInterviewed"] = this.dateInterviewed;
        data["contingentOffer"] = this.contingentOffer;
        return data;
    }
}

export interface IApplicationFlowLogDetail {
    id: number;
    idafl: number;
    routeToID: number;
    dateRouted: string;
    interviewed?: string | undefined;
    dateInterviewed?: string | undefined;
    contingentOffer?: string | undefined;
}

export class QueryResultsOfApplicationReferralSourceViewModel implements IQueryResultsOfApplicationReferralSourceViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ApplicationReferralSourceViewModel[] | undefined;

    constructor(data?: IQueryResultsOfApplicationReferralSourceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ApplicationReferralSourceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfApplicationReferralSourceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfApplicationReferralSourceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfApplicationReferralSourceViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ApplicationReferralSourceViewModel[] | undefined;
}

export class ApplicationReferralSourceQuery extends Query implements IApplicationReferralSourceQuery {

    constructor(data?: IApplicationReferralSourceQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApplicationReferralSourceQuery {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationReferralSourceQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IApplicationReferralSourceQuery extends IQuery {
}

export class AssetTypeViewModel implements IAssetTypeViewModel {
    id!: number;
    assetType1?: string | undefined;

    constructor(data?: IAssetTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetType1 = _data["assetType1"];
        }
    }

    static fromJS(data: any): AssetTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AssetTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetType1"] = this.assetType1;
        return data;
    }
}

export interface IAssetTypeViewModel {
    id: number;
    assetType1?: string | undefined;
}

export class QueryResultsOfAssetTypeViewModel implements IQueryResultsOfAssetTypeViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: AssetTypeViewModel[] | undefined;

    constructor(data?: IQueryResultsOfAssetTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AssetTypeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfAssetTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfAssetTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfAssetTypeViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: AssetTypeViewModel[] | undefined;
}

export class AssetType implements IAssetType {
    id!: number;
    assetType1?: string | undefined;
    fixedAssets?: FixedAsset[] | undefined;

    constructor(data?: IAssetType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.assetType1 = _data["assetType1"];
            if (Array.isArray(_data["fixedAssets"])) {
                this.fixedAssets = [] as any;
                for (let item of _data["fixedAssets"])
                    this.fixedAssets!.push(FixedAsset.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AssetType {
        data = typeof data === 'object' ? data : {};
        let result = new AssetType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["assetType1"] = this.assetType1;
        if (Array.isArray(this.fixedAssets)) {
            data["fixedAssets"] = [];
            for (let item of this.fixedAssets)
                data["fixedAssets"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAssetType {
    id: number;
    assetType1?: string | undefined;
    fixedAssets?: FixedAsset[] | undefined;
}

export class FixedAsset implements IFixedAsset {
    id!: number;
    fixedAssetNumber?: string | undefined;
    description?: string | undefined;
    assetTypeId?: number | undefined;
    assetId?: string | undefined;
    trailerNumber?: string | undefined;
    serialVinnumber?: string | undefined;
    costCenterId?: number | undefined;
    descriptionofLocation?: string | undefined;
    placedInService?: string | undefined;
    retirementReason?: string | undefined;
    retirementDate?: string | undefined;
    assetType?: AssetType | undefined;
    costCenter?: CostCenter | undefined;

    constructor(data?: IFixedAsset) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fixedAssetNumber = _data["fixedAssetNumber"];
            this.description = _data["description"];
            this.assetTypeId = _data["assetTypeId"];
            this.assetId = _data["assetId"];
            this.trailerNumber = _data["trailerNumber"];
            this.serialVinnumber = _data["serialVinnumber"];
            this.costCenterId = _data["costCenterId"];
            this.descriptionofLocation = _data["descriptionofLocation"];
            this.placedInService = _data["placedInService"];
            this.retirementReason = _data["retirementReason"];
            this.retirementDate = _data["retirementDate"];
            this.assetType = _data["assetType"] ? AssetType.fromJS(_data["assetType"]) : <any>undefined;
            this.costCenter = _data["costCenter"] ? CostCenter.fromJS(_data["costCenter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FixedAsset {
        data = typeof data === 'object' ? data : {};
        let result = new FixedAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fixedAssetNumber"] = this.fixedAssetNumber;
        data["description"] = this.description;
        data["assetTypeId"] = this.assetTypeId;
        data["assetId"] = this.assetId;
        data["trailerNumber"] = this.trailerNumber;
        data["serialVinnumber"] = this.serialVinnumber;
        data["costCenterId"] = this.costCenterId;
        data["descriptionofLocation"] = this.descriptionofLocation;
        data["placedInService"] = this.placedInService;
        data["retirementReason"] = this.retirementReason;
        data["retirementDate"] = this.retirementDate;
        data["assetType"] = this.assetType ? this.assetType.toJSON() : <any>undefined;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFixedAsset {
    id: number;
    fixedAssetNumber?: string | undefined;
    description?: string | undefined;
    assetTypeId?: number | undefined;
    assetId?: string | undefined;
    trailerNumber?: string | undefined;
    serialVinnumber?: string | undefined;
    costCenterId?: number | undefined;
    descriptionofLocation?: string | undefined;
    placedInService?: string | undefined;
    retirementReason?: string | undefined;
    retirementDate?: string | undefined;
    assetType?: AssetType | undefined;
    costCenter?: CostCenter | undefined;
}

export class CostCenter implements ICostCenter {
    id!: number;
    costCenterNumber!: number;
    location?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICostCenter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.costCenterNumber = _data["costCenterNumber"];
            this.location = _data["location"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CostCenter {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["costCenterNumber"] = this.costCenterNumber;
        data["location"] = this.location;
        data["description"] = this.description;
        return data;
    }
}

export interface ICostCenter {
    id: number;
    costCenterNumber: number;
    location?: string | undefined;
    description?: string | undefined;
}

export class QueryResultsOfAuditLog implements IQueryResultsOfAuditLog {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: AuditLog[] | undefined;

    constructor(data?: IQueryResultsOfAuditLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AuditLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfAuditLog {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfAuditLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfAuditLog {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: AuditLog[] | undefined;
}

export class AuditLog implements IAuditLog {
    id!: number;
    itemId!: number;
    changeType?: string | undefined;
    changedBy?: string | undefined;
    originalValues?: string | undefined;
    newValues?: string | undefined;
    updated!: string;
    product?: Product | undefined;

    constructor(data?: IAuditLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemId = _data["itemId"];
            this.changeType = _data["changeType"];
            this.changedBy = _data["changedBy"];
            this.originalValues = _data["originalValues"];
            this.newValues = _data["newValues"];
            this.updated = _data["updated"];
            this.product = _data["product"] ? Product.fromJS(_data["product"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AuditLog {
        data = typeof data === 'object' ? data : {};
        let result = new AuditLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemId"] = this.itemId;
        data["changeType"] = this.changeType;
        data["changedBy"] = this.changedBy;
        data["originalValues"] = this.originalValues;
        data["newValues"] = this.newValues;
        data["updated"] = this.updated;
        data["product"] = this.product ? this.product.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAuditLog {
    id: number;
    itemId: number;
    changeType?: string | undefined;
    changedBy?: string | undefined;
    originalValues?: string | undefined;
    newValues?: string | undefined;
    updated: string;
    product?: Product | undefined;
}

export class Product implements IProduct {
    id!: number;
    containerId!: number;
    itemBarcode?: string | undefined;
    itemType?: string | undefined;
    weight?: number | undefined;
    createdDate!: string;
    itemStatus?: string | undefined;
    productListing?: string | undefined;
    actionIdLevel1?: number | undefined;
    actionIdLevel2?: number | undefined;
    actionIdLevel3?: number | undefined;
    actionIdLevel4?: number | undefined;
    actionIdLevel5?: number | undefined;
    container?: Container | undefined;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.containerId = _data["containerId"];
            this.itemBarcode = _data["itemBarcode"];
            this.itemType = _data["itemType"];
            this.weight = _data["weight"];
            this.createdDate = _data["createdDate"];
            this.itemStatus = _data["itemStatus"];
            this.productListing = _data["productListing"];
            this.actionIdLevel1 = _data["actionIdLevel1"];
            this.actionIdLevel2 = _data["actionIdLevel2"];
            this.actionIdLevel3 = _data["actionIdLevel3"];
            this.actionIdLevel4 = _data["actionIdLevel4"];
            this.actionIdLevel5 = _data["actionIdLevel5"];
            this.container = _data["container"] ? Container.fromJS(_data["container"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containerId"] = this.containerId;
        data["itemBarcode"] = this.itemBarcode;
        data["itemType"] = this.itemType;
        data["weight"] = this.weight;
        data["createdDate"] = this.createdDate;
        data["itemStatus"] = this.itemStatus;
        data["productListing"] = this.productListing;
        data["actionIdLevel1"] = this.actionIdLevel1;
        data["actionIdLevel2"] = this.actionIdLevel2;
        data["actionIdLevel3"] = this.actionIdLevel3;
        data["actionIdLevel4"] = this.actionIdLevel4;
        data["actionIdLevel5"] = this.actionIdLevel5;
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        return data;
    }
}

export interface IProduct {
    id: number;
    containerId: number;
    itemBarcode?: string | undefined;
    itemType?: string | undefined;
    weight?: number | undefined;
    createdDate: string;
    itemStatus?: string | undefined;
    productListing?: string | undefined;
    actionIdLevel1?: number | undefined;
    actionIdLevel2?: number | undefined;
    actionIdLevel3?: number | undefined;
    actionIdLevel4?: number | undefined;
    actionIdLevel5?: number | undefined;
    container?: Container | undefined;
}

export class Container implements IContainer {
    id!: number;
    containerBarcode?: string | undefined;
    originId?: string | undefined;
    destinationId?: string | undefined;
    createdDate!: string;
    enteredBy?: string | undefined;
    status?: string | undefined;
    comment?: string | undefined;
    updatedDate?: string | undefined;
    updatedBy?: string | undefined;
    bagContainerNumber?: string | undefined;
    origin?: Store | undefined;
    destination?: Store | undefined;

    constructor(data?: IContainer) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.containerBarcode = _data["containerBarcode"];
            this.originId = _data["originId"];
            this.destinationId = _data["destinationId"];
            this.createdDate = _data["createdDate"];
            this.enteredBy = _data["enteredBy"];
            this.status = _data["status"];
            this.comment = _data["comment"];
            this.updatedDate = _data["updatedDate"];
            this.updatedBy = _data["updatedBy"];
            this.bagContainerNumber = _data["bagContainerNumber"];
            this.origin = _data["origin"] ? Store.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? Store.fromJS(_data["destination"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Container {
        data = typeof data === 'object' ? data : {};
        let result = new Container();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containerBarcode"] = this.containerBarcode;
        data["originId"] = this.originId;
        data["destinationId"] = this.destinationId;
        data["createdDate"] = this.createdDate;
        data["enteredBy"] = this.enteredBy;
        data["status"] = this.status;
        data["comment"] = this.comment;
        data["updatedDate"] = this.updatedDate;
        data["updatedBy"] = this.updatedBy;
        data["bagContainerNumber"] = this.bagContainerNumber;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContainer {
    id: number;
    containerBarcode?: string | undefined;
    originId?: string | undefined;
    destinationId?: string | undefined;
    createdDate: string;
    enteredBy?: string | undefined;
    status?: string | undefined;
    comment?: string | undefined;
    updatedDate?: string | undefined;
    updatedBy?: string | undefined;
    bagContainerNumber?: string | undefined;
    origin?: Store | undefined;
    destination?: Store | undefined;
}

export class Store implements IStore {
    id?: string | undefined;
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed!: boolean;
    isGRERunning!: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    status?: string | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;

    constructor(data?: IStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.storeMnemonic = _data["storeMnemonic"];
            this.storeMnemonic2 = _data["storeMnemonic2"];
            this.serverName = _data["serverName"];
            this.gredbName = _data["gredbName"];
            this.isClosed = _data["isClosed"];
            this.isGRERunning = _data["isGRERunning"];
            this.storeLogin = _data["storeLogin"];
            this.district = _data["district"];
            this.status = _data["status"];
            this.glNumber = _data["glNumber"];
            this.glCash = _data["glCash"];
            this.glNumber2 = _data["glNumber2"];
            this.sort = _data["sort"];
            this.locationId = _data["locationId"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.regionId = _data["regionId"];
            this.email = _data["email"];
            this.dmEmail = _data["dmEmail"];
            this.districtEmail = _data["districtEmail"];
            this.prefix = _data["prefix"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.aaExtension = _data["aaExtension"];
        }
    }

    static fromJS(data: any): Store {
        data = typeof data === 'object' ? data : {};
        let result = new Store();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["storeMnemonic"] = this.storeMnemonic;
        data["storeMnemonic2"] = this.storeMnemonic2;
        data["serverName"] = this.serverName;
        data["gredbName"] = this.gredbName;
        data["isClosed"] = this.isClosed;
        data["isGRERunning"] = this.isGRERunning;
        data["storeLogin"] = this.storeLogin;
        data["district"] = this.district;
        data["status"] = this.status;
        data["glNumber"] = this.glNumber;
        data["glCash"] = this.glCash;
        data["glNumber2"] = this.glNumber2;
        data["sort"] = this.sort;
        data["locationId"] = this.locationId;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["regionId"] = this.regionId;
        data["email"] = this.email;
        data["dmEmail"] = this.dmEmail;
        data["districtEmail"] = this.districtEmail;
        data["prefix"] = this.prefix;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["aaExtension"] = this.aaExtension;
        return data;
    }
}

export interface IStore {
    id?: string | undefined;
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed: boolean;
    isGRERunning: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    status?: string | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;
}

export class QueryResultsOfAuditArea implements IQueryResultsOfAuditArea {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: AuditArea[] | undefined;

    constructor(data?: IQueryResultsOfAuditArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AuditArea.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfAuditArea {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfAuditArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfAuditArea {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: AuditArea[] | undefined;
}

export class AuditArea implements IAuditArea {
    id!: number;
    auditArea1?: string | undefined;
    even?: boolean | undefined;
    odd?: boolean | undefined;
    status?: string | undefined;

    constructor(data?: IAuditArea) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditArea1 = _data["auditArea1"];
            this.even = _data["even"];
            this.odd = _data["odd"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AuditArea {
        data = typeof data === 'object' ? data : {};
        let result = new AuditArea();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditArea1"] = this.auditArea1;
        data["even"] = this.even;
        data["odd"] = this.odd;
        data["status"] = this.status;
        return data;
    }
}

export interface IAuditArea {
    id: number;
    auditArea1?: string | undefined;
    even?: boolean | undefined;
    odd?: boolean | undefined;
    status?: string | undefined;
}

export class QueryResultsOfAuditRecord implements IQueryResultsOfAuditRecord {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: AuditRecord[] | undefined;

    constructor(data?: IQueryResultsOfAuditRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AuditRecord.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfAuditRecord {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfAuditRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfAuditRecord {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: AuditRecord[] | undefined;
}

export class AuditRecord implements IAuditRecord {
    id!: number;
    storeId?: string | undefined;
    week!: number;
    year!: number;
    dateComplete!: string;
    completedBy?: string | undefined;
    manager?: string | undefined;
    late?: boolean | undefined;
    store?: Store2 | undefined;
    newAuditDetails?: NewAuditDetail[] | undefined;

    constructor(data?: IAuditRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.week = _data["week"];
            this.year = _data["year"];
            this.dateComplete = _data["dateComplete"];
            this.completedBy = _data["completedBy"];
            this.manager = _data["manager"];
            this.late = _data["late"];
            this.store = _data["store"] ? Store2.fromJS(_data["store"]) : <any>undefined;
            if (Array.isArray(_data["newAuditDetails"])) {
                this.newAuditDetails = [] as any;
                for (let item of _data["newAuditDetails"])
                    this.newAuditDetails!.push(NewAuditDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AuditRecord {
        data = typeof data === 'object' ? data : {};
        let result = new AuditRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["week"] = this.week;
        data["year"] = this.year;
        data["dateComplete"] = this.dateComplete;
        data["completedBy"] = this.completedBy;
        data["manager"] = this.manager;
        data["late"] = this.late;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        if (Array.isArray(this.newAuditDetails)) {
            data["newAuditDetails"] = [];
            for (let item of this.newAuditDetails)
                data["newAuditDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAuditRecord {
    id: number;
    storeId?: string | undefined;
    week: number;
    year: number;
    dateComplete: string;
    completedBy?: string | undefined;
    manager?: string | undefined;
    late?: boolean | undefined;
    store?: Store2 | undefined;
    newAuditDetails?: NewAuditDetail[] | undefined;
}

export class Store2 implements IStore2 {
    id?: string | undefined;
    name?: string | undefined;
    district?: string | undefined;
    status?: string | undefined;
    facility?: string | undefined;
    week?: number | undefined;

    constructor(data?: IStore2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.district = _data["district"];
            this.status = _data["status"];
            this.facility = _data["facility"];
            this.week = _data["week"];
        }
    }

    static fromJS(data: any): Store2 {
        data = typeof data === 'object' ? data : {};
        let result = new Store2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["district"] = this.district;
        data["status"] = this.status;
        data["facility"] = this.facility;
        data["week"] = this.week;
        return data;
    }
}

export interface IStore2 {
    id?: string | undefined;
    name?: string | undefined;
    district?: string | undefined;
    status?: string | undefined;
    facility?: string | undefined;
    week?: number | undefined;
}

export class NewAuditDetail implements INewAuditDetail {
    id!: number;
    auditRecordId!: number;
    auditArea?: string | undefined;
    score!: number;
    employeeNumber?: string | undefined;

    constructor(data?: INewAuditDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditRecordId = _data["auditRecordId"];
            this.auditArea = _data["auditArea"];
            this.score = _data["score"];
            this.employeeNumber = _data["employeeNumber"];
        }
    }

    static fromJS(data: any): NewAuditDetail {
        data = typeof data === 'object' ? data : {};
        let result = new NewAuditDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditRecordId"] = this.auditRecordId;
        data["auditArea"] = this.auditArea;
        data["score"] = this.score;
        data["employeeNumber"] = this.employeeNumber;
        return data;
    }
}

export interface INewAuditDetail {
    id: number;
    auditRecordId: number;
    auditArea?: string | undefined;
    score: number;
    employeeNumber?: string | undefined;
}

export class QueryResultsOfBodyPartViewModel implements IQueryResultsOfBodyPartViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: BodyPartViewModel[] | undefined;

    constructor(data?: IQueryResultsOfBodyPartViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(BodyPartViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfBodyPartViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfBodyPartViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfBodyPartViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: BodyPartViewModel[] | undefined;
}

export class BodyPartViewModel implements IBodyPartViewModel {
    id!: number;
    name?: string | undefined;
    sort!: number;

    constructor(data?: IBodyPartViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): BodyPartViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BodyPartViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["sort"] = this.sort;
        return data;
    }
}

export interface IBodyPartViewModel {
    id: number;
    name?: string | undefined;
    sort: number;
}

export class QueryResultsOfImage implements IQueryResultsOfImage {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Image[] | undefined;

    constructor(data?: IQueryResultsOfImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Image.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfImage {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfImage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfImage {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Image[] | undefined;
}

export class Image implements IImage {
    id!: number;
    itemImage?: string | undefined;
    guid!: string;
    vehicleId!: number;
    type?: string | undefined;

    constructor(data?: IImage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemImage = _data["itemImage"];
            this.guid = _data["guid"];
            this.vehicleId = _data["vehicleId"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): Image {
        data = typeof data === 'object' ? data : {};
        let result = new Image();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemImage"] = this.itemImage;
        data["guid"] = this.guid;
        data["vehicleId"] = this.vehicleId;
        data["type"] = this.type;
        return data;
    }
}

export interface IImage {
    id: number;
    itemImage?: string | undefined;
    guid: string;
    vehicleId: number;
    type?: string | undefined;
}

export class Result implements IResult {
    failed!: boolean;
    messages?: string[] | undefined;
    succeeded!: boolean;
    errors?: { [key: string]: string[]; } | undefined;

    constructor(data?: IResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.failed = _data["failed"];
            if (Array.isArray(_data["messages"])) {
                this.messages = [] as any;
                for (let item of _data["messages"])
                    this.messages!.push(item);
            }
            this.succeeded = _data["succeeded"];
            if (_data["errors"]) {
                this.errors = {} as any;
                for (let key in _data["errors"]) {
                    if (_data["errors"].hasOwnProperty(key))
                        (<any>this.errors)![key] = _data["errors"][key] !== undefined ? _data["errors"][key] : [];
                }
            }
        }
    }

    static fromJS(data: any): Result {
        data = typeof data === 'object' ? data : {};
        let result = new Result();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["failed"] = this.failed;
        if (Array.isArray(this.messages)) {
            data["messages"] = [];
            for (let item of this.messages)
                data["messages"].push(item);
        }
        data["succeeded"] = this.succeeded;
        if (this.errors) {
            data["errors"] = {};
            for (let key in this.errors) {
                if (this.errors.hasOwnProperty(key))
                    (<any>data["errors"])[key] = (<any>this.errors)[key];
            }
        }
        return data;
    }
}

export interface IResult {
    failed: boolean;
    messages?: string[] | undefined;
    succeeded: boolean;
    errors?: { [key: string]: string[]; } | undefined;
}

export class QueryResultsOfCarDonationLocationViewModel implements IQueryResultsOfCarDonationLocationViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: CarDonationLocationViewModel[] | undefined;

    constructor(data?: IQueryResultsOfCarDonationLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CarDonationLocationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfCarDonationLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfCarDonationLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfCarDonationLocationViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: CarDonationLocationViewModel[] | undefined;
}

export class CarDonationLocationViewModel implements ICarDonationLocationViewModel {
    id!: number;
    locationName?: string | undefined;
    locationType?: string | undefined;
    locationStreet?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationZip?: string | undefined;
    locationPhone?: string | undefined;
    locationContactPerson?: string | undefined;

    constructor(data?: ICarDonationLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.locationName = _data["locationName"];
            this.locationType = _data["locationType"];
            this.locationStreet = _data["locationStreet"];
            this.locationCity = _data["locationCity"];
            this.locationState = _data["locationState"];
            this.locationZip = _data["locationZip"];
            this.locationPhone = _data["locationPhone"];
            this.locationContactPerson = _data["locationContactPerson"];
        }
    }

    static fromJS(data: any): CarDonationLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CarDonationLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["locationName"] = this.locationName;
        data["locationType"] = this.locationType;
        data["locationStreet"] = this.locationStreet;
        data["locationCity"] = this.locationCity;
        data["locationState"] = this.locationState;
        data["locationZip"] = this.locationZip;
        data["locationPhone"] = this.locationPhone;
        data["locationContactPerson"] = this.locationContactPerson;
        return data;
    }
}

export interface ICarDonationLocationViewModel {
    id: number;
    locationName?: string | undefined;
    locationType?: string | undefined;
    locationStreet?: string | undefined;
    locationCity?: string | undefined;
    locationState?: string | undefined;
    locationZip?: string | undefined;
    locationPhone?: string | undefined;
    locationContactPerson?: string | undefined;
}

export class VehicleViewModel implements IVehicleViewModel {
    id!: number;
    donorId?: number | undefined;
    locationId!: number;
    date!: string;
    dateSold?: string | undefined;
    titleNo?: string | undefined;
    vinNo?: string | undefined;
    vehicleYear?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    plate?: string | undefined;
    titleState?: string | undefined;
    gross?: number | undefined;
    sellFee?: number | undefined;
    towFee?: number | undefined;
    shopFee?: number | undefined;
    otherFee?: number | undefined;
    notes?: string | undefined;
    titleProblem!: boolean;
    pendingTow!: boolean;
    thankYouLetter!: boolean;
    storeLocation?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    reported!: boolean;
    comments?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    donorStreet?: string | undefined;
    donorCity?: string | undefined;
    donorState?: string | undefined;
    donorZip?: string | undefined;
    donorPhone?: string | undefined;
    donorPhone2?: string | undefined;
    referralId!: number;
    referralComment?: string | undefined;
    ssnumber?: string | undefined;
    mobileDonorId?: number | undefined;
    updateBy?: string | undefined;
    updatedDate?: string | undefined;
    donatedAtStore?: boolean | undefined;

    constructor(data?: IVehicleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.donorId = _data["donorId"];
            this.locationId = _data["locationId"];
            this.date = _data["date"];
            this.dateSold = _data["dateSold"];
            this.titleNo = _data["titleNo"];
            this.vinNo = _data["vinNo"];
            this.vehicleYear = _data["vehicleYear"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.plate = _data["plate"];
            this.titleState = _data["titleState"];
            this.gross = _data["gross"];
            this.sellFee = _data["sellFee"];
            this.towFee = _data["towFee"];
            this.shopFee = _data["shopFee"];
            this.otherFee = _data["otherFee"];
            this.notes = _data["notes"];
            this.titleProblem = _data["titleProblem"];
            this.pendingTow = _data["pendingTow"];
            this.thankYouLetter = _data["thankYouLetter"];
            this.storeLocation = _data["storeLocation"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.reported = _data["reported"];
            this.comments = _data["comments"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.donorStreet = _data["donorStreet"];
            this.donorCity = _data["donorCity"];
            this.donorState = _data["donorState"];
            this.donorZip = _data["donorZip"];
            this.donorPhone = _data["donorPhone"];
            this.donorPhone2 = _data["donorPhone2"];
            this.referralId = _data["referralId"];
            this.referralComment = _data["referralComment"];
            this.ssnumber = _data["ssnumber"];
            this.mobileDonorId = _data["mobileDonorId"];
            this.updateBy = _data["updateBy"];
            this.updatedDate = _data["updatedDate"];
            this.donatedAtStore = _data["donatedAtStore"];
        }
    }

    static fromJS(data: any): VehicleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["donorId"] = this.donorId;
        data["locationId"] = this.locationId;
        data["date"] = this.date;
        data["dateSold"] = this.dateSold;
        data["titleNo"] = this.titleNo;
        data["vinNo"] = this.vinNo;
        data["vehicleYear"] = this.vehicleYear;
        data["make"] = this.make;
        data["model"] = this.model;
        data["plate"] = this.plate;
        data["titleState"] = this.titleState;
        data["gross"] = this.gross;
        data["sellFee"] = this.sellFee;
        data["towFee"] = this.towFee;
        data["shopFee"] = this.shopFee;
        data["otherFee"] = this.otherFee;
        data["notes"] = this.notes;
        data["titleProblem"] = this.titleProblem;
        data["pendingTow"] = this.pendingTow;
        data["thankYouLetter"] = this.thankYouLetter;
        data["storeLocation"] = this.storeLocation;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["reported"] = this.reported;
        data["comments"] = this.comments;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["donorStreet"] = this.donorStreet;
        data["donorCity"] = this.donorCity;
        data["donorState"] = this.donorState;
        data["donorZip"] = this.donorZip;
        data["donorPhone"] = this.donorPhone;
        data["donorPhone2"] = this.donorPhone2;
        data["referralId"] = this.referralId;
        data["referralComment"] = this.referralComment;
        data["ssnumber"] = this.ssnumber;
        data["mobileDonorId"] = this.mobileDonorId;
        data["updateBy"] = this.updateBy;
        data["updatedDate"] = this.updatedDate;
        data["donatedAtStore"] = this.donatedAtStore;
        return data;
    }
}

export interface IVehicleViewModel {
    id: number;
    donorId?: number | undefined;
    locationId: number;
    date: string;
    dateSold?: string | undefined;
    titleNo?: string | undefined;
    vinNo?: string | undefined;
    vehicleYear?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    plate?: string | undefined;
    titleState?: string | undefined;
    gross?: number | undefined;
    sellFee?: number | undefined;
    towFee?: number | undefined;
    shopFee?: number | undefined;
    otherFee?: number | undefined;
    notes?: string | undefined;
    titleProblem: boolean;
    pendingTow: boolean;
    thankYouLetter: boolean;
    storeLocation?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    reported: boolean;
    comments?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    donorStreet?: string | undefined;
    donorCity?: string | undefined;
    donorState?: string | undefined;
    donorZip?: string | undefined;
    donorPhone?: string | undefined;
    donorPhone2?: string | undefined;
    referralId: number;
    referralComment?: string | undefined;
    ssnumber?: string | undefined;
    mobileDonorId?: number | undefined;
    updateBy?: string | undefined;
    updatedDate?: string | undefined;
    donatedAtStore?: boolean | undefined;
}

export class Vehicle implements IVehicle {
    id!: number;
    donorId?: number | undefined;
    locationId!: number;
    date!: string;
    dateSold?: string | undefined;
    titleNo?: string | undefined;
    vinNo?: string | undefined;
    vehicleYear?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    plate?: string | undefined;
    titleState?: string | undefined;
    gross?: number | undefined;
    sellFee?: number | undefined;
    towFee?: number | undefined;
    shopFee?: number | undefined;
    otherFee?: number | undefined;
    notes?: string | undefined;
    titleProblem!: boolean;
    pendingTow!: boolean;
    thankYouLetter!: boolean;
    storeLocation?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    reported!: boolean;
    comments?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    donorStreet?: string | undefined;
    donorCity?: string | undefined;
    donorState?: string | undefined;
    donorZip?: string | undefined;
    donorPhone?: string | undefined;
    donorPhone2?: string | undefined;
    referralId!: number;
    referralComment?: string | undefined;
    ssnumber?: string | undefined;
    mobileDonorId?: number | undefined;
    updateBy?: string | undefined;
    updatedDate?: string | undefined;
    donatedAtStore?: boolean | undefined;

    constructor(data?: IVehicle) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.donorId = _data["donorId"];
            this.locationId = _data["locationId"];
            this.date = _data["date"];
            this.dateSold = _data["dateSold"];
            this.titleNo = _data["titleNo"];
            this.vinNo = _data["vinNo"];
            this.vehicleYear = _data["vehicleYear"];
            this.make = _data["make"];
            this.model = _data["model"];
            this.plate = _data["plate"];
            this.titleState = _data["titleState"];
            this.gross = _data["gross"];
            this.sellFee = _data["sellFee"];
            this.towFee = _data["towFee"];
            this.shopFee = _data["shopFee"];
            this.otherFee = _data["otherFee"];
            this.notes = _data["notes"];
            this.titleProblem = _data["titleProblem"];
            this.pendingTow = _data["pendingTow"];
            this.thankYouLetter = _data["thankYouLetter"];
            this.storeLocation = _data["storeLocation"];
            this.street = _data["street"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.reported = _data["reported"];
            this.comments = _data["comments"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.donorStreet = _data["donorStreet"];
            this.donorCity = _data["donorCity"];
            this.donorState = _data["donorState"];
            this.donorZip = _data["donorZip"];
            this.donorPhone = _data["donorPhone"];
            this.donorPhone2 = _data["donorPhone2"];
            this.referralId = _data["referralId"];
            this.referralComment = _data["referralComment"];
            this.ssnumber = _data["ssnumber"];
            this.mobileDonorId = _data["mobileDonorId"];
            this.updateBy = _data["updateBy"];
            this.updatedDate = _data["updatedDate"];
            this.donatedAtStore = _data["donatedAtStore"];
        }
    }

    static fromJS(data: any): Vehicle {
        data = typeof data === 'object' ? data : {};
        let result = new Vehicle();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["donorId"] = this.donorId;
        data["locationId"] = this.locationId;
        data["date"] = this.date;
        data["dateSold"] = this.dateSold;
        data["titleNo"] = this.titleNo;
        data["vinNo"] = this.vinNo;
        data["vehicleYear"] = this.vehicleYear;
        data["make"] = this.make;
        data["model"] = this.model;
        data["plate"] = this.plate;
        data["titleState"] = this.titleState;
        data["gross"] = this.gross;
        data["sellFee"] = this.sellFee;
        data["towFee"] = this.towFee;
        data["shopFee"] = this.shopFee;
        data["otherFee"] = this.otherFee;
        data["notes"] = this.notes;
        data["titleProblem"] = this.titleProblem;
        data["pendingTow"] = this.pendingTow;
        data["thankYouLetter"] = this.thankYouLetter;
        data["storeLocation"] = this.storeLocation;
        data["street"] = this.street;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["reported"] = this.reported;
        data["comments"] = this.comments;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["donorStreet"] = this.donorStreet;
        data["donorCity"] = this.donorCity;
        data["donorState"] = this.donorState;
        data["donorZip"] = this.donorZip;
        data["donorPhone"] = this.donorPhone;
        data["donorPhone2"] = this.donorPhone2;
        data["referralId"] = this.referralId;
        data["referralComment"] = this.referralComment;
        data["ssnumber"] = this.ssnumber;
        data["mobileDonorId"] = this.mobileDonorId;
        data["updateBy"] = this.updateBy;
        data["updatedDate"] = this.updatedDate;
        data["donatedAtStore"] = this.donatedAtStore;
        return data;
    }
}

export interface IVehicle {
    id: number;
    donorId?: number | undefined;
    locationId: number;
    date: string;
    dateSold?: string | undefined;
    titleNo?: string | undefined;
    vinNo?: string | undefined;
    vehicleYear?: string | undefined;
    make?: string | undefined;
    model?: string | undefined;
    plate?: string | undefined;
    titleState?: string | undefined;
    gross?: number | undefined;
    sellFee?: number | undefined;
    towFee?: number | undefined;
    shopFee?: number | undefined;
    otherFee?: number | undefined;
    notes?: string | undefined;
    titleProblem: boolean;
    pendingTow: boolean;
    thankYouLetter: boolean;
    storeLocation?: string | undefined;
    street?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    reported: boolean;
    comments?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    donorStreet?: string | undefined;
    donorCity?: string | undefined;
    donorState?: string | undefined;
    donorZip?: string | undefined;
    donorPhone?: string | undefined;
    donorPhone2?: string | undefined;
    referralId: number;
    referralComment?: string | undefined;
    ssnumber?: string | undefined;
    mobileDonorId?: number | undefined;
    updateBy?: string | undefined;
    updatedDate?: string | undefined;
    donatedAtStore?: boolean | undefined;
}

export class QueryResultsOfVehicleViewModel implements IQueryResultsOfVehicleViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: VehicleViewModel[] | undefined;

    constructor(data?: IQueryResultsOfVehicleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(VehicleViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfVehicleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfVehicleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfVehicleViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: VehicleViewModel[] | undefined;
}

export class GWCA implements IGWCA {
    id!: number;
    employeeNumber!: number;
    managerName?: string | undefined;
    phone?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;
    numberOfChildren!: number;
    numberOfTeenagers!: number;
    numberOfAdults!: number;
    reasonForRequest?: string | undefined;
    gwcaDs?: GWCAD[] | undefined;

    constructor(data?: IGWCA) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeNumber = _data["employeeNumber"];
            this.managerName = _data["managerName"];
            this.phone = _data["phone"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.numberOfChildren = _data["numberOfChildren"];
            this.numberOfTeenagers = _data["numberOfTeenagers"];
            this.numberOfAdults = _data["numberOfAdults"];
            this.reasonForRequest = _data["reasonForRequest"];
            if (Array.isArray(_data["gwcaDs"])) {
                this.gwcaDs = [] as any;
                for (let item of _data["gwcaDs"])
                    this.gwcaDs!.push(GWCAD.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GWCA {
        data = typeof data === 'object' ? data : {};
        let result = new GWCA();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeNumber"] = this.employeeNumber;
        data["managerName"] = this.managerName;
        data["phone"] = this.phone;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["numberOfChildren"] = this.numberOfChildren;
        data["numberOfTeenagers"] = this.numberOfTeenagers;
        data["numberOfAdults"] = this.numberOfAdults;
        data["reasonForRequest"] = this.reasonForRequest;
        if (Array.isArray(this.gwcaDs)) {
            data["gwcaDs"] = [];
            for (let item of this.gwcaDs)
                data["gwcaDs"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGWCA {
    id: number;
    employeeNumber: number;
    managerName?: string | undefined;
    phone?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
    numberOfChildren: number;
    numberOfTeenagers: number;
    numberOfAdults: number;
    reasonForRequest?: string | undefined;
    gwcaDs?: GWCAD[] | undefined;
}

export class GWCAD implements IGWCAD {
    id!: number;
    gwcaid!: number;
    childFirstName?: string | undefined;
    childLastName?: string | undefined;
    gender?: string | undefined;
    age!: number;
    favoriteColor?: string | undefined;
    favoriteToy?: string | undefined;
    favoriteBookGenre?: string | undefined;
    childPreferredName?: string | undefined;

    constructor(data?: IGWCAD) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gwcaid = _data["gwcaid"];
            this.childFirstName = _data["childFirstName"];
            this.childLastName = _data["childLastName"];
            this.gender = _data["gender"];
            this.age = _data["age"];
            this.favoriteColor = _data["favoriteColor"];
            this.favoriteToy = _data["favoriteToy"];
            this.favoriteBookGenre = _data["favoriteBookGenre"];
            this.childPreferredName = _data["childPreferredName"];
        }
    }

    static fromJS(data: any): GWCAD {
        data = typeof data === 'object' ? data : {};
        let result = new GWCAD();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gwcaid"] = this.gwcaid;
        data["childFirstName"] = this.childFirstName;
        data["childLastName"] = this.childLastName;
        data["gender"] = this.gender;
        data["age"] = this.age;
        data["favoriteColor"] = this.favoriteColor;
        data["favoriteToy"] = this.favoriteToy;
        data["favoriteBookGenre"] = this.favoriteBookGenre;
        data["childPreferredName"] = this.childPreferredName;
        return data;
    }
}

export interface IGWCAD {
    id: number;
    gwcaid: number;
    childFirstName?: string | undefined;
    childLastName?: string | undefined;
    gender?: string | undefined;
    age: number;
    favoriteColor?: string | undefined;
    favoriteToy?: string | undefined;
    favoriteBookGenre?: string | undefined;
    childPreferredName?: string | undefined;
}

export class QueryResultsOfCaseManagementViewModel implements IQueryResultsOfCaseManagementViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: CaseManagementViewModel[] | undefined;

    constructor(data?: IQueryResultsOfCaseManagementViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CaseManagementViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfCaseManagementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfCaseManagementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfCaseManagementViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: CaseManagementViewModel[] | undefined;
}

export class CaseManagementViewModel implements ICaseManagementViewModel {
    id!: number;
    gicwid!: number;
    date!: string;
    staffId?: number | undefined;
    note?: string | undefined;
    categoryId!: number;
    staff?: StaffViewModel | undefined;
    caseManagementCategory?: CaseManagementCategoryViewModel | undefined;

    constructor(data?: ICaseManagementViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gicwid = _data["gicwid"];
            this.date = _data["date"];
            this.staffId = _data["staffId"];
            this.note = _data["note"];
            this.categoryId = _data["categoryId"];
            this.staff = _data["staff"] ? StaffViewModel.fromJS(_data["staff"]) : <any>undefined;
            this.caseManagementCategory = _data["caseManagementCategory"] ? CaseManagementCategoryViewModel.fromJS(_data["caseManagementCategory"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseManagementViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseManagementViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gicwid"] = this.gicwid;
        data["date"] = this.date;
        data["staffId"] = this.staffId;
        data["note"] = this.note;
        data["categoryId"] = this.categoryId;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        data["caseManagementCategory"] = this.caseManagementCategory ? this.caseManagementCategory.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaseManagementViewModel {
    id: number;
    gicwid: number;
    date: string;
    staffId?: number | undefined;
    note?: string | undefined;
    categoryId: number;
    staff?: StaffViewModel | undefined;
    caseManagementCategory?: CaseManagementCategoryViewModel | undefined;
}

export class StaffViewModel implements IStaffViewModel {
    id!: number;
    name?: string | undefined;
    phone?: string | undefined;
    employeeNumber?: string | undefined;

    constructor(data?: IStaffViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.employeeNumber = _data["employeeNumber"];
        }
    }

    static fromJS(data: any): StaffViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StaffViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["employeeNumber"] = this.employeeNumber;
        return data;
    }
}

export interface IStaffViewModel {
    id: number;
    name?: string | undefined;
    phone?: string | undefined;
    employeeNumber?: string | undefined;
}

export class CaseManagementCategoryViewModel implements ICaseManagementCategoryViewModel {
    id!: number;
    category?: string | undefined;

    constructor(data?: ICaseManagementCategoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): CaseManagementCategoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CaseManagementCategoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        return data;
    }
}

export interface ICaseManagementCategoryViewModel {
    id: number;
    category?: string | undefined;
}

export class QueryResultsOfCaseManagementCategory implements IQueryResultsOfCaseManagementCategory {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: CaseManagementCategory[] | undefined;

    constructor(data?: IQueryResultsOfCaseManagementCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CaseManagementCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfCaseManagementCategory {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfCaseManagementCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfCaseManagementCategory {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: CaseManagementCategory[] | undefined;
}

export class CaseManagementCategory implements ICaseManagementCategory {
    id!: number;
    category?: string | undefined;

    constructor(data?: ICaseManagementCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): CaseManagementCategory {
        data = typeof data === 'object' ? data : {};
        let result = new CaseManagementCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        return data;
    }
}

export interface ICaseManagementCategory {
    id: number;
    category?: string | undefined;
}

export class JCSCaseNoteCategoryOutputViewModel implements IJCSCaseNoteCategoryOutputViewModel {
    id!: number;
    category?: string | undefined;

    constructor(data?: IJCSCaseNoteCategoryOutputViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): JCSCaseNoteCategoryOutputViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new JCSCaseNoteCategoryOutputViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        return data;
    }
}

export interface IJCSCaseNoteCategoryOutputViewModel {
    id: number;
    category?: string | undefined;
}

export class CaseManagement implements ICaseManagement {
    id!: number;
    gicwid!: number;
    date!: string;
    staffId?: number | undefined;
    note?: string | undefined;
    categoryId!: number;
    staff?: Staff | undefined;
    category?: CaseManagementCategory | undefined;

    constructor(data?: ICaseManagement) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gicwid = _data["gicwid"];
            this.date = _data["date"];
            this.staffId = _data["staffId"];
            this.note = _data["note"];
            this.categoryId = _data["categoryId"];
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : <any>undefined;
            this.category = _data["category"] ? CaseManagementCategory.fromJS(_data["category"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CaseManagement {
        data = typeof data === 'object' ? data : {};
        let result = new CaseManagement();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gicwid"] = this.gicwid;
        data["date"] = this.date;
        data["staffId"] = this.staffId;
        data["note"] = this.note;
        data["categoryId"] = this.categoryId;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        data["category"] = this.category ? this.category.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICaseManagement {
    id: number;
    gicwid: number;
    date: string;
    staffId?: number | undefined;
    note?: string | undefined;
    categoryId: number;
    staff?: Staff | undefined;
    category?: CaseManagementCategory | undefined;
}

export class Staff implements IStaff {
    id!: number;
    name?: string | undefined;
    phone?: string | undefined;
    locationId?: number | undefined;
    active?: boolean | undefined;
    employmentSpecialist!: boolean;
    lts!: boolean;
    vt?: boolean | undefined;
    placementStartRange?: number | undefined;
    placementEndRange?: number | undefined;
    employeeNumber?: string | undefined;
    location?: Location | undefined;

    constructor(data?: IStaff) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.locationId = _data["locationId"];
            this.active = _data["active"];
            this.employmentSpecialist = _data["employmentSpecialist"];
            this.lts = _data["lts"];
            this.vt = _data["vt"];
            this.placementStartRange = _data["placementStartRange"];
            this.placementEndRange = _data["placementEndRange"];
            this.employeeNumber = _data["employeeNumber"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Staff {
        data = typeof data === 'object' ? data : {};
        let result = new Staff();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["locationId"] = this.locationId;
        data["active"] = this.active;
        data["employmentSpecialist"] = this.employmentSpecialist;
        data["lts"] = this.lts;
        data["vt"] = this.vt;
        data["placementStartRange"] = this.placementStartRange;
        data["placementEndRange"] = this.placementEndRange;
        data["employeeNumber"] = this.employeeNumber;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStaff {
    id: number;
    name?: string | undefined;
    phone?: string | undefined;
    locationId?: number | undefined;
    active?: boolean | undefined;
    employmentSpecialist: boolean;
    lts: boolean;
    vt?: boolean | undefined;
    placementStartRange?: number | undefined;
    placementEndRange?: number | undefined;
    employeeNumber?: string | undefined;
    location?: Location | undefined;
}

export class Location implements ILocation {
    id!: number;
    name?: string | undefined;
    annualPlacementGoal?: number | undefined;
    annualCweGoal?: number | undefined;
    averageStartingWage?: number | undefined;
    hoursWeek?: number | undefined;
    idField?: number | undefined;
    trailing90Day?: number | undefined;
    type?: string | undefined;
    divisonAbrv?: string | undefined;
    store?: boolean | undefined;
    address?: string | undefined;
    phone?: string | undefined;

    constructor(data?: ILocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.annualPlacementGoal = _data["annualPlacementGoal"];
            this.annualCweGoal = _data["annualCweGoal"];
            this.averageStartingWage = _data["averageStartingWage"];
            this.hoursWeek = _data["hoursWeek"];
            this.idField = _data["idField"];
            this.trailing90Day = _data["trailing90Day"];
            this.type = _data["type"];
            this.divisonAbrv = _data["divisonAbrv"];
            this.store = _data["store"];
            this.address = _data["address"];
            this.phone = _data["phone"];
        }
    }

    static fromJS(data: any): Location {
        data = typeof data === 'object' ? data : {};
        let result = new Location();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["annualPlacementGoal"] = this.annualPlacementGoal;
        data["annualCweGoal"] = this.annualCweGoal;
        data["averageStartingWage"] = this.averageStartingWage;
        data["hoursWeek"] = this.hoursWeek;
        data["idField"] = this.idField;
        data["trailing90Day"] = this.trailing90Day;
        data["type"] = this.type;
        data["divisonAbrv"] = this.divisonAbrv;
        data["store"] = this.store;
        data["address"] = this.address;
        data["phone"] = this.phone;
        return data;
    }
}

export interface ILocation {
    id: number;
    name?: string | undefined;
    annualPlacementGoal?: number | undefined;
    annualCweGoal?: number | undefined;
    averageStartingWage?: number | undefined;
    hoursWeek?: number | undefined;
    idField?: number | undefined;
    trailing90Day?: number | undefined;
    type?: string | undefined;
    divisonAbrv?: string | undefined;
    store?: boolean | undefined;
    address?: string | undefined;
    phone?: string | undefined;
}

export class QueryResultsOfCashCountViewModel implements IQueryResultsOfCashCountViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: CashCountViewModel[] | undefined;

    constructor(data?: IQueryResultsOfCashCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CashCountViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfCashCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfCashCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfCashCountViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: CashCountViewModel[] | undefined;
}

export class CashCountViewModel implements ICashCountViewModel {
    cashCountId!: number;
    storeId?: string | undefined;
    cashCount?: string | undefined;
    enteredBy?: string | undefined;
    date!: string;
    openingFunds?: boolean | undefined;
    closingFunds?: boolean | undefined;
    cashierDeposit?: boolean | undefined;
    bankDeposit?: boolean | undefined;
    store?: StoreViewModel | undefined;

    constructor(data?: ICashCountViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.cashCountId = _data["cashCountId"];
            this.storeId = _data["storeId"];
            this.cashCount = _data["cashCount"];
            this.enteredBy = _data["enteredBy"];
            this.date = _data["date"];
            this.openingFunds = _data["openingFunds"];
            this.closingFunds = _data["closingFunds"];
            this.cashierDeposit = _data["cashierDeposit"];
            this.bankDeposit = _data["bankDeposit"];
            this.store = _data["store"] ? StoreViewModel.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CashCountViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CashCountViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["cashCountId"] = this.cashCountId;
        data["storeId"] = this.storeId;
        data["cashCount"] = this.cashCount;
        data["enteredBy"] = this.enteredBy;
        data["date"] = this.date;
        data["openingFunds"] = this.openingFunds;
        data["closingFunds"] = this.closingFunds;
        data["cashierDeposit"] = this.cashierDeposit;
        data["bankDeposit"] = this.bankDeposit;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICashCountViewModel {
    cashCountId: number;
    storeId?: string | undefined;
    cashCount?: string | undefined;
    enteredBy?: string | undefined;
    date: string;
    openingFunds?: boolean | undefined;
    closingFunds?: boolean | undefined;
    cashierDeposit?: boolean | undefined;
    bankDeposit?: boolean | undefined;
    store?: StoreViewModel | undefined;
}

export class StoreViewModel implements IStoreViewModel {
    id?: string | undefined;
    name?: string | undefined;
    glNumber?: string | undefined;
    costCenterType?: string | undefined;
    area?: string | undefined;
    district?: string | undefined;
    hub?: string | undefined;
    isDiscontinued?: boolean | undefined;

    constructor(data?: IStoreViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.glNumber = _data["glNumber"];
            this.costCenterType = _data["costCenterType"];
            this.area = _data["area"];
            this.district = _data["district"];
            this.hub = _data["hub"];
            this.isDiscontinued = _data["isDiscontinued"];
        }
    }

    static fromJS(data: any): StoreViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoreViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["glNumber"] = this.glNumber;
        data["costCenterType"] = this.costCenterType;
        data["area"] = this.area;
        data["district"] = this.district;
        data["hub"] = this.hub;
        data["isDiscontinued"] = this.isDiscontinued;
        return data;
    }
}

export interface IStoreViewModel {
    id?: string | undefined;
    name?: string | undefined;
    glNumber?: string | undefined;
    costCenterType?: string | undefined;
    area?: string | undefined;
    district?: string | undefined;
    hub?: string | undefined;
    isDiscontinued?: boolean | undefined;
}

export class CashCountSavingModel implements ICashCountSavingModel {
    employeeId!: number;
    cashCountId!: number;
    storeId?: string | undefined;
    userId?: string | undefined;
    registerId?: string | undefined;
    cashCount!: number;
    enteredBy?: string | undefined;
    date!: string;
    openingFunds?: boolean | undefined;
    closingFunds?: boolean | undefined;
    cashierDeposit?: boolean | undefined;
    bankDeposit?: boolean | undefined;
    ones!: number;
    twos!: number;
    fives!: number;
    twenties!: number;
    hundreds!: number;
    pennies!: number;
    nickels!: number;
    dimes!: number;
    quarters!: number;
    fifties!: number;
    halfs!: number;
    coins!: number;
    tens!: number;
    penny!: number;
    nickel!: number;
    dime!: number;
    quarter!: number;
    half!: number;
    coin!: number;
    store?: StoreViewModel | undefined;

    constructor(data?: ICashCountSavingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"];
            this.cashCountId = _data["cashCountId"];
            this.storeId = _data["storeId"];
            this.userId = _data["userId"];
            this.registerId = _data["registerId"];
            this.cashCount = _data["cashCount"];
            this.enteredBy = _data["enteredBy"];
            this.date = _data["date"];
            this.openingFunds = _data["openingFunds"];
            this.closingFunds = _data["closingFunds"];
            this.cashierDeposit = _data["cashierDeposit"];
            this.bankDeposit = _data["bankDeposit"];
            this.ones = _data["ones"];
            this.twos = _data["twos"];
            this.fives = _data["fives"];
            this.twenties = _data["twenties"];
            this.hundreds = _data["hundreds"];
            this.pennies = _data["pennies"];
            this.nickels = _data["nickels"];
            this.dimes = _data["dimes"];
            this.quarters = _data["quarters"];
            this.fifties = _data["fifties"];
            this.halfs = _data["halfs"];
            this.coins = _data["coins"];
            this.tens = _data["tens"];
            this.penny = _data["penny"];
            this.nickel = _data["nickel"];
            this.dime = _data["dime"];
            this.quarter = _data["quarter"];
            this.half = _data["half"];
            this.coin = _data["coin"];
            this.store = _data["store"] ? StoreViewModel.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CashCountSavingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CashCountSavingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId;
        data["cashCountId"] = this.cashCountId;
        data["storeId"] = this.storeId;
        data["userId"] = this.userId;
        data["registerId"] = this.registerId;
        data["cashCount"] = this.cashCount;
        data["enteredBy"] = this.enteredBy;
        data["date"] = this.date;
        data["openingFunds"] = this.openingFunds;
        data["closingFunds"] = this.closingFunds;
        data["cashierDeposit"] = this.cashierDeposit;
        data["bankDeposit"] = this.bankDeposit;
        data["ones"] = this.ones;
        data["twos"] = this.twos;
        data["fives"] = this.fives;
        data["twenties"] = this.twenties;
        data["hundreds"] = this.hundreds;
        data["pennies"] = this.pennies;
        data["nickels"] = this.nickels;
        data["dimes"] = this.dimes;
        data["quarters"] = this.quarters;
        data["fifties"] = this.fifties;
        data["halfs"] = this.halfs;
        data["coins"] = this.coins;
        data["tens"] = this.tens;
        data["penny"] = this.penny;
        data["nickel"] = this.nickel;
        data["dime"] = this.dime;
        data["quarter"] = this.quarter;
        data["half"] = this.half;
        data["coin"] = this.coin;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICashCountSavingModel {
    employeeId: number;
    cashCountId: number;
    storeId?: string | undefined;
    userId?: string | undefined;
    registerId?: string | undefined;
    cashCount: number;
    enteredBy?: string | undefined;
    date: string;
    openingFunds?: boolean | undefined;
    closingFunds?: boolean | undefined;
    cashierDeposit?: boolean | undefined;
    bankDeposit?: boolean | undefined;
    ones: number;
    twos: number;
    fives: number;
    twenties: number;
    hundreds: number;
    pennies: number;
    nickels: number;
    dimes: number;
    quarters: number;
    fifties: number;
    halfs: number;
    coins: number;
    tens: number;
    penny: number;
    nickel: number;
    dime: number;
    quarter: number;
    half: number;
    coin: number;
    store?: StoreViewModel | undefined;
}

export class CashierVarianceViewModel implements ICashierVarianceViewModel {
    id!: number;
    storeLogin?: string | undefined;
    entryDate!: string;
    enteredByEmpNum?: string | undefined;
    cashierEmpNum?: string | undefined;
    varianceType?: string | undefined;
    varianceAmount!: number;
    remarks?: string | undefined;
    signature?: string | undefined;
    voidExplanation?: string | undefined;
    updateDate?: string | undefined;

    constructor(data?: ICashierVarianceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeLogin = _data["storeLogin"];
            this.entryDate = _data["entryDate"];
            this.enteredByEmpNum = _data["enteredByEmpNum"];
            this.cashierEmpNum = _data["cashierEmpNum"];
            this.varianceType = _data["varianceType"];
            this.varianceAmount = _data["varianceAmount"];
            this.remarks = _data["remarks"];
            this.signature = _data["signature"];
            this.voidExplanation = _data["voidExplanation"];
            this.updateDate = _data["updateDate"];
        }
    }

    static fromJS(data: any): CashierVarianceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CashierVarianceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeLogin"] = this.storeLogin;
        data["entryDate"] = this.entryDate;
        data["enteredByEmpNum"] = this.enteredByEmpNum;
        data["cashierEmpNum"] = this.cashierEmpNum;
        data["varianceType"] = this.varianceType;
        data["varianceAmount"] = this.varianceAmount;
        data["remarks"] = this.remarks;
        data["signature"] = this.signature;
        data["voidExplanation"] = this.voidExplanation;
        data["updateDate"] = this.updateDate;
        return data;
    }
}

export interface ICashierVarianceViewModel {
    id: number;
    storeLogin?: string | undefined;
    entryDate: string;
    enteredByEmpNum?: string | undefined;
    cashierEmpNum?: string | undefined;
    varianceType?: string | undefined;
    varianceAmount: number;
    remarks?: string | undefined;
    signature?: string | undefined;
    voidExplanation?: string | undefined;
    updateDate?: string | undefined;
}

export class CashierVariance implements ICashierVariance {
    id!: number;
    storeLogin?: string | undefined;
    entryDate!: string;
    enteredByEmpNum?: string | undefined;
    cashierEmpNum?: string | undefined;
    varianceType?: string | undefined;
    varianceAmount!: number;
    remarks?: string | undefined;
    signature?: string | undefined;
    voidExplanation?: string | undefined;
    updateDate?: string | undefined;

    constructor(data?: ICashierVariance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeLogin = _data["storeLogin"];
            this.entryDate = _data["entryDate"];
            this.enteredByEmpNum = _data["enteredByEmpNum"];
            this.cashierEmpNum = _data["cashierEmpNum"];
            this.varianceType = _data["varianceType"];
            this.varianceAmount = _data["varianceAmount"];
            this.remarks = _data["remarks"];
            this.signature = _data["signature"];
            this.voidExplanation = _data["voidExplanation"];
            this.updateDate = _data["updateDate"];
        }
    }

    static fromJS(data: any): CashierVariance {
        data = typeof data === 'object' ? data : {};
        let result = new CashierVariance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeLogin"] = this.storeLogin;
        data["entryDate"] = this.entryDate;
        data["enteredByEmpNum"] = this.enteredByEmpNum;
        data["cashierEmpNum"] = this.cashierEmpNum;
        data["varianceType"] = this.varianceType;
        data["varianceAmount"] = this.varianceAmount;
        data["remarks"] = this.remarks;
        data["signature"] = this.signature;
        data["voidExplanation"] = this.voidExplanation;
        data["updateDate"] = this.updateDate;
        return data;
    }
}

export interface ICashierVariance {
    id: number;
    storeLogin?: string | undefined;
    entryDate: string;
    enteredByEmpNum?: string | undefined;
    cashierEmpNum?: string | undefined;
    varianceType?: string | undefined;
    varianceAmount: number;
    remarks?: string | undefined;
    signature?: string | undefined;
    voidExplanation?: string | undefined;
    updateDate?: string | undefined;
}

export class QueryResultsOfCashierVarianceViewModel implements IQueryResultsOfCashierVarianceViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: CashierVarianceViewModel[] | undefined;

    constructor(data?: IQueryResultsOfCashierVarianceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CashierVarianceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfCashierVarianceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfCashierVarianceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfCashierVarianceViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: CashierVarianceViewModel[] | undefined;
}

export class ChristmasBudgetViewModel implements IChristmasBudgetViewModel {
    id!: number;
    year!: number;
    week!: number;
    budget!: number;
    budgetMoney!: number;

    constructor(data?: IChristmasBudgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.week = _data["week"];
            this.budget = _data["budget"];
            this.budgetMoney = _data["budgetMoney"];
        }
    }

    static fromJS(data: any): ChristmasBudgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ChristmasBudgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["week"] = this.week;
        data["budget"] = this.budget;
        data["budgetMoney"] = this.budgetMoney;
        return data;
    }
}

export interface IChristmasBudgetViewModel {
    id: number;
    year: number;
    week: number;
    budget: number;
    budgetMoney: number;
}

export class QueryResultsOfChristmasBudgetViewModel implements IQueryResultsOfChristmasBudgetViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ChristmasBudgetViewModel[] | undefined;

    constructor(data?: IQueryResultsOfChristmasBudgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ChristmasBudgetViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfChristmasBudgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfChristmasBudgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfChristmasBudgetViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ChristmasBudgetViewModel[] | undefined;
}

export class ChristmasBudget implements IChristmasBudget {
    id!: number;
    year!: number;
    week!: number;
    budget!: number;
    budgetMoney!: number;

    constructor(data?: IChristmasBudget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.week = _data["week"];
            this.budget = _data["budget"];
            this.budgetMoney = _data["budgetMoney"];
        }
    }

    static fromJS(data: any): ChristmasBudget {
        data = typeof data === 'object' ? data : {};
        let result = new ChristmasBudget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["week"] = this.week;
        data["budget"] = this.budget;
        data["budgetMoney"] = this.budgetMoney;
        return data;
    }
}

export interface IChristmasBudget {
    id: number;
    year: number;
    week: number;
    budget: number;
    budgetMoney: number;
}

export class CommunicationLogViewModel implements ICommunicationLogViewModel {
    id!: number;
    storeId?: string | undefined;
    entryDate!: string;
    enteredBy?: string | undefined;
    remarks?: string | undefined;
    store?: StoreViewModel2 | undefined;

    constructor(data?: ICommunicationLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.entryDate = _data["entryDate"];
            this.enteredBy = _data["enteredBy"];
            this.remarks = _data["remarks"];
            this.store = _data["store"] ? StoreViewModel2.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommunicationLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["entryDate"] = this.entryDate;
        data["enteredBy"] = this.enteredBy;
        data["remarks"] = this.remarks;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommunicationLogViewModel {
    id: number;
    storeId?: string | undefined;
    entryDate: string;
    enteredBy?: string | undefined;
    remarks?: string | undefined;
    store?: StoreViewModel2 | undefined;
}

export class StoreViewModel2 implements IStoreViewModel2 {
    id?: string | undefined;
    name?: string | undefined;

    constructor(data?: IStoreViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): StoreViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new StoreViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IStoreViewModel2 {
    id?: string | undefined;
    name?: string | undefined;
}

export class QueryResultsOfCommunicationLogViewModel implements IQueryResultsOfCommunicationLogViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: CommunicationLogViewModel[] | undefined;

    constructor(data?: IQueryResultsOfCommunicationLogViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CommunicationLogViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfCommunicationLogViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfCommunicationLogViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfCommunicationLogViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: CommunicationLogViewModel[] | undefined;
}

export class CommunicationLogQuery extends Query implements ICommunicationLogQuery {

    constructor(data?: ICommunicationLogQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): CommunicationLogQuery {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationLogQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface ICommunicationLogQuery extends IQuery {
}

export class CommunicationLogSavingRequest implements ICommunicationLogSavingRequest {
    storeId?: string | undefined;
    entryDate!: string;
    enteredBy?: string | undefined;
    remarks?: string | undefined;

    constructor(data?: ICommunicationLogSavingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.storeId = _data["storeId"];
            this.entryDate = _data["entryDate"];
            this.enteredBy = _data["enteredBy"];
            this.remarks = _data["remarks"];
        }
    }

    static fromJS(data: any): CommunicationLogSavingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationLogSavingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["entryDate"] = this.entryDate;
        data["enteredBy"] = this.enteredBy;
        data["remarks"] = this.remarks;
        return data;
    }
}

export interface ICommunicationLogSavingRequest {
    storeId?: string | undefined;
    entryDate: string;
    enteredBy?: string | undefined;
    remarks?: string | undefined;
}

export class CommunicationLogUpdatingRequest implements ICommunicationLogUpdatingRequest {
    id!: number;
    storeId?: string | undefined;
    entryDate!: string;
    enteredBy?: string | undefined;
    remarks?: string | undefined;
    store?: StoreViewModel | undefined;

    constructor(data?: ICommunicationLogUpdatingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.entryDate = _data["entryDate"];
            this.enteredBy = _data["enteredBy"];
            this.remarks = _data["remarks"];
            this.store = _data["store"] ? StoreViewModel.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): CommunicationLogUpdatingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CommunicationLogUpdatingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["entryDate"] = this.entryDate;
        data["enteredBy"] = this.enteredBy;
        data["remarks"] = this.remarks;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

export interface ICommunicationLogUpdatingRequest {
    id: number;
    storeId?: string | undefined;
    entryDate: string;
    enteredBy?: string | undefined;
    remarks?: string | undefined;
    store?: StoreViewModel | undefined;
}

export class ContainerAudit implements IContainerAudit {
    id!: number;
    containerType?: string | undefined;
    containerBarcode?: string | undefined;
    auditDate!: string;
    storeId?: string | undefined;
    initials?: string | undefined;
    shipDate!: string;
    itemCount!: number;
    cracked?: number | undefined;
    brokenSpine?: number | undefined;
    moistureDamage?: number | undefined;
    writtenIn?: number | undefined;
    missingPages?: number | undefined;
    conditionUpgraded?: number | undefined;
    conditionDowngraded?: number | undefined;
    vhscassette?: number | undefined;
    contentDoNotMatchCover?: number | undefined;
    missingParts?: number | undefined;
    volumeSet?: number | undefined;
    exLibrary?: number | undefined;
    notForResale?: number | undefined;
    incompleteSet?: number | undefined;
    inappropriate?: number | undefined;
    caseDoesNotMatchLabel?: number | undefined;
    other?: number | undefined;
    comment?: string | undefined;

    constructor(data?: IContainerAudit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.containerType = _data["containerType"];
            this.containerBarcode = _data["containerBarcode"];
            this.auditDate = _data["auditDate"];
            this.storeId = _data["storeId"];
            this.initials = _data["initials"];
            this.shipDate = _data["shipDate"];
            this.itemCount = _data["itemCount"];
            this.cracked = _data["cracked"];
            this.brokenSpine = _data["brokenSpine"];
            this.moistureDamage = _data["moistureDamage"];
            this.writtenIn = _data["writtenIn"];
            this.missingPages = _data["missingPages"];
            this.conditionUpgraded = _data["conditionUpgraded"];
            this.conditionDowngraded = _data["conditionDowngraded"];
            this.vhscassette = _data["vhscassette"];
            this.contentDoNotMatchCover = _data["contentDoNotMatchCover"];
            this.missingParts = _data["missingParts"];
            this.volumeSet = _data["volumeSet"];
            this.exLibrary = _data["exLibrary"];
            this.notForResale = _data["notForResale"];
            this.incompleteSet = _data["incompleteSet"];
            this.inappropriate = _data["inappropriate"];
            this.caseDoesNotMatchLabel = _data["caseDoesNotMatchLabel"];
            this.other = _data["other"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): ContainerAudit {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerAudit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containerType"] = this.containerType;
        data["containerBarcode"] = this.containerBarcode;
        data["auditDate"] = this.auditDate;
        data["storeId"] = this.storeId;
        data["initials"] = this.initials;
        data["shipDate"] = this.shipDate;
        data["itemCount"] = this.itemCount;
        data["cracked"] = this.cracked;
        data["brokenSpine"] = this.brokenSpine;
        data["moistureDamage"] = this.moistureDamage;
        data["writtenIn"] = this.writtenIn;
        data["missingPages"] = this.missingPages;
        data["conditionUpgraded"] = this.conditionUpgraded;
        data["conditionDowngraded"] = this.conditionDowngraded;
        data["vhscassette"] = this.vhscassette;
        data["contentDoNotMatchCover"] = this.contentDoNotMatchCover;
        data["missingParts"] = this.missingParts;
        data["volumeSet"] = this.volumeSet;
        data["exLibrary"] = this.exLibrary;
        data["notForResale"] = this.notForResale;
        data["incompleteSet"] = this.incompleteSet;
        data["inappropriate"] = this.inappropriate;
        data["caseDoesNotMatchLabel"] = this.caseDoesNotMatchLabel;
        data["other"] = this.other;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IContainerAudit {
    id: number;
    containerType?: string | undefined;
    containerBarcode?: string | undefined;
    auditDate: string;
    storeId?: string | undefined;
    initials?: string | undefined;
    shipDate: string;
    itemCount: number;
    cracked?: number | undefined;
    brokenSpine?: number | undefined;
    moistureDamage?: number | undefined;
    writtenIn?: number | undefined;
    missingPages?: number | undefined;
    conditionUpgraded?: number | undefined;
    conditionDowngraded?: number | undefined;
    vhscassette?: number | undefined;
    contentDoNotMatchCover?: number | undefined;
    missingParts?: number | undefined;
    volumeSet?: number | undefined;
    exLibrary?: number | undefined;
    notForResale?: number | undefined;
    incompleteSet?: number | undefined;
    inappropriate?: number | undefined;
    caseDoesNotMatchLabel?: number | undefined;
    other?: number | undefined;
    comment?: string | undefined;
}

export class QueryResultsOfContainerAudit implements IQueryResultsOfContainerAudit {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ContainerAudit[] | undefined;

    constructor(data?: IQueryResultsOfContainerAudit) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContainerAudit.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfContainerAudit {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfContainerAudit();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfContainerAudit {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ContainerAudit[] | undefined;
}

export class ContainerViewModel implements IContainerViewModel {
    id!: number;
    containerBarcode?: string | undefined;
    originId?: string | undefined;
    destinationId?: string | undefined;
    createdDate!: string;
    enteredBy?: string | undefined;
    status?: string | undefined;
    comment?: string | undefined;
    updatedDate?: string | undefined;
    weight?: number | undefined;
    updatedBy?: string | undefined;
    bagContainerNumber?: string | undefined;
    originName?: string | undefined;
    destinationName?: string | undefined;
    origin?: Store | undefined;
    destination?: Store | undefined;

    constructor(data?: IContainerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.containerBarcode = _data["containerBarcode"];
            this.originId = _data["originId"];
            this.destinationId = _data["destinationId"];
            this.createdDate = _data["createdDate"];
            this.enteredBy = _data["enteredBy"];
            this.status = _data["status"];
            this.comment = _data["comment"];
            this.updatedDate = _data["updatedDate"];
            this.weight = _data["weight"];
            this.updatedBy = _data["updatedBy"];
            this.bagContainerNumber = _data["bagContainerNumber"];
            this.originName = _data["originName"];
            this.destinationName = _data["destinationName"];
            this.origin = _data["origin"] ? Store.fromJS(_data["origin"]) : <any>undefined;
            this.destination = _data["destination"] ? Store.fromJS(_data["destination"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContainerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containerBarcode"] = this.containerBarcode;
        data["originId"] = this.originId;
        data["destinationId"] = this.destinationId;
        data["createdDate"] = this.createdDate;
        data["enteredBy"] = this.enteredBy;
        data["status"] = this.status;
        data["comment"] = this.comment;
        data["updatedDate"] = this.updatedDate;
        data["weight"] = this.weight;
        data["updatedBy"] = this.updatedBy;
        data["bagContainerNumber"] = this.bagContainerNumber;
        data["originName"] = this.originName;
        data["destinationName"] = this.destinationName;
        data["origin"] = this.origin ? this.origin.toJSON() : <any>undefined;
        data["destination"] = this.destination ? this.destination.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContainerViewModel {
    id: number;
    containerBarcode?: string | undefined;
    originId?: string | undefined;
    destinationId?: string | undefined;
    createdDate: string;
    enteredBy?: string | undefined;
    status?: string | undefined;
    comment?: string | undefined;
    updatedDate?: string | undefined;
    weight?: number | undefined;
    updatedBy?: string | undefined;
    bagContainerNumber?: string | undefined;
    originName?: string | undefined;
    destinationName?: string | undefined;
    origin?: Store | undefined;
    destination?: Store | undefined;
}

export class QueryResultsOfContainerViewModel implements IQueryResultsOfContainerViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ContainerViewModel[] | undefined;

    constructor(data?: IQueryResultsOfContainerViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContainerViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfContainerViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfContainerViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfContainerViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ContainerViewModel[] | undefined;
}

export class ContainerIssue implements IContainerIssue {
    id!: number;
    containerId!: number;
    issue?: string | undefined;
    comments?: string | undefined;
    container?: Container | undefined;

    constructor(data?: IContainerIssue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.containerId = _data["containerId"];
            this.issue = _data["issue"];
            this.comments = _data["comments"];
            this.container = _data["container"] ? Container.fromJS(_data["container"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ContainerIssue {
        data = typeof data === 'object' ? data : {};
        let result = new ContainerIssue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["containerId"] = this.containerId;
        data["issue"] = this.issue;
        data["comments"] = this.comments;
        data["container"] = this.container ? this.container.toJSON() : <any>undefined;
        return data;
    }
}

export interface IContainerIssue {
    id: number;
    containerId: number;
    issue?: string | undefined;
    comments?: string | undefined;
    container?: Container | undefined;
}

export class QueryResultsOfContainerIssue implements IQueryResultsOfContainerIssue {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ContainerIssue[] | undefined;

    constructor(data?: IQueryResultsOfContainerIssue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ContainerIssue.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfContainerIssue {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfContainerIssue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfContainerIssue {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ContainerIssue[] | undefined;
}

export class QueryResultsOfCostCenterViewModel implements IQueryResultsOfCostCenterViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: CostCenterViewModel[] | undefined;

    constructor(data?: IQueryResultsOfCostCenterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CostCenterViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfCostCenterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfCostCenterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfCostCenterViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: CostCenterViewModel[] | undefined;
}

export class CostCenterViewModel implements ICostCenterViewModel {
    id!: number;
    costCenterNumber!: number;
    location?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICostCenterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.costCenterNumber = _data["costCenterNumber"];
            this.location = _data["location"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CostCenterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["costCenterNumber"] = this.costCenterNumber;
        data["location"] = this.location;
        data["description"] = this.description;
        return data;
    }
}

export interface ICostCenterViewModel {
    id: number;
    costCenterNumber: number;
    location?: string | undefined;
    description?: string | undefined;
}

export class CostCenterSavingModel implements ICostCenterSavingModel {
    id!: number;
    costCenterNumber!: number;
    location?: string | undefined;
    description?: string | undefined;

    constructor(data?: ICostCenterSavingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.costCenterNumber = _data["costCenterNumber"];
            this.location = _data["location"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CostCenterSavingModel {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenterSavingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["costCenterNumber"] = this.costCenterNumber;
        data["location"] = this.location;
        data["description"] = this.description;
        return data;
    }
}

export interface ICostCenterSavingModel {
    id: number;
    costCenterNumber: number;
    location?: string | undefined;
    description?: string | undefined;
}

export class QueryResultsOfCostCenter implements IQueryResultsOfCostCenter {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: CostCenter2[] | undefined;

    constructor(data?: IQueryResultsOfCostCenter) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(CostCenter2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfCostCenter {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfCostCenter();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfCostCenter {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: CostCenter2[] | undefined;
}

export class CostCenter2 implements ICostCenter2 {
    id!: number;
    actnumbR_1?: string | undefined;
    name?: string | undefined;

    constructor(data?: ICostCenter2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.actnumbR_1 = _data["actnumbR_1"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): CostCenter2 {
        data = typeof data === 'object' ? data : {};
        let result = new CostCenter2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["actnumbR_1"] = this.actnumbR_1;
        data["name"] = this.name;
        return data;
    }
}

export interface ICostCenter2 {
    id: number;
    actnumbR_1?: string | undefined;
    name?: string | undefined;
}

export class DailyActivityLog implements IDailyActivityLog {
    id!: number;
    date!: string;
    store?: string | undefined;
    suspectName?: string | undefined;
    dollarAmt!: number;
    stopTime!: string;
    procTime!: number;
    floorTime!: number;
    travelTime!: number;
    disposition?: string | undefined;
    cdsubmitted!: boolean;
    enteredBy?: string | undefined;
    entryDate?: string | undefined;

    constructor(data?: IDailyActivityLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"];
            this.store = _data["store"];
            this.suspectName = _data["suspectName"];
            this.dollarAmt = _data["dollarAmt"];
            this.stopTime = _data["stopTime"];
            this.procTime = _data["procTime"];
            this.floorTime = _data["floorTime"];
            this.travelTime = _data["travelTime"];
            this.disposition = _data["disposition"];
            this.cdsubmitted = _data["cdsubmitted"];
            this.enteredBy = _data["enteredBy"];
            this.entryDate = _data["entryDate"];
        }
    }

    static fromJS(data: any): DailyActivityLog {
        data = typeof data === 'object' ? data : {};
        let result = new DailyActivityLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date;
        data["store"] = this.store;
        data["suspectName"] = this.suspectName;
        data["dollarAmt"] = this.dollarAmt;
        data["stopTime"] = this.stopTime;
        data["procTime"] = this.procTime;
        data["floorTime"] = this.floorTime;
        data["travelTime"] = this.travelTime;
        data["disposition"] = this.disposition;
        data["cdsubmitted"] = this.cdsubmitted;
        data["enteredBy"] = this.enteredBy;
        data["entryDate"] = this.entryDate;
        return data;
    }
}

export interface IDailyActivityLog {
    id: number;
    date: string;
    store?: string | undefined;
    suspectName?: string | undefined;
    dollarAmt: number;
    stopTime: string;
    procTime: number;
    floorTime: number;
    travelTime: number;
    disposition?: string | undefined;
    cdsubmitted: boolean;
    enteredBy?: string | undefined;
    entryDate?: string | undefined;
}

export class DepositRecordViewModel implements IDepositRecordViewModel {
    id!: number;
    date!: string;
    deposit!: number;
    paperChecks!: number;
    foundMoney?: number | undefined;
    changeOrder?: number | undefined;
    dateEntered?: string | undefined;
    store?: StoreViewModel3 | undefined;

    constructor(data?: IDepositRecordViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"];
            this.deposit = _data["deposit"];
            this.paperChecks = _data["paperChecks"];
            this.foundMoney = _data["foundMoney"];
            this.changeOrder = _data["changeOrder"];
            this.dateEntered = _data["dateEntered"];
            this.store = _data["store"] ? StoreViewModel3.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DepositRecordViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DepositRecordViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date;
        data["deposit"] = this.deposit;
        data["paperChecks"] = this.paperChecks;
        data["foundMoney"] = this.foundMoney;
        data["changeOrder"] = this.changeOrder;
        data["dateEntered"] = this.dateEntered;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDepositRecordViewModel {
    id: number;
    date: string;
    deposit: number;
    paperChecks: number;
    foundMoney?: number | undefined;
    changeOrder?: number | undefined;
    dateEntered?: string | undefined;
    store?: StoreViewModel3 | undefined;
}

export class StoreViewModel3 implements IStoreViewModel3 {
    id?: string | undefined;
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed!: boolean;
    isGRERunning!: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    costCenterType?: string | undefined;
    status?: string | undefined;
    retailSQFeet?: number | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    milesFromCorporate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;
    rowguid!: string;

    constructor(data?: IStoreViewModel3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.storeMnemonic = _data["storeMnemonic"];
            this.storeMnemonic2 = _data["storeMnemonic2"];
            this.serverName = _data["serverName"];
            this.gredbName = _data["gredbName"];
            this.isClosed = _data["isClosed"];
            this.isGRERunning = _data["isGRERunning"];
            this.storeLogin = _data["storeLogin"];
            this.district = _data["district"];
            this.costCenterType = _data["costCenterType"];
            this.status = _data["status"];
            this.retailSQFeet = _data["retailSQFeet"];
            this.glNumber = _data["glNumber"];
            this.glCash = _data["glCash"];
            this.glNumber2 = _data["glNumber2"];
            this.sort = _data["sort"];
            this.locationId = _data["locationId"];
            this.milesFromCorporate = _data["milesFromCorporate"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.regionId = _data["regionId"];
            this.email = _data["email"];
            this.dmEmail = _data["dmEmail"];
            this.districtEmail = _data["districtEmail"];
            this.prefix = _data["prefix"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.aaExtension = _data["aaExtension"];
            this.rowguid = _data["rowguid"];
        }
    }

    static fromJS(data: any): StoreViewModel3 {
        data = typeof data === 'object' ? data : {};
        let result = new StoreViewModel3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["storeMnemonic"] = this.storeMnemonic;
        data["storeMnemonic2"] = this.storeMnemonic2;
        data["serverName"] = this.serverName;
        data["gredbName"] = this.gredbName;
        data["isClosed"] = this.isClosed;
        data["isGRERunning"] = this.isGRERunning;
        data["storeLogin"] = this.storeLogin;
        data["district"] = this.district;
        data["costCenterType"] = this.costCenterType;
        data["status"] = this.status;
        data["retailSQFeet"] = this.retailSQFeet;
        data["glNumber"] = this.glNumber;
        data["glCash"] = this.glCash;
        data["glNumber2"] = this.glNumber2;
        data["sort"] = this.sort;
        data["locationId"] = this.locationId;
        data["milesFromCorporate"] = this.milesFromCorporate;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["regionId"] = this.regionId;
        data["email"] = this.email;
        data["dmEmail"] = this.dmEmail;
        data["districtEmail"] = this.districtEmail;
        data["prefix"] = this.prefix;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["aaExtension"] = this.aaExtension;
        data["rowguid"] = this.rowguid;
        return data;
    }
}

export interface IStoreViewModel3 {
    id?: string | undefined;
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed: boolean;
    isGRERunning: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    costCenterType?: string | undefined;
    status?: string | undefined;
    retailSQFeet?: number | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    milesFromCorporate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;
    rowguid: string;
}

export class DepositRecord implements IDepositRecord {
    id!: number;
    storeId?: string | undefined;
    date!: string;
    deposit!: number;
    paperChecks!: number;
    foundMoney!: number;
    changeOrder!: number;
    enteredBy?: string | undefined;
    dateEntered!: string;

    constructor(data?: IDepositRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.date = _data["date"];
            this.deposit = _data["deposit"];
            this.paperChecks = _data["paperChecks"];
            this.foundMoney = _data["foundMoney"];
            this.changeOrder = _data["changeOrder"];
            this.enteredBy = _data["enteredBy"];
            this.dateEntered = _data["dateEntered"];
        }
    }

    static fromJS(data: any): DepositRecord {
        data = typeof data === 'object' ? data : {};
        let result = new DepositRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["date"] = this.date;
        data["deposit"] = this.deposit;
        data["paperChecks"] = this.paperChecks;
        data["foundMoney"] = this.foundMoney;
        data["changeOrder"] = this.changeOrder;
        data["enteredBy"] = this.enteredBy;
        data["dateEntered"] = this.dateEntered;
        return data;
    }
}

export interface IDepositRecord {
    id: number;
    storeId?: string | undefined;
    date: string;
    deposit: number;
    paperChecks: number;
    foundMoney: number;
    changeOrder: number;
    enteredBy?: string | undefined;
    dateEntered: string;
}

export class QueryResultsOfDepositRecordViewModel implements IQueryResultsOfDepositRecordViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: DepositRecordViewModel[] | undefined;

    constructor(data?: IQueryResultsOfDepositRecordViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DepositRecordViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfDepositRecordViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfDepositRecordViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfDepositRecordViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: DepositRecordViewModel[] | undefined;
}

export class QueryResultsOfDisabilViewModel implements IQueryResultsOfDisabilViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: DisabilViewModel[] | undefined;

    constructor(data?: IQueryResultsOfDisabilViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DisabilViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfDisabilViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfDisabilViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfDisabilViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: DisabilViewModel[] | undefined;
}

export class DisabilViewModel implements IDisabilViewModel {
    code?: string | undefined;
    description?: string | undefined;

    constructor(data?: IDisabilViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): DisabilViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DisabilViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        return data;
    }
}

export interface IDisabilViewModel {
    code?: string | undefined;
    description?: string | undefined;
}

export class DMAuditRecord implements IDMAuditRecord {
    id!: number;
    storeId?: string | undefined;
    month!: number;
    year!: number;
    dateComplete!: string;
    completedBy?: string | undefined;
    manager?: string | undefined;
    dmAuditDetails?: DMAuditDetail[] | undefined;

    constructor(data?: IDMAuditRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.month = _data["month"];
            this.year = _data["year"];
            this.dateComplete = _data["dateComplete"];
            this.completedBy = _data["completedBy"];
            this.manager = _data["manager"];
            if (Array.isArray(_data["dmAuditDetails"])) {
                this.dmAuditDetails = [] as any;
                for (let item of _data["dmAuditDetails"])
                    this.dmAuditDetails!.push(DMAuditDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DMAuditRecord {
        data = typeof data === 'object' ? data : {};
        let result = new DMAuditRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["month"] = this.month;
        data["year"] = this.year;
        data["dateComplete"] = this.dateComplete;
        data["completedBy"] = this.completedBy;
        data["manager"] = this.manager;
        if (Array.isArray(this.dmAuditDetails)) {
            data["dmAuditDetails"] = [];
            for (let item of this.dmAuditDetails)
                data["dmAuditDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDMAuditRecord {
    id: number;
    storeId?: string | undefined;
    month: number;
    year: number;
    dateComplete: string;
    completedBy?: string | undefined;
    manager?: string | undefined;
    dmAuditDetails?: DMAuditDetail[] | undefined;
}

export class DMAuditDetail implements IDMAuditDetail {
    id!: number;
    dmAuditRecordId!: number;
    auditCategory?: string | undefined;
    auditSubCategory?: string | undefined;
    auditArea?: string | undefined;
    auditAreaDescription?: string | undefined;
    points!: number;
    comments?: string | undefined;

    constructor(data?: IDMAuditDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.dmAuditRecordId = _data["dmAuditRecordId"];
            this.auditCategory = _data["auditCategory"];
            this.auditSubCategory = _data["auditSubCategory"];
            this.auditArea = _data["auditArea"];
            this.auditAreaDescription = _data["auditAreaDescription"];
            this.points = _data["points"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): DMAuditDetail {
        data = typeof data === 'object' ? data : {};
        let result = new DMAuditDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["dmAuditRecordId"] = this.dmAuditRecordId;
        data["auditCategory"] = this.auditCategory;
        data["auditSubCategory"] = this.auditSubCategory;
        data["auditArea"] = this.auditArea;
        data["auditAreaDescription"] = this.auditAreaDescription;
        data["points"] = this.points;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IDMAuditDetail {
    id: number;
    dmAuditRecordId: number;
    auditCategory?: string | undefined;
    auditSubCategory?: string | undefined;
    auditArea?: string | undefined;
    auditAreaDescription?: string | undefined;
    points: number;
    comments?: string | undefined;
}

export class QueryResultsOfDonationBudgetViewModel implements IQueryResultsOfDonationBudgetViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: DonationBudgetViewModel[] | undefined;

    constructor(data?: IQueryResultsOfDonationBudgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DonationBudgetViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfDonationBudgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfDonationBudgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfDonationBudgetViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: DonationBudgetViewModel[] | undefined;
}

export class DonationBudgetViewModel implements IDonationBudgetViewModel {
    id!: number;
    year?: number | undefined;
    location?: number | undefined;
    budget?: number | undefined;
    budgetMoney!: number;
    site?: SiteViewModel | undefined;

    constructor(data?: IDonationBudgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.location = _data["location"];
            this.budget = _data["budget"];
            this.budgetMoney = _data["budgetMoney"];
            this.site = _data["site"] ? SiteViewModel.fromJS(_data["site"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DonationBudgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DonationBudgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["location"] = this.location;
        data["budget"] = this.budget;
        data["budgetMoney"] = this.budgetMoney;
        data["site"] = this.site ? this.site.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDonationBudgetViewModel {
    id: number;
    year?: number | undefined;
    location?: number | undefined;
    budget?: number | undefined;
    budgetMoney: number;
    site?: SiteViewModel | undefined;
}

export class SiteViewModel implements ISiteViewModel {
    id!: number;
    name?: string | undefined;
    costCenterType?: string | undefined;
    division?: string | undefined;
    number?: number | undefined;
    annualGoalPounds?: number | undefined;
    trailer?: string | undefined;
    siteDescription?: string | undefined;
    statusId?: number | undefined;
    storeId?: string | undefined;
    typeCode?: string | undefined;

    constructor(data?: ISiteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.costCenterType = _data["costCenterType"];
            this.division = _data["division"];
            this.number = _data["number"];
            this.annualGoalPounds = _data["annualGoalPounds"];
            this.trailer = _data["trailer"];
            this.siteDescription = _data["siteDescription"];
            this.statusId = _data["statusId"];
            this.storeId = _data["storeId"];
            this.typeCode = _data["typeCode"];
        }
    }

    static fromJS(data: any): SiteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SiteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["costCenterType"] = this.costCenterType;
        data["division"] = this.division;
        data["number"] = this.number;
        data["annualGoalPounds"] = this.annualGoalPounds;
        data["trailer"] = this.trailer;
        data["siteDescription"] = this.siteDescription;
        data["statusId"] = this.statusId;
        data["storeId"] = this.storeId;
        data["typeCode"] = this.typeCode;
        return data;
    }
}

export interface ISiteViewModel {
    id: number;
    name?: string | undefined;
    costCenterType?: string | undefined;
    division?: string | undefined;
    number?: number | undefined;
    annualGoalPounds?: number | undefined;
    trailer?: string | undefined;
    siteDescription?: string | undefined;
    statusId?: number | undefined;
    storeId?: string | undefined;
    typeCode?: string | undefined;
}

export class DonationBudget implements IDonationBudget {
    id?: number | undefined;
    year?: number | undefined;
    location?: number | undefined;
    budget?: number | undefined;
    budgetMoney!: number;

    constructor(data?: IDonationBudget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.location = _data["location"];
            this.budget = _data["budget"];
            this.budgetMoney = _data["budgetMoney"];
        }
    }

    static fromJS(data: any): DonationBudget {
        data = typeof data === 'object' ? data : {};
        let result = new DonationBudget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["location"] = this.location;
        data["budget"] = this.budget;
        data["budgetMoney"] = this.budgetMoney;
        return data;
    }
}

export interface IDonationBudget {
    id?: number | undefined;
    year?: number | undefined;
    location?: number | undefined;
    budget?: number | undefined;
    budgetMoney: number;
}

export class DonationInError implements IDonationInError {
    id!: number;
    status?: string | undefined;
    donorFirstName?: string | undefined;
    donorLastName?: string | undefined;
    donorPhone?: string | undefined;
    donorCell?: string | undefined;
    donationDate!: string;
    donationTime!: string;
    attendantPresent!: boolean;
    donationSiteId?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;
    trailerId?: number | undefined;
    trailerAtSite?: boolean | undefined;
    trailerTransferDate?: string | undefined;
    trailerDestinationId?: string | undefined;
    reported?: boolean | undefined;
    donorTwoFirstName?: string | undefined;
    donorTwoLastName?: string | undefined;
    email?: string | undefined;
    donationInErrorDetails?: DonationInErrorDetail[] | undefined;
    donationInErrorPictures?: DonationInErrorPicture[] | undefined;

    constructor(data?: IDonationInError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.donorFirstName = _data["donorFirstName"];
            this.donorLastName = _data["donorLastName"];
            this.donorPhone = _data["donorPhone"];
            this.donorCell = _data["donorCell"];
            this.donationDate = _data["donationDate"];
            this.donationTime = _data["donationTime"];
            this.attendantPresent = _data["attendantPresent"];
            this.donationSiteId = _data["donationSiteId"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.trailerId = _data["trailerId"];
            this.trailerAtSite = _data["trailerAtSite"];
            this.trailerTransferDate = _data["trailerTransferDate"];
            this.trailerDestinationId = _data["trailerDestinationId"];
            this.reported = _data["reported"];
            this.donorTwoFirstName = _data["donorTwoFirstName"];
            this.donorTwoLastName = _data["donorTwoLastName"];
            this.email = _data["email"];
            if (Array.isArray(_data["donationInErrorDetails"])) {
                this.donationInErrorDetails = [] as any;
                for (let item of _data["donationInErrorDetails"])
                    this.donationInErrorDetails!.push(DonationInErrorDetail.fromJS(item));
            }
            if (Array.isArray(_data["donationInErrorPictures"])) {
                this.donationInErrorPictures = [] as any;
                for (let item of _data["donationInErrorPictures"])
                    this.donationInErrorPictures!.push(DonationInErrorPicture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): DonationInError {
        data = typeof data === 'object' ? data : {};
        let result = new DonationInError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["donorFirstName"] = this.donorFirstName;
        data["donorLastName"] = this.donorLastName;
        data["donorPhone"] = this.donorPhone;
        data["donorCell"] = this.donorCell;
        data["donationDate"] = this.donationDate;
        data["donationTime"] = this.donationTime;
        data["attendantPresent"] = this.attendantPresent;
        data["donationSiteId"] = this.donationSiteId;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["trailerId"] = this.trailerId;
        data["trailerAtSite"] = this.trailerAtSite;
        data["trailerTransferDate"] = this.trailerTransferDate;
        data["trailerDestinationId"] = this.trailerDestinationId;
        data["reported"] = this.reported;
        data["donorTwoFirstName"] = this.donorTwoFirstName;
        data["donorTwoLastName"] = this.donorTwoLastName;
        data["email"] = this.email;
        if (Array.isArray(this.donationInErrorDetails)) {
            data["donationInErrorDetails"] = [];
            for (let item of this.donationInErrorDetails)
                data["donationInErrorDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.donationInErrorPictures)) {
            data["donationInErrorPictures"] = [];
            for (let item of this.donationInErrorPictures)
                data["donationInErrorPictures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IDonationInError {
    id: number;
    status?: string | undefined;
    donorFirstName?: string | undefined;
    donorLastName?: string | undefined;
    donorPhone?: string | undefined;
    donorCell?: string | undefined;
    donationDate: string;
    donationTime: string;
    attendantPresent: boolean;
    donationSiteId?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
    trailerId?: number | undefined;
    trailerAtSite?: boolean | undefined;
    trailerTransferDate?: string | undefined;
    trailerDestinationId?: string | undefined;
    reported?: boolean | undefined;
    donorTwoFirstName?: string | undefined;
    donorTwoLastName?: string | undefined;
    email?: string | undefined;
    donationInErrorDetails?: DonationInErrorDetail[] | undefined;
    donationInErrorPictures?: DonationInErrorPicture[] | undefined;
}

export class DonationInErrorDetail implements IDonationInErrorDetail {
    id!: number;
    donationInErrorId!: number;
    itemDescription?: string | undefined;
    itemType?: string | undefined;
    makeModel?: string | undefined;
    approximateSizeWeight?: string | undefined;
    additionalInformation?: string | undefined;
    donationInError?: DonationInError | undefined;

    constructor(data?: IDonationInErrorDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.donationInErrorId = _data["donationInErrorId"];
            this.itemDescription = _data["itemDescription"];
            this.itemType = _data["itemType"];
            this.makeModel = _data["makeModel"];
            this.approximateSizeWeight = _data["approximateSizeWeight"];
            this.additionalInformation = _data["additionalInformation"];
            this.donationInError = _data["donationInError"] ? DonationInError.fromJS(_data["donationInError"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DonationInErrorDetail {
        data = typeof data === 'object' ? data : {};
        let result = new DonationInErrorDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["donationInErrorId"] = this.donationInErrorId;
        data["itemDescription"] = this.itemDescription;
        data["itemType"] = this.itemType;
        data["makeModel"] = this.makeModel;
        data["approximateSizeWeight"] = this.approximateSizeWeight;
        data["additionalInformation"] = this.additionalInformation;
        data["donationInError"] = this.donationInError ? this.donationInError.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDonationInErrorDetail {
    id: number;
    donationInErrorId: number;
    itemDescription?: string | undefined;
    itemType?: string | undefined;
    makeModel?: string | undefined;
    approximateSizeWeight?: string | undefined;
    additionalInformation?: string | undefined;
    donationInError?: DonationInError | undefined;
}

export class DonationInErrorPicture implements IDonationInErrorPicture {
    id!: number;
    donationInErrorId!: number;
    picture?: string | undefined;
    donationInError?: DonationInError | undefined;

    constructor(data?: IDonationInErrorPicture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.donationInErrorId = _data["donationInErrorId"];
            this.picture = _data["picture"];
            this.donationInError = _data["donationInError"] ? DonationInError.fromJS(_data["donationInError"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DonationInErrorPicture {
        data = typeof data === 'object' ? data : {};
        let result = new DonationInErrorPicture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["donationInErrorId"] = this.donationInErrorId;
        data["picture"] = this.picture;
        data["donationInError"] = this.donationInError ? this.donationInError.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDonationInErrorPicture {
    id: number;
    donationInErrorId: number;
    picture?: string | undefined;
    donationInError?: DonationInError | undefined;
}

export class DonationInErrorEditViewModel implements IDonationInErrorEditViewModel {
    id!: number;
    status?: string | undefined;
    donorFirstName?: string | undefined;
    donorLastName?: string | undefined;
    donorPhone?: string | undefined;
    donorCell?: string | undefined;
    donationDate!: string;
    donationTime!: string;
    attendantPresent!: boolean;
    donationSiteId?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;
    trailerId?: number | undefined;
    trailerAtSite?: boolean | undefined;
    trailerTransferDate?: string | undefined;
    trailerDestinationId?: string | undefined;
    reported?: boolean | undefined;
    donorTwoFirstName?: string | undefined;
    donorTwoLastName?: string | undefined;
    email?: string | undefined;

    constructor(data?: IDonationInErrorEditViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.status = _data["status"];
            this.donorFirstName = _data["donorFirstName"];
            this.donorLastName = _data["donorLastName"];
            this.donorPhone = _data["donorPhone"];
            this.donorCell = _data["donorCell"];
            this.donationDate = _data["donationDate"];
            this.donationTime = _data["donationTime"];
            this.attendantPresent = _data["attendantPresent"];
            this.donationSiteId = _data["donationSiteId"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.trailerId = _data["trailerId"];
            this.trailerAtSite = _data["trailerAtSite"];
            this.trailerTransferDate = _data["trailerTransferDate"];
            this.trailerDestinationId = _data["trailerDestinationId"];
            this.reported = _data["reported"];
            this.donorTwoFirstName = _data["donorTwoFirstName"];
            this.donorTwoLastName = _data["donorTwoLastName"];
            this.email = _data["email"];
        }
    }

    static fromJS(data: any): DonationInErrorEditViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DonationInErrorEditViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["status"] = this.status;
        data["donorFirstName"] = this.donorFirstName;
        data["donorLastName"] = this.donorLastName;
        data["donorPhone"] = this.donorPhone;
        data["donorCell"] = this.donorCell;
        data["donationDate"] = this.donationDate;
        data["donationTime"] = this.donationTime;
        data["attendantPresent"] = this.attendantPresent;
        data["donationSiteId"] = this.donationSiteId;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["trailerId"] = this.trailerId;
        data["trailerAtSite"] = this.trailerAtSite;
        data["trailerTransferDate"] = this.trailerTransferDate;
        data["trailerDestinationId"] = this.trailerDestinationId;
        data["reported"] = this.reported;
        data["donorTwoFirstName"] = this.donorTwoFirstName;
        data["donorTwoLastName"] = this.donorTwoLastName;
        data["email"] = this.email;
        return data;
    }
}

export interface IDonationInErrorEditViewModel {
    id: number;
    status?: string | undefined;
    donorFirstName?: string | undefined;
    donorLastName?: string | undefined;
    donorPhone?: string | undefined;
    donorCell?: string | undefined;
    donationDate: string;
    donationTime: string;
    attendantPresent: boolean;
    donationSiteId?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
    trailerId?: number | undefined;
    trailerAtSite?: boolean | undefined;
    trailerTransferDate?: string | undefined;
    trailerDestinationId?: string | undefined;
    reported?: boolean | undefined;
    donorTwoFirstName?: string | undefined;
    donorTwoLastName?: string | undefined;
    email?: string | undefined;
}

export class QueryResultsOfDonationInError implements IQueryResultsOfDonationInError {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: DonationInError[] | undefined;

    constructor(data?: IQueryResultsOfDonationInError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DonationInError.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfDonationInError {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfDonationInError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfDonationInError {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: DonationInError[] | undefined;
}

export class QueryResultsOfDonationInErrorDetail implements IQueryResultsOfDonationInErrorDetail {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: DonationInErrorDetail[] | undefined;

    constructor(data?: IQueryResultsOfDonationInErrorDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DonationInErrorDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfDonationInErrorDetail {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfDonationInErrorDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfDonationInErrorDetail {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: DonationInErrorDetail[] | undefined;
}

export class QueryResultsOfDonationInErrorPicture implements IQueryResultsOfDonationInErrorPicture {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: DonationInErrorPicture[] | undefined;

    constructor(data?: IQueryResultsOfDonationInErrorPicture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DonationInErrorPicture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfDonationInErrorPicture {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfDonationInErrorPicture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfDonationInErrorPicture {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: DonationInErrorPicture[] | undefined;
}

export class DonationInErrorPicture2 implements IDonationInErrorPicture2 {
    id!: number;
    donationInErrorId!: number;
    picture?: string | undefined;

    constructor(data?: IDonationInErrorPicture2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.donationInErrorId = _data["donationInErrorId"];
            this.picture = _data["picture"];
        }
    }

    static fromJS(data: any): DonationInErrorPicture2 {
        data = typeof data === 'object' ? data : {};
        let result = new DonationInErrorPicture2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["donationInErrorId"] = this.donationInErrorId;
        data["picture"] = this.picture;
        return data;
    }
}

export interface IDonationInErrorPicture2 {
    id: number;
    donationInErrorId: number;
    picture?: string | undefined;
}

export class QueryResultsOfDonorCountDailyViewModel implements IQueryResultsOfDonorCountDailyViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: DonorCountDailyViewModel[] | undefined;

    constructor(data?: IQueryResultsOfDonorCountDailyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(DonorCountDailyViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfDonorCountDailyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfDonorCountDailyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfDonorCountDailyViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: DonorCountDailyViewModel[] | undefined;
}

export class DonorCountDailyViewModel implements IDonorCountDailyViewModel {
    id!: number;
    siteId!: number;
    collectionDate!: string;
    noOfDonors!: number;
    site?: SiteViewModel2 | undefined;

    constructor(data?: IDonorCountDailyViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.collectionDate = _data["collectionDate"];
            this.noOfDonors = _data["noOfDonors"];
            this.site = _data["site"] ? SiteViewModel2.fromJS(_data["site"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DonorCountDailyViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new DonorCountDailyViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["collectionDate"] = this.collectionDate;
        data["noOfDonors"] = this.noOfDonors;
        data["site"] = this.site ? this.site.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDonorCountDailyViewModel {
    id: number;
    siteId: number;
    collectionDate: string;
    noOfDonors: number;
    site?: SiteViewModel2 | undefined;
}

export class SiteViewModel2 implements ISiteViewModel2 {
    id!: number;
    name?: string | undefined;
    division?: string | undefined;
    type?: string | undefined;
    number?: number | undefined;
    annualGoalPounds?: number | undefined;
    trailer?: string | undefined;
    siteDescription?: string | undefined;
    statusId?: number | undefined;
    storeId?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: ISiteViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.division = _data["division"];
            this.type = _data["type"];
            this.number = _data["number"];
            this.annualGoalPounds = _data["annualGoalPounds"];
            this.trailer = _data["trailer"];
            this.siteDescription = _data["siteDescription"];
            this.statusId = _data["statusId"];
            this.storeId = _data["storeId"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): SiteViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new SiteViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["division"] = this.division;
        data["type"] = this.type;
        data["number"] = this.number;
        data["annualGoalPounds"] = this.annualGoalPounds;
        data["trailer"] = this.trailer;
        data["siteDescription"] = this.siteDescription;
        data["statusId"] = this.statusId;
        data["storeId"] = this.storeId;
        data["active"] = this.active;
        return data;
    }
}

export interface ISiteViewModel2 {
    id: number;
    name?: string | undefined;
    division?: string | undefined;
    type?: string | undefined;
    number?: number | undefined;
    annualGoalPounds?: number | undefined;
    trailer?: string | undefined;
    siteDescription?: string | undefined;
    statusId?: number | undefined;
    storeId?: string | undefined;
    active?: boolean | undefined;
}

export class DonorCountsDaily implements IDonorCountsDaily {
    id!: number;
    siteId!: number;
    collectionDate!: string;
    noOfDonors!: number;

    constructor(data?: IDonorCountsDaily) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.siteId = _data["siteId"];
            this.collectionDate = _data["collectionDate"];
            this.noOfDonors = _data["noOfDonors"];
        }
    }

    static fromJS(data: any): DonorCountsDaily {
        data = typeof data === 'object' ? data : {};
        let result = new DonorCountsDaily();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["siteId"] = this.siteId;
        data["collectionDate"] = this.collectionDate;
        data["noOfDonors"] = this.noOfDonors;
        return data;
    }
}

export interface IDonorCountsDaily {
    id: number;
    siteId: number;
    collectionDate: string;
    noOfDonors: number;
}

export class AncillaryService implements IAncillaryService {
    id!: number;
    department?: string | undefined;
    serviceType?: string | undefined;
    type?: string | undefined;
    organization?: string | undefined;
    contactPerson?: string | undefined;
    contactPhone?: string | undefined;
    itemsServicesRequested?: string | undefined;
    date!: string;
    approvedByReferredTo?: string | undefined;
    itemsServicesProvided?: string | undefined;
    peopleServed!: number;
    gicwPeopleServed!: number;
    servicesProvided!: number;
    peopleReferred!: number;
    enteredBy?: string | undefined;
    dateEntered?: string | undefined;
    ageGroup?: string | undefined;
    gicwContact?: string | undefined;
    newPeople?: number | undefined;
    locationId?: number | undefined;
    dollars?: number | undefined;
    comment?: string | undefined;
    referred?: boolean | undefined;
    contactEmail?: string | undefined;

    constructor(data?: IAncillaryService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.department = _data["department"];
            this.serviceType = _data["serviceType"];
            this.type = _data["type"];
            this.organization = _data["organization"];
            this.contactPerson = _data["contactPerson"];
            this.contactPhone = _data["contactPhone"];
            this.itemsServicesRequested = _data["itemsServicesRequested"];
            this.date = _data["date"];
            this.approvedByReferredTo = _data["approvedByReferredTo"];
            this.itemsServicesProvided = _data["itemsServicesProvided"];
            this.peopleServed = _data["peopleServed"];
            this.gicwPeopleServed = _data["gicwPeopleServed"];
            this.servicesProvided = _data["servicesProvided"];
            this.peopleReferred = _data["peopleReferred"];
            this.enteredBy = _data["enteredBy"];
            this.dateEntered = _data["dateEntered"];
            this.ageGroup = _data["ageGroup"];
            this.gicwContact = _data["gicwContact"];
            this.newPeople = _data["newPeople"];
            this.locationId = _data["locationId"];
            this.dollars = _data["dollars"];
            this.comment = _data["comment"];
            this.referred = _data["referred"];
            this.contactEmail = _data["contactEmail"];
        }
    }

    static fromJS(data: any): AncillaryService {
        data = typeof data === 'object' ? data : {};
        let result = new AncillaryService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["department"] = this.department;
        data["serviceType"] = this.serviceType;
        data["type"] = this.type;
        data["organization"] = this.organization;
        data["contactPerson"] = this.contactPerson;
        data["contactPhone"] = this.contactPhone;
        data["itemsServicesRequested"] = this.itemsServicesRequested;
        data["date"] = this.date;
        data["approvedByReferredTo"] = this.approvedByReferredTo;
        data["itemsServicesProvided"] = this.itemsServicesProvided;
        data["peopleServed"] = this.peopleServed;
        data["gicwPeopleServed"] = this.gicwPeopleServed;
        data["servicesProvided"] = this.servicesProvided;
        data["peopleReferred"] = this.peopleReferred;
        data["enteredBy"] = this.enteredBy;
        data["dateEntered"] = this.dateEntered;
        data["ageGroup"] = this.ageGroup;
        data["gicwContact"] = this.gicwContact;
        data["newPeople"] = this.newPeople;
        data["locationId"] = this.locationId;
        data["dollars"] = this.dollars;
        data["comment"] = this.comment;
        data["referred"] = this.referred;
        data["contactEmail"] = this.contactEmail;
        return data;
    }
}

export interface IAncillaryService {
    id: number;
    department?: string | undefined;
    serviceType?: string | undefined;
    type?: string | undefined;
    organization?: string | undefined;
    contactPerson?: string | undefined;
    contactPhone?: string | undefined;
    itemsServicesRequested?: string | undefined;
    date: string;
    approvedByReferredTo?: string | undefined;
    itemsServicesProvided?: string | undefined;
    peopleServed: number;
    gicwPeopleServed: number;
    servicesProvided: number;
    peopleReferred: number;
    enteredBy?: string | undefined;
    dateEntered?: string | undefined;
    ageGroup?: string | undefined;
    gicwContact?: string | undefined;
    newPeople?: number | undefined;
    locationId?: number | undefined;
    dollars?: number | undefined;
    comment?: string | undefined;
    referred?: boolean | undefined;
    contactEmail?: string | undefined;
}

export class QueryResultsOfAncillaryService implements IQueryResultsOfAncillaryService {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: AncillaryService[] | undefined;

    constructor(data?: IQueryResultsOfAncillaryService) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AncillaryService.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfAncillaryService {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfAncillaryService();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfAncillaryService {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: AncillaryService[] | undefined;
}

export class TblECEEmployeeViewModel implements ITblECEEmployeeViewModel {
    id?: string | undefined;
    employeeId?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    timeInUs?: number | undefined;
    country?: string | undefined;
    dateRequested?: string | undefined;
    dateAssigned?: string | undefined;
    dateEligible?: string | undefined;
    veteran?: boolean | undefined;
    familyOfVeteran?: boolean | undefined;
    primaryLanguageSpanish?: boolean | undefined;
    expectedGEDDate?: string | undefined;
    lastGradeAttended?: number | undefined;
    yearsSinceLastInSchool?: number | undefined;
    referredToForGED?: string | undefined;

    constructor(data?: ITblECEEmployeeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.timeInUs = _data["timeInUs"];
            this.country = _data["country"];
            this.dateRequested = _data["dateRequested"];
            this.dateAssigned = _data["dateAssigned"];
            this.dateEligible = _data["dateEligible"];
            this.veteran = _data["veteran"];
            this.familyOfVeteran = _data["familyOfVeteran"];
            this.primaryLanguageSpanish = _data["primaryLanguageSpanish"];
            this.expectedGEDDate = _data["expectedGEDDate"];
            this.lastGradeAttended = _data["lastGradeAttended"];
            this.yearsSinceLastInSchool = _data["yearsSinceLastInSchool"];
            this.referredToForGED = _data["referredToForGED"];
        }
    }

    static fromJS(data: any): TblECEEmployeeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TblECEEmployeeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["timeInUs"] = this.timeInUs;
        data["country"] = this.country;
        data["dateRequested"] = this.dateRequested;
        data["dateAssigned"] = this.dateAssigned;
        data["dateEligible"] = this.dateEligible;
        data["veteran"] = this.veteran;
        data["familyOfVeteran"] = this.familyOfVeteran;
        data["primaryLanguageSpanish"] = this.primaryLanguageSpanish;
        data["expectedGEDDate"] = this.expectedGEDDate;
        data["lastGradeAttended"] = this.lastGradeAttended;
        data["yearsSinceLastInSchool"] = this.yearsSinceLastInSchool;
        data["referredToForGED"] = this.referredToForGED;
        return data;
    }
}

export interface ITblECEEmployeeViewModel {
    id?: string | undefined;
    employeeId?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    timeInUs?: number | undefined;
    country?: string | undefined;
    dateRequested?: string | undefined;
    dateAssigned?: string | undefined;
    dateEligible?: string | undefined;
    veteran?: boolean | undefined;
    familyOfVeteran?: boolean | undefined;
    primaryLanguageSpanish?: boolean | undefined;
    expectedGEDDate?: string | undefined;
    lastGradeAttended?: number | undefined;
    yearsSinceLastInSchool?: number | undefined;
    referredToForGED?: string | undefined;
}

export class TblECEEmployeeSavingModel implements ITblECEEmployeeSavingModel {
    id?: string | undefined;
    employeeId?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    timeInUs?: number | undefined;
    country?: string | undefined;
    dateRequested?: string | undefined;
    dateAssigned?: string | undefined;
    dateEligible?: string | undefined;
    expectedGEDDate?: string | undefined;
    lastGradeAttended?: number | undefined;
    yearsSinceLastInSchool?: number | undefined;
    referredToForGED?: string | undefined;

    constructor(data?: ITblECEEmployeeSavingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.phone = _data["phone"];
            this.email = _data["email"];
            this.timeInUs = _data["timeInUs"];
            this.country = _data["country"];
            this.dateRequested = _data["dateRequested"];
            this.dateAssigned = _data["dateAssigned"];
            this.dateEligible = _data["dateEligible"];
            this.expectedGEDDate = _data["expectedGEDDate"];
            this.lastGradeAttended = _data["lastGradeAttended"];
            this.yearsSinceLastInSchool = _data["yearsSinceLastInSchool"];
            this.referredToForGED = _data["referredToForGED"];
        }
    }

    static fromJS(data: any): TblECEEmployeeSavingModel {
        data = typeof data === 'object' ? data : {};
        let result = new TblECEEmployeeSavingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["phone"] = this.phone;
        data["email"] = this.email;
        data["timeInUs"] = this.timeInUs;
        data["country"] = this.country;
        data["dateRequested"] = this.dateRequested;
        data["dateAssigned"] = this.dateAssigned;
        data["dateEligible"] = this.dateEligible;
        data["expectedGEDDate"] = this.expectedGEDDate;
        data["lastGradeAttended"] = this.lastGradeAttended;
        data["yearsSinceLastInSchool"] = this.yearsSinceLastInSchool;
        data["referredToForGED"] = this.referredToForGED;
        return data;
    }
}

export interface ITblECEEmployeeSavingModel {
    id?: string | undefined;
    employeeId?: string | undefined;
    phone?: string | undefined;
    email?: string | undefined;
    timeInUs?: number | undefined;
    country?: string | undefined;
    dateRequested?: string | undefined;
    dateAssigned?: string | undefined;
    dateEligible?: string | undefined;
    expectedGEDDate?: string | undefined;
    lastGradeAttended?: number | undefined;
    yearsSinceLastInSchool?: number | undefined;
    referredToForGED?: string | undefined;
}

export class EcollectibleListingsQuickEntry implements IEcollectibleListingsQuickEntry {
    id!: string;
    qty!: number;

    constructor(data?: IEcollectibleListingsQuickEntry) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.qty = _data["qty"];
        }
    }

    static fromJS(data: any): EcollectibleListingsQuickEntry {
        data = typeof data === 'object' ? data : {};
        let result = new EcollectibleListingsQuickEntry();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["qty"] = this.qty;
        return data;
    }
}

export interface IEcollectibleListingsQuickEntry {
    id: string;
    qty: number;
}

export class EmployeeInjuryNoticeViewModel implements IEmployeeInjuryNoticeViewModel {
    id!: number;
    employeeNumber?: string | undefined;

    constructor(data?: IEmployeeInjuryNoticeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeNumber = _data["employeeNumber"];
        }
    }

    static fromJS(data: any): EmployeeInjuryNoticeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInjuryNoticeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeNumber"] = this.employeeNumber;
        return data;
    }
}

export interface IEmployeeInjuryNoticeViewModel {
    id: number;
    employeeNumber?: string | undefined;
}

export class EmployeeInjuryNoticeQuery extends Query implements IEmployeeInjuryNoticeQuery {

    constructor(data?: IEmployeeInjuryNoticeQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EmployeeInjuryNoticeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInjuryNoticeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEmployeeInjuryNoticeQuery extends IQuery {
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions!: { [key: string]: any; };

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.extensions = {};
        }
    }

    init(_data?: any) {
        if (_data) {
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
            if (_data["extensions"]) {
                this.extensions = {} as any;
                for (let key in _data["extensions"]) {
                    if (_data["extensions"].hasOwnProperty(key))
                        (<any>this.extensions)![key] = _data["extensions"][key];
                }
            }
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        if (this.extensions) {
            data["extensions"] = {};
            for (let key in this.extensions) {
                if (this.extensions.hasOwnProperty(key))
                    (<any>data["extensions"])[key] = (<any>this.extensions)[key];
            }
        }
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;
    extensions: { [key: string]: any; };
}

export class EmployeeInjuryNotice implements IEmployeeInjuryNotice {
    id!: number;
    employeeNumber?: string | undefined;
    sunday?: string | undefined;
    monday?: string | undefined;
    tuesday?: string | undefined;
    wednesday?: string | undefined;
    thursday?: string | undefined;
    friday?: string | undefined;
    saturday?: string | undefined;
    leftShift!: boolean;
    leftShiftDate!: string;
    leftEarly!: boolean;
    leftEarlyDate!: string;
    dateOfInjury!: string;
    timeOfInjury!: string;
    nameOfSupervisorRpt?: string | undefined;
    dateReported!: string;
    storeLocationOfInjury?: string | undefined;
    outsideLocationOfInjury?: string | undefined;
    partOfBodyAffected!: number;
    descriptionOfInjury?: string | undefined;
    priorInjury!: boolean;
    dateOfPriorInjury!: string;
    descriptionOfInjuryCause?: string | undefined;
    firstAidProvided!: boolean;
    firstAidDescription?: string | undefined;
    aidNotGiveDescription?: string | undefined;
    drugTest!: boolean;
    medicalTreatment!: boolean;
    nameOfHospital?: string | undefined;
    witnessOne?: string | undefined;
    witnessOneEmployee!: boolean;
    witnessOneAddress?: string | undefined;
    witnessOneState?: string | undefined;
    witnessOneCity?: string | undefined;
    witnessOneZip?: string | undefined;
    witnessOnePhone?: string | undefined;
    witnessTwo?: string | undefined;
    witnessTwoEmployee!: boolean;
    witnessTwoAddress?: string | undefined;
    witnessTwoCity?: string | undefined;
    witnessTwoState?: string | undefined;
    witnessTwoZip?: string | undefined;
    witnessTwoPhone?: string | undefined;
    additionalComments?: string | undefined;
    enteredBy?: string | undefined;
    dateEntered!: string;
    baseSignature?: string | undefined;
    signature?: string | undefined;
    reported!: boolean;
    costCenter?: string | undefined;

    constructor(data?: IEmployeeInjuryNotice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeNumber = _data["employeeNumber"];
            this.sunday = _data["sunday"];
            this.monday = _data["monday"];
            this.tuesday = _data["tuesday"];
            this.wednesday = _data["wednesday"];
            this.thursday = _data["thursday"];
            this.friday = _data["friday"];
            this.saturday = _data["saturday"];
            this.leftShift = _data["leftShift"];
            this.leftShiftDate = _data["leftShiftDate"];
            this.leftEarly = _data["leftEarly"];
            this.leftEarlyDate = _data["leftEarlyDate"];
            this.dateOfInjury = _data["dateOfInjury"];
            this.timeOfInjury = _data["timeOfInjury"];
            this.nameOfSupervisorRpt = _data["nameOfSupervisorRpt"];
            this.dateReported = _data["dateReported"];
            this.storeLocationOfInjury = _data["storeLocationOfInjury"];
            this.outsideLocationOfInjury = _data["outsideLocationOfInjury"];
            this.partOfBodyAffected = _data["partOfBodyAffected"];
            this.descriptionOfInjury = _data["descriptionOfInjury"];
            this.priorInjury = _data["priorInjury"];
            this.dateOfPriorInjury = _data["dateOfPriorInjury"];
            this.descriptionOfInjuryCause = _data["descriptionOfInjuryCause"];
            this.firstAidProvided = _data["firstAidProvided"];
            this.firstAidDescription = _data["firstAidDescription"];
            this.aidNotGiveDescription = _data["aidNotGiveDescription"];
            this.drugTest = _data["drugTest"];
            this.medicalTreatment = _data["medicalTreatment"];
            this.nameOfHospital = _data["nameOfHospital"];
            this.witnessOne = _data["witnessOne"];
            this.witnessOneEmployee = _data["witnessOneEmployee"];
            this.witnessOneAddress = _data["witnessOneAddress"];
            this.witnessOneState = _data["witnessOneState"];
            this.witnessOneCity = _data["witnessOneCity"];
            this.witnessOneZip = _data["witnessOneZip"];
            this.witnessOnePhone = _data["witnessOnePhone"];
            this.witnessTwo = _data["witnessTwo"];
            this.witnessTwoEmployee = _data["witnessTwoEmployee"];
            this.witnessTwoAddress = _data["witnessTwoAddress"];
            this.witnessTwoCity = _data["witnessTwoCity"];
            this.witnessTwoState = _data["witnessTwoState"];
            this.witnessTwoZip = _data["witnessTwoZip"];
            this.witnessTwoPhone = _data["witnessTwoPhone"];
            this.additionalComments = _data["additionalComments"];
            this.enteredBy = _data["enteredBy"];
            this.dateEntered = _data["dateEntered"];
            this.baseSignature = _data["baseSignature"];
            this.signature = _data["signature"];
            this.reported = _data["reported"];
            this.costCenter = _data["costCenter"];
        }
    }

    static fromJS(data: any): EmployeeInjuryNotice {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeInjuryNotice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeNumber"] = this.employeeNumber;
        data["sunday"] = this.sunday;
        data["monday"] = this.monday;
        data["tuesday"] = this.tuesday;
        data["wednesday"] = this.wednesday;
        data["thursday"] = this.thursday;
        data["friday"] = this.friday;
        data["saturday"] = this.saturday;
        data["leftShift"] = this.leftShift;
        data["leftShiftDate"] = this.leftShiftDate;
        data["leftEarly"] = this.leftEarly;
        data["leftEarlyDate"] = this.leftEarlyDate;
        data["dateOfInjury"] = this.dateOfInjury;
        data["timeOfInjury"] = this.timeOfInjury;
        data["nameOfSupervisorRpt"] = this.nameOfSupervisorRpt;
        data["dateReported"] = this.dateReported;
        data["storeLocationOfInjury"] = this.storeLocationOfInjury;
        data["outsideLocationOfInjury"] = this.outsideLocationOfInjury;
        data["partOfBodyAffected"] = this.partOfBodyAffected;
        data["descriptionOfInjury"] = this.descriptionOfInjury;
        data["priorInjury"] = this.priorInjury;
        data["dateOfPriorInjury"] = this.dateOfPriorInjury;
        data["descriptionOfInjuryCause"] = this.descriptionOfInjuryCause;
        data["firstAidProvided"] = this.firstAidProvided;
        data["firstAidDescription"] = this.firstAidDescription;
        data["aidNotGiveDescription"] = this.aidNotGiveDescription;
        data["drugTest"] = this.drugTest;
        data["medicalTreatment"] = this.medicalTreatment;
        data["nameOfHospital"] = this.nameOfHospital;
        data["witnessOne"] = this.witnessOne;
        data["witnessOneEmployee"] = this.witnessOneEmployee;
        data["witnessOneAddress"] = this.witnessOneAddress;
        data["witnessOneState"] = this.witnessOneState;
        data["witnessOneCity"] = this.witnessOneCity;
        data["witnessOneZip"] = this.witnessOneZip;
        data["witnessOnePhone"] = this.witnessOnePhone;
        data["witnessTwo"] = this.witnessTwo;
        data["witnessTwoEmployee"] = this.witnessTwoEmployee;
        data["witnessTwoAddress"] = this.witnessTwoAddress;
        data["witnessTwoCity"] = this.witnessTwoCity;
        data["witnessTwoState"] = this.witnessTwoState;
        data["witnessTwoZip"] = this.witnessTwoZip;
        data["witnessTwoPhone"] = this.witnessTwoPhone;
        data["additionalComments"] = this.additionalComments;
        data["enteredBy"] = this.enteredBy;
        data["dateEntered"] = this.dateEntered;
        data["baseSignature"] = this.baseSignature;
        data["signature"] = this.signature;
        data["reported"] = this.reported;
        data["costCenter"] = this.costCenter;
        return data;
    }
}

export interface IEmployeeInjuryNotice {
    id: number;
    employeeNumber?: string | undefined;
    sunday?: string | undefined;
    monday?: string | undefined;
    tuesday?: string | undefined;
    wednesday?: string | undefined;
    thursday?: string | undefined;
    friday?: string | undefined;
    saturday?: string | undefined;
    leftShift: boolean;
    leftShiftDate: string;
    leftEarly: boolean;
    leftEarlyDate: string;
    dateOfInjury: string;
    timeOfInjury: string;
    nameOfSupervisorRpt?: string | undefined;
    dateReported: string;
    storeLocationOfInjury?: string | undefined;
    outsideLocationOfInjury?: string | undefined;
    partOfBodyAffected: number;
    descriptionOfInjury?: string | undefined;
    priorInjury: boolean;
    dateOfPriorInjury: string;
    descriptionOfInjuryCause?: string | undefined;
    firstAidProvided: boolean;
    firstAidDescription?: string | undefined;
    aidNotGiveDescription?: string | undefined;
    drugTest: boolean;
    medicalTreatment: boolean;
    nameOfHospital?: string | undefined;
    witnessOne?: string | undefined;
    witnessOneEmployee: boolean;
    witnessOneAddress?: string | undefined;
    witnessOneState?: string | undefined;
    witnessOneCity?: string | undefined;
    witnessOneZip?: string | undefined;
    witnessOnePhone?: string | undefined;
    witnessTwo?: string | undefined;
    witnessTwoEmployee: boolean;
    witnessTwoAddress?: string | undefined;
    witnessTwoCity?: string | undefined;
    witnessTwoState?: string | undefined;
    witnessTwoZip?: string | undefined;
    witnessTwoPhone?: string | undefined;
    additionalComments?: string | undefined;
    enteredBy?: string | undefined;
    dateEntered: string;
    baseSignature?: string | undefined;
    signature?: string | undefined;
    reported: boolean;
    costCenter?: string | undefined;
}

export class EmployeeDetailViewModel implements IEmployeeDetailViewModel {
    employeeNo!: number;
    title?: string | undefined;
    department?: string | undefined;
    application?: ApplicationViewModel | undefined;

    constructor(data?: IEmployeeDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeNo = _data["employeeNo"];
            this.title = _data["title"];
            this.department = _data["department"];
            this.application = _data["application"] ? ApplicationViewModel.fromJS(_data["application"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EmployeeDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeNo"] = this.employeeNo;
        data["title"] = this.title;
        data["department"] = this.department;
        data["application"] = this.application ? this.application.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEmployeeDetailViewModel {
    employeeNo: number;
    title?: string | undefined;
    department?: string | undefined;
    application?: ApplicationViewModel | undefined;
}

export class ApplicationViewModel implements IApplicationViewModel {
    id!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IApplicationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): ApplicationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IApplicationViewModel {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class EmployeeViewModel implements IEmployeeViewModel {
    id!: number;
    employeeNumber!: number;
    name?: string | undefined;
    storeName?: string | undefined;
    custNum?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    jobCode?: JobCode | undefined;
    accessPoint?: AccessPoint | undefined;
    costCenter?: number | undefined;
    originalHireDate?: string | undefined;
    ebFlxId?: string | undefined;
    description?: string | undefined;
    locationCode?: number | undefined;
    status?: string | undefined;
    termDate?: string | undefined;
    title?: string | undefined;
    dateOfHire?: string | undefined;
    stringCostCenter?: string | undefined;

    constructor(data?: IEmployeeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeNumber = _data["employeeNumber"];
            this.name = _data["name"];
            this.storeName = _data["storeName"];
            this.custNum = _data["custNum"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.jobCode = _data["jobCode"] ? JobCode.fromJS(_data["jobCode"]) : <any>undefined;
            this.accessPoint = _data["accessPoint"] ? AccessPoint.fromJS(_data["accessPoint"]) : <any>undefined;
            this.costCenter = _data["costCenter"];
            this.originalHireDate = _data["originalHireDate"];
            this.ebFlxId = _data["ebFlxId"];
            this.description = _data["description"];
            this.locationCode = _data["locationCode"];
            this.status = _data["status"];
            this.termDate = _data["termDate"];
            this.title = _data["title"];
            this.dateOfHire = _data["dateOfHire"];
            this.stringCostCenter = _data["stringCostCenter"];
        }
    }

    static fromJS(data: any): EmployeeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeNumber"] = this.employeeNumber;
        data["name"] = this.name;
        data["storeName"] = this.storeName;
        data["custNum"] = this.custNum;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["jobCode"] = this.jobCode ? this.jobCode.toJSON() : <any>undefined;
        data["accessPoint"] = this.accessPoint ? this.accessPoint.toJSON() : <any>undefined;
        data["costCenter"] = this.costCenter;
        data["originalHireDate"] = this.originalHireDate;
        data["ebFlxId"] = this.ebFlxId;
        data["description"] = this.description;
        data["locationCode"] = this.locationCode;
        data["status"] = this.status;
        data["termDate"] = this.termDate;
        data["title"] = this.title;
        data["dateOfHire"] = this.dateOfHire;
        data["stringCostCenter"] = this.stringCostCenter;
        return data;
    }
}

export interface IEmployeeViewModel {
    id: number;
    employeeNumber: number;
    name?: string | undefined;
    storeName?: string | undefined;
    custNum?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    jobCode?: JobCode | undefined;
    accessPoint?: AccessPoint | undefined;
    costCenter?: number | undefined;
    originalHireDate?: string | undefined;
    ebFlxId?: string | undefined;
    description?: string | undefined;
    locationCode?: number | undefined;
    status?: string | undefined;
    termDate?: string | undefined;
    title?: string | undefined;
    dateOfHire?: string | undefined;
    stringCostCenter?: string | undefined;
}

export abstract class EntityBaseOfInteger implements IEntityBaseOfInteger {
    id!: number;

    constructor(data?: IEntityBaseOfInteger) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityBaseOfInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBaseOfInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityBaseOfInteger {
    id: number;
}

export abstract class EntityBase extends EntityBaseOfInteger implements IEntityBase {

    constructor(data?: IEntityBase) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): EntityBase {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBase' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IEntityBase extends IEntityBaseOfInteger {
}

export class JobCode extends EntityBase implements IJobCode {
    code?: string | undefined;
    description?: string | undefined;
    windowsAcct?: boolean | undefined;
    emailAcct?: boolean | undefined;
    appName?: string | undefined;
    user?: string | undefined;
    hostName?: string | undefined;
    hostIp?: string | undefined;
    department?: string | undefined;
    management?: boolean | undefined;
    fileShare?: boolean | undefined;
    predictiveScheduling?: boolean | undefined;

    constructor(data?: IJobCode) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.code = _data["code"];
            this.description = _data["description"];
            this.windowsAcct = _data["windowsAcct"];
            this.emailAcct = _data["emailAcct"];
            this.appName = _data["appName"];
            this.user = _data["user"];
            this.hostName = _data["hostName"];
            this.hostIp = _data["hostIp"];
            this.department = _data["department"];
            this.management = _data["management"];
            this.fileShare = _data["fileShare"];
            this.predictiveScheduling = _data["predictiveScheduling"];
        }
    }

    static fromJS(data: any): JobCode {
        data = typeof data === 'object' ? data : {};
        let result = new JobCode();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code;
        data["description"] = this.description;
        data["windowsAcct"] = this.windowsAcct;
        data["emailAcct"] = this.emailAcct;
        data["appName"] = this.appName;
        data["user"] = this.user;
        data["hostName"] = this.hostName;
        data["hostIp"] = this.hostIp;
        data["department"] = this.department;
        data["management"] = this.management;
        data["fileShare"] = this.fileShare;
        data["predictiveScheduling"] = this.predictiveScheduling;
        super.toJSON(data);
        return data;
    }
}

export interface IJobCode extends IEntityBase {
    code?: string | undefined;
    description?: string | undefined;
    windowsAcct?: boolean | undefined;
    emailAcct?: boolean | undefined;
    appName?: string | undefined;
    user?: string | undefined;
    hostName?: string | undefined;
    hostIp?: string | undefined;
    department?: string | undefined;
    management?: boolean | undefined;
    fileShare?: boolean | undefined;
    predictiveScheduling?: boolean | undefined;
}

export class AccessPoint extends EntityBase implements IAccessPoint {
    description?: string | undefined;
    locationCode?: number | undefined;
    costTransferDistribution?: string | undefined;
    isDiscontinued!: boolean;

    constructor(data?: IAccessPoint) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.description = _data["description"];
            this.locationCode = _data["locationCode"];
            this.costTransferDistribution = _data["costTransferDistribution"];
            this.isDiscontinued = _data["isDiscontinued"];
        }
    }

    static fromJS(data: any): AccessPoint {
        data = typeof data === 'object' ? data : {};
        let result = new AccessPoint();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["locationCode"] = this.locationCode;
        data["costTransferDistribution"] = this.costTransferDistribution;
        data["isDiscontinued"] = this.isDiscontinued;
        super.toJSON(data);
        return data;
    }
}

export interface IAccessPoint extends IEntityBase {
    description?: string | undefined;
    locationCode?: number | undefined;
    costTransferDistribution?: string | undefined;
    isDiscontinued: boolean;
}

export class QueryResultsOfEmployeeViewModel implements IQueryResultsOfEmployeeViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: EmployeeViewModel[] | undefined;

    constructor(data?: IQueryResultsOfEmployeeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EmployeeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfEmployeeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfEmployeeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfEmployeeViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: EmployeeViewModel[] | undefined;
}

export class QueryResultsOfECEEmployeeViewModel implements IQueryResultsOfECEEmployeeViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ECEEmployeeViewModel[] | undefined;

    constructor(data?: IQueryResultsOfECEEmployeeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ECEEmployeeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfECEEmployeeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfECEEmployeeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfECEEmployeeViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ECEEmployeeViewModel[] | undefined;
}

export class ECEEmployeeViewModel implements IECEEmployeeViewModel {
    id!: number;
    name?: string | undefined;
    employeeNumber?: string | undefined;
    costCenter?: string | undefined;
    ejTitle?: string | undefined;
    doh?: string | undefined;
    termDate?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    promotionDate?: string | undefined;

    constructor(data?: IECEEmployeeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.employeeNumber = _data["employeeNumber"];
            this.costCenter = _data["costCenter"];
            this.ejTitle = _data["ejTitle"];
            this.doh = _data["doh"];
            this.termDate = _data["termDate"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.promotionDate = _data["promotionDate"];
        }
    }

    static fromJS(data: any): ECEEmployeeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ECEEmployeeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["employeeNumber"] = this.employeeNumber;
        data["costCenter"] = this.costCenter;
        data["ejTitle"] = this.ejTitle;
        data["doh"] = this.doh;
        data["termDate"] = this.termDate;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["promotionDate"] = this.promotionDate;
        return data;
    }
}

export interface IECEEmployeeViewModel {
    id: number;
    name?: string | undefined;
    employeeNumber?: string | undefined;
    costCenter?: string | undefined;
    ejTitle?: string | undefined;
    doh?: string | undefined;
    termDate?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    promotionDate?: string | undefined;
}

export class QueryResultsOfActiveEmployeeViewModel implements IQueryResultsOfActiveEmployeeViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ActiveEmployeeViewModel[] | undefined;

    constructor(data?: IQueryResultsOfActiveEmployeeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ActiveEmployeeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfActiveEmployeeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfActiveEmployeeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfActiveEmployeeViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ActiveEmployeeViewModel[] | undefined;
}

export class ActiveEmployeeViewModel implements IActiveEmployeeViewModel {
    id!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    deptID?: number | undefined;
    doh?: string | undefined;
    employeeNumber?: string | undefined;
    description?: string | undefined;
    costCenterName?: string | undefined;
    expr1?: string | undefined;
    ebSocNumber?: string | undefined;

    constructor(data?: IActiveEmployeeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.deptID = _data["deptID"];
            this.doh = _data["doh"];
            this.employeeNumber = _data["employeeNumber"];
            this.description = _data["description"];
            this.costCenterName = _data["costCenterName"];
            this.expr1 = _data["expr1"];
            this.ebSocNumber = _data["ebSocNumber"];
        }
    }

    static fromJS(data: any): ActiveEmployeeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveEmployeeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["deptID"] = this.deptID;
        data["doh"] = this.doh;
        data["employeeNumber"] = this.employeeNumber;
        data["description"] = this.description;
        data["costCenterName"] = this.costCenterName;
        data["expr1"] = this.expr1;
        data["ebSocNumber"] = this.ebSocNumber;
        return data;
    }
}

export interface IActiveEmployeeViewModel {
    id: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    deptID?: number | undefined;
    doh?: string | undefined;
    employeeNumber?: string | undefined;
    description?: string | undefined;
    costCenterName?: string | undefined;
    expr1?: string | undefined;
    ebSocNumber?: string | undefined;
}

export class QueryResultsOfEmployee implements IQueryResultsOfEmployee {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Employee[] | undefined;

    constructor(data?: IQueryResultsOfEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Employee.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfEmployee {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfEmployee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfEmployee {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Employee[] | undefined;
}

export class Employee implements IEmployee {
    id?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    ssn?: string | undefined;
    ebFlxID!: number;
    dateMod?: string | undefined;
    epFlxID?: number | undefined;
    epDateBorn?: string | undefined;
    epSex?: string | undefined;
    doh?: string | undefined;
    epHomePhone?: string | undefined;
    epCellPhone?: string | undefined;
    epStreet1?: string | undefined;
    epStreet2?: string | undefined;
    epCity?: string | undefined;
    epState?: string | undefined;
    epZip?: string | undefined;
    ejTitle?: string | undefined;
    costCenter!: number;

    constructor(data?: IEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.ssn = _data["ssn"];
            this.ebFlxID = _data["ebFlxID"];
            this.dateMod = _data["dateMod"];
            this.epFlxID = _data["epFlxID"];
            this.epDateBorn = _data["epDateBorn"];
            this.epSex = _data["epSex"];
            this.doh = _data["doh"];
            this.epHomePhone = _data["epHomePhone"];
            this.epCellPhone = _data["epCellPhone"];
            this.epStreet1 = _data["epStreet1"];
            this.epStreet2 = _data["epStreet2"];
            this.epCity = _data["epCity"];
            this.epState = _data["epState"];
            this.epZip = _data["epZip"];
            this.ejTitle = _data["ejTitle"];
            this.costCenter = _data["costCenter"];
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["ssn"] = this.ssn;
        data["ebFlxID"] = this.ebFlxID;
        data["dateMod"] = this.dateMod;
        data["epFlxID"] = this.epFlxID;
        data["epDateBorn"] = this.epDateBorn;
        data["epSex"] = this.epSex;
        data["doh"] = this.doh;
        data["epHomePhone"] = this.epHomePhone;
        data["epCellPhone"] = this.epCellPhone;
        data["epStreet1"] = this.epStreet1;
        data["epStreet2"] = this.epStreet2;
        data["epCity"] = this.epCity;
        data["epState"] = this.epState;
        data["epZip"] = this.epZip;
        data["ejTitle"] = this.ejTitle;
        data["costCenter"] = this.costCenter;
        return data;
    }
}

export interface IEmployee {
    id?: string | undefined;
    name?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    ssn?: string | undefined;
    ebFlxID: number;
    dateMod?: string | undefined;
    epFlxID?: number | undefined;
    epDateBorn?: string | undefined;
    epSex?: string | undefined;
    doh?: string | undefined;
    epHomePhone?: string | undefined;
    epCellPhone?: string | undefined;
    epStreet1?: string | undefined;
    epStreet2?: string | undefined;
    epCity?: string | undefined;
    epState?: string | undefined;
    epZip?: string | undefined;
    ejTitle?: string | undefined;
    costCenter: number;
}

export class QueryResultsOfEmployeeViewModel2 implements IQueryResultsOfEmployeeViewModel2 {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: EmployeeViewModel2[] | undefined;

    constructor(data?: IQueryResultsOfEmployeeViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EmployeeViewModel2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfEmployeeViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfEmployeeViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfEmployeeViewModel2 {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: EmployeeViewModel2[] | undefined;
}

export class EmployeeViewModel2 implements IEmployeeViewModel2 {
    id?: string | undefined;
    fistName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: IEmployeeViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fistName = _data["fistName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): EmployeeViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fistName"] = this.fistName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface IEmployeeViewModel2 {
    id?: string | undefined;
    fistName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
}

export class EmploymentHistory implements IEmploymentHistory {
    id!: number;
    gicwid?: number | undefined;
    employerName?: string | undefined;
    employerAddress?: string | undefined;
    employerCity?: string | undefined;
    employerState?: string | undefined;
    jobDuties?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    salary?: number | undefined;
    reasonforLeaving?: string | undefined;

    constructor(data?: IEmploymentHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gicwid = _data["gicwid"];
            this.employerName = _data["employerName"];
            this.employerAddress = _data["employerAddress"];
            this.employerCity = _data["employerCity"];
            this.employerState = _data["employerState"];
            this.jobDuties = _data["jobDuties"];
            this.startDate = _data["startDate"];
            this.endDate = _data["endDate"];
            this.salary = _data["salary"];
            this.reasonforLeaving = _data["reasonforLeaving"];
        }
    }

    static fromJS(data: any): EmploymentHistory {
        data = typeof data === 'object' ? data : {};
        let result = new EmploymentHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gicwid"] = this.gicwid;
        data["employerName"] = this.employerName;
        data["employerAddress"] = this.employerAddress;
        data["employerCity"] = this.employerCity;
        data["employerState"] = this.employerState;
        data["jobDuties"] = this.jobDuties;
        data["startDate"] = this.startDate;
        data["endDate"] = this.endDate;
        data["salary"] = this.salary;
        data["reasonforLeaving"] = this.reasonforLeaving;
        return data;
    }
}

export interface IEmploymentHistory {
    id: number;
    gicwid?: number | undefined;
    employerName?: string | undefined;
    employerAddress?: string | undefined;
    employerCity?: string | undefined;
    employerState?: string | undefined;
    jobDuties?: string | undefined;
    startDate?: string | undefined;
    endDate?: string | undefined;
    salary?: number | undefined;
    reasonforLeaving?: string | undefined;
}

export class QueryResultsOfEmploymentHistory implements IQueryResultsOfEmploymentHistory {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: EmploymentHistory[] | undefined;

    constructor(data?: IQueryResultsOfEmploymentHistory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EmploymentHistory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfEmploymentHistory {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfEmploymentHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfEmploymentHistory {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: EmploymentHistory[] | undefined;
}

export class EquipmentInventory implements IEquipmentInventory {
    id!: number;
    storeId?: string | undefined;
    invDate!: string;
    grayTotes!: number;
    blueMetalBarCage!: number;
    blueMetalMeshCage!: number;
    bluePlasticCage!: number;
    blueOrYellowDandexCarts!: number;
    greyZracks!: number;
    yellowAndChromeZracks!: number;
    hangerZracks!: number;
    wireMailStockingCart!: number;
    bishopCarts!: number;
    mattressCarts!: number;
    mellonBoxesFullOrEmpty!: number;
    palletsFullOrEmpty!: number;
    outletBlueTables!: number;
    bookStockingCarts!: number;
    shoppingCartsChrome36By22!: number;
    shoppingCartsChrome42By23!: number;
    shoppingCartsGrey41By24!: number;
    shoppingCartsGrey37By21!: number;
    shoppingCartsTwoTiered21By20!: number;
    handBaskets!: number;
    handBasketsWithWheels!: number;
    toteDollies!: number;
    palletJacks!: number;
    dateEntered!: string;
    enteredBy?: string | undefined;
    store?: Store3 | undefined;

    constructor(data?: IEquipmentInventory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.invDate = _data["invDate"];
            this.grayTotes = _data["grayTotes"];
            this.blueMetalBarCage = _data["blueMetalBarCage"];
            this.blueMetalMeshCage = _data["blueMetalMeshCage"];
            this.bluePlasticCage = _data["bluePlasticCage"];
            this.blueOrYellowDandexCarts = _data["blueOrYellowDandexCarts"];
            this.greyZracks = _data["greyZracks"];
            this.yellowAndChromeZracks = _data["yellowAndChromeZracks"];
            this.hangerZracks = _data["hangerZracks"];
            this.wireMailStockingCart = _data["wireMailStockingCart"];
            this.bishopCarts = _data["bishopCarts"];
            this.mattressCarts = _data["mattressCarts"];
            this.mellonBoxesFullOrEmpty = _data["mellonBoxesFullOrEmpty"];
            this.palletsFullOrEmpty = _data["palletsFullOrEmpty"];
            this.outletBlueTables = _data["outletBlueTables"];
            this.bookStockingCarts = _data["bookStockingCarts"];
            this.shoppingCartsChrome36By22 = _data["shoppingCartsChrome36By22"];
            this.shoppingCartsChrome42By23 = _data["shoppingCartsChrome42By23"];
            this.shoppingCartsGrey41By24 = _data["shoppingCartsGrey41By24"];
            this.shoppingCartsGrey37By21 = _data["shoppingCartsGrey37By21"];
            this.shoppingCartsTwoTiered21By20 = _data["shoppingCartsTwoTiered21By20"];
            this.handBaskets = _data["handBaskets"];
            this.handBasketsWithWheels = _data["handBasketsWithWheels"];
            this.toteDollies = _data["toteDollies"];
            this.palletJacks = _data["palletJacks"];
            this.dateEntered = _data["dateEntered"];
            this.enteredBy = _data["enteredBy"];
            this.store = _data["store"] ? Store3.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EquipmentInventory {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentInventory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["invDate"] = this.invDate;
        data["grayTotes"] = this.grayTotes;
        data["blueMetalBarCage"] = this.blueMetalBarCage;
        data["blueMetalMeshCage"] = this.blueMetalMeshCage;
        data["bluePlasticCage"] = this.bluePlasticCage;
        data["blueOrYellowDandexCarts"] = this.blueOrYellowDandexCarts;
        data["greyZracks"] = this.greyZracks;
        data["yellowAndChromeZracks"] = this.yellowAndChromeZracks;
        data["hangerZracks"] = this.hangerZracks;
        data["wireMailStockingCart"] = this.wireMailStockingCart;
        data["bishopCarts"] = this.bishopCarts;
        data["mattressCarts"] = this.mattressCarts;
        data["mellonBoxesFullOrEmpty"] = this.mellonBoxesFullOrEmpty;
        data["palletsFullOrEmpty"] = this.palletsFullOrEmpty;
        data["outletBlueTables"] = this.outletBlueTables;
        data["bookStockingCarts"] = this.bookStockingCarts;
        data["shoppingCartsChrome36By22"] = this.shoppingCartsChrome36By22;
        data["shoppingCartsChrome42By23"] = this.shoppingCartsChrome42By23;
        data["shoppingCartsGrey41By24"] = this.shoppingCartsGrey41By24;
        data["shoppingCartsGrey37By21"] = this.shoppingCartsGrey37By21;
        data["shoppingCartsTwoTiered21By20"] = this.shoppingCartsTwoTiered21By20;
        data["handBaskets"] = this.handBaskets;
        data["handBasketsWithWheels"] = this.handBasketsWithWheels;
        data["toteDollies"] = this.toteDollies;
        data["palletJacks"] = this.palletJacks;
        data["dateEntered"] = this.dateEntered;
        data["enteredBy"] = this.enteredBy;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEquipmentInventory {
    id: number;
    storeId?: string | undefined;
    invDate: string;
    grayTotes: number;
    blueMetalBarCage: number;
    blueMetalMeshCage: number;
    bluePlasticCage: number;
    blueOrYellowDandexCarts: number;
    greyZracks: number;
    yellowAndChromeZracks: number;
    hangerZracks: number;
    wireMailStockingCart: number;
    bishopCarts: number;
    mattressCarts: number;
    mellonBoxesFullOrEmpty: number;
    palletsFullOrEmpty: number;
    outletBlueTables: number;
    bookStockingCarts: number;
    shoppingCartsChrome36By22: number;
    shoppingCartsChrome42By23: number;
    shoppingCartsGrey41By24: number;
    shoppingCartsGrey37By21: number;
    shoppingCartsTwoTiered21By20: number;
    handBaskets: number;
    handBasketsWithWheels: number;
    toteDollies: number;
    palletJacks: number;
    dateEntered: string;
    enteredBy?: string | undefined;
    store?: Store3 | undefined;
}

export class Store3 implements IStore3 {
    id?: string | undefined;
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed!: boolean;
    isGRERunning!: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    status?: string | undefined;
    retailSQFeet?: number | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    milesFromCorporate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;

    constructor(data?: IStore3) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.storeMnemonic = _data["storeMnemonic"];
            this.storeMnemonic2 = _data["storeMnemonic2"];
            this.serverName = _data["serverName"];
            this.gredbName = _data["gredbName"];
            this.isClosed = _data["isClosed"];
            this.isGRERunning = _data["isGRERunning"];
            this.storeLogin = _data["storeLogin"];
            this.district = _data["district"];
            this.status = _data["status"];
            this.retailSQFeet = _data["retailSQFeet"];
            this.glNumber = _data["glNumber"];
            this.glCash = _data["glCash"];
            this.glNumber2 = _data["glNumber2"];
            this.sort = _data["sort"];
            this.locationId = _data["locationId"];
            this.milesFromCorporate = _data["milesFromCorporate"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.regionId = _data["regionId"];
            this.email = _data["email"];
            this.dmEmail = _data["dmEmail"];
            this.districtEmail = _data["districtEmail"];
            this.prefix = _data["prefix"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.aaExtension = _data["aaExtension"];
        }
    }

    static fromJS(data: any): Store3 {
        data = typeof data === 'object' ? data : {};
        let result = new Store3();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["storeMnemonic"] = this.storeMnemonic;
        data["storeMnemonic2"] = this.storeMnemonic2;
        data["serverName"] = this.serverName;
        data["gredbName"] = this.gredbName;
        data["isClosed"] = this.isClosed;
        data["isGRERunning"] = this.isGRERunning;
        data["storeLogin"] = this.storeLogin;
        data["district"] = this.district;
        data["status"] = this.status;
        data["retailSQFeet"] = this.retailSQFeet;
        data["glNumber"] = this.glNumber;
        data["glCash"] = this.glCash;
        data["glNumber2"] = this.glNumber2;
        data["sort"] = this.sort;
        data["locationId"] = this.locationId;
        data["milesFromCorporate"] = this.milesFromCorporate;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["regionId"] = this.regionId;
        data["email"] = this.email;
        data["dmEmail"] = this.dmEmail;
        data["districtEmail"] = this.districtEmail;
        data["prefix"] = this.prefix;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["aaExtension"] = this.aaExtension;
        return data;
    }
}

export interface IStore3 {
    id?: string | undefined;
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed: boolean;
    isGRERunning: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    status?: string | undefined;
    retailSQFeet?: number | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    milesFromCorporate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;
}

export class QueryResultsOfEquipmentInventoryViewModel implements IQueryResultsOfEquipmentInventoryViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: EquipmentInventoryViewModel[] | undefined;

    constructor(data?: IQueryResultsOfEquipmentInventoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EquipmentInventoryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfEquipmentInventoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfEquipmentInventoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfEquipmentInventoryViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: EquipmentInventoryViewModel[] | undefined;
}

export class EquipmentInventoryViewModel implements IEquipmentInventoryViewModel {
    id!: number;
    storeId?: string | undefined;
    invDate!: string;
    grayTotes!: number;
    blueMetalBarCage!: number;
    blueMetalMeshCage!: number;
    bluePlasticCage!: number;
    blueOrYellowDandexCarts!: number;
    greyZracks!: number;
    yellowAndChromeZracks!: number;
    hangerZracks!: number;
    wireMailStockingCart!: number;
    bishopCarts!: number;
    mattressCarts!: number;
    mellonBoxesFullOrEmpty!: number;
    palletsFullOrEmpty!: number;
    outletBlueTables!: number;
    bookStockingCarts!: number;
    shoppingCartsChrome36By22!: number;
    shoppingCartsChrome42By23!: number;
    shoppingCartsGrey41By24!: number;
    shoppingCartsGrey37By21!: number;
    shoppingCartsTwoTiered21By20!: number;
    handBaskets!: number;
    handBasketsWithWheels!: number;
    toteDollies!: number;
    palletJacks!: number;
    dateEntered!: string;
    enteredBy?: string | undefined;
    store?: StoreViewModel | undefined;

    constructor(data?: IEquipmentInventoryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.invDate = _data["invDate"];
            this.grayTotes = _data["grayTotes"];
            this.blueMetalBarCage = _data["blueMetalBarCage"];
            this.blueMetalMeshCage = _data["blueMetalMeshCage"];
            this.bluePlasticCage = _data["bluePlasticCage"];
            this.blueOrYellowDandexCarts = _data["blueOrYellowDandexCarts"];
            this.greyZracks = _data["greyZracks"];
            this.yellowAndChromeZracks = _data["yellowAndChromeZracks"];
            this.hangerZracks = _data["hangerZracks"];
            this.wireMailStockingCart = _data["wireMailStockingCart"];
            this.bishopCarts = _data["bishopCarts"];
            this.mattressCarts = _data["mattressCarts"];
            this.mellonBoxesFullOrEmpty = _data["mellonBoxesFullOrEmpty"];
            this.palletsFullOrEmpty = _data["palletsFullOrEmpty"];
            this.outletBlueTables = _data["outletBlueTables"];
            this.bookStockingCarts = _data["bookStockingCarts"];
            this.shoppingCartsChrome36By22 = _data["shoppingCartsChrome36By22"];
            this.shoppingCartsChrome42By23 = _data["shoppingCartsChrome42By23"];
            this.shoppingCartsGrey41By24 = _data["shoppingCartsGrey41By24"];
            this.shoppingCartsGrey37By21 = _data["shoppingCartsGrey37By21"];
            this.shoppingCartsTwoTiered21By20 = _data["shoppingCartsTwoTiered21By20"];
            this.handBaskets = _data["handBaskets"];
            this.handBasketsWithWheels = _data["handBasketsWithWheels"];
            this.toteDollies = _data["toteDollies"];
            this.palletJacks = _data["palletJacks"];
            this.dateEntered = _data["dateEntered"];
            this.enteredBy = _data["enteredBy"];
            this.store = _data["store"] ? StoreViewModel.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EquipmentInventoryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EquipmentInventoryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["invDate"] = this.invDate;
        data["grayTotes"] = this.grayTotes;
        data["blueMetalBarCage"] = this.blueMetalBarCage;
        data["blueMetalMeshCage"] = this.blueMetalMeshCage;
        data["bluePlasticCage"] = this.bluePlasticCage;
        data["blueOrYellowDandexCarts"] = this.blueOrYellowDandexCarts;
        data["greyZracks"] = this.greyZracks;
        data["yellowAndChromeZracks"] = this.yellowAndChromeZracks;
        data["hangerZracks"] = this.hangerZracks;
        data["wireMailStockingCart"] = this.wireMailStockingCart;
        data["bishopCarts"] = this.bishopCarts;
        data["mattressCarts"] = this.mattressCarts;
        data["mellonBoxesFullOrEmpty"] = this.mellonBoxesFullOrEmpty;
        data["palletsFullOrEmpty"] = this.palletsFullOrEmpty;
        data["outletBlueTables"] = this.outletBlueTables;
        data["bookStockingCarts"] = this.bookStockingCarts;
        data["shoppingCartsChrome36By22"] = this.shoppingCartsChrome36By22;
        data["shoppingCartsChrome42By23"] = this.shoppingCartsChrome42By23;
        data["shoppingCartsGrey41By24"] = this.shoppingCartsGrey41By24;
        data["shoppingCartsGrey37By21"] = this.shoppingCartsGrey37By21;
        data["shoppingCartsTwoTiered21By20"] = this.shoppingCartsTwoTiered21By20;
        data["handBaskets"] = this.handBaskets;
        data["handBasketsWithWheels"] = this.handBasketsWithWheels;
        data["toteDollies"] = this.toteDollies;
        data["palletJacks"] = this.palletJacks;
        data["dateEntered"] = this.dateEntered;
        data["enteredBy"] = this.enteredBy;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEquipmentInventoryViewModel {
    id: number;
    storeId?: string | undefined;
    invDate: string;
    grayTotes: number;
    blueMetalBarCage: number;
    blueMetalMeshCage: number;
    bluePlasticCage: number;
    blueOrYellowDandexCarts: number;
    greyZracks: number;
    yellowAndChromeZracks: number;
    hangerZracks: number;
    wireMailStockingCart: number;
    bishopCarts: number;
    mattressCarts: number;
    mellonBoxesFullOrEmpty: number;
    palletsFullOrEmpty: number;
    outletBlueTables: number;
    bookStockingCarts: number;
    shoppingCartsChrome36By22: number;
    shoppingCartsChrome42By23: number;
    shoppingCartsGrey41By24: number;
    shoppingCartsGrey37By21: number;
    shoppingCartsTwoTiered21By20: number;
    handBaskets: number;
    handBasketsWithWheels: number;
    toteDollies: number;
    palletJacks: number;
    dateEntered: string;
    enteredBy?: string | undefined;
    store?: StoreViewModel | undefined;
}

export class ESLCitizenshipViewModel implements IESLCitizenshipViewModel {
    id!: number;
    name?: string | undefined;
    country?: string | undefined;
    dateOfCitizenship?: string | undefined;
    employeeCommunity?: string | undefined;
    location?: string | undefined;
    title?: string | undefined;
    roiandPhoto?: boolean | undefined;
    notes?: string | undefined;

    constructor(data?: IESLCitizenshipViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.country = _data["country"];
            this.dateOfCitizenship = _data["dateOfCitizenship"];
            this.employeeCommunity = _data["employeeCommunity"];
            this.location = _data["location"];
            this.title = _data["title"];
            this.roiandPhoto = _data["roiandPhoto"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): ESLCitizenshipViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ESLCitizenshipViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["country"] = this.country;
        data["dateOfCitizenship"] = this.dateOfCitizenship;
        data["employeeCommunity"] = this.employeeCommunity;
        data["location"] = this.location;
        data["title"] = this.title;
        data["roiandPhoto"] = this.roiandPhoto;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IESLCitizenshipViewModel {
    id: number;
    name?: string | undefined;
    country?: string | undefined;
    dateOfCitizenship?: string | undefined;
    employeeCommunity?: string | undefined;
    location?: string | undefined;
    title?: string | undefined;
    roiandPhoto?: boolean | undefined;
    notes?: string | undefined;
}

export class QueryResultsOfESLCitizenshipViewModel implements IQueryResultsOfESLCitizenshipViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ESLCitizenshipViewModel[] | undefined;

    constructor(data?: IQueryResultsOfESLCitizenshipViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ESLCitizenshipViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfESLCitizenshipViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfESLCitizenshipViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfESLCitizenshipViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ESLCitizenshipViewModel[] | undefined;
}

export class ESLCitizenship implements IESLCitizenship {
    id!: number;
    name?: string | undefined;
    country?: string | undefined;
    dateOfCitizenship?: string | undefined;
    employeeCommunity?: string | undefined;
    location?: string | undefined;
    title?: string | undefined;
    roiandPhoto?: boolean | undefined;
    notes?: string | undefined;

    constructor(data?: IESLCitizenship) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.country = _data["country"];
            this.dateOfCitizenship = _data["dateOfCitizenship"];
            this.employeeCommunity = _data["employeeCommunity"];
            this.location = _data["location"];
            this.title = _data["title"];
            this.roiandPhoto = _data["roiandPhoto"];
            this.notes = _data["notes"];
        }
    }

    static fromJS(data: any): ESLCitizenship {
        data = typeof data === 'object' ? data : {};
        let result = new ESLCitizenship();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["country"] = this.country;
        data["dateOfCitizenship"] = this.dateOfCitizenship;
        data["employeeCommunity"] = this.employeeCommunity;
        data["location"] = this.location;
        data["title"] = this.title;
        data["roiandPhoto"] = this.roiandPhoto;
        data["notes"] = this.notes;
        return data;
    }
}

export interface IESLCitizenship {
    id: number;
    name?: string | undefined;
    country?: string | undefined;
    dateOfCitizenship?: string | undefined;
    employeeCommunity?: string | undefined;
    location?: string | undefined;
    title?: string | undefined;
    roiandPhoto?: boolean | undefined;
    notes?: string | undefined;
}

export class QueryResultsOfESLClass implements IQueryResultsOfESLClass {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ESLClass[] | undefined;

    constructor(data?: IQueryResultsOfESLClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ESLClass.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfESLClass {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfESLClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfESLClass {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ESLClass[] | undefined;
}

export class ESLClass implements IESLClass {
    id?: string | undefined;
    className?: string | undefined;
    instructor?: string | undefined;
    classDate!: string;
    classHours!: number;
    actualHours!: number;

    constructor(data?: IESLClass) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.className = _data["className"];
            this.instructor = _data["instructor"];
            this.classDate = _data["classDate"];
            this.classHours = _data["classHours"];
            this.actualHours = _data["actualHours"];
        }
    }

    static fromJS(data: any): ESLClass {
        data = typeof data === 'object' ? data : {};
        let result = new ESLClass();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["className"] = this.className;
        data["instructor"] = this.instructor;
        data["classDate"] = this.classDate;
        data["classHours"] = this.classHours;
        data["actualHours"] = this.actualHours;
        return data;
    }
}

export interface IESLClass {
    id?: string | undefined;
    className?: string | undefined;
    instructor?: string | undefined;
    classDate: string;
    classHours: number;
    actualHours: number;
}

export class ESLClassType implements IESLClassType {
    id!: number;
    className?: string | undefined;
    classType?: string | undefined;
    asrtype?: string | undefined;
    active!: boolean;

    constructor(data?: IESLClassType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.className = _data["className"];
            this.classType = _data["classType"];
            this.asrtype = _data["asrtype"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ESLClassType {
        data = typeof data === 'object' ? data : {};
        let result = new ESLClassType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["className"] = this.className;
        data["classType"] = this.classType;
        data["asrtype"] = this.asrtype;
        data["active"] = this.active;
        return data;
    }
}

export interface IESLClassType {
    id: number;
    className?: string | undefined;
    classType?: string | undefined;
    asrtype?: string | undefined;
    active: boolean;
}

export class QueryResultsOfESLClassType implements IQueryResultsOfESLClassType {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ESLClassType[] | undefined;

    constructor(data?: IQueryResultsOfESLClassType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ESLClassType.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfESLClassType {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfESLClassType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfESLClassType {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ESLClassType[] | undefined;
}

export class ESLGoal extends EntityBase implements IESLGoal {
    year!: number;
    individuals!: number;
    services!: number;
    classes!: number;

    constructor(data?: IESLGoal) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.year = _data["year"];
            this.individuals = _data["individuals"];
            this.services = _data["services"];
            this.classes = _data["classes"];
        }
    }

    static fromJS(data: any): ESLGoal {
        data = typeof data === 'object' ? data : {};
        let result = new ESLGoal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["individuals"] = this.individuals;
        data["services"] = this.services;
        data["classes"] = this.classes;
        super.toJSON(data);
        return data;
    }
}

export interface IESLGoal extends IEntityBase {
    year: number;
    individuals: number;
    services: number;
    classes: number;
}

export class QueryResultsOfESLGoal implements IQueryResultsOfESLGoal {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ESLGoal[] | undefined;

    constructor(data?: IQueryResultsOfESLGoal) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ESLGoal.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfESLGoal {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfESLGoal();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfESLGoal {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ESLGoal[] | undefined;
}

export class ESLInstructor implements IESLInstructor {
    id!: number;
    instructor?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: IESLInstructor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.instructor = _data["instructor"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ESLInstructor {
        data = typeof data === 'object' ? data : {};
        let result = new ESLInstructor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["instructor"] = this.instructor;
        data["active"] = this.active;
        return data;
    }
}

export interface IESLInstructor {
    id: number;
    instructor?: string | undefined;
    active?: boolean | undefined;
}

export class QueryResultsOfESLInstructor implements IQueryResultsOfESLInstructor {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ESLInstructor[] | undefined;

    constructor(data?: IQueryResultsOfESLInstructor) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ESLInstructor.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfESLInstructor {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfESLInstructor();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfESLInstructor {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ESLInstructor[] | undefined;
}

export class QueryResultsOfESLParticipantViewModel implements IQueryResultsOfESLParticipantViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ESLParticipantViewModel[] | undefined;

    constructor(data?: IQueryResultsOfESLParticipantViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ESLParticipantViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfESLParticipantViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfESLParticipantViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfESLParticipantViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ESLParticipantViewModel[] | undefined;
}

export class ESLParticipantViewModel implements IESLParticipantViewModel {
    id?: string | undefined;
    employeeId?: string | undefined;
    type?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    esllevel?: string | undefined;
    store?: string | undefined;
    job?: string | undefined;
    country?: string | undefined;
    yearOfBirth!: number;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    married?: string | undefined;
    yrsofEd!: number;
    timeInUs?: number | undefined;
    previousEsl?: string | undefined;
    wksofEsl?: number | undefined;
    location?: string | undefined;
    phone?: string | undefined;
    classLocation?: string | undefined;
    referralSourceId?: number | undefined;
    veteran?: boolean | undefined;
    familyOfVeteran?: boolean | undefined;
    primaryLanguageSpanish?: boolean | undefined;
    zipCode?: string | undefined;
    firstLanguage?: string | undefined;
    email?: string | undefined;
    universityCollege?: string | undefined;
    programDegree?: string | undefined;
    studentId?: string | undefined;
    desiredObservationHours?: number | undefined;
    desiredCoTeachingHours?: number | undefined;
    referralSource?: ESLReferralSource | undefined;
    caseNotes?: ESLCaseNoteViewModel[] | undefined;
    scores?: ESLScoreViewModel[] | undefined;

    constructor(data?: IESLParticipantViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.type = _data["type"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.esllevel = _data["esllevel"];
            this.store = _data["store"];
            this.job = _data["job"];
            this.country = _data["country"];
            this.yearOfBirth = _data["yearOfBirth"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.married = _data["married"];
            this.yrsofEd = _data["yrsofEd"];
            this.timeInUs = _data["timeInUs"];
            this.previousEsl = _data["previousEsl"];
            this.wksofEsl = _data["wksofEsl"];
            this.location = _data["location"];
            this.phone = _data["phone"];
            this.classLocation = _data["classLocation"];
            this.referralSourceId = _data["referralSourceId"];
            this.veteran = _data["veteran"];
            this.familyOfVeteran = _data["familyOfVeteran"];
            this.primaryLanguageSpanish = _data["primaryLanguageSpanish"];
            this.zipCode = _data["zipCode"];
            this.firstLanguage = _data["firstLanguage"];
            this.email = _data["email"];
            this.universityCollege = _data["universityCollege"];
            this.programDegree = _data["programDegree"];
            this.studentId = _data["studentId"];
            this.desiredObservationHours = _data["desiredObservationHours"];
            this.desiredCoTeachingHours = _data["desiredCoTeachingHours"];
            this.referralSource = _data["referralSource"] ? ESLReferralSource.fromJS(_data["referralSource"]) : <any>undefined;
            if (Array.isArray(_data["caseNotes"])) {
                this.caseNotes = [] as any;
                for (let item of _data["caseNotes"])
                    this.caseNotes!.push(ESLCaseNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["scores"])) {
                this.scores = [] as any;
                for (let item of _data["scores"])
                    this.scores!.push(ESLScoreViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ESLParticipantViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ESLParticipantViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["type"] = this.type;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["esllevel"] = this.esllevel;
        data["store"] = this.store;
        data["job"] = this.job;
        data["country"] = this.country;
        data["yearOfBirth"] = this.yearOfBirth;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["married"] = this.married;
        data["yrsofEd"] = this.yrsofEd;
        data["timeInUs"] = this.timeInUs;
        data["previousEsl"] = this.previousEsl;
        data["wksofEsl"] = this.wksofEsl;
        data["location"] = this.location;
        data["phone"] = this.phone;
        data["classLocation"] = this.classLocation;
        data["referralSourceId"] = this.referralSourceId;
        data["veteran"] = this.veteran;
        data["familyOfVeteran"] = this.familyOfVeteran;
        data["primaryLanguageSpanish"] = this.primaryLanguageSpanish;
        data["zipCode"] = this.zipCode;
        data["firstLanguage"] = this.firstLanguage;
        data["email"] = this.email;
        data["universityCollege"] = this.universityCollege;
        data["programDegree"] = this.programDegree;
        data["studentId"] = this.studentId;
        data["desiredObservationHours"] = this.desiredObservationHours;
        data["desiredCoTeachingHours"] = this.desiredCoTeachingHours;
        data["referralSource"] = this.referralSource ? this.referralSource.toJSON() : <any>undefined;
        if (Array.isArray(this.caseNotes)) {
            data["caseNotes"] = [];
            for (let item of this.caseNotes)
                data["caseNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.scores)) {
            data["scores"] = [];
            for (let item of this.scores)
                data["scores"].push(item.toJSON());
        }
        return data;
    }
}

export interface IESLParticipantViewModel {
    id?: string | undefined;
    employeeId?: string | undefined;
    type?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    esllevel?: string | undefined;
    store?: string | undefined;
    job?: string | undefined;
    country?: string | undefined;
    yearOfBirth: number;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    married?: string | undefined;
    yrsofEd: number;
    timeInUs?: number | undefined;
    previousEsl?: string | undefined;
    wksofEsl?: number | undefined;
    location?: string | undefined;
    phone?: string | undefined;
    classLocation?: string | undefined;
    referralSourceId?: number | undefined;
    veteran?: boolean | undefined;
    familyOfVeteran?: boolean | undefined;
    primaryLanguageSpanish?: boolean | undefined;
    zipCode?: string | undefined;
    firstLanguage?: string | undefined;
    email?: string | undefined;
    universityCollege?: string | undefined;
    programDegree?: string | undefined;
    studentId?: string | undefined;
    desiredObservationHours?: number | undefined;
    desiredCoTeachingHours?: number | undefined;
    referralSource?: ESLReferralSource | undefined;
    caseNotes?: ESLCaseNoteViewModel[] | undefined;
    scores?: ESLScoreViewModel[] | undefined;
}

export class ESLReferralSource implements IESLReferralSource {
    id!: number;
    referralSource?: string | undefined;

    constructor(data?: IESLReferralSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referralSource = _data["referralSource"];
        }
    }

    static fromJS(data: any): ESLReferralSource {
        data = typeof data === 'object' ? data : {};
        let result = new ESLReferralSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referralSource"] = this.referralSource;
        return data;
    }
}

export interface IESLReferralSource {
    id: number;
    referralSource?: string | undefined;
}

export class ESLCaseNoteViewModel implements IESLCaseNoteViewModel {
    id!: number;
    employeeId?: string | undefined;
    date!: string;
    staffId!: number;
    note?: string | undefined;

    constructor(data?: IESLCaseNoteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.date = _data["date"];
            this.staffId = _data["staffId"];
            this.note = _data["note"];
        }
    }

    static fromJS(data: any): ESLCaseNoteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ESLCaseNoteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["date"] = this.date;
        data["staffId"] = this.staffId;
        data["note"] = this.note;
        return data;
    }
}

export interface IESLCaseNoteViewModel {
    id: number;
    employeeId?: string | undefined;
    date: string;
    staffId: number;
    note?: string | undefined;
}

export class ESLScoreViewModel implements IESLScoreViewModel {
    id!: number;
    employeeId?: string | undefined;
    date!: string;
    test?: string | undefined;
    preScore!: number;
    postScore?: number | undefined;

    constructor(data?: IESLScoreViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.employeeId = _data["employeeId"];
            this.date = _data["date"];
            this.test = _data["test"];
            this.preScore = _data["preScore"];
            this.postScore = _data["postScore"];
        }
    }

    static fromJS(data: any): ESLScoreViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ESLScoreViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["employeeId"] = this.employeeId;
        data["date"] = this.date;
        data["test"] = this.test;
        data["preScore"] = this.preScore;
        data["postScore"] = this.postScore;
        return data;
    }
}

export interface IESLScoreViewModel {
    id: number;
    employeeId?: string | undefined;
    date: string;
    test?: string | undefined;
    preScore: number;
    postScore?: number | undefined;
}

export class ESLParticipantSavingModel implements IESLParticipantSavingModel {
    id?: string | undefined;
    type?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    esllevel?: string | undefined;
    store?: string | undefined;
    job?: string | undefined;
    country?: string | undefined;
    yearOfBirth!: number;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    married?: string | undefined;
    yrsofEd!: number;
    timeInUs?: number | undefined;
    previousEsl?: string | undefined;
    wksofEsl?: number | undefined;
    location?: string | undefined;
    phone?: string | undefined;
    classLocation?: string | undefined;
    referralSourceId?: number | undefined;
    veteran?: boolean | undefined;
    familyOfVeteran?: boolean | undefined;
    primaryLanguageSpanish?: boolean | undefined;
    zipCode?: string | undefined;
    firstLanguage?: string | undefined;
    email?: string | undefined;
    universityCollege?: string | undefined;
    programDegree?: string | undefined;
    studentId?: string | undefined;
    desiredObservationHours?: number | undefined;
    desiredCoTeachingHours?: number | undefined;
    caseNotes?: ESLCaseNoteViewModel[] | undefined;
    scores?: ESLScoreViewModel[] | undefined;

    constructor(data?: IESLParticipantSavingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.lastName = _data["lastName"];
            this.firstName = _data["firstName"];
            this.esllevel = _data["esllevel"];
            this.store = _data["store"];
            this.job = _data["job"];
            this.country = _data["country"];
            this.yearOfBirth = _data["yearOfBirth"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.married = _data["married"];
            this.yrsofEd = _data["yrsofEd"];
            this.timeInUs = _data["timeInUs"];
            this.previousEsl = _data["previousEsl"];
            this.wksofEsl = _data["wksofEsl"];
            this.location = _data["location"];
            this.phone = _data["phone"];
            this.classLocation = _data["classLocation"];
            this.referralSourceId = _data["referralSourceId"];
            this.veteran = _data["veteran"];
            this.familyOfVeteran = _data["familyOfVeteran"];
            this.primaryLanguageSpanish = _data["primaryLanguageSpanish"];
            this.zipCode = _data["zipCode"];
            this.firstLanguage = _data["firstLanguage"];
            this.email = _data["email"];
            this.universityCollege = _data["universityCollege"];
            this.programDegree = _data["programDegree"];
            this.studentId = _data["studentId"];
            this.desiredObservationHours = _data["desiredObservationHours"];
            this.desiredCoTeachingHours = _data["desiredCoTeachingHours"];
            if (Array.isArray(_data["caseNotes"])) {
                this.caseNotes = [] as any;
                for (let item of _data["caseNotes"])
                    this.caseNotes!.push(ESLCaseNoteViewModel.fromJS(item));
            }
            if (Array.isArray(_data["scores"])) {
                this.scores = [] as any;
                for (let item of _data["scores"])
                    this.scores!.push(ESLScoreViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ESLParticipantSavingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ESLParticipantSavingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["lastName"] = this.lastName;
        data["firstName"] = this.firstName;
        data["esllevel"] = this.esllevel;
        data["store"] = this.store;
        data["job"] = this.job;
        data["country"] = this.country;
        data["yearOfBirth"] = this.yearOfBirth;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["married"] = this.married;
        data["yrsofEd"] = this.yrsofEd;
        data["timeInUs"] = this.timeInUs;
        data["previousEsl"] = this.previousEsl;
        data["wksofEsl"] = this.wksofEsl;
        data["location"] = this.location;
        data["phone"] = this.phone;
        data["classLocation"] = this.classLocation;
        data["referralSourceId"] = this.referralSourceId;
        data["veteran"] = this.veteran;
        data["familyOfVeteran"] = this.familyOfVeteran;
        data["primaryLanguageSpanish"] = this.primaryLanguageSpanish;
        data["zipCode"] = this.zipCode;
        data["firstLanguage"] = this.firstLanguage;
        data["email"] = this.email;
        data["universityCollege"] = this.universityCollege;
        data["programDegree"] = this.programDegree;
        data["studentId"] = this.studentId;
        data["desiredObservationHours"] = this.desiredObservationHours;
        data["desiredCoTeachingHours"] = this.desiredCoTeachingHours;
        if (Array.isArray(this.caseNotes)) {
            data["caseNotes"] = [];
            for (let item of this.caseNotes)
                data["caseNotes"].push(item.toJSON());
        }
        if (Array.isArray(this.scores)) {
            data["scores"] = [];
            for (let item of this.scores)
                data["scores"].push(item.toJSON());
        }
        return data;
    }
}

export interface IESLParticipantSavingModel {
    id?: string | undefined;
    type?: string | undefined;
    lastName?: string | undefined;
    firstName?: string | undefined;
    esllevel?: string | undefined;
    store?: string | undefined;
    job?: string | undefined;
    country?: string | undefined;
    yearOfBirth: number;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    married?: string | undefined;
    yrsofEd: number;
    timeInUs?: number | undefined;
    previousEsl?: string | undefined;
    wksofEsl?: number | undefined;
    location?: string | undefined;
    phone?: string | undefined;
    classLocation?: string | undefined;
    referralSourceId?: number | undefined;
    veteran?: boolean | undefined;
    familyOfVeteran?: boolean | undefined;
    primaryLanguageSpanish?: boolean | undefined;
    zipCode?: string | undefined;
    firstLanguage?: string | undefined;
    email?: string | undefined;
    universityCollege?: string | undefined;
    programDegree?: string | undefined;
    studentId?: string | undefined;
    desiredObservationHours?: number | undefined;
    desiredCoTeachingHours?: number | undefined;
    caseNotes?: ESLCaseNoteViewModel[] | undefined;
    scores?: ESLScoreViewModel[] | undefined;
}

export class QueryResultsOfESLReferralSource implements IQueryResultsOfESLReferralSource {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ESLReferralSource[] | undefined;

    constructor(data?: IQueryResultsOfESLReferralSource) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ESLReferralSource.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfESLReferralSource {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfESLReferralSource();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfESLReferralSource {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ESLReferralSource[] | undefined;
}

export class QueryResultsOfESLTrainingSummaryViewModel implements IQueryResultsOfESLTrainingSummaryViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ESLTrainingSummaryViewModel[] | undefined;

    constructor(data?: IQueryResultsOfESLTrainingSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ESLTrainingSummaryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfESLTrainingSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfESLTrainingSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfESLTrainingSummaryViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ESLTrainingSummaryViewModel[] | undefined;
}

export class ESLTrainingSummaryViewModel implements IESLTrainingSummaryViewModel {
    id!: number;
    classDate!: string;
    entryDate!: string;
    hours!: number;
    location?: LocationViewModel | undefined;
    class?: ESLClassTypeViewModel | undefined;
    teacher?: ESLInstructorViewModel | undefined;
    trainingDetails?: ESLTrainingDetailViewModel[] | undefined;

    constructor(data?: IESLTrainingSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.classDate = _data["classDate"];
            this.entryDate = _data["entryDate"];
            this.hours = _data["hours"];
            this.location = _data["location"] ? LocationViewModel.fromJS(_data["location"]) : <any>undefined;
            this.class = _data["class"] ? ESLClassTypeViewModel.fromJS(_data["class"]) : <any>undefined;
            this.teacher = _data["teacher"] ? ESLInstructorViewModel.fromJS(_data["teacher"]) : <any>undefined;
            if (Array.isArray(_data["trainingDetails"])) {
                this.trainingDetails = [] as any;
                for (let item of _data["trainingDetails"])
                    this.trainingDetails!.push(ESLTrainingDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ESLTrainingSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ESLTrainingSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["classDate"] = this.classDate;
        data["entryDate"] = this.entryDate;
        data["hours"] = this.hours;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["class"] = this.class ? this.class.toJSON() : <any>undefined;
        data["teacher"] = this.teacher ? this.teacher.toJSON() : <any>undefined;
        if (Array.isArray(this.trainingDetails)) {
            data["trainingDetails"] = [];
            for (let item of this.trainingDetails)
                data["trainingDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IESLTrainingSummaryViewModel {
    id: number;
    classDate: string;
    entryDate: string;
    hours: number;
    location?: LocationViewModel | undefined;
    class?: ESLClassTypeViewModel | undefined;
    teacher?: ESLInstructorViewModel | undefined;
    trainingDetails?: ESLTrainingDetailViewModel[] | undefined;
}

export class LocationViewModel implements ILocationViewModel {
    id!: number;
    location1?: string | undefined;

    constructor(data?: ILocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.location1 = _data["location1"];
        }
    }

    static fromJS(data: any): LocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["location1"] = this.location1;
        return data;
    }
}

export interface ILocationViewModel {
    id: number;
    location1?: string | undefined;
}

export class ESLClassTypeViewModel implements IESLClassTypeViewModel {
    id!: number;
    className?: string | undefined;
    classType?: string | undefined;
    asrtype?: string | undefined;
    active!: boolean;

    constructor(data?: IESLClassTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.className = _data["className"];
            this.classType = _data["classType"];
            this.asrtype = _data["asrtype"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): ESLClassTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ESLClassTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["className"] = this.className;
        data["classType"] = this.classType;
        data["asrtype"] = this.asrtype;
        data["active"] = this.active;
        return data;
    }
}

export interface IESLClassTypeViewModel {
    id: number;
    className?: string | undefined;
    classType?: string | undefined;
    asrtype?: string | undefined;
    active: boolean;
}

export class ESLInstructorViewModel implements IESLInstructorViewModel {
    id!: number;
    instructor?: string | undefined;

    constructor(data?: IESLInstructorViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.instructor = _data["instructor"];
        }
    }

    static fromJS(data: any): ESLInstructorViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ESLInstructorViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["instructor"] = this.instructor;
        return data;
    }
}

export interface IESLInstructorViewModel {
    id: number;
    instructor?: string | undefined;
}

export class ESLTrainingDetailViewModel implements IESLTrainingDetailViewModel {
    id!: number;
    trainingSummaryId!: number;
    employeeId?: string | undefined;
    hours!: number;

    constructor(data?: IESLTrainingDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trainingSummaryId = _data["trainingSummaryId"];
            this.employeeId = _data["employeeId"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): ESLTrainingDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ESLTrainingDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trainingSummaryId"] = this.trainingSummaryId;
        data["employeeId"] = this.employeeId;
        data["hours"] = this.hours;
        return data;
    }
}

export interface IESLTrainingDetailViewModel {
    id: number;
    trainingSummaryId: number;
    employeeId?: string | undefined;
    hours: number;
}

export class ESLTrainingSummary implements IESLTrainingSummary {
    id!: number;
    teacherId!: number;
    classId!: number;
    classDate!: string;
    entryDate!: string;
    hours!: number;
    locationId!: number;
    trainingDetails?: ESLTrainingDetail[] | undefined;

    constructor(data?: IESLTrainingSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teacherId = _data["teacherId"];
            this.classId = _data["classId"];
            this.classDate = _data["classDate"];
            this.entryDate = _data["entryDate"];
            this.hours = _data["hours"];
            this.locationId = _data["locationId"];
            if (Array.isArray(_data["trainingDetails"])) {
                this.trainingDetails = [] as any;
                for (let item of _data["trainingDetails"])
                    this.trainingDetails!.push(ESLTrainingDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ESLTrainingSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ESLTrainingSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teacherId"] = this.teacherId;
        data["classId"] = this.classId;
        data["classDate"] = this.classDate;
        data["entryDate"] = this.entryDate;
        data["hours"] = this.hours;
        data["locationId"] = this.locationId;
        if (Array.isArray(this.trainingDetails)) {
            data["trainingDetails"] = [];
            for (let item of this.trainingDetails)
                data["trainingDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IESLTrainingSummary {
    id: number;
    teacherId: number;
    classId: number;
    classDate: string;
    entryDate: string;
    hours: number;
    locationId: number;
    trainingDetails?: ESLTrainingDetail[] | undefined;
}

export class ESLTrainingDetail implements IESLTrainingDetail {
    id!: number;
    trainingSummaryId!: number;
    employeeId?: string | undefined;
    hours!: number;

    constructor(data?: IESLTrainingDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.trainingSummaryId = _data["trainingSummaryId"];
            this.employeeId = _data["employeeId"];
            this.hours = _data["hours"];
        }
    }

    static fromJS(data: any): ESLTrainingDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ESLTrainingDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["trainingSummaryId"] = this.trainingSummaryId;
        data["employeeId"] = this.employeeId;
        data["hours"] = this.hours;
        return data;
    }
}

export interface IESLTrainingDetail {
    id: number;
    trainingSummaryId: number;
    employeeId?: string | undefined;
    hours: number;
}

export class EmployeeQuery extends Query implements IEmployeeQuery {
    storeId?: string | undefined;
    employeeNumber?: string | undefined;

    constructor(data?: IEmployeeQuery) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.storeId = _data["storeId"];
            this.employeeNumber = _data["employeeNumber"];
        }
    }

    static fromJS(data: any): EmployeeQuery {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeQuery();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["storeId"] = this.storeId;
        data["employeeNumber"] = this.employeeNumber;
        super.toJSON(data);
        return data;
    }
}

export interface IEmployeeQuery extends IQuery {
    storeId?: string | undefined;
    employeeNumber?: string | undefined;
}

export class Employee2 extends EntityBase implements IEmployee2 {
    name?: string | undefined;
    startedOn!: string;
    store?: Store4 | undefined;
    documents?: DocumentCollection | undefined;

    constructor(data?: IEmployee2) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.startedOn = _data["startedOn"];
            this.store = _data["store"] ? Store4.fromJS(_data["store"]) : <any>undefined;
            this.documents = _data["documents"] ? DocumentCollection.fromJS(_data["documents"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Employee2 {
        data = typeof data === 'object' ? data : {};
        let result = new Employee2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["startedOn"] = this.startedOn;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        data["documents"] = this.documents ? this.documents.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IEmployee2 extends IEntityBase {
    name?: string | undefined;
    startedOn: string;
    store?: Store4 | undefined;
    documents?: DocumentCollection | undefined;
}

export abstract class EntityBaseOfString implements IEntityBaseOfString {
    id?: string | undefined;

    constructor(data?: IEntityBaseOfString) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EntityBaseOfString {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'EntityBaseOfString' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        return data;
    }
}

export interface IEntityBaseOfString {
    id?: string | undefined;
}

export class Store4 extends EntityBaseOfString implements IStore4 {
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed!: boolean;
    isGRERunning!: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    cost_Center_type?: string | undefined;
    status?: string | undefined;
    retailSQFeet?: number | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    milesFromCorporate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;
    rowguid!: string;
    id?: string | undefined;

    constructor(data?: IStore4) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.storeMnemonic = _data["storeMnemonic"];
            this.storeMnemonic2 = _data["storeMnemonic2"];
            this.serverName = _data["serverName"];
            this.gredbName = _data["gredbName"];
            this.isClosed = _data["isClosed"];
            this.isGRERunning = _data["isGRERunning"];
            this.storeLogin = _data["storeLogin"];
            this.district = _data["district"];
            this.cost_Center_type = _data["cost_Center_type"];
            this.status = _data["status"];
            this.retailSQFeet = _data["retailSQFeet"];
            this.glNumber = _data["glNumber"];
            this.glCash = _data["glCash"];
            this.glNumber2 = _data["glNumber2"];
            this.sort = _data["sort"];
            this.locationId = _data["locationId"];
            this.milesFromCorporate = _data["milesFromCorporate"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.regionId = _data["regionId"];
            this.email = _data["email"];
            this.dmEmail = _data["dmEmail"];
            this.districtEmail = _data["districtEmail"];
            this.prefix = _data["prefix"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.aaExtension = _data["aaExtension"];
            this.rowguid = _data["rowguid"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): Store4 {
        data = typeof data === 'object' ? data : {};
        let result = new Store4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["storeMnemonic"] = this.storeMnemonic;
        data["storeMnemonic2"] = this.storeMnemonic2;
        data["serverName"] = this.serverName;
        data["gredbName"] = this.gredbName;
        data["isClosed"] = this.isClosed;
        data["isGRERunning"] = this.isGRERunning;
        data["storeLogin"] = this.storeLogin;
        data["district"] = this.district;
        data["cost_Center_type"] = this.cost_Center_type;
        data["status"] = this.status;
        data["retailSQFeet"] = this.retailSQFeet;
        data["glNumber"] = this.glNumber;
        data["glCash"] = this.glCash;
        data["glNumber2"] = this.glNumber2;
        data["sort"] = this.sort;
        data["locationId"] = this.locationId;
        data["milesFromCorporate"] = this.milesFromCorporate;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["regionId"] = this.regionId;
        data["email"] = this.email;
        data["dmEmail"] = this.dmEmail;
        data["districtEmail"] = this.districtEmail;
        data["prefix"] = this.prefix;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["aaExtension"] = this.aaExtension;
        data["rowguid"] = this.rowguid;
        data["id"] = this.id;
        super.toJSON(data);
        return data;
    }
}

export interface IStore4 extends IEntityBaseOfString {
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed: boolean;
    isGRERunning: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    cost_Center_type?: string | undefined;
    status?: string | undefined;
    retailSQFeet?: number | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    milesFromCorporate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;
    rowguid: string;
    id?: string | undefined;
}

export abstract class MultiParentCollectionBaseOfDocumentAndInteger extends EntityBaseOfInteger implements IMultiParentCollectionBaseOfDocumentAndInteger {
    items?: Document[] | undefined;

    constructor(data?: IMultiParentCollectionBaseOfDocumentAndInteger) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(Document.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MultiParentCollectionBaseOfDocumentAndInteger {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MultiParentCollectionBaseOfDocumentAndInteger' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        super.toJSON(data);
        return data;
    }
}

export interface IMultiParentCollectionBaseOfDocumentAndInteger extends IEntityBaseOfInteger {
    items?: Document[] | undefined;
}

export abstract class MultiParentCollectionBaseOfDocument extends MultiParentCollectionBaseOfDocumentAndInteger implements IMultiParentCollectionBaseOfDocument {

    constructor(data?: IMultiParentCollectionBaseOfDocument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): MultiParentCollectionBaseOfDocument {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MultiParentCollectionBaseOfDocument' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IMultiParentCollectionBaseOfDocument extends IMultiParentCollectionBaseOfDocumentAndInteger {
}

export class DocumentCollection extends MultiParentCollectionBaseOfDocument implements IDocumentCollection {

    constructor(data?: IDocumentCollection) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): DocumentCollection {
        data = typeof data === 'object' ? data : {};
        let result = new DocumentCollection();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

export interface IDocumentCollection extends IMultiParentCollectionBaseOfDocument {
}

export class Document extends EntityBase implements IDocument {
    name?: string | undefined;
    docParent?: DocParent | undefined;

    constructor(data?: IDocument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.docParent = _data["docParent"] ? DocParent.fromJS(_data["docParent"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Document {
        data = typeof data === 'object' ? data : {};
        let result = new Document();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["docParent"] = this.docParent ? this.docParent.toJSON() : <any>undefined;
        super.toJSON(data);
        return data;
    }
}

export interface IDocument extends IEntityBase {
    name?: string | undefined;
    docParent?: DocParent | undefined;
}

export class DocParent extends EntityBase implements IDocParent {
    name?: string | undefined;

    constructor(data?: IDocParent) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): DocParent {
        data = typeof data === 'object' ? data : {};
        let result = new DocParent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IDocParent extends IEntityBase {
    name?: string | undefined;
}

export class PicklistOption implements IPicklistOption {
    id!: number;
    name?: string | undefined;
    details?: string | undefined;

    constructor(data?: IPicklistOption) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.details = _data["details"];
        }
    }

    static fromJS(data: any): PicklistOption {
        data = typeof data === 'object' ? data : {};
        let result = new PicklistOption();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["details"] = this.details;
        return data;
    }
}

export interface IPicklistOption {
    id: number;
    name?: string | undefined;
    details?: string | undefined;
}

export class IssueViewModel implements IIssueViewModel {
    id!: number;
    taskType?: string | undefined;
    issueTypeId!: number;
    itemNumber?: string | undefined;
    description?: string | undefined;
    employeeNumber?: string | undefined;
    enterDate!: string;
    enteredBy?: string | undefined;
    issueType?: IssueTypeViewModel | undefined;

    constructor(data?: IIssueViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.taskType = _data["taskType"];
            this.issueTypeId = _data["issueTypeId"];
            this.itemNumber = _data["itemNumber"];
            this.description = _data["description"];
            this.employeeNumber = _data["employeeNumber"];
            this.enterDate = _data["enterDate"];
            this.enteredBy = _data["enteredBy"];
            this.issueType = _data["issueType"] ? IssueTypeViewModel.fromJS(_data["issueType"]) : <any>undefined;
        }
    }

    static fromJS(data: any): IssueViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssueViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["taskType"] = this.taskType;
        data["issueTypeId"] = this.issueTypeId;
        data["itemNumber"] = this.itemNumber;
        data["description"] = this.description;
        data["employeeNumber"] = this.employeeNumber;
        data["enterDate"] = this.enterDate;
        data["enteredBy"] = this.enteredBy;
        data["issueType"] = this.issueType ? this.issueType.toJSON() : <any>undefined;
        return data;
    }
}

export interface IIssueViewModel {
    id: number;
    taskType?: string | undefined;
    issueTypeId: number;
    itemNumber?: string | undefined;
    description?: string | undefined;
    employeeNumber?: string | undefined;
    enterDate: string;
    enteredBy?: string | undefined;
    issueType?: IssueTypeViewModel | undefined;
}

export class IssueTypeViewModel implements IIssueTypeViewModel {
    id!: number;
    issueTypeDescription?: string | undefined;
    type?: string | undefined;

    constructor(data?: IIssueTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.issueTypeDescription = _data["issueTypeDescription"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): IssueTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IssueTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issueTypeDescription"] = this.issueTypeDescription;
        data["type"] = this.type;
        return data;
    }
}

export interface IIssueTypeViewModel {
    id: number;
    issueTypeDescription?: string | undefined;
    type?: string | undefined;
}

export class Issue implements IIssue {
    id!: number;
    issueTypeId!: number;
    itemNumber?: string | undefined;
    description?: string | undefined;
    employeeNumber?: string | undefined;
    enterDate!: string;
    enteredBy?: string | undefined;

    constructor(data?: IIssue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.issueTypeId = _data["issueTypeId"];
            this.itemNumber = _data["itemNumber"];
            this.description = _data["description"];
            this.employeeNumber = _data["employeeNumber"];
            this.enterDate = _data["enterDate"];
            this.enteredBy = _data["enteredBy"];
        }
    }

    static fromJS(data: any): Issue {
        data = typeof data === 'object' ? data : {};
        let result = new Issue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["issueTypeId"] = this.issueTypeId;
        data["itemNumber"] = this.itemNumber;
        data["description"] = this.description;
        data["employeeNumber"] = this.employeeNumber;
        data["enterDate"] = this.enterDate;
        data["enteredBy"] = this.enteredBy;
        return data;
    }
}

export interface IIssue {
    id: number;
    issueTypeId: number;
    itemNumber?: string | undefined;
    description?: string | undefined;
    employeeNumber?: string | undefined;
    enterDate: string;
    enteredBy?: string | undefined;
}

export class TaskTypeViewModel implements ITaskTypeViewModel {
    id!: number;
    type?: string | undefined;

    constructor(data?: ITaskTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
        }
    }

    static fromJS(data: any): TaskTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TaskTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        return data;
    }
}

export interface ITaskTypeViewModel {
    id: number;
    type?: string | undefined;
}

export class QueryResultsOfIssueTypeViewModel implements IQueryResultsOfIssueTypeViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: IssueTypeViewModel[] | undefined;

    constructor(data?: IQueryResultsOfIssueTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(IssueTypeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfIssueTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfIssueTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfIssueTypeViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: IssueTypeViewModel[] | undefined;
}

export class FixedAssetViewModel implements IFixedAssetViewModel {
    id!: number;
    fixedAssetNumber?: string | undefined;
    description?: string | undefined;
    assetTypeId?: number | undefined;
    assetId?: string | undefined;
    trailerNumber?: string | undefined;
    serialVinnumber?: string | undefined;
    costCenterId?: number | undefined;
    descriptionofLocation?: string | undefined;
    placedInService?: string | undefined;
    retirementReason?: string | undefined;
    retirementDate?: string | undefined;
    assetType?: AssetTypeViewModel | undefined;
    costCenter?: CostCenterViewModel | undefined;

    constructor(data?: IFixedAssetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fixedAssetNumber = _data["fixedAssetNumber"];
            this.description = _data["description"];
            this.assetTypeId = _data["assetTypeId"];
            this.assetId = _data["assetId"];
            this.trailerNumber = _data["trailerNumber"];
            this.serialVinnumber = _data["serialVinnumber"];
            this.costCenterId = _data["costCenterId"];
            this.descriptionofLocation = _data["descriptionofLocation"];
            this.placedInService = _data["placedInService"];
            this.retirementReason = _data["retirementReason"];
            this.retirementDate = _data["retirementDate"];
            this.assetType = _data["assetType"] ? AssetTypeViewModel.fromJS(_data["assetType"]) : <any>undefined;
            this.costCenter = _data["costCenter"] ? CostCenterViewModel.fromJS(_data["costCenter"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FixedAssetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FixedAssetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fixedAssetNumber"] = this.fixedAssetNumber;
        data["description"] = this.description;
        data["assetTypeId"] = this.assetTypeId;
        data["assetId"] = this.assetId;
        data["trailerNumber"] = this.trailerNumber;
        data["serialVinnumber"] = this.serialVinnumber;
        data["costCenterId"] = this.costCenterId;
        data["descriptionofLocation"] = this.descriptionofLocation;
        data["placedInService"] = this.placedInService;
        data["retirementReason"] = this.retirementReason;
        data["retirementDate"] = this.retirementDate;
        data["assetType"] = this.assetType ? this.assetType.toJSON() : <any>undefined;
        data["costCenter"] = this.costCenter ? this.costCenter.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFixedAssetViewModel {
    id: number;
    fixedAssetNumber?: string | undefined;
    description?: string | undefined;
    assetTypeId?: number | undefined;
    assetId?: string | undefined;
    trailerNumber?: string | undefined;
    serialVinnumber?: string | undefined;
    costCenterId?: number | undefined;
    descriptionofLocation?: string | undefined;
    placedInService?: string | undefined;
    retirementReason?: string | undefined;
    retirementDate?: string | undefined;
    assetType?: AssetTypeViewModel | undefined;
    costCenter?: CostCenterViewModel | undefined;
}

export class FixedAsset2 implements IFixedAsset2 {
    id!: number;
    fixedAssetNumber?: string | undefined;
    description?: string | undefined;
    assetTypeId?: number | undefined;
    assetId?: string | undefined;
    trailerNumber?: string | undefined;
    serialVinnumber?: string | undefined;
    costCenterId?: number | undefined;
    descriptionofLocation?: string | undefined;
    placedInService?: string | undefined;
    retirementReason?: string | undefined;
    retirementDate?: string | undefined;

    constructor(data?: IFixedAsset2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fixedAssetNumber = _data["fixedAssetNumber"];
            this.description = _data["description"];
            this.assetTypeId = _data["assetTypeId"];
            this.assetId = _data["assetId"];
            this.trailerNumber = _data["trailerNumber"];
            this.serialVinnumber = _data["serialVinnumber"];
            this.costCenterId = _data["costCenterId"];
            this.descriptionofLocation = _data["descriptionofLocation"];
            this.placedInService = _data["placedInService"];
            this.retirementReason = _data["retirementReason"];
            this.retirementDate = _data["retirementDate"];
        }
    }

    static fromJS(data: any): FixedAsset2 {
        data = typeof data === 'object' ? data : {};
        let result = new FixedAsset2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fixedAssetNumber"] = this.fixedAssetNumber;
        data["description"] = this.description;
        data["assetTypeId"] = this.assetTypeId;
        data["assetId"] = this.assetId;
        data["trailerNumber"] = this.trailerNumber;
        data["serialVinnumber"] = this.serialVinnumber;
        data["costCenterId"] = this.costCenterId;
        data["descriptionofLocation"] = this.descriptionofLocation;
        data["placedInService"] = this.placedInService;
        data["retirementReason"] = this.retirementReason;
        data["retirementDate"] = this.retirementDate;
        return data;
    }
}

export interface IFixedAsset2 {
    id: number;
    fixedAssetNumber?: string | undefined;
    description?: string | undefined;
    assetTypeId?: number | undefined;
    assetId?: string | undefined;
    trailerNumber?: string | undefined;
    serialVinnumber?: string | undefined;
    costCenterId?: number | undefined;
    descriptionofLocation?: string | undefined;
    placedInService?: string | undefined;
    retirementReason?: string | undefined;
    retirementDate?: string | undefined;
}

export class QueryResultsOfFixedAssetViewModel implements IQueryResultsOfFixedAssetViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: FixedAssetViewModel[] | undefined;

    constructor(data?: IQueryResultsOfFixedAssetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(FixedAssetViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfFixedAssetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfFixedAssetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfFixedAssetViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: FixedAssetViewModel[] | undefined;
}

export class GeneralInventoryDetail implements IGeneralInventoryDetail {
    id!: number;
    gisid!: number;
    giiid!: number;
    count!: number;
    gii?: GeneralInventoryItem | undefined;

    constructor(data?: IGeneralInventoryDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gisid = _data["gisid"];
            this.giiid = _data["giiid"];
            this.count = _data["count"];
            this.gii = _data["gii"] ? GeneralInventoryItem.fromJS(_data["gii"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GeneralInventoryDetail {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralInventoryDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gisid"] = this.gisid;
        data["giiid"] = this.giiid;
        data["count"] = this.count;
        data["gii"] = this.gii ? this.gii.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGeneralInventoryDetail {
    id: number;
    gisid: number;
    giiid: number;
    count: number;
    gii?: GeneralInventoryItem | undefined;
}

export class GeneralInventoryItem implements IGeneralInventoryItem {
    id!: number;
    itemDescription?: string | undefined;
    active!: boolean;

    constructor(data?: IGeneralInventoryItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemDescription = _data["itemDescription"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): GeneralInventoryItem {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralInventoryItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemDescription"] = this.itemDescription;
        data["active"] = this.active;
        return data;
    }
}

export interface IGeneralInventoryItem {
    id: number;
    itemDescription?: string | undefined;
    active: boolean;
}

export class QueryResultsOfGeneralInventoryDetail implements IQueryResultsOfGeneralInventoryDetail {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: GeneralInventoryDetail[] | undefined;

    constructor(data?: IQueryResultsOfGeneralInventoryDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(GeneralInventoryDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfGeneralInventoryDetail {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfGeneralInventoryDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfGeneralInventoryDetail {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: GeneralInventoryDetail[] | undefined;
}

export class GeneralInventoryItemViewModel implements IGeneralInventoryItemViewModel {
    id!: number;
    itemDescription?: string | undefined;
    active!: boolean;

    constructor(data?: IGeneralInventoryItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.itemDescription = _data["itemDescription"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): GeneralInventoryItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralInventoryItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["itemDescription"] = this.itemDescription;
        data["active"] = this.active;
        return data;
    }
}

export interface IGeneralInventoryItemViewModel {
    id: number;
    itemDescription?: string | undefined;
    active: boolean;
}

export class QueryResultsOfGeneralInventoryItemViewModel implements IQueryResultsOfGeneralInventoryItemViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: GeneralInventoryItemViewModel[] | undefined;

    constructor(data?: IQueryResultsOfGeneralInventoryItemViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(GeneralInventoryItemViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfGeneralInventoryItemViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfGeneralInventoryItemViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfGeneralInventoryItemViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: GeneralInventoryItemViewModel[] | undefined;
}

export class GeneralInventorySummary implements IGeneralInventorySummary {
    id!: number;
    storeId?: string | undefined;
    dateTime!: string;
    enteredBy?: string | undefined;
    comments?: string | undefined;
    store?: Store3 | undefined;
    generalInventoryDetails?: GeneralInventoryDetail[] | undefined;

    constructor(data?: IGeneralInventorySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.dateTime = _data["dateTime"];
            this.enteredBy = _data["enteredBy"];
            this.comments = _data["comments"];
            this.store = _data["store"] ? Store3.fromJS(_data["store"]) : <any>undefined;
            if (Array.isArray(_data["generalInventoryDetails"])) {
                this.generalInventoryDetails = [] as any;
                for (let item of _data["generalInventoryDetails"])
                    this.generalInventoryDetails!.push(GeneralInventoryDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GeneralInventorySummary {
        data = typeof data === 'object' ? data : {};
        let result = new GeneralInventorySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["dateTime"] = this.dateTime;
        data["enteredBy"] = this.enteredBy;
        data["comments"] = this.comments;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        if (Array.isArray(this.generalInventoryDetails)) {
            data["generalInventoryDetails"] = [];
            for (let item of this.generalInventoryDetails)
                data["generalInventoryDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGeneralInventorySummary {
    id: number;
    storeId?: string | undefined;
    dateTime: string;
    enteredBy?: string | undefined;
    comments?: string | undefined;
    store?: Store3 | undefined;
    generalInventoryDetails?: GeneralInventoryDetail[] | undefined;
}

export class QueryResultsOfGeneralInventorySummary implements IQueryResultsOfGeneralInventorySummary {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: GeneralInventorySummary[] | undefined;

    constructor(data?: IQueryResultsOfGeneralInventorySummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(GeneralInventorySummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfGeneralInventorySummary {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfGeneralInventorySummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfGeneralInventorySummary {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: GeneralInventorySummary[] | undefined;
}

export class HalloweenBudgetViewModel implements IHalloweenBudgetViewModel {
    id!: number;
    year!: number;
    week!: number;
    budget?: number | undefined;
    budgetMoney?: number | undefined;

    constructor(data?: IHalloweenBudgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.week = _data["week"];
            this.budget = _data["budget"];
            this.budgetMoney = _data["budgetMoney"];
        }
    }

    static fromJS(data: any): HalloweenBudgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new HalloweenBudgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["week"] = this.week;
        data["budget"] = this.budget;
        data["budgetMoney"] = this.budgetMoney;
        return data;
    }
}

export interface IHalloweenBudgetViewModel {
    id: number;
    year: number;
    week: number;
    budget?: number | undefined;
    budgetMoney?: number | undefined;
}

export class QueryResultsOfHalloweenBudgetViewModel implements IQueryResultsOfHalloweenBudgetViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: HalloweenBudgetViewModel[] | undefined;

    constructor(data?: IQueryResultsOfHalloweenBudgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(HalloweenBudgetViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfHalloweenBudgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfHalloweenBudgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfHalloweenBudgetViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: HalloweenBudgetViewModel[] | undefined;
}

export class HalloweenBudget implements IHalloweenBudget {
    id!: number;
    year!: number;
    week!: number;
    budget?: number | undefined;
    budgetMoney?: number | undefined;

    constructor(data?: IHalloweenBudget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.week = _data["week"];
            this.budget = _data["budget"];
            this.budgetMoney = _data["budgetMoney"];
        }
    }

    static fromJS(data: any): HalloweenBudget {
        data = typeof data === 'object' ? data : {};
        let result = new HalloweenBudget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["week"] = this.week;
        data["budget"] = this.budget;
        data["budgetMoney"] = this.budgetMoney;
        return data;
    }
}

export interface IHalloweenBudget {
    id: number;
    year: number;
    week: number;
    budget?: number | undefined;
    budgetMoney?: number | undefined;
}

export class Box implements IBox {
    id!: number;
    boxNumber!: number;
    location?: string | undefined;
    department?: string | undefined;
    boxDescription?: string | undefined;
    restricted!: boolean;

    constructor(data?: IBox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.boxNumber = _data["boxNumber"];
            this.location = _data["location"];
            this.department = _data["department"];
            this.boxDescription = _data["boxDescription"];
            this.restricted = _data["restricted"];
        }
    }

    static fromJS(data: any): Box {
        data = typeof data === 'object' ? data : {};
        let result = new Box();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["boxNumber"] = this.boxNumber;
        data["location"] = this.location;
        data["department"] = this.department;
        data["boxDescription"] = this.boxDescription;
        data["restricted"] = this.restricted;
        return data;
    }
}

export interface IBox {
    id: number;
    boxNumber: number;
    location?: string | undefined;
    department?: string | undefined;
    boxDescription?: string | undefined;
    restricted: boolean;
}

export class QueryResultsOfBox implements IQueryResultsOfBox {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Box[] | undefined;

    constructor(data?: IQueryResultsOfBox) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Box.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfBox {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfBox();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfBox {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Box[] | undefined;
}

export class QueryResultsOfItem implements IQueryResultsOfItem {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Item[] | undefined;

    constructor(data?: IQueryResultsOfItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Item.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfItem {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfItem();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfItem {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Item[] | undefined;
}

export class Item implements IItem {
    id!: number;
    boxId!: number;
    itemNumber!: number;
    itemDescription?: string | undefined;
    image?: string | undefined;
    guid!: string;
    itemNote?: string | undefined;
    year?: number | undefined;

    constructor(data?: IItem) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.boxId = _data["boxId"];
            this.itemNumber = _data["itemNumber"];
            this.itemDescription = _data["itemDescription"];
            this.image = _data["image"];
            this.guid = _data["guid"];
            this.itemNote = _data["itemNote"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): Item {
        data = typeof data === 'object' ? data : {};
        let result = new Item();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["boxId"] = this.boxId;
        data["itemNumber"] = this.itemNumber;
        data["itemDescription"] = this.itemDescription;
        data["image"] = this.image;
        data["guid"] = this.guid;
        data["itemNote"] = this.itemNote;
        data["year"] = this.year;
        return data;
    }
}

export interface IItem {
    id: number;
    boxId: number;
    itemNumber: number;
    itemDescription?: string | undefined;
    image?: string | undefined;
    guid: string;
    itemNote?: string | undefined;
    year?: number | undefined;
}

export class IDViewModel implements IIDViewModel {
    id!: number;
    ssn?: string | undefined;
    last4SSN?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    preferredName?: string | undefined;
    division!: number;
    entryDate?: string | undefined;
    status?: number | undefined;
    intakeStatus?: string | undefined;
    intakeGeneralist!: number;
    employmentSpecialists!: number;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    phone?: string | undefined;
    phoneCarrier?: string | undefined;
    alternatePhone?: string | undefined;
    email?: string | undefined;
    birthYear?: number | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    primaryDisability?: string | undefined;
    secondaryDisability?: string | undefined;
    tertiaryDisability?: string | undefined;
    quaternaryDisability?: string | undefined;
    primaryLanguageSpanish?: boolean | undefined;
    referralCounselor?: number | undefined;
    vocGoal1?: string | undefined;
    vocGoal2?: string | undefined;
    requiredWage?: number | undefined;
    acceptableShifts?: string | undefined;
    preferredDaystoWork?: string | undefined;
    continuedEd?: string | undefined;
    needsCareerCenter?: boolean | undefined;
    needsEsl?: boolean | undefined;
    transportation?: string | undefined;
    needsTransportation?: boolean | undefined;
    needsClothing?: boolean | undefined;
    needsChildCare?: boolean | undefined;
    needsHousing?: boolean | undefined;
    needsFood?: boolean | undefined;
    canPassDrugScreen?: boolean | undefined;
    criminalRecord?: string | undefined;
    probationOfficer?: string | undefined;
    probationOfficerPhone?: string | undefined;
    needsMedicalReferral?: boolean | undefined;
    needsMentalHealthReferral?: boolean | undefined;
    callBackDate?: string | undefined;
    quickNote?: string | undefined;
    isLocked?: boolean | undefined;
    lockedBy?: string | undefined;
    searchable?: string | undefined;

    constructor(data?: IIDViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ssn = _data["ssn"];
            this.last4SSN = _data["last4SSN"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.preferredName = _data["preferredName"];
            this.division = _data["division"];
            this.entryDate = _data["entryDate"];
            this.status = _data["status"];
            this.intakeStatus = _data["intakeStatus"];
            this.intakeGeneralist = _data["intakeGeneralist"];
            this.employmentSpecialists = _data["employmentSpecialists"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.phone = _data["phone"];
            this.phoneCarrier = _data["phoneCarrier"];
            this.alternatePhone = _data["alternatePhone"];
            this.email = _data["email"];
            this.birthYear = _data["birthYear"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.primaryDisability = _data["primaryDisability"];
            this.secondaryDisability = _data["secondaryDisability"];
            this.tertiaryDisability = _data["tertiaryDisability"];
            this.quaternaryDisability = _data["quaternaryDisability"];
            this.primaryLanguageSpanish = _data["primaryLanguageSpanish"];
            this.referralCounselor = _data["referralCounselor"];
            this.vocGoal1 = _data["vocGoal1"];
            this.vocGoal2 = _data["vocGoal2"];
            this.requiredWage = _data["requiredWage"];
            this.acceptableShifts = _data["acceptableShifts"];
            this.preferredDaystoWork = _data["preferredDaystoWork"];
            this.continuedEd = _data["continuedEd"];
            this.needsCareerCenter = _data["needsCareerCenter"];
            this.needsEsl = _data["needsEsl"];
            this.transportation = _data["transportation"];
            this.needsTransportation = _data["needsTransportation"];
            this.needsClothing = _data["needsClothing"];
            this.needsChildCare = _data["needsChildCare"];
            this.needsHousing = _data["needsHousing"];
            this.needsFood = _data["needsFood"];
            this.canPassDrugScreen = _data["canPassDrugScreen"];
            this.criminalRecord = _data["criminalRecord"];
            this.probationOfficer = _data["probationOfficer"];
            this.probationOfficerPhone = _data["probationOfficerPhone"];
            this.needsMedicalReferral = _data["needsMedicalReferral"];
            this.needsMentalHealthReferral = _data["needsMentalHealthReferral"];
            this.callBackDate = _data["callBackDate"];
            this.quickNote = _data["quickNote"];
            this.isLocked = _data["isLocked"];
            this.lockedBy = _data["lockedBy"];
            this.searchable = _data["searchable"];
        }
    }

    static fromJS(data: any): IDViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IDViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ssn"] = this.ssn;
        data["last4SSN"] = this.last4SSN;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["preferredName"] = this.preferredName;
        data["division"] = this.division;
        data["entryDate"] = this.entryDate;
        data["status"] = this.status;
        data["intakeStatus"] = this.intakeStatus;
        data["intakeGeneralist"] = this.intakeGeneralist;
        data["employmentSpecialists"] = this.employmentSpecialists;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["phone"] = this.phone;
        data["phoneCarrier"] = this.phoneCarrier;
        data["alternatePhone"] = this.alternatePhone;
        data["email"] = this.email;
        data["birthYear"] = this.birthYear;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["primaryDisability"] = this.primaryDisability;
        data["secondaryDisability"] = this.secondaryDisability;
        data["tertiaryDisability"] = this.tertiaryDisability;
        data["quaternaryDisability"] = this.quaternaryDisability;
        data["primaryLanguageSpanish"] = this.primaryLanguageSpanish;
        data["referralCounselor"] = this.referralCounselor;
        data["vocGoal1"] = this.vocGoal1;
        data["vocGoal2"] = this.vocGoal2;
        data["requiredWage"] = this.requiredWage;
        data["acceptableShifts"] = this.acceptableShifts;
        data["preferredDaystoWork"] = this.preferredDaystoWork;
        data["continuedEd"] = this.continuedEd;
        data["needsCareerCenter"] = this.needsCareerCenter;
        data["needsEsl"] = this.needsEsl;
        data["transportation"] = this.transportation;
        data["needsTransportation"] = this.needsTransportation;
        data["needsClothing"] = this.needsClothing;
        data["needsChildCare"] = this.needsChildCare;
        data["needsHousing"] = this.needsHousing;
        data["needsFood"] = this.needsFood;
        data["canPassDrugScreen"] = this.canPassDrugScreen;
        data["criminalRecord"] = this.criminalRecord;
        data["probationOfficer"] = this.probationOfficer;
        data["probationOfficerPhone"] = this.probationOfficerPhone;
        data["needsMedicalReferral"] = this.needsMedicalReferral;
        data["needsMentalHealthReferral"] = this.needsMentalHealthReferral;
        data["callBackDate"] = this.callBackDate;
        data["quickNote"] = this.quickNote;
        data["isLocked"] = this.isLocked;
        data["lockedBy"] = this.lockedBy;
        data["searchable"] = this.searchable;
        return data;
    }
}

export interface IIDViewModel {
    id: number;
    ssn?: string | undefined;
    last4SSN?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    preferredName?: string | undefined;
    division: number;
    entryDate?: string | undefined;
    status?: number | undefined;
    intakeStatus?: string | undefined;
    intakeGeneralist: number;
    employmentSpecialists: number;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    phone?: string | undefined;
    phoneCarrier?: string | undefined;
    alternatePhone?: string | undefined;
    email?: string | undefined;
    birthYear?: number | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    primaryDisability?: string | undefined;
    secondaryDisability?: string | undefined;
    tertiaryDisability?: string | undefined;
    quaternaryDisability?: string | undefined;
    primaryLanguageSpanish?: boolean | undefined;
    referralCounselor?: number | undefined;
    vocGoal1?: string | undefined;
    vocGoal2?: string | undefined;
    requiredWage?: number | undefined;
    acceptableShifts?: string | undefined;
    preferredDaystoWork?: string | undefined;
    continuedEd?: string | undefined;
    needsCareerCenter?: boolean | undefined;
    needsEsl?: boolean | undefined;
    transportation?: string | undefined;
    needsTransportation?: boolean | undefined;
    needsClothing?: boolean | undefined;
    needsChildCare?: boolean | undefined;
    needsHousing?: boolean | undefined;
    needsFood?: boolean | undefined;
    canPassDrugScreen?: boolean | undefined;
    criminalRecord?: string | undefined;
    probationOfficer?: string | undefined;
    probationOfficerPhone?: string | undefined;
    needsMedicalReferral?: boolean | undefined;
    needsMentalHealthReferral?: boolean | undefined;
    callBackDate?: string | undefined;
    quickNote?: string | undefined;
    isLocked?: boolean | undefined;
    lockedBy?: string | undefined;
    searchable?: string | undefined;
}

export class QueryResultsOfIDViewModel implements IQueryResultsOfIDViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: IDViewModel[] | undefined;

    constructor(data?: IQueryResultsOfIDViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(IDViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfIDViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfIDViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfIDViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: IDViewModel[] | undefined;
}

export class ID implements IID {
    id!: number;
    ssn?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    phone?: string | undefined;
    alternatePhone?: string | undefined;
    email?: string | undefined;
    birthYear?: number | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    primaryDisability?: string | undefined;
    secondaryDisability?: string | undefined;
    tertiaryDisability?: string | undefined;
    quaternaryDisability?: string | undefined;
    primaryLanguageSpanish?: boolean | undefined;
    vocGoal1?: string | undefined;
    vocGoal2?: string | undefined;
    requiredWage?: number | undefined;
    acceptableShifts?: string | undefined;
    preferredDaystoWork?: string | undefined;
    continuedEd?: string | undefined;
    needsCareerCenter?: boolean | undefined;
    needsEsl?: boolean | undefined;
    transportation?: string | undefined;
    needsTransportation?: boolean | undefined;
    needsClothing?: boolean | undefined;
    needsChildCare?: boolean | undefined;
    needsHousing?: boolean | undefined;
    needsFood?: boolean | undefined;
    canPassDrugScreen?: boolean | undefined;
    criminalRecord?: string | undefined;
    probationOfficer?: string | undefined;
    probationOfficerPhone?: string | undefined;
    division?: number | undefined;
    employmentSpecialists?: number | undefined;
    intakeGeneralist?: number | undefined;
    preferredName?: string | undefined;
    quickNote?: string | undefined;
    status?: number | undefined;
    intakeStatus?: string | undefined;
    phoneCarrier?: string | undefined;
    callBackDate?: string | undefined;

    constructor(data?: IID) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ssn = _data["ssn"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.phone = _data["phone"];
            this.alternatePhone = _data["alternatePhone"];
            this.email = _data["email"];
            this.birthYear = _data["birthYear"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.primaryDisability = _data["primaryDisability"];
            this.secondaryDisability = _data["secondaryDisability"];
            this.tertiaryDisability = _data["tertiaryDisability"];
            this.quaternaryDisability = _data["quaternaryDisability"];
            this.primaryLanguageSpanish = _data["primaryLanguageSpanish"];
            this.vocGoal1 = _data["vocGoal1"];
            this.vocGoal2 = _data["vocGoal2"];
            this.requiredWage = _data["requiredWage"];
            this.acceptableShifts = _data["acceptableShifts"];
            this.preferredDaystoWork = _data["preferredDaystoWork"];
            this.continuedEd = _data["continuedEd"];
            this.needsCareerCenter = _data["needsCareerCenter"];
            this.needsEsl = _data["needsEsl"];
            this.transportation = _data["transportation"];
            this.needsTransportation = _data["needsTransportation"];
            this.needsClothing = _data["needsClothing"];
            this.needsChildCare = _data["needsChildCare"];
            this.needsHousing = _data["needsHousing"];
            this.needsFood = _data["needsFood"];
            this.canPassDrugScreen = _data["canPassDrugScreen"];
            this.criminalRecord = _data["criminalRecord"];
            this.probationOfficer = _data["probationOfficer"];
            this.probationOfficerPhone = _data["probationOfficerPhone"];
            this.division = _data["division"];
            this.employmentSpecialists = _data["employmentSpecialists"];
            this.intakeGeneralist = _data["intakeGeneralist"];
            this.preferredName = _data["preferredName"];
            this.quickNote = _data["quickNote"];
            this.status = _data["status"];
            this.intakeStatus = _data["intakeStatus"];
            this.phoneCarrier = _data["phoneCarrier"];
            this.callBackDate = _data["callBackDate"];
        }
    }

    static fromJS(data: any): ID {
        data = typeof data === 'object' ? data : {};
        let result = new ID();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ssn"] = this.ssn;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["phone"] = this.phone;
        data["alternatePhone"] = this.alternatePhone;
        data["email"] = this.email;
        data["birthYear"] = this.birthYear;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["primaryDisability"] = this.primaryDisability;
        data["secondaryDisability"] = this.secondaryDisability;
        data["tertiaryDisability"] = this.tertiaryDisability;
        data["quaternaryDisability"] = this.quaternaryDisability;
        data["primaryLanguageSpanish"] = this.primaryLanguageSpanish;
        data["vocGoal1"] = this.vocGoal1;
        data["vocGoal2"] = this.vocGoal2;
        data["requiredWage"] = this.requiredWage;
        data["acceptableShifts"] = this.acceptableShifts;
        data["preferredDaystoWork"] = this.preferredDaystoWork;
        data["continuedEd"] = this.continuedEd;
        data["needsCareerCenter"] = this.needsCareerCenter;
        data["needsEsl"] = this.needsEsl;
        data["transportation"] = this.transportation;
        data["needsTransportation"] = this.needsTransportation;
        data["needsClothing"] = this.needsClothing;
        data["needsChildCare"] = this.needsChildCare;
        data["needsHousing"] = this.needsHousing;
        data["needsFood"] = this.needsFood;
        data["canPassDrugScreen"] = this.canPassDrugScreen;
        data["criminalRecord"] = this.criminalRecord;
        data["probationOfficer"] = this.probationOfficer;
        data["probationOfficerPhone"] = this.probationOfficerPhone;
        data["division"] = this.division;
        data["employmentSpecialists"] = this.employmentSpecialists;
        data["intakeGeneralist"] = this.intakeGeneralist;
        data["preferredName"] = this.preferredName;
        data["quickNote"] = this.quickNote;
        data["status"] = this.status;
        data["intakeStatus"] = this.intakeStatus;
        data["phoneCarrier"] = this.phoneCarrier;
        data["callBackDate"] = this.callBackDate;
        return data;
    }
}

export interface IID {
    id: number;
    ssn?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    phone?: string | undefined;
    alternatePhone?: string | undefined;
    email?: string | undefined;
    birthYear?: number | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    primaryDisability?: string | undefined;
    secondaryDisability?: string | undefined;
    tertiaryDisability?: string | undefined;
    quaternaryDisability?: string | undefined;
    primaryLanguageSpanish?: boolean | undefined;
    vocGoal1?: string | undefined;
    vocGoal2?: string | undefined;
    requiredWage?: number | undefined;
    acceptableShifts?: string | undefined;
    preferredDaystoWork?: string | undefined;
    continuedEd?: string | undefined;
    needsCareerCenter?: boolean | undefined;
    needsEsl?: boolean | undefined;
    transportation?: string | undefined;
    needsTransportation?: boolean | undefined;
    needsClothing?: boolean | undefined;
    needsChildCare?: boolean | undefined;
    needsHousing?: boolean | undefined;
    needsFood?: boolean | undefined;
    canPassDrugScreen?: boolean | undefined;
    criminalRecord?: string | undefined;
    probationOfficer?: string | undefined;
    probationOfficerPhone?: string | undefined;
    division?: number | undefined;
    employmentSpecialists?: number | undefined;
    intakeGeneralist?: number | undefined;
    preferredName?: string | undefined;
    quickNote?: string | undefined;
    status?: number | undefined;
    intakeStatus?: string | undefined;
    phoneCarrier?: string | undefined;
    callBackDate?: string | undefined;
}

export class QueryResultsOfIncidentLocationViewModel implements IQueryResultsOfIncidentLocationViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: IncidentLocationViewModel[] | undefined;

    constructor(data?: IQueryResultsOfIncidentLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(IncidentLocationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfIncidentLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfIncidentLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfIncidentLocationViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: IncidentLocationViewModel[] | undefined;
}

export class IncidentLocationViewModel implements IIncidentLocationViewModel {
    id!: number;
    name?: string | undefined;
    costCenterNumber?: string | undefined;
    active!: boolean;

    constructor(data?: IIncidentLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.costCenterNumber = _data["costCenterNumber"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): IncidentLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["costCenterNumber"] = this.costCenterNumber;
        data["active"] = this.active;
        return data;
    }
}

export interface IIncidentLocationViewModel {
    id: number;
    name?: string | undefined;
    costCenterNumber?: string | undefined;
    active: boolean;
}

export class IncidentPictureViewModel implements IIncidentPictureViewModel {
    id!: number;
    incidentSummaryId!: number;
    picture?: string | undefined;

    constructor(data?: IIncidentPictureViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incidentSummaryId = _data["incidentSummaryId"];
            this.picture = _data["picture"];
        }
    }

    static fromJS(data: any): IncidentPictureViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentPictureViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incidentSummaryId"] = this.incidentSummaryId;
        data["picture"] = this.picture;
        return data;
    }
}

export interface IIncidentPictureViewModel {
    id: number;
    incidentSummaryId: number;
    picture?: string | undefined;
}

export class QueryResultsOfIncidentTypeViewModel implements IQueryResultsOfIncidentTypeViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: IncidentTypeViewModel[] | undefined;

    constructor(data?: IQueryResultsOfIncidentTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(IncidentTypeViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfIncidentTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfIncidentTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfIncidentTypeViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: IncidentTypeViewModel[] | undefined;
}

export class IncidentTypeViewModel implements IIncidentTypeViewModel {
    id!: number;
    name?: string | undefined;

    constructor(data?: IIncidentTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): IncidentTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IIncidentTypeViewModel {
    id: number;
    name?: string | undefined;
}

export class IncidentSummary implements IIncidentSummary {
    id!: number;
    storeId?: string | undefined;
    incidentDate!: string;
    incidentTime?: string | undefined;
    filedBy?: string | undefined;
    positionOfFiler?: string | undefined;
    incidentTypeId!: number;
    description?: string | undefined;
    autoMake?: string | undefined;
    color?: string | undefined;
    licensePlateNumber?: string | undefined;
    state?: string | undefined;
    autoIdentifyingMarks?: string | undefined;
    policeReportFiled!: boolean;
    policeCaseNumber?: string | undefined;
    additionalInformation?: string | undefined;
    reported?: boolean | undefined;
    enteredby?: string | undefined;
    incidentDetails?: IncidentDetail[] | undefined;
    incidentPictures?: IncidentPicture[] | undefined;

    constructor(data?: IIncidentSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.incidentDate = _data["incidentDate"];
            this.incidentTime = _data["incidentTime"];
            this.filedBy = _data["filedBy"];
            this.positionOfFiler = _data["positionOfFiler"];
            this.incidentTypeId = _data["incidentTypeId"];
            this.description = _data["description"];
            this.autoMake = _data["autoMake"];
            this.color = _data["color"];
            this.licensePlateNumber = _data["licensePlateNumber"];
            this.state = _data["state"];
            this.autoIdentifyingMarks = _data["autoIdentifyingMarks"];
            this.policeReportFiled = _data["policeReportFiled"];
            this.policeCaseNumber = _data["policeCaseNumber"];
            this.additionalInformation = _data["additionalInformation"];
            this.reported = _data["reported"];
            this.enteredby = _data["enteredby"];
            if (Array.isArray(_data["incidentDetails"])) {
                this.incidentDetails = [] as any;
                for (let item of _data["incidentDetails"])
                    this.incidentDetails!.push(IncidentDetail.fromJS(item));
            }
            if (Array.isArray(_data["incidentPictures"])) {
                this.incidentPictures = [] as any;
                for (let item of _data["incidentPictures"])
                    this.incidentPictures!.push(IncidentPicture.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncidentSummary {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["incidentDate"] = this.incidentDate;
        data["incidentTime"] = this.incidentTime;
        data["filedBy"] = this.filedBy;
        data["positionOfFiler"] = this.positionOfFiler;
        data["incidentTypeId"] = this.incidentTypeId;
        data["description"] = this.description;
        data["autoMake"] = this.autoMake;
        data["color"] = this.color;
        data["licensePlateNumber"] = this.licensePlateNumber;
        data["state"] = this.state;
        data["autoIdentifyingMarks"] = this.autoIdentifyingMarks;
        data["policeReportFiled"] = this.policeReportFiled;
        data["policeCaseNumber"] = this.policeCaseNumber;
        data["additionalInformation"] = this.additionalInformation;
        data["reported"] = this.reported;
        data["enteredby"] = this.enteredby;
        if (Array.isArray(this.incidentDetails)) {
            data["incidentDetails"] = [];
            for (let item of this.incidentDetails)
                data["incidentDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.incidentPictures)) {
            data["incidentPictures"] = [];
            for (let item of this.incidentPictures)
                data["incidentPictures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIncidentSummary {
    id: number;
    storeId?: string | undefined;
    incidentDate: string;
    incidentTime?: string | undefined;
    filedBy?: string | undefined;
    positionOfFiler?: string | undefined;
    incidentTypeId: number;
    description?: string | undefined;
    autoMake?: string | undefined;
    color?: string | undefined;
    licensePlateNumber?: string | undefined;
    state?: string | undefined;
    autoIdentifyingMarks?: string | undefined;
    policeReportFiled: boolean;
    policeCaseNumber?: string | undefined;
    additionalInformation?: string | undefined;
    reported?: boolean | undefined;
    enteredby?: string | undefined;
    incidentDetails?: IncidentDetail[] | undefined;
    incidentPictures?: IncidentPicture[] | undefined;
}

export class IncidentDetail implements IIncidentDetail {
    id!: number;
    incidentSummaryId!: number;
    witnessFirstName?: string | undefined;
    witnessLastName?: string | undefined;
    witnessAddress?: string | undefined;
    witnessCity?: string | undefined;
    witnessState?: string | undefined;
    witnessZip?: string | undefined;
    witnessPhone?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IIncidentDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incidentSummaryId = _data["incidentSummaryId"];
            this.witnessFirstName = _data["witnessFirstName"];
            this.witnessLastName = _data["witnessLastName"];
            this.witnessAddress = _data["witnessAddress"];
            this.witnessCity = _data["witnessCity"];
            this.witnessState = _data["witnessState"];
            this.witnessZip = _data["witnessZip"];
            this.witnessPhone = _data["witnessPhone"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): IncidentDetail {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incidentSummaryId"] = this.incidentSummaryId;
        data["witnessFirstName"] = this.witnessFirstName;
        data["witnessLastName"] = this.witnessLastName;
        data["witnessAddress"] = this.witnessAddress;
        data["witnessCity"] = this.witnessCity;
        data["witnessState"] = this.witnessState;
        data["witnessZip"] = this.witnessZip;
        data["witnessPhone"] = this.witnessPhone;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IIncidentDetail {
    id: number;
    incidentSummaryId: number;
    witnessFirstName?: string | undefined;
    witnessLastName?: string | undefined;
    witnessAddress?: string | undefined;
    witnessCity?: string | undefined;
    witnessState?: string | undefined;
    witnessZip?: string | undefined;
    witnessPhone?: string | undefined;
    comments?: string | undefined;
}

export class IncidentPicture implements IIncidentPicture {
    id!: number;
    incidentSummaryId!: number;
    picture?: string | undefined;

    constructor(data?: IIncidentPicture) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incidentSummaryId = _data["incidentSummaryId"];
            this.picture = _data["picture"];
        }
    }

    static fromJS(data: any): IncidentPicture {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentPicture();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incidentSummaryId"] = this.incidentSummaryId;
        data["picture"] = this.picture;
        return data;
    }
}

export interface IIncidentPicture {
    id: number;
    incidentSummaryId: number;
    picture?: string | undefined;
}

export class IncidentSummaryViewModel implements IIncidentSummaryViewModel {
    id!: number;
    storeId?: string | undefined;
    incidentDate!: string;
    incidentTime?: string | undefined;
    filedBy?: string | undefined;
    positionOfFiler?: string | undefined;
    incidentTypeId!: number;
    description?: string | undefined;
    autoMake?: string | undefined;
    color?: string | undefined;
    licensePlateNumber?: string | undefined;
    state?: string | undefined;
    autoIdentifyingMarks?: string | undefined;
    policeReportFiled!: boolean;
    policeCaseNumber?: string | undefined;
    additionalInformation?: string | undefined;
    reported?: boolean | undefined;
    enteredby?: string | undefined;
    incidentType?: IncidentTypeViewModel | undefined;
    incidentDetails?: IncidentDetailViewModel[] | undefined;
    incidentPictures?: IncidentPictureViewModel[] | undefined;

    constructor(data?: IIncidentSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.incidentDate = _data["incidentDate"];
            this.incidentTime = _data["incidentTime"];
            this.filedBy = _data["filedBy"];
            this.positionOfFiler = _data["positionOfFiler"];
            this.incidentTypeId = _data["incidentTypeId"];
            this.description = _data["description"];
            this.autoMake = _data["autoMake"];
            this.color = _data["color"];
            this.licensePlateNumber = _data["licensePlateNumber"];
            this.state = _data["state"];
            this.autoIdentifyingMarks = _data["autoIdentifyingMarks"];
            this.policeReportFiled = _data["policeReportFiled"];
            this.policeCaseNumber = _data["policeCaseNumber"];
            this.additionalInformation = _data["additionalInformation"];
            this.reported = _data["reported"];
            this.enteredby = _data["enteredby"];
            this.incidentType = _data["incidentType"] ? IncidentTypeViewModel.fromJS(_data["incidentType"]) : <any>undefined;
            if (Array.isArray(_data["incidentDetails"])) {
                this.incidentDetails = [] as any;
                for (let item of _data["incidentDetails"])
                    this.incidentDetails!.push(IncidentDetailViewModel.fromJS(item));
            }
            if (Array.isArray(_data["incidentPictures"])) {
                this.incidentPictures = [] as any;
                for (let item of _data["incidentPictures"])
                    this.incidentPictures!.push(IncidentPictureViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): IncidentSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["incidentDate"] = this.incidentDate;
        data["incidentTime"] = this.incidentTime;
        data["filedBy"] = this.filedBy;
        data["positionOfFiler"] = this.positionOfFiler;
        data["incidentTypeId"] = this.incidentTypeId;
        data["description"] = this.description;
        data["autoMake"] = this.autoMake;
        data["color"] = this.color;
        data["licensePlateNumber"] = this.licensePlateNumber;
        data["state"] = this.state;
        data["autoIdentifyingMarks"] = this.autoIdentifyingMarks;
        data["policeReportFiled"] = this.policeReportFiled;
        data["policeCaseNumber"] = this.policeCaseNumber;
        data["additionalInformation"] = this.additionalInformation;
        data["reported"] = this.reported;
        data["enteredby"] = this.enteredby;
        data["incidentType"] = this.incidentType ? this.incidentType.toJSON() : <any>undefined;
        if (Array.isArray(this.incidentDetails)) {
            data["incidentDetails"] = [];
            for (let item of this.incidentDetails)
                data["incidentDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.incidentPictures)) {
            data["incidentPictures"] = [];
            for (let item of this.incidentPictures)
                data["incidentPictures"].push(item.toJSON());
        }
        return data;
    }
}

export interface IIncidentSummaryViewModel {
    id: number;
    storeId?: string | undefined;
    incidentDate: string;
    incidentTime?: string | undefined;
    filedBy?: string | undefined;
    positionOfFiler?: string | undefined;
    incidentTypeId: number;
    description?: string | undefined;
    autoMake?: string | undefined;
    color?: string | undefined;
    licensePlateNumber?: string | undefined;
    state?: string | undefined;
    autoIdentifyingMarks?: string | undefined;
    policeReportFiled: boolean;
    policeCaseNumber?: string | undefined;
    additionalInformation?: string | undefined;
    reported?: boolean | undefined;
    enteredby?: string | undefined;
    incidentType?: IncidentTypeViewModel | undefined;
    incidentDetails?: IncidentDetailViewModel[] | undefined;
    incidentPictures?: IncidentPictureViewModel[] | undefined;
}

export class IncidentDetailViewModel implements IIncidentDetailViewModel {
    id!: number;
    incidentSummaryId!: number;
    witnessFirstName?: string | undefined;
    witnessLastName?: string | undefined;
    witnessAddress?: string | undefined;
    witnessCity?: string | undefined;
    witnessState?: string | undefined;
    witnessZip?: string | undefined;
    witnessPhone?: string | undefined;
    comments?: string | undefined;

    constructor(data?: IIncidentDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.incidentSummaryId = _data["incidentSummaryId"];
            this.witnessFirstName = _data["witnessFirstName"];
            this.witnessLastName = _data["witnessLastName"];
            this.witnessAddress = _data["witnessAddress"];
            this.witnessCity = _data["witnessCity"];
            this.witnessState = _data["witnessState"];
            this.witnessZip = _data["witnessZip"];
            this.witnessPhone = _data["witnessPhone"];
            this.comments = _data["comments"];
        }
    }

    static fromJS(data: any): IncidentDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new IncidentDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["incidentSummaryId"] = this.incidentSummaryId;
        data["witnessFirstName"] = this.witnessFirstName;
        data["witnessLastName"] = this.witnessLastName;
        data["witnessAddress"] = this.witnessAddress;
        data["witnessCity"] = this.witnessCity;
        data["witnessState"] = this.witnessState;
        data["witnessZip"] = this.witnessZip;
        data["witnessPhone"] = this.witnessPhone;
        data["comments"] = this.comments;
        return data;
    }
}

export interface IIncidentDetailViewModel {
    id: number;
    incidentSummaryId: number;
    witnessFirstName?: string | undefined;
    witnessLastName?: string | undefined;
    witnessAddress?: string | undefined;
    witnessCity?: string | undefined;
    witnessState?: string | undefined;
    witnessZip?: string | undefined;
    witnessPhone?: string | undefined;
    comments?: string | undefined;
}

export class QueryResultsOfJccertification implements IQueryResultsOfJccertification {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Jccertification[] | undefined;

    constructor(data?: IQueryResultsOfJccertification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Jccertification.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfJccertification {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfJccertification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfJccertification {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Jccertification[] | undefined;
}

export class Jccertification implements IJccertification {
    id!: number;
    gicwid!: number;
    description?: string | undefined;

    constructor(data?: IJccertification) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gicwid = _data["gicwid"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Jccertification {
        data = typeof data === 'object' ? data : {};
        let result = new Jccertification();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gicwid"] = this.gicwid;
        data["description"] = this.description;
        return data;
    }
}

export interface IJccertification {
    id: number;
    gicwid: number;
    description?: string | undefined;
}

export class QueryResultsOfJccontactLog implements IQueryResultsOfJccontactLog {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: JccontactLog[] | undefined;

    constructor(data?: IQueryResultsOfJccontactLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(JccontactLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfJccontactLog {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfJccontactLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfJccontactLog {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: JccontactLog[] | undefined;
}

export class JccontactLog implements IJccontactLog {
    id!: number;
    contactId!: number;
    commentDate!: string;
    enteredDate!: string;
    enteredBy?: string | undefined;
    note?: string | undefined;
    callBackDate?: string | undefined;
    jcentityContact?: JcentityContact | undefined;

    constructor(data?: IJccontactLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.contactId = _data["contactId"];
            this.commentDate = _data["commentDate"];
            this.enteredDate = _data["enteredDate"];
            this.enteredBy = _data["enteredBy"];
            this.note = _data["note"];
            this.callBackDate = _data["callBackDate"];
            this.jcentityContact = _data["jcentityContact"] ? JcentityContact.fromJS(_data["jcentityContact"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JccontactLog {
        data = typeof data === 'object' ? data : {};
        let result = new JccontactLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["contactId"] = this.contactId;
        data["commentDate"] = this.commentDate;
        data["enteredDate"] = this.enteredDate;
        data["enteredBy"] = this.enteredBy;
        data["note"] = this.note;
        data["callBackDate"] = this.callBackDate;
        data["jcentityContact"] = this.jcentityContact ? this.jcentityContact.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJccontactLog {
    id: number;
    contactId: number;
    commentDate: string;
    enteredDate: string;
    enteredBy?: string | undefined;
    note?: string | undefined;
    callBackDate?: string | undefined;
    jcentityContact?: JcentityContact | undefined;
}

export class JcentityContact implements IJcentityContact {
    id!: number;
    entityLocationId!: number;
    name?: string | undefined;
    contactType?: string | undefined;
    title?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    email?: string | undefined;
    comment?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;
    availableSaturday!: boolean;
    jcentityLocation?: JcentityLocation | undefined;

    constructor(data?: IJcentityContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityLocationId = _data["entityLocationId"];
            this.name = _data["name"];
            this.contactType = _data["contactType"];
            this.title = _data["title"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.email = _data["email"];
            this.comment = _data["comment"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.availableSaturday = _data["availableSaturday"];
            this.jcentityLocation = _data["jcentityLocation"] ? JcentityLocation.fromJS(_data["jcentityLocation"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JcentityContact {
        data = typeof data === 'object' ? data : {};
        let result = new JcentityContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityLocationId"] = this.entityLocationId;
        data["name"] = this.name;
        data["contactType"] = this.contactType;
        data["title"] = this.title;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["email"] = this.email;
        data["comment"] = this.comment;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["availableSaturday"] = this.availableSaturday;
        data["jcentityLocation"] = this.jcentityLocation ? this.jcentityLocation.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJcentityContact {
    id: number;
    entityLocationId: number;
    name?: string | undefined;
    contactType?: string | undefined;
    title?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    email?: string | undefined;
    comment?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
    availableSaturday: boolean;
    jcentityLocation?: JcentityLocation | undefined;
}

export class JcentityLocation implements IJcentityLocation {
    id!: number;
    entityId!: number;
    locationType?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;
    jcentity?: Jcentity | undefined;

    constructor(data?: IJcentityLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.locationType = _data["locationType"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.jcentity = _data["jcentity"] ? Jcentity.fromJS(_data["jcentity"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JcentityLocation {
        data = typeof data === 'object' ? data : {};
        let result = new JcentityLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["locationType"] = this.locationType;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["jcentity"] = this.jcentity ? this.jcentity.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJcentityLocation {
    id: number;
    entityId: number;
    locationType?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
    jcentity?: Jcentity | undefined;
}

export class Jcentity implements IJcentity {
    id!: number;
    entityName?: string | undefined;
    entityType?: string | undefined;
    website?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;

    constructor(data?: IJcentity) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityName = _data["entityName"];
            this.entityType = _data["entityType"];
            this.website = _data["website"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
        }
    }

    static fromJS(data: any): Jcentity {
        data = typeof data === 'object' ? data : {};
        let result = new Jcentity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityName"] = this.entityName;
        data["entityType"] = this.entityType;
        data["website"] = this.website;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        return data;
    }
}

export interface IJcentity {
    id: number;
    entityName?: string | undefined;
    entityType?: string | undefined;
    website?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
}

export class QueryResultsOfJcdegree implements IQueryResultsOfJcdegree {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Jcdegree[] | undefined;

    constructor(data?: IQueryResultsOfJcdegree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Jcdegree.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfJcdegree {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfJcdegree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfJcdegree {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Jcdegree[] | undefined;
}

export class Jcdegree implements IJcdegree {
    id!: number;
    gicwid!: number;
    degree?: string | undefined;
    degreeDescription?: string | undefined;

    constructor(data?: IJcdegree) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gicwid = _data["gicwid"];
            this.degree = _data["degree"];
            this.degreeDescription = _data["degreeDescription"];
        }
    }

    static fromJS(data: any): Jcdegree {
        data = typeof data === 'object' ? data : {};
        let result = new Jcdegree();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gicwid"] = this.gicwid;
        data["degree"] = this.degree;
        data["degreeDescription"] = this.degreeDescription;
        return data;
    }
}

export interface IJcdegree {
    id: number;
    gicwid: number;
    degree?: string | undefined;
    degreeDescription?: string | undefined;
}

export class QueryResultsOfJcentityContact implements IQueryResultsOfJcentityContact {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: JcentityContact[] | undefined;

    constructor(data?: IQueryResultsOfJcentityContact) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(JcentityContact.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfJcentityContact {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfJcentityContact();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfJcentityContact {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: JcentityContact[] | undefined;
}

export class JcentityViewModel implements IJcentityViewModel {
    id!: number;
    entityName?: string | undefined;
    entityType?: string | undefined;
    website?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;

    constructor(data?: IJcentityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityName = _data["entityName"];
            this.entityType = _data["entityType"];
            this.website = _data["website"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
        }
    }

    static fromJS(data: any): JcentityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new JcentityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityName"] = this.entityName;
        data["entityType"] = this.entityType;
        data["website"] = this.website;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        return data;
    }
}

export interface IJcentityViewModel {
    id: number;
    entityName?: string | undefined;
    entityType?: string | undefined;
    website?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
}

export class Jcentity2 implements IJcentity2 {
    id!: number;
    entityName?: string | undefined;
    entityType?: string | undefined;
    website?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;

    constructor(data?: IJcentity2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityName = _data["entityName"];
            this.entityType = _data["entityType"];
            this.website = _data["website"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
        }
    }

    static fromJS(data: any): Jcentity2 {
        data = typeof data === 'object' ? data : {};
        let result = new Jcentity2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityName"] = this.entityName;
        data["entityType"] = this.entityType;
        data["website"] = this.website;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        return data;
    }
}

export interface IJcentity2 {
    id: number;
    entityName?: string | undefined;
    entityType?: string | undefined;
    website?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
}

export class QueryResultsOfJcentityViewModel implements IQueryResultsOfJcentityViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: JcentityViewModel[] | undefined;

    constructor(data?: IQueryResultsOfJcentityViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(JcentityViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfJcentityViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfJcentityViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfJcentityViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: JcentityViewModel[] | undefined;
}

export class JCEntityEventViewModel implements IJCEntityEventViewModel {
    id!: number;
    entityId!: number;
    staffId!: number;
    eventType?: string | undefined;
    eventDescription?: string | undefined;
    eventDate!: string;
    startTime!: string;
    endTime!: string;
    jobOpenings?: number | undefined;
    numberOfEmployers?: number | undefined;
    numberOfAttendees!: number;
    newEnrollments?: number | undefined;
    numberOfJobOffers!: number;
    comment?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;
    location?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    contactName?: string | undefined;
    contactPhone?: string | undefined;
    jobCategory?: string | undefined;
    jobDescriptions?: string | undefined;

    constructor(data?: IJCEntityEventViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.staffId = _data["staffId"];
            this.eventType = _data["eventType"];
            this.eventDescription = _data["eventDescription"];
            this.eventDate = _data["eventDate"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.jobOpenings = _data["jobOpenings"];
            this.numberOfEmployers = _data["numberOfEmployers"];
            this.numberOfAttendees = _data["numberOfAttendees"];
            this.newEnrollments = _data["newEnrollments"];
            this.numberOfJobOffers = _data["numberOfJobOffers"];
            this.comment = _data["comment"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.location = _data["location"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.contactName = _data["contactName"];
            this.contactPhone = _data["contactPhone"];
            this.jobCategory = _data["jobCategory"];
            this.jobDescriptions = _data["jobDescriptions"];
        }
    }

    static fromJS(data: any): JCEntityEventViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new JCEntityEventViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["staffId"] = this.staffId;
        data["eventType"] = this.eventType;
        data["eventDescription"] = this.eventDescription;
        data["eventDate"] = this.eventDate;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["jobOpenings"] = this.jobOpenings;
        data["numberOfEmployers"] = this.numberOfEmployers;
        data["numberOfAttendees"] = this.numberOfAttendees;
        data["newEnrollments"] = this.newEnrollments;
        data["numberOfJobOffers"] = this.numberOfJobOffers;
        data["comment"] = this.comment;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["location"] = this.location;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["contactName"] = this.contactName;
        data["contactPhone"] = this.contactPhone;
        data["jobCategory"] = this.jobCategory;
        data["jobDescriptions"] = this.jobDescriptions;
        return data;
    }
}

export interface IJCEntityEventViewModel {
    id: number;
    entityId: number;
    staffId: number;
    eventType?: string | undefined;
    eventDescription?: string | undefined;
    eventDate: string;
    startTime: string;
    endTime: string;
    jobOpenings?: number | undefined;
    numberOfEmployers?: number | undefined;
    numberOfAttendees: number;
    newEnrollments?: number | undefined;
    numberOfJobOffers: number;
    comment?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
    location?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    contactName?: string | undefined;
    contactPhone?: string | undefined;
    jobCategory?: string | undefined;
    jobDescriptions?: string | undefined;
}

export class QueryResultsOfJCEntityEventViewModel implements IQueryResultsOfJCEntityEventViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: JCEntityEventViewModel[] | undefined;

    constructor(data?: IQueryResultsOfJCEntityEventViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(JCEntityEventViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfJCEntityEventViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfJCEntityEventViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfJCEntityEventViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: JCEntityEventViewModel[] | undefined;
}

export class JCEntityEvent implements IJCEntityEvent {
    id!: number;
    entityId!: number;
    staffId!: number;
    eventType?: string | undefined;
    eventDescription?: string | undefined;
    eventDate!: string;
    startTime!: string;
    endTime!: string;
    jobOpenings?: number | undefined;
    numberOfEmployers?: number | undefined;
    numberOfAttendees!: number;
    newEnrollments?: number | undefined;
    numberOfJobOffers!: number;
    comment?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;
    location?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    contactName?: string | undefined;
    contactPhone?: string | undefined;
    jobCategory?: string | undefined;
    jobDescriptions?: string | undefined;

    constructor(data?: IJCEntityEvent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.staffId = _data["staffId"];
            this.eventType = _data["eventType"];
            this.eventDescription = _data["eventDescription"];
            this.eventDate = _data["eventDate"];
            this.startTime = _data["startTime"];
            this.endTime = _data["endTime"];
            this.jobOpenings = _data["jobOpenings"];
            this.numberOfEmployers = _data["numberOfEmployers"];
            this.numberOfAttendees = _data["numberOfAttendees"];
            this.newEnrollments = _data["newEnrollments"];
            this.numberOfJobOffers = _data["numberOfJobOffers"];
            this.comment = _data["comment"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.location = _data["location"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.contactName = _data["contactName"];
            this.contactPhone = _data["contactPhone"];
            this.jobCategory = _data["jobCategory"];
            this.jobDescriptions = _data["jobDescriptions"];
        }
    }

    static fromJS(data: any): JCEntityEvent {
        data = typeof data === 'object' ? data : {};
        let result = new JCEntityEvent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["staffId"] = this.staffId;
        data["eventType"] = this.eventType;
        data["eventDescription"] = this.eventDescription;
        data["eventDate"] = this.eventDate;
        data["startTime"] = this.startTime;
        data["endTime"] = this.endTime;
        data["jobOpenings"] = this.jobOpenings;
        data["numberOfEmployers"] = this.numberOfEmployers;
        data["numberOfAttendees"] = this.numberOfAttendees;
        data["newEnrollments"] = this.newEnrollments;
        data["numberOfJobOffers"] = this.numberOfJobOffers;
        data["comment"] = this.comment;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["location"] = this.location;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["contactName"] = this.contactName;
        data["contactPhone"] = this.contactPhone;
        data["jobCategory"] = this.jobCategory;
        data["jobDescriptions"] = this.jobDescriptions;
        return data;
    }
}

export interface IJCEntityEvent {
    id: number;
    entityId: number;
    staffId: number;
    eventType?: string | undefined;
    eventDescription?: string | undefined;
    eventDate: string;
    startTime: string;
    endTime: string;
    jobOpenings?: number | undefined;
    numberOfEmployers?: number | undefined;
    numberOfAttendees: number;
    newEnrollments?: number | undefined;
    numberOfJobOffers: number;
    comment?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
    location?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    contactName?: string | undefined;
    contactPhone?: string | undefined;
    jobCategory?: string | undefined;
    jobDescriptions?: string | undefined;
}

export class JCEntityEventDetailViewModel implements IJCEntityEventDetailViewModel {
    id!: number;
    jcEntityEventId!: number;
    staffId!: number;
    entityId!: number;
    enteredBy?: string | undefined;
    enteredDate!: string;
    comment?: string | undefined;
    jobOpenings?: number | undefined;

    constructor(data?: IJCEntityEventDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jcEntityEventId = _data["jcEntityEventId"];
            this.staffId = _data["staffId"];
            this.entityId = _data["entityId"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.comment = _data["comment"];
            this.jobOpenings = _data["jobOpenings"];
        }
    }

    static fromJS(data: any): JCEntityEventDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new JCEntityEventDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jcEntityEventId"] = this.jcEntityEventId;
        data["staffId"] = this.staffId;
        data["entityId"] = this.entityId;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["comment"] = this.comment;
        data["jobOpenings"] = this.jobOpenings;
        return data;
    }
}

export interface IJCEntityEventDetailViewModel {
    id: number;
    jcEntityEventId: number;
    staffId: number;
    entityId: number;
    enteredBy?: string | undefined;
    enteredDate: string;
    comment?: string | undefined;
    jobOpenings?: number | undefined;
}

export class QueryResultsOfJCEntityEventDetailViewModel implements IQueryResultsOfJCEntityEventDetailViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: JCEntityEventDetailViewModel[] | undefined;

    constructor(data?: IQueryResultsOfJCEntityEventDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(JCEntityEventDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfJCEntityEventDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfJCEntityEventDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfJCEntityEventDetailViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: JCEntityEventDetailViewModel[] | undefined;
}

export class JCEntityEventDetail implements IJCEntityEventDetail {
    id!: number;
    jcEntityEventId!: number;
    staffId!: number;
    entityId!: number;
    enteredBy?: string | undefined;
    enteredDate!: string;
    comment?: string | undefined;
    jobOpenings?: number | undefined;

    constructor(data?: IJCEntityEventDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.jcEntityEventId = _data["jcEntityEventId"];
            this.staffId = _data["staffId"];
            this.entityId = _data["entityId"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.comment = _data["comment"];
            this.jobOpenings = _data["jobOpenings"];
        }
    }

    static fromJS(data: any): JCEntityEventDetail {
        data = typeof data === 'object' ? data : {};
        let result = new JCEntityEventDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["jcEntityEventId"] = this.jcEntityEventId;
        data["staffId"] = this.staffId;
        data["entityId"] = this.entityId;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["comment"] = this.comment;
        data["jobOpenings"] = this.jobOpenings;
        return data;
    }
}

export interface IJCEntityEventDetail {
    id: number;
    jcEntityEventId: number;
    staffId: number;
    entityId: number;
    enteredBy?: string | undefined;
    enteredDate: string;
    comment?: string | undefined;
    jobOpenings?: number | undefined;
}

export class QueryResultsOfAMPJcentityLocationViewModel implements IQueryResultsOfAMPJcentityLocationViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: AMPJcentityLocationViewModel[] | undefined;

    constructor(data?: IQueryResultsOfAMPJcentityLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(AMPJcentityLocationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfAMPJcentityLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfAMPJcentityLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfAMPJcentityLocationViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: AMPJcentityLocationViewModel[] | undefined;
}

export class AMPJcentityLocationViewModel implements IAMPJcentityLocationViewModel {
    id!: number;
    entityId!: number;
    locationType?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;

    constructor(data?: IAMPJcentityLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.locationType = _data["locationType"];
            this.phone = _data["phone"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
        }
    }

    static fromJS(data: any): AMPJcentityLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AMPJcentityLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["locationType"] = this.locationType;
        data["phone"] = this.phone;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        return data;
    }
}

export interface IAMPJcentityLocationViewModel {
    id: number;
    entityId: number;
    locationType?: string | undefined;
    phone?: string | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
}

export class QueryResultsOfJcentityLocationViewModel implements IQueryResultsOfJcentityLocationViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: JcentityLocationViewModel[] | undefined;

    constructor(data?: IQueryResultsOfJcentityLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(JcentityLocationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfJcentityLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfJcentityLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfJcentityLocationViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: JcentityLocationViewModel[] | undefined;
}

export class JcentityLocationViewModel implements IJcentityLocationViewModel {
    id?: string | undefined;
    address?: string | undefined;
    entityName?: string | undefined;

    constructor(data?: IJcentityLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.entityName = _data["entityName"];
        }
    }

    static fromJS(data: any): JcentityLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new JcentityLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["entityName"] = this.entityName;
        return data;
    }
}

export interface IJcentityLocationViewModel {
    id?: string | undefined;
    address?: string | undefined;
    entityName?: string | undefined;
}

export class JCEntityLocationOutputViewModel implements IJCEntityLocationOutputViewModel {
    id!: number;
    address?: string | undefined;
    entityName?: string | undefined;

    constructor(data?: IJCEntityLocationOutputViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.address = _data["address"];
            this.entityName = _data["entityName"];
        }
    }

    static fromJS(data: any): JCEntityLocationOutputViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new JCEntityLocationOutputViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["address"] = this.address;
        data["entityName"] = this.entityName;
        return data;
    }
}

export interface IJCEntityLocationOutputViewModel {
    id: number;
    address?: string | undefined;
    entityName?: string | undefined;
}

export class QueryResultsOfJCParticipantViewModel implements IQueryResultsOfJCParticipantViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: JCParticipantViewModel[] | undefined;

    constructor(data?: IQueryResultsOfJCParticipantViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(JCParticipantViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfJCParticipantViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfJCParticipantViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfJCParticipantViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: JCParticipantViewModel[] | undefined;
}

export class JCParticipantViewModel implements IJCParticipantViewModel {
    gicwid!: number;
    ssn?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    preferredName?: string | undefined;
    division!: number;
    employmentSpecialists!: number;
    location?: Location | undefined;
    staff?: Staff | undefined;

    constructor(data?: IJCParticipantViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.gicwid = _data["gicwid"];
            this.ssn = _data["ssn"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.preferredName = _data["preferredName"];
            this.division = _data["division"];
            this.employmentSpecialists = _data["employmentSpecialists"];
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : <any>undefined;
        }
    }

    static fromJS(data: any): JCParticipantViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new JCParticipantViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gicwid"] = this.gicwid;
        data["ssn"] = this.ssn;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["preferredName"] = this.preferredName;
        data["division"] = this.division;
        data["employmentSpecialists"] = this.employmentSpecialists;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        return data;
    }
}

export interface IJCParticipantViewModel {
    gicwid: number;
    ssn?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    preferredName?: string | undefined;
    division: number;
    employmentSpecialists: number;
    location?: Location | undefined;
    staff?: Staff | undefined;
}

export class EntityHistoryByIDOutputViewModel implements IEntityHistoryByIDOutputViewModel {
    id!: number;
    eventName?: string | undefined;
    enteredDate!: string;
    enteredBy?: string | undefined;
    entityName?: string | undefined;
    entityType?: string | undefined;
    description?: string | undefined;

    constructor(data?: IEntityHistoryByIDOutputViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.eventName = _data["eventName"];
            this.enteredDate = _data["enteredDate"];
            this.enteredBy = _data["enteredBy"];
            this.entityName = _data["entityName"];
            this.entityType = _data["entityType"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EntityHistoryByIDOutputViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EntityHistoryByIDOutputViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["eventName"] = this.eventName;
        data["enteredDate"] = this.enteredDate;
        data["enteredBy"] = this.enteredBy;
        data["entityName"] = this.entityName;
        data["entityType"] = this.entityType;
        data["description"] = this.description;
        return data;
    }
}

export interface IEntityHistoryByIDOutputViewModel {
    id: number;
    eventName?: string | undefined;
    enteredDate: string;
    enteredBy?: string | undefined;
    entityName?: string | undefined;
    entityType?: string | undefined;
    description?: string | undefined;
}

export class QueryResultsOfJCEntityJobLeadViewModel implements IQueryResultsOfJCEntityJobLeadViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: JCEntityJobLeadViewModel[] | undefined;

    constructor(data?: IQueryResultsOfJCEntityJobLeadViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(JCEntityJobLeadViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfJCEntityJobLeadViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfJCEntityJobLeadViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfJCEntityJobLeadViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: JCEntityJobLeadViewModel[] | undefined;
}

export class JCEntityJobLeadViewModel implements IJCEntityJobLeadViewModel {
    id!: number;
    entityId!: number;
    location?: string | undefined;
    jobTitle?: string | undefined;
    jobDescription?: string | undefined;
    postDate!: string;
    startingWage?: number | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;
    comment?: string | undefined;

    constructor(data?: IJCEntityJobLeadViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.location = _data["location"];
            this.jobTitle = _data["jobTitle"];
            this.jobDescription = _data["jobDescription"];
            this.postDate = _data["postDate"];
            this.startingWage = _data["startingWage"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): JCEntityJobLeadViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new JCEntityJobLeadViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["location"] = this.location;
        data["jobTitle"] = this.jobTitle;
        data["jobDescription"] = this.jobDescription;
        data["postDate"] = this.postDate;
        data["startingWage"] = this.startingWage;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IJCEntityJobLeadViewModel {
    id: number;
    entityId: number;
    location?: string | undefined;
    jobTitle?: string | undefined;
    jobDescription?: string | undefined;
    postDate: string;
    startingWage?: number | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
    comment?: string | undefined;
}

export class JCEntityJobLead implements IJCEntityJobLead {
    id!: number;
    entityId!: number;
    location?: string | undefined;
    jobTitle?: string | undefined;
    jobDescription?: string | undefined;
    postDate!: string;
    startingWage?: number | undefined;
    enteredBy?: string | undefined;
    enteredDate!: string;
    comment?: string | undefined;

    constructor(data?: IJCEntityJobLead) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.location = _data["location"];
            this.jobTitle = _data["jobTitle"];
            this.jobDescription = _data["jobDescription"];
            this.postDate = _data["postDate"];
            this.startingWage = _data["startingWage"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this.comment = _data["comment"];
        }
    }

    static fromJS(data: any): JCEntityJobLead {
        data = typeof data === 'object' ? data : {};
        let result = new JCEntityJobLead();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["location"] = this.location;
        data["jobTitle"] = this.jobTitle;
        data["jobDescription"] = this.jobDescription;
        data["postDate"] = this.postDate;
        data["startingWage"] = this.startingWage;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["comment"] = this.comment;
        return data;
    }
}

export interface IJCEntityJobLead {
    id: number;
    entityId: number;
    location?: string | undefined;
    jobTitle?: string | undefined;
    jobDescription?: string | undefined;
    postDate: string;
    startingWage?: number | undefined;
    enteredBy?: string | undefined;
    enteredDate: string;
    comment?: string | undefined;
}

export class QueryResultsOfApplicationJobListViewModel implements IQueryResultsOfApplicationJobListViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ApplicationJobListViewModel[] | undefined;

    constructor(data?: IQueryResultsOfApplicationJobListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ApplicationJobListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfApplicationJobListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfApplicationJobListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfApplicationJobListViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ApplicationJobListViewModel[] | undefined;
}

export class KaizenSuggestion implements IKaizenSuggestion {
    id!: number;
    date!: string;
    storeId?: string | undefined;
    departmentArea?: string | undefined;
    submittedBy?: string | undefined;
    suggestion?: string | undefined;
    assignedTo?: string | undefined;
    dateAssigned?: string | undefined;
    followUpDate?: string | undefined;
    planOfAction?: string | undefined;
    reported?: boolean | undefined;
    dateCompleted?: string | undefined;
    store?: Store2 | undefined;

    constructor(data?: IKaizenSuggestion) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"];
            this.storeId = _data["storeId"];
            this.departmentArea = _data["departmentArea"];
            this.submittedBy = _data["submittedBy"];
            this.suggestion = _data["suggestion"];
            this.assignedTo = _data["assignedTo"];
            this.dateAssigned = _data["dateAssigned"];
            this.followUpDate = _data["followUpDate"];
            this.planOfAction = _data["planOfAction"];
            this.reported = _data["reported"];
            this.dateCompleted = _data["dateCompleted"];
            this.store = _data["store"] ? Store2.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KaizenSuggestion {
        data = typeof data === 'object' ? data : {};
        let result = new KaizenSuggestion();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date;
        data["storeId"] = this.storeId;
        data["departmentArea"] = this.departmentArea;
        data["submittedBy"] = this.submittedBy;
        data["suggestion"] = this.suggestion;
        data["assignedTo"] = this.assignedTo;
        data["dateAssigned"] = this.dateAssigned;
        data["followUpDate"] = this.followUpDate;
        data["planOfAction"] = this.planOfAction;
        data["reported"] = this.reported;
        data["dateCompleted"] = this.dateCompleted;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKaizenSuggestion {
    id: number;
    date: string;
    storeId?: string | undefined;
    departmentArea?: string | undefined;
    submittedBy?: string | undefined;
    suggestion?: string | undefined;
    assignedTo?: string | undefined;
    dateAssigned?: string | undefined;
    followUpDate?: string | undefined;
    planOfAction?: string | undefined;
    reported?: boolean | undefined;
    dateCompleted?: string | undefined;
    store?: Store2 | undefined;
}

export class QueryResultsOfLaborHourBudget implements IQueryResultsOfLaborHourBudget {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: LaborHourBudget[] | undefined;

    constructor(data?: IQueryResultsOfLaborHourBudget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(LaborHourBudget.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfLaborHourBudget {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfLaborHourBudget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfLaborHourBudget {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: LaborHourBudget[] | undefined;
}

export class LaborHourBudget implements ILaborHourBudget {
    id!: number;
    year!: number;
    qtr!: number;
    month!: number;
    storeId?: string | undefined;
    laborHrs!: number;

    constructor(data?: ILaborHourBudget) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.qtr = _data["qtr"];
            this.month = _data["month"];
            this.storeId = _data["storeId"];
            this.laborHrs = _data["laborHrs"];
        }
    }

    static fromJS(data: any): LaborHourBudget {
        data = typeof data === 'object' ? data : {};
        let result = new LaborHourBudget();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["qtr"] = this.qtr;
        data["month"] = this.month;
        data["storeId"] = this.storeId;
        data["laborHrs"] = this.laborHrs;
        return data;
    }
}

export interface ILaborHourBudget {
    id: number;
    year: number;
    qtr: number;
    month: number;
    storeId?: string | undefined;
    laborHrs: number;
}

export class QueryResultsOfApplicationFlowLogRouteToViewModel implements IQueryResultsOfApplicationFlowLogRouteToViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ApplicationFlowLogRouteToViewModel[] | undefined;

    constructor(data?: IQueryResultsOfApplicationFlowLogRouteToViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ApplicationFlowLogRouteToViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfApplicationFlowLogRouteToViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfApplicationFlowLogRouteToViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfApplicationFlowLogRouteToViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ApplicationFlowLogRouteToViewModel[] | undefined;
}

export class QueryResultsOfLocationViewModel implements IQueryResultsOfLocationViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: LocationViewModel[] | undefined;

    constructor(data?: IQueryResultsOfLocationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(LocationViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfLocationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfLocationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfLocationViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: LocationViewModel[] | undefined;
}

export class QueryResultsOfLocation implements IQueryResultsOfLocation {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Location[] | undefined;

    constructor(data?: IQueryResultsOfLocation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Location.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfLocation {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfLocation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfLocation {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Location[] | undefined;
}

export class LocationsJCSOutputViewModel implements ILocationsJCSOutputViewModel {
    id!: number;
    name?: string | undefined;

    constructor(data?: ILocationsJCSOutputViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): LocationsJCSOutputViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LocationsJCSOutputViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface ILocationsJCSOutputViewModel {
    id: number;
    name?: string | undefined;
}

export class LossControlReviewViewModel implements ILossControlReviewViewModel {
    id!: number;
    storeId?: string | undefined;
    reviewDate!: string;
    enteredBy?: string | undefined;
    enteredDate!: string;
    _1!: boolean;
    comment1?: string | undefined;
    action1?: string | undefined;
    _2!: boolean;
    comment2?: string | undefined;
    action2?: string | undefined;
    _3!: boolean;
    comment3?: string | undefined;
    action3?: string | undefined;
    _4!: boolean;
    comment4?: string | undefined;
    action4?: string | undefined;
    _5!: boolean;
    comment5?: string | undefined;
    action5?: string | undefined;
    _6!: boolean;
    comment6?: string | undefined;
    action6?: string | undefined;
    _7!: boolean;
    comment7?: string | undefined;
    action7?: string | undefined;
    _8!: boolean;
    comment8?: string | undefined;
    action8?: string | undefined;
    _9!: boolean;
    comment9?: string | undefined;
    action9?: string | undefined;
    _10!: boolean;
    comment10?: string | undefined;
    action10?: string | undefined;
    _11!: boolean;
    comment11?: string | undefined;
    action11?: string | undefined;
    _12!: boolean;
    comment12?: string | undefined;
    action12?: string | undefined;
    _13!: boolean;
    comment13?: string | undefined;
    action13?: string | undefined;
    _14!: boolean;
    comment14?: string | undefined;
    action14?: string | undefined;
    _15!: boolean;
    comment15?: string | undefined;
    action15?: string | undefined;
    _16!: boolean;
    comment16?: string | undefined;
    action16?: string | undefined;
    _17!: boolean;
    comment17?: string | undefined;
    action17?: string | undefined;
    _18!: boolean;
    comment18?: string | undefined;
    action18?: string | undefined;
    _19!: boolean;
    comment19?: string | undefined;
    action19?: string | undefined;
    _20!: boolean;
    comment20?: string | undefined;
    action20?: string | undefined;
    _21!: boolean;
    comment21?: string | undefined;
    action21?: string | undefined;
    _22!: boolean;
    comment22?: string | undefined;
    action22?: string | undefined;
    _23!: boolean;
    comment23?: string | undefined;
    action23?: string | undefined;
    _24!: boolean;
    comment24?: string | undefined;
    action24?: string | undefined;
    _25!: boolean;
    comment25?: string | undefined;
    action25?: string | undefined;
    _26!: boolean;
    comment26?: string | undefined;
    action26?: string | undefined;
    _27!: boolean;
    comment27?: string | undefined;
    action27?: string | undefined;
    _28!: boolean;
    comment28?: string | undefined;
    action28?: string | undefined;
    _29!: boolean;
    comment29?: string | undefined;
    action29?: string | undefined;
    _30!: boolean;
    comment30?: string | undefined;
    action30?: string | undefined;
    _31!: boolean;
    comment31?: string | undefined;
    action31?: string | undefined;
    _32!: boolean;
    comment32?: string | undefined;
    action32?: string | undefined;
    _33!: boolean;
    comment33?: string | undefined;
    action33?: string | undefined;
    _34!: boolean;
    comment34?: string | undefined;
    action34?: string | undefined;
    _35!: boolean;
    comment35?: string | undefined;
    action35?: string | undefined;
    _36!: boolean;
    comment36?: string | undefined;
    action36?: string | undefined;
    _37!: boolean;
    comment37?: string | undefined;
    action37?: string | undefined;
    _38!: boolean;
    comment38?: string | undefined;
    action38?: string | undefined;
    _39!: boolean;
    comment39?: string | undefined;
    action39?: string | undefined;
    _40!: boolean;
    comment40?: string | undefined;
    action40?: string | undefined;
    _41!: boolean;
    comment41?: string | undefined;
    action41?: string | undefined;
    _42!: boolean;
    comment42?: string | undefined;
    action42?: string | undefined;
    _43!: boolean;
    comment43?: string | undefined;
    action43?: string | undefined;
    _44!: boolean;
    comment44?: string | undefined;
    action44?: string | undefined;
    _45!: boolean;
    comment45?: string | undefined;
    action45?: string | undefined;
    _46!: boolean;
    comment46?: string | undefined;
    action46?: string | undefined;
    _47!: boolean;
    comment47?: string | undefined;
    action47?: string | undefined;
    _48!: boolean;
    comment48?: string | undefined;
    action48?: string | undefined;
    _49!: boolean;
    comment49?: string | undefined;
    action49?: string | undefined;
    _50!: boolean;
    comment50?: string | undefined;
    action50?: string | undefined;
    _51!: boolean;
    comment51?: string | undefined;
    action51?: string | undefined;
    _52!: boolean;
    comment52?: string | undefined;
    action52?: string | undefined;
    _53!: boolean;
    comment53?: string | undefined;
    action53?: string | undefined;
    _54!: boolean;
    comment54?: string | undefined;
    action54?: string | undefined;
    _55!: boolean;
    comment55?: string | undefined;
    action55?: string | undefined;
    _56!: boolean;
    comment56?: string | undefined;
    action56?: string | undefined;
    _57!: boolean;
    comment57?: string | undefined;
    action57?: string | undefined;
    _58!: boolean;
    comment58?: string | undefined;
    action58?: string | undefined;
    _59!: boolean;
    comment59?: string | undefined;
    action59?: string | undefined;
    _60!: boolean;
    comment60?: string | undefined;
    action60?: string | undefined;
    _61!: boolean;
    comment61?: string | undefined;
    action61?: string | undefined;
    _62!: boolean;
    comment62?: string | undefined;
    action62?: string | undefined;
    _63!: boolean;
    comment63?: string | undefined;
    action63?: string | undefined;
    _64!: boolean;
    comment64?: string | undefined;
    action64?: string | undefined;
    _65!: boolean;
    comment65?: string | undefined;
    action65?: string | undefined;
    _66!: boolean;
    comment66?: string | undefined;
    action66?: string | undefined;
    _67!: boolean;
    comment67?: string | undefined;
    action67?: string | undefined;
    remarks?: string | undefined;
    approved?: boolean | undefined;
    editedBy?: string | undefined;
    editedDate?: string | undefined;
    reported?: boolean | undefined;
    store?: StoreViewModel2 | undefined;

    constructor(data?: ILossControlReviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.reviewDate = _data["reviewDate"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this._1 = _data["_1"];
            this.comment1 = _data["comment1"];
            this.action1 = _data["action1"];
            this._2 = _data["_2"];
            this.comment2 = _data["comment2"];
            this.action2 = _data["action2"];
            this._3 = _data["_3"];
            this.comment3 = _data["comment3"];
            this.action3 = _data["action3"];
            this._4 = _data["_4"];
            this.comment4 = _data["comment4"];
            this.action4 = _data["action4"];
            this._5 = _data["_5"];
            this.comment5 = _data["comment5"];
            this.action5 = _data["action5"];
            this._6 = _data["_6"];
            this.comment6 = _data["comment6"];
            this.action6 = _data["action6"];
            this._7 = _data["_7"];
            this.comment7 = _data["comment7"];
            this.action7 = _data["action7"];
            this._8 = _data["_8"];
            this.comment8 = _data["comment8"];
            this.action8 = _data["action8"];
            this._9 = _data["_9"];
            this.comment9 = _data["comment9"];
            this.action9 = _data["action9"];
            this._10 = _data["_10"];
            this.comment10 = _data["comment10"];
            this.action10 = _data["action10"];
            this._11 = _data["_11"];
            this.comment11 = _data["comment11"];
            this.action11 = _data["action11"];
            this._12 = _data["_12"];
            this.comment12 = _data["comment12"];
            this.action12 = _data["action12"];
            this._13 = _data["_13"];
            this.comment13 = _data["comment13"];
            this.action13 = _data["action13"];
            this._14 = _data["_14"];
            this.comment14 = _data["comment14"];
            this.action14 = _data["action14"];
            this._15 = _data["_15"];
            this.comment15 = _data["comment15"];
            this.action15 = _data["action15"];
            this._16 = _data["_16"];
            this.comment16 = _data["comment16"];
            this.action16 = _data["action16"];
            this._17 = _data["_17"];
            this.comment17 = _data["comment17"];
            this.action17 = _data["action17"];
            this._18 = _data["_18"];
            this.comment18 = _data["comment18"];
            this.action18 = _data["action18"];
            this._19 = _data["_19"];
            this.comment19 = _data["comment19"];
            this.action19 = _data["action19"];
            this._20 = _data["_20"];
            this.comment20 = _data["comment20"];
            this.action20 = _data["action20"];
            this._21 = _data["_21"];
            this.comment21 = _data["comment21"];
            this.action21 = _data["action21"];
            this._22 = _data["_22"];
            this.comment22 = _data["comment22"];
            this.action22 = _data["action22"];
            this._23 = _data["_23"];
            this.comment23 = _data["comment23"];
            this.action23 = _data["action23"];
            this._24 = _data["_24"];
            this.comment24 = _data["comment24"];
            this.action24 = _data["action24"];
            this._25 = _data["_25"];
            this.comment25 = _data["comment25"];
            this.action25 = _data["action25"];
            this._26 = _data["_26"];
            this.comment26 = _data["comment26"];
            this.action26 = _data["action26"];
            this._27 = _data["_27"];
            this.comment27 = _data["comment27"];
            this.action27 = _data["action27"];
            this._28 = _data["_28"];
            this.comment28 = _data["comment28"];
            this.action28 = _data["action28"];
            this._29 = _data["_29"];
            this.comment29 = _data["comment29"];
            this.action29 = _data["action29"];
            this._30 = _data["_30"];
            this.comment30 = _data["comment30"];
            this.action30 = _data["action30"];
            this._31 = _data["_31"];
            this.comment31 = _data["comment31"];
            this.action31 = _data["action31"];
            this._32 = _data["_32"];
            this.comment32 = _data["comment32"];
            this.action32 = _data["action32"];
            this._33 = _data["_33"];
            this.comment33 = _data["comment33"];
            this.action33 = _data["action33"];
            this._34 = _data["_34"];
            this.comment34 = _data["comment34"];
            this.action34 = _data["action34"];
            this._35 = _data["_35"];
            this.comment35 = _data["comment35"];
            this.action35 = _data["action35"];
            this._36 = _data["_36"];
            this.comment36 = _data["comment36"];
            this.action36 = _data["action36"];
            this._37 = _data["_37"];
            this.comment37 = _data["comment37"];
            this.action37 = _data["action37"];
            this._38 = _data["_38"];
            this.comment38 = _data["comment38"];
            this.action38 = _data["action38"];
            this._39 = _data["_39"];
            this.comment39 = _data["comment39"];
            this.action39 = _data["action39"];
            this._40 = _data["_40"];
            this.comment40 = _data["comment40"];
            this.action40 = _data["action40"];
            this._41 = _data["_41"];
            this.comment41 = _data["comment41"];
            this.action41 = _data["action41"];
            this._42 = _data["_42"];
            this.comment42 = _data["comment42"];
            this.action42 = _data["action42"];
            this._43 = _data["_43"];
            this.comment43 = _data["comment43"];
            this.action43 = _data["action43"];
            this._44 = _data["_44"];
            this.comment44 = _data["comment44"];
            this.action44 = _data["action44"];
            this._45 = _data["_45"];
            this.comment45 = _data["comment45"];
            this.action45 = _data["action45"];
            this._46 = _data["_46"];
            this.comment46 = _data["comment46"];
            this.action46 = _data["action46"];
            this._47 = _data["_47"];
            this.comment47 = _data["comment47"];
            this.action47 = _data["action47"];
            this._48 = _data["_48"];
            this.comment48 = _data["comment48"];
            this.action48 = _data["action48"];
            this._49 = _data["_49"];
            this.comment49 = _data["comment49"];
            this.action49 = _data["action49"];
            this._50 = _data["_50"];
            this.comment50 = _data["comment50"];
            this.action50 = _data["action50"];
            this._51 = _data["_51"];
            this.comment51 = _data["comment51"];
            this.action51 = _data["action51"];
            this._52 = _data["_52"];
            this.comment52 = _data["comment52"];
            this.action52 = _data["action52"];
            this._53 = _data["_53"];
            this.comment53 = _data["comment53"];
            this.action53 = _data["action53"];
            this._54 = _data["_54"];
            this.comment54 = _data["comment54"];
            this.action54 = _data["action54"];
            this._55 = _data["_55"];
            this.comment55 = _data["comment55"];
            this.action55 = _data["action55"];
            this._56 = _data["_56"];
            this.comment56 = _data["comment56"];
            this.action56 = _data["action56"];
            this._57 = _data["_57"];
            this.comment57 = _data["comment57"];
            this.action57 = _data["action57"];
            this._58 = _data["_58"];
            this.comment58 = _data["comment58"];
            this.action58 = _data["action58"];
            this._59 = _data["_59"];
            this.comment59 = _data["comment59"];
            this.action59 = _data["action59"];
            this._60 = _data["_60"];
            this.comment60 = _data["comment60"];
            this.action60 = _data["action60"];
            this._61 = _data["_61"];
            this.comment61 = _data["comment61"];
            this.action61 = _data["action61"];
            this._62 = _data["_62"];
            this.comment62 = _data["comment62"];
            this.action62 = _data["action62"];
            this._63 = _data["_63"];
            this.comment63 = _data["comment63"];
            this.action63 = _data["action63"];
            this._64 = _data["_64"];
            this.comment64 = _data["comment64"];
            this.action64 = _data["action64"];
            this._65 = _data["_65"];
            this.comment65 = _data["comment65"];
            this.action65 = _data["action65"];
            this._66 = _data["_66"];
            this.comment66 = _data["comment66"];
            this.action66 = _data["action66"];
            this._67 = _data["_67"];
            this.comment67 = _data["comment67"];
            this.action67 = _data["action67"];
            this.remarks = _data["remarks"];
            this.approved = _data["approved"];
            this.editedBy = _data["editedBy"];
            this.editedDate = _data["editedDate"];
            this.reported = _data["reported"];
            this.store = _data["store"] ? StoreViewModel2.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LossControlReviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new LossControlReviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["reviewDate"] = this.reviewDate;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["_1"] = this._1;
        data["comment1"] = this.comment1;
        data["action1"] = this.action1;
        data["_2"] = this._2;
        data["comment2"] = this.comment2;
        data["action2"] = this.action2;
        data["_3"] = this._3;
        data["comment3"] = this.comment3;
        data["action3"] = this.action3;
        data["_4"] = this._4;
        data["comment4"] = this.comment4;
        data["action4"] = this.action4;
        data["_5"] = this._5;
        data["comment5"] = this.comment5;
        data["action5"] = this.action5;
        data["_6"] = this._6;
        data["comment6"] = this.comment6;
        data["action6"] = this.action6;
        data["_7"] = this._7;
        data["comment7"] = this.comment7;
        data["action7"] = this.action7;
        data["_8"] = this._8;
        data["comment8"] = this.comment8;
        data["action8"] = this.action8;
        data["_9"] = this._9;
        data["comment9"] = this.comment9;
        data["action9"] = this.action9;
        data["_10"] = this._10;
        data["comment10"] = this.comment10;
        data["action10"] = this.action10;
        data["_11"] = this._11;
        data["comment11"] = this.comment11;
        data["action11"] = this.action11;
        data["_12"] = this._12;
        data["comment12"] = this.comment12;
        data["action12"] = this.action12;
        data["_13"] = this._13;
        data["comment13"] = this.comment13;
        data["action13"] = this.action13;
        data["_14"] = this._14;
        data["comment14"] = this.comment14;
        data["action14"] = this.action14;
        data["_15"] = this._15;
        data["comment15"] = this.comment15;
        data["action15"] = this.action15;
        data["_16"] = this._16;
        data["comment16"] = this.comment16;
        data["action16"] = this.action16;
        data["_17"] = this._17;
        data["comment17"] = this.comment17;
        data["action17"] = this.action17;
        data["_18"] = this._18;
        data["comment18"] = this.comment18;
        data["action18"] = this.action18;
        data["_19"] = this._19;
        data["comment19"] = this.comment19;
        data["action19"] = this.action19;
        data["_20"] = this._20;
        data["comment20"] = this.comment20;
        data["action20"] = this.action20;
        data["_21"] = this._21;
        data["comment21"] = this.comment21;
        data["action21"] = this.action21;
        data["_22"] = this._22;
        data["comment22"] = this.comment22;
        data["action22"] = this.action22;
        data["_23"] = this._23;
        data["comment23"] = this.comment23;
        data["action23"] = this.action23;
        data["_24"] = this._24;
        data["comment24"] = this.comment24;
        data["action24"] = this.action24;
        data["_25"] = this._25;
        data["comment25"] = this.comment25;
        data["action25"] = this.action25;
        data["_26"] = this._26;
        data["comment26"] = this.comment26;
        data["action26"] = this.action26;
        data["_27"] = this._27;
        data["comment27"] = this.comment27;
        data["action27"] = this.action27;
        data["_28"] = this._28;
        data["comment28"] = this.comment28;
        data["action28"] = this.action28;
        data["_29"] = this._29;
        data["comment29"] = this.comment29;
        data["action29"] = this.action29;
        data["_30"] = this._30;
        data["comment30"] = this.comment30;
        data["action30"] = this.action30;
        data["_31"] = this._31;
        data["comment31"] = this.comment31;
        data["action31"] = this.action31;
        data["_32"] = this._32;
        data["comment32"] = this.comment32;
        data["action32"] = this.action32;
        data["_33"] = this._33;
        data["comment33"] = this.comment33;
        data["action33"] = this.action33;
        data["_34"] = this._34;
        data["comment34"] = this.comment34;
        data["action34"] = this.action34;
        data["_35"] = this._35;
        data["comment35"] = this.comment35;
        data["action35"] = this.action35;
        data["_36"] = this._36;
        data["comment36"] = this.comment36;
        data["action36"] = this.action36;
        data["_37"] = this._37;
        data["comment37"] = this.comment37;
        data["action37"] = this.action37;
        data["_38"] = this._38;
        data["comment38"] = this.comment38;
        data["action38"] = this.action38;
        data["_39"] = this._39;
        data["comment39"] = this.comment39;
        data["action39"] = this.action39;
        data["_40"] = this._40;
        data["comment40"] = this.comment40;
        data["action40"] = this.action40;
        data["_41"] = this._41;
        data["comment41"] = this.comment41;
        data["action41"] = this.action41;
        data["_42"] = this._42;
        data["comment42"] = this.comment42;
        data["action42"] = this.action42;
        data["_43"] = this._43;
        data["comment43"] = this.comment43;
        data["action43"] = this.action43;
        data["_44"] = this._44;
        data["comment44"] = this.comment44;
        data["action44"] = this.action44;
        data["_45"] = this._45;
        data["comment45"] = this.comment45;
        data["action45"] = this.action45;
        data["_46"] = this._46;
        data["comment46"] = this.comment46;
        data["action46"] = this.action46;
        data["_47"] = this._47;
        data["comment47"] = this.comment47;
        data["action47"] = this.action47;
        data["_48"] = this._48;
        data["comment48"] = this.comment48;
        data["action48"] = this.action48;
        data["_49"] = this._49;
        data["comment49"] = this.comment49;
        data["action49"] = this.action49;
        data["_50"] = this._50;
        data["comment50"] = this.comment50;
        data["action50"] = this.action50;
        data["_51"] = this._51;
        data["comment51"] = this.comment51;
        data["action51"] = this.action51;
        data["_52"] = this._52;
        data["comment52"] = this.comment52;
        data["action52"] = this.action52;
        data["_53"] = this._53;
        data["comment53"] = this.comment53;
        data["action53"] = this.action53;
        data["_54"] = this._54;
        data["comment54"] = this.comment54;
        data["action54"] = this.action54;
        data["_55"] = this._55;
        data["comment55"] = this.comment55;
        data["action55"] = this.action55;
        data["_56"] = this._56;
        data["comment56"] = this.comment56;
        data["action56"] = this.action56;
        data["_57"] = this._57;
        data["comment57"] = this.comment57;
        data["action57"] = this.action57;
        data["_58"] = this._58;
        data["comment58"] = this.comment58;
        data["action58"] = this.action58;
        data["_59"] = this._59;
        data["comment59"] = this.comment59;
        data["action59"] = this.action59;
        data["_60"] = this._60;
        data["comment60"] = this.comment60;
        data["action60"] = this.action60;
        data["_61"] = this._61;
        data["comment61"] = this.comment61;
        data["action61"] = this.action61;
        data["_62"] = this._62;
        data["comment62"] = this.comment62;
        data["action62"] = this.action62;
        data["_63"] = this._63;
        data["comment63"] = this.comment63;
        data["action63"] = this.action63;
        data["_64"] = this._64;
        data["comment64"] = this.comment64;
        data["action64"] = this.action64;
        data["_65"] = this._65;
        data["comment65"] = this.comment65;
        data["action65"] = this.action65;
        data["_66"] = this._66;
        data["comment66"] = this.comment66;
        data["action66"] = this.action66;
        data["_67"] = this._67;
        data["comment67"] = this.comment67;
        data["action67"] = this.action67;
        data["remarks"] = this.remarks;
        data["approved"] = this.approved;
        data["editedBy"] = this.editedBy;
        data["editedDate"] = this.editedDate;
        data["reported"] = this.reported;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILossControlReviewViewModel {
    id: number;
    storeId?: string | undefined;
    reviewDate: string;
    enteredBy?: string | undefined;
    enteredDate: string;
    _1: boolean;
    comment1?: string | undefined;
    action1?: string | undefined;
    _2: boolean;
    comment2?: string | undefined;
    action2?: string | undefined;
    _3: boolean;
    comment3?: string | undefined;
    action3?: string | undefined;
    _4: boolean;
    comment4?: string | undefined;
    action4?: string | undefined;
    _5: boolean;
    comment5?: string | undefined;
    action5?: string | undefined;
    _6: boolean;
    comment6?: string | undefined;
    action6?: string | undefined;
    _7: boolean;
    comment7?: string | undefined;
    action7?: string | undefined;
    _8: boolean;
    comment8?: string | undefined;
    action8?: string | undefined;
    _9: boolean;
    comment9?: string | undefined;
    action9?: string | undefined;
    _10: boolean;
    comment10?: string | undefined;
    action10?: string | undefined;
    _11: boolean;
    comment11?: string | undefined;
    action11?: string | undefined;
    _12: boolean;
    comment12?: string | undefined;
    action12?: string | undefined;
    _13: boolean;
    comment13?: string | undefined;
    action13?: string | undefined;
    _14: boolean;
    comment14?: string | undefined;
    action14?: string | undefined;
    _15: boolean;
    comment15?: string | undefined;
    action15?: string | undefined;
    _16: boolean;
    comment16?: string | undefined;
    action16?: string | undefined;
    _17: boolean;
    comment17?: string | undefined;
    action17?: string | undefined;
    _18: boolean;
    comment18?: string | undefined;
    action18?: string | undefined;
    _19: boolean;
    comment19?: string | undefined;
    action19?: string | undefined;
    _20: boolean;
    comment20?: string | undefined;
    action20?: string | undefined;
    _21: boolean;
    comment21?: string | undefined;
    action21?: string | undefined;
    _22: boolean;
    comment22?: string | undefined;
    action22?: string | undefined;
    _23: boolean;
    comment23?: string | undefined;
    action23?: string | undefined;
    _24: boolean;
    comment24?: string | undefined;
    action24?: string | undefined;
    _25: boolean;
    comment25?: string | undefined;
    action25?: string | undefined;
    _26: boolean;
    comment26?: string | undefined;
    action26?: string | undefined;
    _27: boolean;
    comment27?: string | undefined;
    action27?: string | undefined;
    _28: boolean;
    comment28?: string | undefined;
    action28?: string | undefined;
    _29: boolean;
    comment29?: string | undefined;
    action29?: string | undefined;
    _30: boolean;
    comment30?: string | undefined;
    action30?: string | undefined;
    _31: boolean;
    comment31?: string | undefined;
    action31?: string | undefined;
    _32: boolean;
    comment32?: string | undefined;
    action32?: string | undefined;
    _33: boolean;
    comment33?: string | undefined;
    action33?: string | undefined;
    _34: boolean;
    comment34?: string | undefined;
    action34?: string | undefined;
    _35: boolean;
    comment35?: string | undefined;
    action35?: string | undefined;
    _36: boolean;
    comment36?: string | undefined;
    action36?: string | undefined;
    _37: boolean;
    comment37?: string | undefined;
    action37?: string | undefined;
    _38: boolean;
    comment38?: string | undefined;
    action38?: string | undefined;
    _39: boolean;
    comment39?: string | undefined;
    action39?: string | undefined;
    _40: boolean;
    comment40?: string | undefined;
    action40?: string | undefined;
    _41: boolean;
    comment41?: string | undefined;
    action41?: string | undefined;
    _42: boolean;
    comment42?: string | undefined;
    action42?: string | undefined;
    _43: boolean;
    comment43?: string | undefined;
    action43?: string | undefined;
    _44: boolean;
    comment44?: string | undefined;
    action44?: string | undefined;
    _45: boolean;
    comment45?: string | undefined;
    action45?: string | undefined;
    _46: boolean;
    comment46?: string | undefined;
    action46?: string | undefined;
    _47: boolean;
    comment47?: string | undefined;
    action47?: string | undefined;
    _48: boolean;
    comment48?: string | undefined;
    action48?: string | undefined;
    _49: boolean;
    comment49?: string | undefined;
    action49?: string | undefined;
    _50: boolean;
    comment50?: string | undefined;
    action50?: string | undefined;
    _51: boolean;
    comment51?: string | undefined;
    action51?: string | undefined;
    _52: boolean;
    comment52?: string | undefined;
    action52?: string | undefined;
    _53: boolean;
    comment53?: string | undefined;
    action53?: string | undefined;
    _54: boolean;
    comment54?: string | undefined;
    action54?: string | undefined;
    _55: boolean;
    comment55?: string | undefined;
    action55?: string | undefined;
    _56: boolean;
    comment56?: string | undefined;
    action56?: string | undefined;
    _57: boolean;
    comment57?: string | undefined;
    action57?: string | undefined;
    _58: boolean;
    comment58?: string | undefined;
    action58?: string | undefined;
    _59: boolean;
    comment59?: string | undefined;
    action59?: string | undefined;
    _60: boolean;
    comment60?: string | undefined;
    action60?: string | undefined;
    _61: boolean;
    comment61?: string | undefined;
    action61?: string | undefined;
    _62: boolean;
    comment62?: string | undefined;
    action62?: string | undefined;
    _63: boolean;
    comment63?: string | undefined;
    action63?: string | undefined;
    _64: boolean;
    comment64?: string | undefined;
    action64?: string | undefined;
    _65: boolean;
    comment65?: string | undefined;
    action65?: string | undefined;
    _66: boolean;
    comment66?: string | undefined;
    action66?: string | undefined;
    _67: boolean;
    comment67?: string | undefined;
    action67?: string | undefined;
    remarks?: string | undefined;
    approved?: boolean | undefined;
    editedBy?: string | undefined;
    editedDate?: string | undefined;
    reported?: boolean | undefined;
    store?: StoreViewModel2 | undefined;
}

export class LossControlReview implements ILossControlReview {
    id!: number;
    storeId?: string | undefined;
    reviewDate!: string;
    enteredBy?: string | undefined;
    enteredDate!: string;
    _1!: boolean;
    comment1?: string | undefined;
    action1?: string | undefined;
    _2!: boolean;
    comment2?: string | undefined;
    action2?: string | undefined;
    _3!: boolean;
    comment3?: string | undefined;
    action3?: string | undefined;
    _4!: boolean;
    comment4?: string | undefined;
    action4?: string | undefined;
    _5!: boolean;
    comment5?: string | undefined;
    action5?: string | undefined;
    _6!: boolean;
    comment6?: string | undefined;
    action6?: string | undefined;
    _7!: boolean;
    comment7?: string | undefined;
    action7?: string | undefined;
    _8!: boolean;
    comment8?: string | undefined;
    action8?: string | undefined;
    _9!: boolean;
    comment9?: string | undefined;
    action9?: string | undefined;
    _10!: boolean;
    comment10?: string | undefined;
    action10?: string | undefined;
    _11!: boolean;
    comment11?: string | undefined;
    action11?: string | undefined;
    _12!: boolean;
    comment12?: string | undefined;
    action12?: string | undefined;
    _13!: boolean;
    comment13?: string | undefined;
    action13?: string | undefined;
    _14!: boolean;
    comment14?: string | undefined;
    action14?: string | undefined;
    _15!: boolean;
    comment15?: string | undefined;
    action15?: string | undefined;
    _16!: boolean;
    comment16?: string | undefined;
    action16?: string | undefined;
    _17!: boolean;
    comment17?: string | undefined;
    action17?: string | undefined;
    _18!: boolean;
    comment18?: string | undefined;
    action18?: string | undefined;
    _19!: boolean;
    comment19?: string | undefined;
    action19?: string | undefined;
    _20!: boolean;
    comment20?: string | undefined;
    action20?: string | undefined;
    _21!: boolean;
    comment21?: string | undefined;
    action21?: string | undefined;
    _22!: boolean;
    comment22?: string | undefined;
    action22?: string | undefined;
    _23!: boolean;
    comment23?: string | undefined;
    action23?: string | undefined;
    _24!: boolean;
    comment24?: string | undefined;
    action24?: string | undefined;
    _25!: boolean;
    comment25?: string | undefined;
    action25?: string | undefined;
    _26!: boolean;
    comment26?: string | undefined;
    action26?: string | undefined;
    _27!: boolean;
    comment27?: string | undefined;
    action27?: string | undefined;
    _28!: boolean;
    comment28?: string | undefined;
    action28?: string | undefined;
    _29!: boolean;
    comment29?: string | undefined;
    action29?: string | undefined;
    _30!: boolean;
    comment30?: string | undefined;
    action30?: string | undefined;
    _31!: boolean;
    comment31?: string | undefined;
    action31?: string | undefined;
    _32!: boolean;
    comment32?: string | undefined;
    action32?: string | undefined;
    _33!: boolean;
    comment33?: string | undefined;
    action33?: string | undefined;
    _34!: boolean;
    comment34?: string | undefined;
    action34?: string | undefined;
    _35!: boolean;
    comment35?: string | undefined;
    action35?: string | undefined;
    _36!: boolean;
    comment36?: string | undefined;
    action36?: string | undefined;
    _37!: boolean;
    comment37?: string | undefined;
    action37?: string | undefined;
    _38!: boolean;
    comment38?: string | undefined;
    action38?: string | undefined;
    _39!: boolean;
    comment39?: string | undefined;
    action39?: string | undefined;
    _40!: boolean;
    comment40?: string | undefined;
    action40?: string | undefined;
    _41!: boolean;
    comment41?: string | undefined;
    action41?: string | undefined;
    _42!: boolean;
    comment42?: string | undefined;
    action42?: string | undefined;
    _43!: boolean;
    comment43?: string | undefined;
    action43?: string | undefined;
    _44!: boolean;
    comment44?: string | undefined;
    action44?: string | undefined;
    _45!: boolean;
    comment45?: string | undefined;
    action45?: string | undefined;
    _46!: boolean;
    comment46?: string | undefined;
    action46?: string | undefined;
    _47!: boolean;
    comment47?: string | undefined;
    action47?: string | undefined;
    _48!: boolean;
    comment48?: string | undefined;
    action48?: string | undefined;
    _49!: boolean;
    comment49?: string | undefined;
    action49?: string | undefined;
    _50!: boolean;
    comment50?: string | undefined;
    action50?: string | undefined;
    _51!: boolean;
    comment51?: string | undefined;
    action51?: string | undefined;
    _52!: boolean;
    comment52?: string | undefined;
    action52?: string | undefined;
    _53!: boolean;
    comment53?: string | undefined;
    action53?: string | undefined;
    _54!: boolean;
    comment54?: string | undefined;
    action54?: string | undefined;
    _55!: boolean;
    comment55?: string | undefined;
    action55?: string | undefined;
    _56!: boolean;
    comment56?: string | undefined;
    action56?: string | undefined;
    _57!: boolean;
    comment57?: string | undefined;
    action57?: string | undefined;
    _58!: boolean;
    comment58?: string | undefined;
    action58?: string | undefined;
    _59!: boolean;
    comment59?: string | undefined;
    action59?: string | undefined;
    _60!: boolean;
    comment60?: string | undefined;
    action60?: string | undefined;
    _61!: boolean;
    comment61?: string | undefined;
    action61?: string | undefined;
    _62!: boolean;
    comment62?: string | undefined;
    action62?: string | undefined;
    _63!: boolean;
    comment63?: string | undefined;
    action63?: string | undefined;
    _64!: boolean;
    comment64?: string | undefined;
    action64?: string | undefined;
    _65!: boolean;
    comment65?: string | undefined;
    action65?: string | undefined;
    _66!: boolean;
    comment66?: string | undefined;
    action66?: string | undefined;
    _67!: boolean;
    comment67?: string | undefined;
    action67?: string | undefined;
    remarks?: string | undefined;
    approved?: boolean | undefined;
    editedBy?: string | undefined;
    editedDate?: string | undefined;
    reported?: boolean | undefined;
    store?: Store5 | undefined;

    constructor(data?: ILossControlReview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.reviewDate = _data["reviewDate"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
            this._1 = _data["_1"];
            this.comment1 = _data["comment1"];
            this.action1 = _data["action1"];
            this._2 = _data["_2"];
            this.comment2 = _data["comment2"];
            this.action2 = _data["action2"];
            this._3 = _data["_3"];
            this.comment3 = _data["comment3"];
            this.action3 = _data["action3"];
            this._4 = _data["_4"];
            this.comment4 = _data["comment4"];
            this.action4 = _data["action4"];
            this._5 = _data["_5"];
            this.comment5 = _data["comment5"];
            this.action5 = _data["action5"];
            this._6 = _data["_6"];
            this.comment6 = _data["comment6"];
            this.action6 = _data["action6"];
            this._7 = _data["_7"];
            this.comment7 = _data["comment7"];
            this.action7 = _data["action7"];
            this._8 = _data["_8"];
            this.comment8 = _data["comment8"];
            this.action8 = _data["action8"];
            this._9 = _data["_9"];
            this.comment9 = _data["comment9"];
            this.action9 = _data["action9"];
            this._10 = _data["_10"];
            this.comment10 = _data["comment10"];
            this.action10 = _data["action10"];
            this._11 = _data["_11"];
            this.comment11 = _data["comment11"];
            this.action11 = _data["action11"];
            this._12 = _data["_12"];
            this.comment12 = _data["comment12"];
            this.action12 = _data["action12"];
            this._13 = _data["_13"];
            this.comment13 = _data["comment13"];
            this.action13 = _data["action13"];
            this._14 = _data["_14"];
            this.comment14 = _data["comment14"];
            this.action14 = _data["action14"];
            this._15 = _data["_15"];
            this.comment15 = _data["comment15"];
            this.action15 = _data["action15"];
            this._16 = _data["_16"];
            this.comment16 = _data["comment16"];
            this.action16 = _data["action16"];
            this._17 = _data["_17"];
            this.comment17 = _data["comment17"];
            this.action17 = _data["action17"];
            this._18 = _data["_18"];
            this.comment18 = _data["comment18"];
            this.action18 = _data["action18"];
            this._19 = _data["_19"];
            this.comment19 = _data["comment19"];
            this.action19 = _data["action19"];
            this._20 = _data["_20"];
            this.comment20 = _data["comment20"];
            this.action20 = _data["action20"];
            this._21 = _data["_21"];
            this.comment21 = _data["comment21"];
            this.action21 = _data["action21"];
            this._22 = _data["_22"];
            this.comment22 = _data["comment22"];
            this.action22 = _data["action22"];
            this._23 = _data["_23"];
            this.comment23 = _data["comment23"];
            this.action23 = _data["action23"];
            this._24 = _data["_24"];
            this.comment24 = _data["comment24"];
            this.action24 = _data["action24"];
            this._25 = _data["_25"];
            this.comment25 = _data["comment25"];
            this.action25 = _data["action25"];
            this._26 = _data["_26"];
            this.comment26 = _data["comment26"];
            this.action26 = _data["action26"];
            this._27 = _data["_27"];
            this.comment27 = _data["comment27"];
            this.action27 = _data["action27"];
            this._28 = _data["_28"];
            this.comment28 = _data["comment28"];
            this.action28 = _data["action28"];
            this._29 = _data["_29"];
            this.comment29 = _data["comment29"];
            this.action29 = _data["action29"];
            this._30 = _data["_30"];
            this.comment30 = _data["comment30"];
            this.action30 = _data["action30"];
            this._31 = _data["_31"];
            this.comment31 = _data["comment31"];
            this.action31 = _data["action31"];
            this._32 = _data["_32"];
            this.comment32 = _data["comment32"];
            this.action32 = _data["action32"];
            this._33 = _data["_33"];
            this.comment33 = _data["comment33"];
            this.action33 = _data["action33"];
            this._34 = _data["_34"];
            this.comment34 = _data["comment34"];
            this.action34 = _data["action34"];
            this._35 = _data["_35"];
            this.comment35 = _data["comment35"];
            this.action35 = _data["action35"];
            this._36 = _data["_36"];
            this.comment36 = _data["comment36"];
            this.action36 = _data["action36"];
            this._37 = _data["_37"];
            this.comment37 = _data["comment37"];
            this.action37 = _data["action37"];
            this._38 = _data["_38"];
            this.comment38 = _data["comment38"];
            this.action38 = _data["action38"];
            this._39 = _data["_39"];
            this.comment39 = _data["comment39"];
            this.action39 = _data["action39"];
            this._40 = _data["_40"];
            this.comment40 = _data["comment40"];
            this.action40 = _data["action40"];
            this._41 = _data["_41"];
            this.comment41 = _data["comment41"];
            this.action41 = _data["action41"];
            this._42 = _data["_42"];
            this.comment42 = _data["comment42"];
            this.action42 = _data["action42"];
            this._43 = _data["_43"];
            this.comment43 = _data["comment43"];
            this.action43 = _data["action43"];
            this._44 = _data["_44"];
            this.comment44 = _data["comment44"];
            this.action44 = _data["action44"];
            this._45 = _data["_45"];
            this.comment45 = _data["comment45"];
            this.action45 = _data["action45"];
            this._46 = _data["_46"];
            this.comment46 = _data["comment46"];
            this.action46 = _data["action46"];
            this._47 = _data["_47"];
            this.comment47 = _data["comment47"];
            this.action47 = _data["action47"];
            this._48 = _data["_48"];
            this.comment48 = _data["comment48"];
            this.action48 = _data["action48"];
            this._49 = _data["_49"];
            this.comment49 = _data["comment49"];
            this.action49 = _data["action49"];
            this._50 = _data["_50"];
            this.comment50 = _data["comment50"];
            this.action50 = _data["action50"];
            this._51 = _data["_51"];
            this.comment51 = _data["comment51"];
            this.action51 = _data["action51"];
            this._52 = _data["_52"];
            this.comment52 = _data["comment52"];
            this.action52 = _data["action52"];
            this._53 = _data["_53"];
            this.comment53 = _data["comment53"];
            this.action53 = _data["action53"];
            this._54 = _data["_54"];
            this.comment54 = _data["comment54"];
            this.action54 = _data["action54"];
            this._55 = _data["_55"];
            this.comment55 = _data["comment55"];
            this.action55 = _data["action55"];
            this._56 = _data["_56"];
            this.comment56 = _data["comment56"];
            this.action56 = _data["action56"];
            this._57 = _data["_57"];
            this.comment57 = _data["comment57"];
            this.action57 = _data["action57"];
            this._58 = _data["_58"];
            this.comment58 = _data["comment58"];
            this.action58 = _data["action58"];
            this._59 = _data["_59"];
            this.comment59 = _data["comment59"];
            this.action59 = _data["action59"];
            this._60 = _data["_60"];
            this.comment60 = _data["comment60"];
            this.action60 = _data["action60"];
            this._61 = _data["_61"];
            this.comment61 = _data["comment61"];
            this.action61 = _data["action61"];
            this._62 = _data["_62"];
            this.comment62 = _data["comment62"];
            this.action62 = _data["action62"];
            this._63 = _data["_63"];
            this.comment63 = _data["comment63"];
            this.action63 = _data["action63"];
            this._64 = _data["_64"];
            this.comment64 = _data["comment64"];
            this.action64 = _data["action64"];
            this._65 = _data["_65"];
            this.comment65 = _data["comment65"];
            this.action65 = _data["action65"];
            this._66 = _data["_66"];
            this.comment66 = _data["comment66"];
            this.action66 = _data["action66"];
            this._67 = _data["_67"];
            this.comment67 = _data["comment67"];
            this.action67 = _data["action67"];
            this.remarks = _data["remarks"];
            this.approved = _data["approved"];
            this.editedBy = _data["editedBy"];
            this.editedDate = _data["editedDate"];
            this.reported = _data["reported"];
            this.store = _data["store"] ? Store5.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): LossControlReview {
        data = typeof data === 'object' ? data : {};
        let result = new LossControlReview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["reviewDate"] = this.reviewDate;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        data["_1"] = this._1;
        data["comment1"] = this.comment1;
        data["action1"] = this.action1;
        data["_2"] = this._2;
        data["comment2"] = this.comment2;
        data["action2"] = this.action2;
        data["_3"] = this._3;
        data["comment3"] = this.comment3;
        data["action3"] = this.action3;
        data["_4"] = this._4;
        data["comment4"] = this.comment4;
        data["action4"] = this.action4;
        data["_5"] = this._5;
        data["comment5"] = this.comment5;
        data["action5"] = this.action5;
        data["_6"] = this._6;
        data["comment6"] = this.comment6;
        data["action6"] = this.action6;
        data["_7"] = this._7;
        data["comment7"] = this.comment7;
        data["action7"] = this.action7;
        data["_8"] = this._8;
        data["comment8"] = this.comment8;
        data["action8"] = this.action8;
        data["_9"] = this._9;
        data["comment9"] = this.comment9;
        data["action9"] = this.action9;
        data["_10"] = this._10;
        data["comment10"] = this.comment10;
        data["action10"] = this.action10;
        data["_11"] = this._11;
        data["comment11"] = this.comment11;
        data["action11"] = this.action11;
        data["_12"] = this._12;
        data["comment12"] = this.comment12;
        data["action12"] = this.action12;
        data["_13"] = this._13;
        data["comment13"] = this.comment13;
        data["action13"] = this.action13;
        data["_14"] = this._14;
        data["comment14"] = this.comment14;
        data["action14"] = this.action14;
        data["_15"] = this._15;
        data["comment15"] = this.comment15;
        data["action15"] = this.action15;
        data["_16"] = this._16;
        data["comment16"] = this.comment16;
        data["action16"] = this.action16;
        data["_17"] = this._17;
        data["comment17"] = this.comment17;
        data["action17"] = this.action17;
        data["_18"] = this._18;
        data["comment18"] = this.comment18;
        data["action18"] = this.action18;
        data["_19"] = this._19;
        data["comment19"] = this.comment19;
        data["action19"] = this.action19;
        data["_20"] = this._20;
        data["comment20"] = this.comment20;
        data["action20"] = this.action20;
        data["_21"] = this._21;
        data["comment21"] = this.comment21;
        data["action21"] = this.action21;
        data["_22"] = this._22;
        data["comment22"] = this.comment22;
        data["action22"] = this.action22;
        data["_23"] = this._23;
        data["comment23"] = this.comment23;
        data["action23"] = this.action23;
        data["_24"] = this._24;
        data["comment24"] = this.comment24;
        data["action24"] = this.action24;
        data["_25"] = this._25;
        data["comment25"] = this.comment25;
        data["action25"] = this.action25;
        data["_26"] = this._26;
        data["comment26"] = this.comment26;
        data["action26"] = this.action26;
        data["_27"] = this._27;
        data["comment27"] = this.comment27;
        data["action27"] = this.action27;
        data["_28"] = this._28;
        data["comment28"] = this.comment28;
        data["action28"] = this.action28;
        data["_29"] = this._29;
        data["comment29"] = this.comment29;
        data["action29"] = this.action29;
        data["_30"] = this._30;
        data["comment30"] = this.comment30;
        data["action30"] = this.action30;
        data["_31"] = this._31;
        data["comment31"] = this.comment31;
        data["action31"] = this.action31;
        data["_32"] = this._32;
        data["comment32"] = this.comment32;
        data["action32"] = this.action32;
        data["_33"] = this._33;
        data["comment33"] = this.comment33;
        data["action33"] = this.action33;
        data["_34"] = this._34;
        data["comment34"] = this.comment34;
        data["action34"] = this.action34;
        data["_35"] = this._35;
        data["comment35"] = this.comment35;
        data["action35"] = this.action35;
        data["_36"] = this._36;
        data["comment36"] = this.comment36;
        data["action36"] = this.action36;
        data["_37"] = this._37;
        data["comment37"] = this.comment37;
        data["action37"] = this.action37;
        data["_38"] = this._38;
        data["comment38"] = this.comment38;
        data["action38"] = this.action38;
        data["_39"] = this._39;
        data["comment39"] = this.comment39;
        data["action39"] = this.action39;
        data["_40"] = this._40;
        data["comment40"] = this.comment40;
        data["action40"] = this.action40;
        data["_41"] = this._41;
        data["comment41"] = this.comment41;
        data["action41"] = this.action41;
        data["_42"] = this._42;
        data["comment42"] = this.comment42;
        data["action42"] = this.action42;
        data["_43"] = this._43;
        data["comment43"] = this.comment43;
        data["action43"] = this.action43;
        data["_44"] = this._44;
        data["comment44"] = this.comment44;
        data["action44"] = this.action44;
        data["_45"] = this._45;
        data["comment45"] = this.comment45;
        data["action45"] = this.action45;
        data["_46"] = this._46;
        data["comment46"] = this.comment46;
        data["action46"] = this.action46;
        data["_47"] = this._47;
        data["comment47"] = this.comment47;
        data["action47"] = this.action47;
        data["_48"] = this._48;
        data["comment48"] = this.comment48;
        data["action48"] = this.action48;
        data["_49"] = this._49;
        data["comment49"] = this.comment49;
        data["action49"] = this.action49;
        data["_50"] = this._50;
        data["comment50"] = this.comment50;
        data["action50"] = this.action50;
        data["_51"] = this._51;
        data["comment51"] = this.comment51;
        data["action51"] = this.action51;
        data["_52"] = this._52;
        data["comment52"] = this.comment52;
        data["action52"] = this.action52;
        data["_53"] = this._53;
        data["comment53"] = this.comment53;
        data["action53"] = this.action53;
        data["_54"] = this._54;
        data["comment54"] = this.comment54;
        data["action54"] = this.action54;
        data["_55"] = this._55;
        data["comment55"] = this.comment55;
        data["action55"] = this.action55;
        data["_56"] = this._56;
        data["comment56"] = this.comment56;
        data["action56"] = this.action56;
        data["_57"] = this._57;
        data["comment57"] = this.comment57;
        data["action57"] = this.action57;
        data["_58"] = this._58;
        data["comment58"] = this.comment58;
        data["action58"] = this.action58;
        data["_59"] = this._59;
        data["comment59"] = this.comment59;
        data["action59"] = this.action59;
        data["_60"] = this._60;
        data["comment60"] = this.comment60;
        data["action60"] = this.action60;
        data["_61"] = this._61;
        data["comment61"] = this.comment61;
        data["action61"] = this.action61;
        data["_62"] = this._62;
        data["comment62"] = this.comment62;
        data["action62"] = this.action62;
        data["_63"] = this._63;
        data["comment63"] = this.comment63;
        data["action63"] = this.action63;
        data["_64"] = this._64;
        data["comment64"] = this.comment64;
        data["action64"] = this.action64;
        data["_65"] = this._65;
        data["comment65"] = this.comment65;
        data["action65"] = this.action65;
        data["_66"] = this._66;
        data["comment66"] = this.comment66;
        data["action66"] = this.action66;
        data["_67"] = this._67;
        data["comment67"] = this.comment67;
        data["action67"] = this.action67;
        data["remarks"] = this.remarks;
        data["approved"] = this.approved;
        data["editedBy"] = this.editedBy;
        data["editedDate"] = this.editedDate;
        data["reported"] = this.reported;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

export interface ILossControlReview {
    id: number;
    storeId?: string | undefined;
    reviewDate: string;
    enteredBy?: string | undefined;
    enteredDate: string;
    _1: boolean;
    comment1?: string | undefined;
    action1?: string | undefined;
    _2: boolean;
    comment2?: string | undefined;
    action2?: string | undefined;
    _3: boolean;
    comment3?: string | undefined;
    action3?: string | undefined;
    _4: boolean;
    comment4?: string | undefined;
    action4?: string | undefined;
    _5: boolean;
    comment5?: string | undefined;
    action5?: string | undefined;
    _6: boolean;
    comment6?: string | undefined;
    action6?: string | undefined;
    _7: boolean;
    comment7?: string | undefined;
    action7?: string | undefined;
    _8: boolean;
    comment8?: string | undefined;
    action8?: string | undefined;
    _9: boolean;
    comment9?: string | undefined;
    action9?: string | undefined;
    _10: boolean;
    comment10?: string | undefined;
    action10?: string | undefined;
    _11: boolean;
    comment11?: string | undefined;
    action11?: string | undefined;
    _12: boolean;
    comment12?: string | undefined;
    action12?: string | undefined;
    _13: boolean;
    comment13?: string | undefined;
    action13?: string | undefined;
    _14: boolean;
    comment14?: string | undefined;
    action14?: string | undefined;
    _15: boolean;
    comment15?: string | undefined;
    action15?: string | undefined;
    _16: boolean;
    comment16?: string | undefined;
    action16?: string | undefined;
    _17: boolean;
    comment17?: string | undefined;
    action17?: string | undefined;
    _18: boolean;
    comment18?: string | undefined;
    action18?: string | undefined;
    _19: boolean;
    comment19?: string | undefined;
    action19?: string | undefined;
    _20: boolean;
    comment20?: string | undefined;
    action20?: string | undefined;
    _21: boolean;
    comment21?: string | undefined;
    action21?: string | undefined;
    _22: boolean;
    comment22?: string | undefined;
    action22?: string | undefined;
    _23: boolean;
    comment23?: string | undefined;
    action23?: string | undefined;
    _24: boolean;
    comment24?: string | undefined;
    action24?: string | undefined;
    _25: boolean;
    comment25?: string | undefined;
    action25?: string | undefined;
    _26: boolean;
    comment26?: string | undefined;
    action26?: string | undefined;
    _27: boolean;
    comment27?: string | undefined;
    action27?: string | undefined;
    _28: boolean;
    comment28?: string | undefined;
    action28?: string | undefined;
    _29: boolean;
    comment29?: string | undefined;
    action29?: string | undefined;
    _30: boolean;
    comment30?: string | undefined;
    action30?: string | undefined;
    _31: boolean;
    comment31?: string | undefined;
    action31?: string | undefined;
    _32: boolean;
    comment32?: string | undefined;
    action32?: string | undefined;
    _33: boolean;
    comment33?: string | undefined;
    action33?: string | undefined;
    _34: boolean;
    comment34?: string | undefined;
    action34?: string | undefined;
    _35: boolean;
    comment35?: string | undefined;
    action35?: string | undefined;
    _36: boolean;
    comment36?: string | undefined;
    action36?: string | undefined;
    _37: boolean;
    comment37?: string | undefined;
    action37?: string | undefined;
    _38: boolean;
    comment38?: string | undefined;
    action38?: string | undefined;
    _39: boolean;
    comment39?: string | undefined;
    action39?: string | undefined;
    _40: boolean;
    comment40?: string | undefined;
    action40?: string | undefined;
    _41: boolean;
    comment41?: string | undefined;
    action41?: string | undefined;
    _42: boolean;
    comment42?: string | undefined;
    action42?: string | undefined;
    _43: boolean;
    comment43?: string | undefined;
    action43?: string | undefined;
    _44: boolean;
    comment44?: string | undefined;
    action44?: string | undefined;
    _45: boolean;
    comment45?: string | undefined;
    action45?: string | undefined;
    _46: boolean;
    comment46?: string | undefined;
    action46?: string | undefined;
    _47: boolean;
    comment47?: string | undefined;
    action47?: string | undefined;
    _48: boolean;
    comment48?: string | undefined;
    action48?: string | undefined;
    _49: boolean;
    comment49?: string | undefined;
    action49?: string | undefined;
    _50: boolean;
    comment50?: string | undefined;
    action50?: string | undefined;
    _51: boolean;
    comment51?: string | undefined;
    action51?: string | undefined;
    _52: boolean;
    comment52?: string | undefined;
    action52?: string | undefined;
    _53: boolean;
    comment53?: string | undefined;
    action53?: string | undefined;
    _54: boolean;
    comment54?: string | undefined;
    action54?: string | undefined;
    _55: boolean;
    comment55?: string | undefined;
    action55?: string | undefined;
    _56: boolean;
    comment56?: string | undefined;
    action56?: string | undefined;
    _57: boolean;
    comment57?: string | undefined;
    action57?: string | undefined;
    _58: boolean;
    comment58?: string | undefined;
    action58?: string | undefined;
    _59: boolean;
    comment59?: string | undefined;
    action59?: string | undefined;
    _60: boolean;
    comment60?: string | undefined;
    action60?: string | undefined;
    _61: boolean;
    comment61?: string | undefined;
    action61?: string | undefined;
    _62: boolean;
    comment62?: string | undefined;
    action62?: string | undefined;
    _63: boolean;
    comment63?: string | undefined;
    action63?: string | undefined;
    _64: boolean;
    comment64?: string | undefined;
    action64?: string | undefined;
    _65: boolean;
    comment65?: string | undefined;
    action65?: string | undefined;
    _66: boolean;
    comment66?: string | undefined;
    action66?: string | undefined;
    _67: boolean;
    comment67?: string | undefined;
    action67?: string | undefined;
    remarks?: string | undefined;
    approved?: boolean | undefined;
    editedBy?: string | undefined;
    editedDate?: string | undefined;
    reported?: boolean | undefined;
    store?: Store5 | undefined;
}

export class Store5 implements IStore5 {
    id?: string | undefined;
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed!: boolean;
    isGRERunning!: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    status?: string | undefined;
    retailSQFeet?: number | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    milesFromCorporate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;
    costCenterType?: string | undefined;

    constructor(data?: IStore5) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.storeMnemonic = _data["storeMnemonic"];
            this.storeMnemonic2 = _data["storeMnemonic2"];
            this.serverName = _data["serverName"];
            this.gredbName = _data["gredbName"];
            this.isClosed = _data["isClosed"];
            this.isGRERunning = _data["isGRERunning"];
            this.storeLogin = _data["storeLogin"];
            this.district = _data["district"];
            this.status = _data["status"];
            this.retailSQFeet = _data["retailSQFeet"];
            this.glNumber = _data["glNumber"];
            this.glCash = _data["glCash"];
            this.glNumber2 = _data["glNumber2"];
            this.sort = _data["sort"];
            this.locationId = _data["locationId"];
            this.milesFromCorporate = _data["milesFromCorporate"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.regionId = _data["regionId"];
            this.email = _data["email"];
            this.dmEmail = _data["dmEmail"];
            this.districtEmail = _data["districtEmail"];
            this.prefix = _data["prefix"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.aaExtension = _data["aaExtension"];
            this.costCenterType = _data["costCenterType"];
        }
    }

    static fromJS(data: any): Store5 {
        data = typeof data === 'object' ? data : {};
        let result = new Store5();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["storeMnemonic"] = this.storeMnemonic;
        data["storeMnemonic2"] = this.storeMnemonic2;
        data["serverName"] = this.serverName;
        data["gredbName"] = this.gredbName;
        data["isClosed"] = this.isClosed;
        data["isGRERunning"] = this.isGRERunning;
        data["storeLogin"] = this.storeLogin;
        data["district"] = this.district;
        data["status"] = this.status;
        data["retailSQFeet"] = this.retailSQFeet;
        data["glNumber"] = this.glNumber;
        data["glCash"] = this.glCash;
        data["glNumber2"] = this.glNumber2;
        data["sort"] = this.sort;
        data["locationId"] = this.locationId;
        data["milesFromCorporate"] = this.milesFromCorporate;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["regionId"] = this.regionId;
        data["email"] = this.email;
        data["dmEmail"] = this.dmEmail;
        data["districtEmail"] = this.districtEmail;
        data["prefix"] = this.prefix;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["aaExtension"] = this.aaExtension;
        data["costCenterType"] = this.costCenterType;
        return data;
    }
}

export interface IStore5 {
    id?: string | undefined;
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed: boolean;
    isGRERunning: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    status?: string | undefined;
    retailSQFeet?: number | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    milesFromCorporate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;
    costCenterType?: string | undefined;
}

export class QueryResultsOfLossControlReviewViewModel implements IQueryResultsOfLossControlReviewViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: LossControlReviewViewModel[] | undefined;

    constructor(data?: IQueryResultsOfLossControlReviewViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(LossControlReviewViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfLossControlReviewViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfLossControlReviewViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfLossControlReviewViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: LossControlReviewViewModel[] | undefined;
}

export class Place implements IPlace {
    id!: number;
    gicwid?: number | undefined;
    placementType?: string | undefined;
    anticipatedRetention!: number;
    placementSubtype?: string | undefined;
    entryDate!: string;
    dateOfHire!: string;
    lastDateOfWork?: string | undefined;
    staffId!: number;
    division!: number;
    jobTitle?: string | undefined;
    startingWage!: number;
    hoursPer1stWeek!: number;
    hoursPer2ndWeek!: number;
    employer?: string | undefined;
    employerContact?: string | undefined;
    employerAddress?: string | undefined;
    employerCity?: string | undefined;
    employerState?: string | undefined;
    employerZip?: string | undefined;
    employerPhone?: string | undefined;
    employerPhoneAlt?: string | undefined;
    employerFax?: string | undefined;
    employerEmail?: string | undefined;
    enteredBy?: number | undefined;
    verifiedDate!: string;
    placementStatus?: string | undefined;
    bonus!: boolean;
    faxVerified!: boolean;
    verificationStatus?: string | undefined;
    weeksWorked?: string | undefined;
    learnedOfPlacement?: string | undefined;
    hireListFromEmployer?: boolean | undefined;
    twnverified?: boolean | undefined;
    staff?: Staff | undefined;
    participant?: ID2 | undefined;

    constructor(data?: IPlace) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gicwid = _data["gicwid"];
            this.placementType = _data["placementType"];
            this.anticipatedRetention = _data["anticipatedRetention"];
            this.placementSubtype = _data["placementSubtype"];
            this.entryDate = _data["entryDate"];
            this.dateOfHire = _data["dateOfHire"];
            this.lastDateOfWork = _data["lastDateOfWork"];
            this.staffId = _data["staffId"];
            this.division = _data["division"];
            this.jobTitle = _data["jobTitle"];
            this.startingWage = _data["startingWage"];
            this.hoursPer1stWeek = _data["hoursPer1stWeek"];
            this.hoursPer2ndWeek = _data["hoursPer2ndWeek"];
            this.employer = _data["employer"];
            this.employerContact = _data["employerContact"];
            this.employerAddress = _data["employerAddress"];
            this.employerCity = _data["employerCity"];
            this.employerState = _data["employerState"];
            this.employerZip = _data["employerZip"];
            this.employerPhone = _data["employerPhone"];
            this.employerPhoneAlt = _data["employerPhoneAlt"];
            this.employerFax = _data["employerFax"];
            this.employerEmail = _data["employerEmail"];
            this.enteredBy = _data["enteredBy"];
            this.verifiedDate = _data["verifiedDate"];
            this.placementStatus = _data["placementStatus"];
            this.bonus = _data["bonus"];
            this.faxVerified = _data["faxVerified"];
            this.verificationStatus = _data["verificationStatus"];
            this.weeksWorked = _data["weeksWorked"];
            this.learnedOfPlacement = _data["learnedOfPlacement"];
            this.hireListFromEmployer = _data["hireListFromEmployer"];
            this.twnverified = _data["twnverified"];
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : <any>undefined;
            this.participant = _data["participant"] ? ID2.fromJS(_data["participant"]) : <any>undefined;
        }
    }

    static fromJS(data: any): Place {
        data = typeof data === 'object' ? data : {};
        let result = new Place();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gicwid"] = this.gicwid;
        data["placementType"] = this.placementType;
        data["anticipatedRetention"] = this.anticipatedRetention;
        data["placementSubtype"] = this.placementSubtype;
        data["entryDate"] = this.entryDate;
        data["dateOfHire"] = this.dateOfHire;
        data["lastDateOfWork"] = this.lastDateOfWork;
        data["staffId"] = this.staffId;
        data["division"] = this.division;
        data["jobTitle"] = this.jobTitle;
        data["startingWage"] = this.startingWage;
        data["hoursPer1stWeek"] = this.hoursPer1stWeek;
        data["hoursPer2ndWeek"] = this.hoursPer2ndWeek;
        data["employer"] = this.employer;
        data["employerContact"] = this.employerContact;
        data["employerAddress"] = this.employerAddress;
        data["employerCity"] = this.employerCity;
        data["employerState"] = this.employerState;
        data["employerZip"] = this.employerZip;
        data["employerPhone"] = this.employerPhone;
        data["employerPhoneAlt"] = this.employerPhoneAlt;
        data["employerFax"] = this.employerFax;
        data["employerEmail"] = this.employerEmail;
        data["enteredBy"] = this.enteredBy;
        data["verifiedDate"] = this.verifiedDate;
        data["placementStatus"] = this.placementStatus;
        data["bonus"] = this.bonus;
        data["faxVerified"] = this.faxVerified;
        data["verificationStatus"] = this.verificationStatus;
        data["weeksWorked"] = this.weeksWorked;
        data["learnedOfPlacement"] = this.learnedOfPlacement;
        data["hireListFromEmployer"] = this.hireListFromEmployer;
        data["twnverified"] = this.twnverified;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        data["participant"] = this.participant ? this.participant.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPlace {
    id: number;
    gicwid?: number | undefined;
    placementType?: string | undefined;
    anticipatedRetention: number;
    placementSubtype?: string | undefined;
    entryDate: string;
    dateOfHire: string;
    lastDateOfWork?: string | undefined;
    staffId: number;
    division: number;
    jobTitle?: string | undefined;
    startingWage: number;
    hoursPer1stWeek: number;
    hoursPer2ndWeek: number;
    employer?: string | undefined;
    employerContact?: string | undefined;
    employerAddress?: string | undefined;
    employerCity?: string | undefined;
    employerState?: string | undefined;
    employerZip?: string | undefined;
    employerPhone?: string | undefined;
    employerPhoneAlt?: string | undefined;
    employerFax?: string | undefined;
    employerEmail?: string | undefined;
    enteredBy?: number | undefined;
    verifiedDate: string;
    placementStatus?: string | undefined;
    bonus: boolean;
    faxVerified: boolean;
    verificationStatus?: string | undefined;
    weeksWorked?: string | undefined;
    learnedOfPlacement?: string | undefined;
    hireListFromEmployer?: boolean | undefined;
    twnverified?: boolean | undefined;
    staff?: Staff | undefined;
    participant?: ID2 | undefined;
}

export class ID2 implements IID2 {
    id!: number;
    ssn?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    preferredName?: string | undefined;
    division!: number;
    entryDate?: string | undefined;
    status?: number | undefined;
    intakeStatus?: string | undefined;
    intakeGeneralist!: number;
    employmentSpecialists!: number;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    phone?: string | undefined;
    phoneCarrier?: string | undefined;
    alternatePhone?: string | undefined;
    email?: string | undefined;
    birthYear?: number | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    primaryDisability?: string | undefined;
    secondaryDisability?: string | undefined;
    tertiaryDisability?: string | undefined;
    quaternaryDisability?: string | undefined;
    primaryLanguageSpanish?: boolean | undefined;
    referralCounselor?: number | undefined;
    vocGoal1?: string | undefined;
    vocGoal2?: string | undefined;
    requiredWage?: number | undefined;
    acceptableShifts?: string | undefined;
    preferredDaystoWork?: string | undefined;
    continuedEd?: string | undefined;
    needsCareerCenter?: boolean | undefined;
    needsEsl?: boolean | undefined;
    transportation?: string | undefined;
    needsTransportation?: boolean | undefined;
    needsClothing?: boolean | undefined;
    needsChildCare?: boolean | undefined;
    needsHousing?: boolean | undefined;
    needsFood?: boolean | undefined;
    canPassDrugScreen?: boolean | undefined;
    criminalRecord?: string | undefined;
    probationOfficer?: string | undefined;
    probationOfficerPhone?: string | undefined;
    needsMedicalReferral?: boolean | undefined;
    needsMentalHealthReferral?: boolean | undefined;
    callBackDate?: string | undefined;
    quickNote?: string | undefined;
    isLocked?: boolean | undefined;
    lockedBy?: string | undefined;
    searchable?: string | undefined;
    referralDetails?: ReferralDetail[] | undefined;
    caseNoteCommunities?: CaseNoteCommunity[] | undefined;
    employmentHistories?: EmploymentHistory[] | undefined;
    serviceProvideds?: ServiceProvided[] | undefined;
    places?: Place[] | undefined;
    servicePeriods?: ServicePeriod[] | undefined;
    location?: Location | undefined;
    staff?: Staff | undefined;
    referral?: JCSReferredBy | undefined;

    constructor(data?: IID2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.ssn = _data["ssn"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.middleName = _data["middleName"];
            this.preferredName = _data["preferredName"];
            this.division = _data["division"];
            this.entryDate = _data["entryDate"];
            this.status = _data["status"];
            this.intakeStatus = _data["intakeStatus"];
            this.intakeGeneralist = _data["intakeGeneralist"];
            this.employmentSpecialists = _data["employmentSpecialists"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.phone = _data["phone"];
            this.phoneCarrier = _data["phoneCarrier"];
            this.alternatePhone = _data["alternatePhone"];
            this.email = _data["email"];
            this.birthYear = _data["birthYear"];
            this.gender = _data["gender"];
            this.ethnicity = _data["ethnicity"];
            this.primaryDisability = _data["primaryDisability"];
            this.secondaryDisability = _data["secondaryDisability"];
            this.tertiaryDisability = _data["tertiaryDisability"];
            this.quaternaryDisability = _data["quaternaryDisability"];
            this.primaryLanguageSpanish = _data["primaryLanguageSpanish"];
            this.referralCounselor = _data["referralCounselor"];
            this.vocGoal1 = _data["vocGoal1"];
            this.vocGoal2 = _data["vocGoal2"];
            this.requiredWage = _data["requiredWage"];
            this.acceptableShifts = _data["acceptableShifts"];
            this.preferredDaystoWork = _data["preferredDaystoWork"];
            this.continuedEd = _data["continuedEd"];
            this.needsCareerCenter = _data["needsCareerCenter"];
            this.needsEsl = _data["needsEsl"];
            this.transportation = _data["transportation"];
            this.needsTransportation = _data["needsTransportation"];
            this.needsClothing = _data["needsClothing"];
            this.needsChildCare = _data["needsChildCare"];
            this.needsHousing = _data["needsHousing"];
            this.needsFood = _data["needsFood"];
            this.canPassDrugScreen = _data["canPassDrugScreen"];
            this.criminalRecord = _data["criminalRecord"];
            this.probationOfficer = _data["probationOfficer"];
            this.probationOfficerPhone = _data["probationOfficerPhone"];
            this.needsMedicalReferral = _data["needsMedicalReferral"];
            this.needsMentalHealthReferral = _data["needsMentalHealthReferral"];
            this.callBackDate = _data["callBackDate"];
            this.quickNote = _data["quickNote"];
            this.isLocked = _data["isLocked"];
            this.lockedBy = _data["lockedBy"];
            this.searchable = _data["searchable"];
            if (Array.isArray(_data["referralDetails"])) {
                this.referralDetails = [] as any;
                for (let item of _data["referralDetails"])
                    this.referralDetails!.push(ReferralDetail.fromJS(item));
            }
            if (Array.isArray(_data["caseNoteCommunities"])) {
                this.caseNoteCommunities = [] as any;
                for (let item of _data["caseNoteCommunities"])
                    this.caseNoteCommunities!.push(CaseNoteCommunity.fromJS(item));
            }
            if (Array.isArray(_data["employmentHistories"])) {
                this.employmentHistories = [] as any;
                for (let item of _data["employmentHistories"])
                    this.employmentHistories!.push(EmploymentHistory.fromJS(item));
            }
            if (Array.isArray(_data["serviceProvideds"])) {
                this.serviceProvideds = [] as any;
                for (let item of _data["serviceProvideds"])
                    this.serviceProvideds!.push(ServiceProvided.fromJS(item));
            }
            if (Array.isArray(_data["places"])) {
                this.places = [] as any;
                for (let item of _data["places"])
                    this.places!.push(Place.fromJS(item));
            }
            if (Array.isArray(_data["servicePeriods"])) {
                this.servicePeriods = [] as any;
                for (let item of _data["servicePeriods"])
                    this.servicePeriods!.push(ServicePeriod.fromJS(item));
            }
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : <any>undefined;
            this.referral = _data["referral"] ? JCSReferredBy.fromJS(_data["referral"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ID2 {
        data = typeof data === 'object' ? data : {};
        let result = new ID2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["ssn"] = this.ssn;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["middleName"] = this.middleName;
        data["preferredName"] = this.preferredName;
        data["division"] = this.division;
        data["entryDate"] = this.entryDate;
        data["status"] = this.status;
        data["intakeStatus"] = this.intakeStatus;
        data["intakeGeneralist"] = this.intakeGeneralist;
        data["employmentSpecialists"] = this.employmentSpecialists;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["phone"] = this.phone;
        data["phoneCarrier"] = this.phoneCarrier;
        data["alternatePhone"] = this.alternatePhone;
        data["email"] = this.email;
        data["birthYear"] = this.birthYear;
        data["gender"] = this.gender;
        data["ethnicity"] = this.ethnicity;
        data["primaryDisability"] = this.primaryDisability;
        data["secondaryDisability"] = this.secondaryDisability;
        data["tertiaryDisability"] = this.tertiaryDisability;
        data["quaternaryDisability"] = this.quaternaryDisability;
        data["primaryLanguageSpanish"] = this.primaryLanguageSpanish;
        data["referralCounselor"] = this.referralCounselor;
        data["vocGoal1"] = this.vocGoal1;
        data["vocGoal2"] = this.vocGoal2;
        data["requiredWage"] = this.requiredWage;
        data["acceptableShifts"] = this.acceptableShifts;
        data["preferredDaystoWork"] = this.preferredDaystoWork;
        data["continuedEd"] = this.continuedEd;
        data["needsCareerCenter"] = this.needsCareerCenter;
        data["needsEsl"] = this.needsEsl;
        data["transportation"] = this.transportation;
        data["needsTransportation"] = this.needsTransportation;
        data["needsClothing"] = this.needsClothing;
        data["needsChildCare"] = this.needsChildCare;
        data["needsHousing"] = this.needsHousing;
        data["needsFood"] = this.needsFood;
        data["canPassDrugScreen"] = this.canPassDrugScreen;
        data["criminalRecord"] = this.criminalRecord;
        data["probationOfficer"] = this.probationOfficer;
        data["probationOfficerPhone"] = this.probationOfficerPhone;
        data["needsMedicalReferral"] = this.needsMedicalReferral;
        data["needsMentalHealthReferral"] = this.needsMentalHealthReferral;
        data["callBackDate"] = this.callBackDate;
        data["quickNote"] = this.quickNote;
        data["isLocked"] = this.isLocked;
        data["lockedBy"] = this.lockedBy;
        data["searchable"] = this.searchable;
        if (Array.isArray(this.referralDetails)) {
            data["referralDetails"] = [];
            for (let item of this.referralDetails)
                data["referralDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.caseNoteCommunities)) {
            data["caseNoteCommunities"] = [];
            for (let item of this.caseNoteCommunities)
                data["caseNoteCommunities"].push(item.toJSON());
        }
        if (Array.isArray(this.employmentHistories)) {
            data["employmentHistories"] = [];
            for (let item of this.employmentHistories)
                data["employmentHistories"].push(item.toJSON());
        }
        if (Array.isArray(this.serviceProvideds)) {
            data["serviceProvideds"] = [];
            for (let item of this.serviceProvideds)
                data["serviceProvideds"].push(item.toJSON());
        }
        if (Array.isArray(this.places)) {
            data["places"] = [];
            for (let item of this.places)
                data["places"].push(item.toJSON());
        }
        if (Array.isArray(this.servicePeriods)) {
            data["servicePeriods"] = [];
            for (let item of this.servicePeriods)
                data["servicePeriods"].push(item.toJSON());
        }
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        data["referral"] = this.referral ? this.referral.toJSON() : <any>undefined;
        return data;
    }
}

export interface IID2 {
    id: number;
    ssn?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
    middleName?: string | undefined;
    preferredName?: string | undefined;
    division: number;
    entryDate?: string | undefined;
    status?: number | undefined;
    intakeStatus?: string | undefined;
    intakeGeneralist: number;
    employmentSpecialists: number;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    phone?: string | undefined;
    phoneCarrier?: string | undefined;
    alternatePhone?: string | undefined;
    email?: string | undefined;
    birthYear?: number | undefined;
    gender?: string | undefined;
    ethnicity?: string | undefined;
    primaryDisability?: string | undefined;
    secondaryDisability?: string | undefined;
    tertiaryDisability?: string | undefined;
    quaternaryDisability?: string | undefined;
    primaryLanguageSpanish?: boolean | undefined;
    referralCounselor?: number | undefined;
    vocGoal1?: string | undefined;
    vocGoal2?: string | undefined;
    requiredWage?: number | undefined;
    acceptableShifts?: string | undefined;
    preferredDaystoWork?: string | undefined;
    continuedEd?: string | undefined;
    needsCareerCenter?: boolean | undefined;
    needsEsl?: boolean | undefined;
    transportation?: string | undefined;
    needsTransportation?: boolean | undefined;
    needsClothing?: boolean | undefined;
    needsChildCare?: boolean | undefined;
    needsHousing?: boolean | undefined;
    needsFood?: boolean | undefined;
    canPassDrugScreen?: boolean | undefined;
    criminalRecord?: string | undefined;
    probationOfficer?: string | undefined;
    probationOfficerPhone?: string | undefined;
    needsMedicalReferral?: boolean | undefined;
    needsMentalHealthReferral?: boolean | undefined;
    callBackDate?: string | undefined;
    quickNote?: string | undefined;
    isLocked?: boolean | undefined;
    lockedBy?: string | undefined;
    searchable?: string | undefined;
    referralDetails?: ReferralDetail[] | undefined;
    caseNoteCommunities?: CaseNoteCommunity[] | undefined;
    employmentHistories?: EmploymentHistory[] | undefined;
    serviceProvideds?: ServiceProvided[] | undefined;
    places?: Place[] | undefined;
    servicePeriods?: ServicePeriod[] | undefined;
    location?: Location | undefined;
    staff?: Staff | undefined;
    referral?: JCSReferredBy | undefined;
}

export class ReferralDetail extends EntityBase implements IReferralDetail {
    gicwId!: number;
    amplocationId!: number;
    enteredBy?: string | undefined;
    enteredDate!: string;

    constructor(data?: IReferralDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.gicwId = _data["gicwId"];
            this.amplocationId = _data["amplocationId"];
            this.enteredBy = _data["enteredBy"];
            this.enteredDate = _data["enteredDate"];
        }
    }

    static fromJS(data: any): ReferralDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gicwId"] = this.gicwId;
        data["amplocationId"] = this.amplocationId;
        data["enteredBy"] = this.enteredBy;
        data["enteredDate"] = this.enteredDate;
        super.toJSON(data);
        return data;
    }
}

export interface IReferralDetail extends IEntityBase {
    gicwId: number;
    amplocationId: number;
    enteredBy?: string | undefined;
    enteredDate: string;
}

export class CaseNoteCommunity extends EntityBase implements ICaseNoteCommunity {
    gicwid!: number;
    date!: string;
    caseNote?: string | undefined;
    enteredBy?: string | undefined;
    entryDate!: string;

    constructor(data?: ICaseNoteCommunity) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.gicwid = _data["gicwid"];
            this.date = _data["date"];
            this.caseNote = _data["caseNote"];
            this.enteredBy = _data["enteredBy"];
            this.entryDate = _data["entryDate"];
        }
    }

    static fromJS(data: any): CaseNoteCommunity {
        data = typeof data === 'object' ? data : {};
        let result = new CaseNoteCommunity();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gicwid"] = this.gicwid;
        data["date"] = this.date;
        data["caseNote"] = this.caseNote;
        data["enteredBy"] = this.enteredBy;
        data["entryDate"] = this.entryDate;
        super.toJSON(data);
        return data;
    }
}

export interface ICaseNoteCommunity extends IEntityBase {
    gicwid: number;
    date: string;
    caseNote?: string | undefined;
    enteredBy?: string | undefined;
    entryDate: string;
}

export class ServiceProvided implements IServiceProvided {
    id!: number;
    gicwId!: number;
    staffId!: number;
    locationId!: number;
    serviceProvided1?: string | undefined;
    serviceProvidedDate!: string;
    quantity!: number;
    serviceDescriptionId!: number;
    dataEntryDate!: string;
    enteredBy?: string | undefined;
    clothingCardNumber?: string | undefined;
    gicw?: ID2 | undefined;
    staff?: Staff | undefined;
    jcentityLocation?: JcentityLocation | undefined;
    serviceDescription?: ServiceDescription | undefined;

    constructor(data?: IServiceProvided) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gicwId = _data["gicwId"];
            this.staffId = _data["staffId"];
            this.locationId = _data["locationId"];
            this.serviceProvided1 = _data["serviceProvided1"];
            this.serviceProvidedDate = _data["serviceProvidedDate"];
            this.quantity = _data["quantity"];
            this.serviceDescriptionId = _data["serviceDescriptionId"];
            this.dataEntryDate = _data["dataEntryDate"];
            this.enteredBy = _data["enteredBy"];
            this.clothingCardNumber = _data["clothingCardNumber"];
            this.gicw = _data["gicw"] ? ID2.fromJS(_data["gicw"]) : <any>undefined;
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : <any>undefined;
            this.jcentityLocation = _data["jcentityLocation"] ? JcentityLocation.fromJS(_data["jcentityLocation"]) : <any>undefined;
            this.serviceDescription = _data["serviceDescription"] ? ServiceDescription.fromJS(_data["serviceDescription"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceProvided {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceProvided();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gicwId"] = this.gicwId;
        data["staffId"] = this.staffId;
        data["locationId"] = this.locationId;
        data["serviceProvided1"] = this.serviceProvided1;
        data["serviceProvidedDate"] = this.serviceProvidedDate;
        data["quantity"] = this.quantity;
        data["serviceDescriptionId"] = this.serviceDescriptionId;
        data["dataEntryDate"] = this.dataEntryDate;
        data["enteredBy"] = this.enteredBy;
        data["clothingCardNumber"] = this.clothingCardNumber;
        data["gicw"] = this.gicw ? this.gicw.toJSON() : <any>undefined;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        data["jcentityLocation"] = this.jcentityLocation ? this.jcentityLocation.toJSON() : <any>undefined;
        data["serviceDescription"] = this.serviceDescription ? this.serviceDescription.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceProvided {
    id: number;
    gicwId: number;
    staffId: number;
    locationId: number;
    serviceProvided1?: string | undefined;
    serviceProvidedDate: string;
    quantity: number;
    serviceDescriptionId: number;
    dataEntryDate: string;
    enteredBy?: string | undefined;
    clothingCardNumber?: string | undefined;
    gicw?: ID2 | undefined;
    staff?: Staff | undefined;
    jcentityLocation?: JcentityLocation | undefined;
    serviceDescription?: ServiceDescription | undefined;
}

export class ServiceDescription implements IServiceDescription {
    id!: number;
    serviceType?: string | undefined;
    serviceDescription1?: string | undefined;
    sortType?: number | undefined;
    sortDescription?: number | undefined;
    serviceProvideds?: ServiceProvided[] | undefined;

    constructor(data?: IServiceDescription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceType = _data["serviceType"];
            this.serviceDescription1 = _data["serviceDescription1"];
            this.sortType = _data["sortType"];
            this.sortDescription = _data["sortDescription"];
            if (Array.isArray(_data["serviceProvideds"])) {
                this.serviceProvideds = [] as any;
                for (let item of _data["serviceProvideds"])
                    this.serviceProvideds!.push(ServiceProvided.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ServiceDescription {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDescription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceType"] = this.serviceType;
        data["serviceDescription1"] = this.serviceDescription1;
        data["sortType"] = this.sortType;
        data["sortDescription"] = this.sortDescription;
        if (Array.isArray(this.serviceProvideds)) {
            data["serviceProvideds"] = [];
            for (let item of this.serviceProvideds)
                data["serviceProvideds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IServiceDescription {
    id: number;
    serviceType?: string | undefined;
    serviceDescription1?: string | undefined;
    sortType?: number | undefined;
    sortDescription?: number | undefined;
    serviceProvideds?: ServiceProvided[] | undefined;
}

export class ServicePeriod implements IServicePeriod {
    id!: number;
    serviceStartDate!: string;
    interruptComment?: string | undefined;
    serviceEndDate?: string | undefined;
    esprovidingService?: number | undefined;
    enteredBy?: string | undefined;
    dateEntered?: string | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: string | undefined;
    _ID!: number;
    identity?: ID2 | undefined;
    staff?: Staff | undefined;

    constructor(data?: IServicePeriod) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceStartDate = _data["serviceStartDate"];
            this.interruptComment = _data["interruptComment"];
            this.serviceEndDate = _data["serviceEndDate"];
            this.esprovidingService = _data["esprovidingService"];
            this.enteredBy = _data["enteredBy"];
            this.dateEntered = _data["dateEntered"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"];
            this._ID = _data["_ID"];
            this.identity = _data["identity"] ? ID2.fromJS(_data["identity"]) : <any>undefined;
            this.staff = _data["staff"] ? Staff.fromJS(_data["staff"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServicePeriod {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePeriod();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceStartDate"] = this.serviceStartDate;
        data["interruptComment"] = this.interruptComment;
        data["serviceEndDate"] = this.serviceEndDate;
        data["esprovidingService"] = this.esprovidingService;
        data["enteredBy"] = this.enteredBy;
        data["dateEntered"] = this.dateEntered;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate;
        data["_ID"] = this._ID;
        data["identity"] = this.identity ? this.identity.toJSON() : <any>undefined;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServicePeriod {
    id: number;
    serviceStartDate: string;
    interruptComment?: string | undefined;
    serviceEndDate?: string | undefined;
    esprovidingService?: number | undefined;
    enteredBy?: string | undefined;
    dateEntered?: string | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: string | undefined;
    _ID: number;
    identity?: ID2 | undefined;
    staff?: Staff | undefined;
}

export class JCSReferredBy extends EntityBase implements IJCSReferredBy {
    name?: string | undefined;

    constructor(data?: IJCSReferredBy) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): JCSReferredBy {
        data = typeof data === 'object' ? data : {};
        let result = new JCSReferredBy();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        super.toJSON(data);
        return data;
    }
}

export interface IJCSReferredBy extends IEntityBase {
    name?: string | undefined;
}

export class QueryResultsOfPlaceViewModel implements IQueryResultsOfPlaceViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: PlaceViewModel[] | undefined;

    constructor(data?: IQueryResultsOfPlaceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(PlaceViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfPlaceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfPlaceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfPlaceViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: PlaceViewModel[] | undefined;
}

export class PlaceViewModel implements IPlaceViewModel {
    id?: string | undefined;
    gicwid?: number | undefined;
    placementType?: string | undefined;
    anticipatedRetention!: number;
    placementSubtype?: string | undefined;
    entryDate!: string;
    dateOfHire!: string;
    lastDateOfWork?: string | undefined;
    staffId!: number;
    division!: number;
    jobTitle?: string | undefined;
    startingWage!: number;
    hoursPer1stWeek!: number;
    hoursPer2ndWeek!: number;
    employer?: string | undefined;
    employerContact?: string | undefined;
    employerAddress?: string | undefined;
    employerCity?: string | undefined;
    employerState?: string | undefined;
    employerZip?: string | undefined;
    employerPhone?: string | undefined;
    employerPhoneAlt?: string | undefined;
    employerFax?: string | undefined;
    employerEmail?: string | undefined;
    enteredBy?: number | undefined;
    verifiedDate!: string;
    placementStatus?: string | undefined;
    bonus!: boolean;
    faxVerified!: boolean;
    verificationStatus?: string | undefined;
    weeksWorked?: string | undefined;
    learnedOfPlacement?: string | undefined;
    hireListFromEmployer?: boolean | undefined;
    twnverified?: boolean | undefined;
    name?: string | undefined;

    constructor(data?: IPlaceViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gicwid = _data["gicwid"];
            this.placementType = _data["placementType"];
            this.anticipatedRetention = _data["anticipatedRetention"];
            this.placementSubtype = _data["placementSubtype"];
            this.entryDate = _data["entryDate"];
            this.dateOfHire = _data["dateOfHire"];
            this.lastDateOfWork = _data["lastDateOfWork"];
            this.staffId = _data["staffId"];
            this.division = _data["division"];
            this.jobTitle = _data["jobTitle"];
            this.startingWage = _data["startingWage"];
            this.hoursPer1stWeek = _data["hoursPer1stWeek"];
            this.hoursPer2ndWeek = _data["hoursPer2ndWeek"];
            this.employer = _data["employer"];
            this.employerContact = _data["employerContact"];
            this.employerAddress = _data["employerAddress"];
            this.employerCity = _data["employerCity"];
            this.employerState = _data["employerState"];
            this.employerZip = _data["employerZip"];
            this.employerPhone = _data["employerPhone"];
            this.employerPhoneAlt = _data["employerPhoneAlt"];
            this.employerFax = _data["employerFax"];
            this.employerEmail = _data["employerEmail"];
            this.enteredBy = _data["enteredBy"];
            this.verifiedDate = _data["verifiedDate"];
            this.placementStatus = _data["placementStatus"];
            this.bonus = _data["bonus"];
            this.faxVerified = _data["faxVerified"];
            this.verificationStatus = _data["verificationStatus"];
            this.weeksWorked = _data["weeksWorked"];
            this.learnedOfPlacement = _data["learnedOfPlacement"];
            this.hireListFromEmployer = _data["hireListFromEmployer"];
            this.twnverified = _data["twnverified"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PlaceViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PlaceViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gicwid"] = this.gicwid;
        data["placementType"] = this.placementType;
        data["anticipatedRetention"] = this.anticipatedRetention;
        data["placementSubtype"] = this.placementSubtype;
        data["entryDate"] = this.entryDate;
        data["dateOfHire"] = this.dateOfHire;
        data["lastDateOfWork"] = this.lastDateOfWork;
        data["staffId"] = this.staffId;
        data["division"] = this.division;
        data["jobTitle"] = this.jobTitle;
        data["startingWage"] = this.startingWage;
        data["hoursPer1stWeek"] = this.hoursPer1stWeek;
        data["hoursPer2ndWeek"] = this.hoursPer2ndWeek;
        data["employer"] = this.employer;
        data["employerContact"] = this.employerContact;
        data["employerAddress"] = this.employerAddress;
        data["employerCity"] = this.employerCity;
        data["employerState"] = this.employerState;
        data["employerZip"] = this.employerZip;
        data["employerPhone"] = this.employerPhone;
        data["employerPhoneAlt"] = this.employerPhoneAlt;
        data["employerFax"] = this.employerFax;
        data["employerEmail"] = this.employerEmail;
        data["enteredBy"] = this.enteredBy;
        data["verifiedDate"] = this.verifiedDate;
        data["placementStatus"] = this.placementStatus;
        data["bonus"] = this.bonus;
        data["faxVerified"] = this.faxVerified;
        data["verificationStatus"] = this.verificationStatus;
        data["weeksWorked"] = this.weeksWorked;
        data["learnedOfPlacement"] = this.learnedOfPlacement;
        data["hireListFromEmployer"] = this.hireListFromEmployer;
        data["twnverified"] = this.twnverified;
        data["name"] = this.name;
        return data;
    }
}

export interface IPlaceViewModel {
    id?: string | undefined;
    gicwid?: number | undefined;
    placementType?: string | undefined;
    anticipatedRetention: number;
    placementSubtype?: string | undefined;
    entryDate: string;
    dateOfHire: string;
    lastDateOfWork?: string | undefined;
    staffId: number;
    division: number;
    jobTitle?: string | undefined;
    startingWage: number;
    hoursPer1stWeek: number;
    hoursPer2ndWeek: number;
    employer?: string | undefined;
    employerContact?: string | undefined;
    employerAddress?: string | undefined;
    employerCity?: string | undefined;
    employerState?: string | undefined;
    employerZip?: string | undefined;
    employerPhone?: string | undefined;
    employerPhoneAlt?: string | undefined;
    employerFax?: string | undefined;
    employerEmail?: string | undefined;
    enteredBy?: number | undefined;
    verifiedDate: string;
    placementStatus?: string | undefined;
    bonus: boolean;
    faxVerified: boolean;
    verificationStatus?: string | undefined;
    weeksWorked?: string | undefined;
    learnedOfPlacement?: string | undefined;
    hireListFromEmployer?: boolean | undefined;
    twnverified?: boolean | undefined;
    name?: string | undefined;
}

export class QueryResultsOfProduct implements IQueryResultsOfProduct {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Product[] | undefined;

    constructor(data?: IQueryResultsOfProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Product.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfProduct {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfProduct {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Product[] | undefined;
}

export class ProductionBudgetViewModel implements IProductionBudgetViewModel {
    id!: number;
    storeId?: string | undefined;
    year!: number;
    month!: number;
    _501!: number;
    _502!: number;
    _503!: number;
    _504!: number;
    _505!: number;
    _506!: number;
    _509!: number;
    _516!: number;
    _517!: number;
    updateBy?: string | undefined;
    updatedDate!: string;
    district?: string | undefined;

    constructor(data?: IProductionBudgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this._501 = _data["_501"];
            this._502 = _data["_502"];
            this._503 = _data["_503"];
            this._504 = _data["_504"];
            this._505 = _data["_505"];
            this._506 = _data["_506"];
            this._509 = _data["_509"];
            this._516 = _data["_516"];
            this._517 = _data["_517"];
            this.updateBy = _data["updateBy"];
            this.updatedDate = _data["updatedDate"];
            this.district = _data["district"];
        }
    }

    static fromJS(data: any): ProductionBudgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionBudgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["_501"] = this._501;
        data["_502"] = this._502;
        data["_503"] = this._503;
        data["_504"] = this._504;
        data["_505"] = this._505;
        data["_506"] = this._506;
        data["_509"] = this._509;
        data["_516"] = this._516;
        data["_517"] = this._517;
        data["updateBy"] = this.updateBy;
        data["updatedDate"] = this.updatedDate;
        data["district"] = this.district;
        return data;
    }
}

export interface IProductionBudgetViewModel {
    id: number;
    storeId?: string | undefined;
    year: number;
    month: number;
    _501: number;
    _502: number;
    _503: number;
    _504: number;
    _505: number;
    _506: number;
    _509: number;
    _516: number;
    _517: number;
    updateBy?: string | undefined;
    updatedDate: string;
    district?: string | undefined;
}

export class QueryResultsOfProductionBudgetViewModel implements IQueryResultsOfProductionBudgetViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ProductionBudgetViewModel[] | undefined;

    constructor(data?: IQueryResultsOfProductionBudgetViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ProductionBudgetViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfProductionBudgetViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfProductionBudgetViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfProductionBudgetViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ProductionBudgetViewModel[] | undefined;
}

export class ProductionBudgetSavingModel implements IProductionBudgetSavingModel {
    id!: number;
    storeId?: string | undefined;
    year!: number;
    month!: number;
    _501!: number;
    _502!: number;
    _503!: number;
    _504!: number;
    _505!: number;
    _506!: number;
    _509!: number;
    _516!: number;
    _517!: number;
    updateBy?: string | undefined;
    updatedDate!: string;
    district?: string | undefined;

    constructor(data?: IProductionBudgetSavingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.year = _data["year"];
            this.month = _data["month"];
            this._501 = _data["_501"];
            this._502 = _data["_502"];
            this._503 = _data["_503"];
            this._504 = _data["_504"];
            this._505 = _data["_505"];
            this._506 = _data["_506"];
            this._509 = _data["_509"];
            this._516 = _data["_516"];
            this._517 = _data["_517"];
            this.updateBy = _data["updateBy"];
            this.updatedDate = _data["updatedDate"];
            this.district = _data["district"];
        }
    }

    static fromJS(data: any): ProductionBudgetSavingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProductionBudgetSavingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["year"] = this.year;
        data["month"] = this.month;
        data["_501"] = this._501;
        data["_502"] = this._502;
        data["_503"] = this._503;
        data["_504"] = this._504;
        data["_505"] = this._505;
        data["_506"] = this._506;
        data["_509"] = this._509;
        data["_516"] = this._516;
        data["_517"] = this._517;
        data["updateBy"] = this.updateBy;
        data["updatedDate"] = this.updatedDate;
        data["district"] = this.district;
        return data;
    }
}

export interface IProductionBudgetSavingModel {
    id: number;
    storeId?: string | undefined;
    year: number;
    month: number;
    _501: number;
    _502: number;
    _503: number;
    _504: number;
    _505: number;
    _506: number;
    _509: number;
    _516: number;
    _517: number;
    updateBy?: string | undefined;
    updatedDate: string;
    district?: string | undefined;
}

export class QueryResultsOfReferralViewModel implements IQueryResultsOfReferralViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ReferralViewModel[] | undefined;

    constructor(data?: IQueryResultsOfReferralViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ReferralViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfReferralViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfReferralViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfReferralViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ReferralViewModel[] | undefined;
}

export class ReferralViewModel implements IReferralViewModel {
    id!: number;
    referralInfo?: string | undefined;

    constructor(data?: IReferralViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.referralInfo = _data["referralInfo"];
        }
    }

    static fromJS(data: any): ReferralViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ReferralViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["referralInfo"] = this.referralInfo;
        return data;
    }
}

export interface IReferralViewModel {
    id: number;
    referralInfo?: string | undefined;
}

export class ReserveFundLog implements IReserveFundLog {
    id!: number;
    storeId?: string | undefined;
    employeeNumber?: string | undefined;
    dateTime!: string;
    amountOut!: number;
    amountIn!: number;
    balance!: number;
    cpu!: number;
    cashPickups?: boolean | undefined;
    bankChangeOrders?: boolean | undefined;
    cashierChange?: boolean | undefined;
    depositArmoredPickup?: boolean | undefined;
    verifySafeFund?: boolean | undefined;
    cashier?: string | undefined;
    pennies!: boolean;
    nickles!: boolean;
    dimes!: boolean;
    quarters!: boolean;
    ones!: boolean;
    fives!: boolean;
    comment?: string | undefined;
    enteredby?: string | undefined;
    store?: Store5 | undefined;

    constructor(data?: IReserveFundLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.employeeNumber = _data["employeeNumber"];
            this.dateTime = _data["dateTime"];
            this.amountOut = _data["amountOut"];
            this.amountIn = _data["amountIn"];
            this.balance = _data["balance"];
            this.cpu = _data["cpu"];
            this.cashPickups = _data["cashPickups"];
            this.bankChangeOrders = _data["bankChangeOrders"];
            this.cashierChange = _data["cashierChange"];
            this.depositArmoredPickup = _data["depositArmoredPickup"];
            this.verifySafeFund = _data["verifySafeFund"];
            this.cashier = _data["cashier"];
            this.pennies = _data["pennies"];
            this.nickles = _data["nickles"];
            this.dimes = _data["dimes"];
            this.quarters = _data["quarters"];
            this.ones = _data["ones"];
            this.fives = _data["fives"];
            this.comment = _data["comment"];
            this.enteredby = _data["enteredby"];
            this.store = _data["store"] ? Store5.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ReserveFundLog {
        data = typeof data === 'object' ? data : {};
        let result = new ReserveFundLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["employeeNumber"] = this.employeeNumber;
        data["dateTime"] = this.dateTime;
        data["amountOut"] = this.amountOut;
        data["amountIn"] = this.amountIn;
        data["balance"] = this.balance;
        data["cpu"] = this.cpu;
        data["cashPickups"] = this.cashPickups;
        data["bankChangeOrders"] = this.bankChangeOrders;
        data["cashierChange"] = this.cashierChange;
        data["depositArmoredPickup"] = this.depositArmoredPickup;
        data["verifySafeFund"] = this.verifySafeFund;
        data["cashier"] = this.cashier;
        data["pennies"] = this.pennies;
        data["nickles"] = this.nickles;
        data["dimes"] = this.dimes;
        data["quarters"] = this.quarters;
        data["ones"] = this.ones;
        data["fives"] = this.fives;
        data["comment"] = this.comment;
        data["enteredby"] = this.enteredby;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

export interface IReserveFundLog {
    id: number;
    storeId?: string | undefined;
    employeeNumber?: string | undefined;
    dateTime: string;
    amountOut: number;
    amountIn: number;
    balance: number;
    cpu: number;
    cashPickups?: boolean | undefined;
    bankChangeOrders?: boolean | undefined;
    cashierChange?: boolean | undefined;
    depositArmoredPickup?: boolean | undefined;
    verifySafeFund?: boolean | undefined;
    cashier?: string | undefined;
    pennies: boolean;
    nickles: boolean;
    dimes: boolean;
    quarters: boolean;
    ones: boolean;
    fives: boolean;
    comment?: string | undefined;
    enteredby?: string | undefined;
    store?: Store5 | undefined;
}

export class QueryResultsOfReserveFundLog implements IQueryResultsOfReserveFundLog {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ReserveFundLog[] | undefined;

    constructor(data?: IQueryResultsOfReserveFundLog) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ReserveFundLog.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfReserveFundLog {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfReserveFundLog();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfReserveFundLog {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ReserveFundLog[] | undefined;
}

export class QueryResultsOfSafetyAuditRecordViewModel implements IQueryResultsOfSafetyAuditRecordViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: SafetyAuditRecordViewModel[] | undefined;

    constructor(data?: IQueryResultsOfSafetyAuditRecordViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SafetyAuditRecordViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfSafetyAuditRecordViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfSafetyAuditRecordViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfSafetyAuditRecordViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: SafetyAuditRecordViewModel[] | undefined;
}

export class SafetyAuditRecordViewModel implements ISafetyAuditRecordViewModel {
    id!: number;
    auditDate!: string;
    auditedBy?: string | undefined;
    entryDate!: string;
    enteredBy?: string | undefined;
    auditComment?: string | undefined;
    store?: StoreViewModel2 | undefined;
    safetyAuditDetails?: SafetyAuditDetail[] | undefined;

    constructor(data?: ISafetyAuditRecordViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.auditDate = _data["auditDate"];
            this.auditedBy = _data["auditedBy"];
            this.entryDate = _data["entryDate"];
            this.enteredBy = _data["enteredBy"];
            this.auditComment = _data["auditComment"];
            this.store = _data["store"] ? StoreViewModel2.fromJS(_data["store"]) : <any>undefined;
            if (Array.isArray(_data["safetyAuditDetails"])) {
                this.safetyAuditDetails = [] as any;
                for (let item of _data["safetyAuditDetails"])
                    this.safetyAuditDetails!.push(SafetyAuditDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SafetyAuditRecordViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyAuditRecordViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["auditDate"] = this.auditDate;
        data["auditedBy"] = this.auditedBy;
        data["entryDate"] = this.entryDate;
        data["enteredBy"] = this.enteredBy;
        data["auditComment"] = this.auditComment;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        if (Array.isArray(this.safetyAuditDetails)) {
            data["safetyAuditDetails"] = [];
            for (let item of this.safetyAuditDetails)
                data["safetyAuditDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISafetyAuditRecordViewModel {
    id: number;
    auditDate: string;
    auditedBy?: string | undefined;
    entryDate: string;
    enteredBy?: string | undefined;
    auditComment?: string | undefined;
    store?: StoreViewModel2 | undefined;
    safetyAuditDetails?: SafetyAuditDetail[] | undefined;
}

export class SafetyAuditDetail implements ISafetyAuditDetail {
    id!: number;
    safetyRecordId!: number;
    category?: string | undefined;
    description?: string | undefined;
    score!: number;
    comment?: string | undefined;
    correctedBy?: string | undefined;
    dateCorrected?: string | undefined;

    constructor(data?: ISafetyAuditDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.safetyRecordId = _data["safetyRecordId"];
            this.category = _data["category"];
            this.description = _data["description"];
            this.score = _data["score"];
            this.comment = _data["comment"];
            this.correctedBy = _data["correctedBy"];
            this.dateCorrected = _data["dateCorrected"];
        }
    }

    static fromJS(data: any): SafetyAuditDetail {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyAuditDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["safetyRecordId"] = this.safetyRecordId;
        data["category"] = this.category;
        data["description"] = this.description;
        data["score"] = this.score;
        data["comment"] = this.comment;
        data["correctedBy"] = this.correctedBy;
        data["dateCorrected"] = this.dateCorrected;
        return data;
    }
}

export interface ISafetyAuditDetail {
    id: number;
    safetyRecordId: number;
    category?: string | undefined;
    description?: string | undefined;
    score: number;
    comment?: string | undefined;
    correctedBy?: string | undefined;
    dateCorrected?: string | undefined;
}

export class SafetyAuditRecord implements ISafetyAuditRecord {
    id!: number;
    storeID?: string | undefined;
    auditDate!: string;
    auditedBy?: string | undefined;
    entryDate!: string;
    enteredBy?: string | undefined;
    auditComment?: string | undefined;
    safetyAuditDetails?: SafetyAuditDetail2[] | undefined;

    constructor(data?: ISafetyAuditRecord) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeID = _data["storeID"];
            this.auditDate = _data["auditDate"];
            this.auditedBy = _data["auditedBy"];
            this.entryDate = _data["entryDate"];
            this.enteredBy = _data["enteredBy"];
            this.auditComment = _data["auditComment"];
            if (Array.isArray(_data["safetyAuditDetails"])) {
                this.safetyAuditDetails = [] as any;
                for (let item of _data["safetyAuditDetails"])
                    this.safetyAuditDetails!.push(SafetyAuditDetail2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SafetyAuditRecord {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyAuditRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeID"] = this.storeID;
        data["auditDate"] = this.auditDate;
        data["auditedBy"] = this.auditedBy;
        data["entryDate"] = this.entryDate;
        data["enteredBy"] = this.enteredBy;
        data["auditComment"] = this.auditComment;
        if (Array.isArray(this.safetyAuditDetails)) {
            data["safetyAuditDetails"] = [];
            for (let item of this.safetyAuditDetails)
                data["safetyAuditDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ISafetyAuditRecord {
    id: number;
    storeID?: string | undefined;
    auditDate: string;
    auditedBy?: string | undefined;
    entryDate: string;
    enteredBy?: string | undefined;
    auditComment?: string | undefined;
    safetyAuditDetails?: SafetyAuditDetail2[] | undefined;
}

export class SafetyAuditDetail2 implements ISafetyAuditDetail2 {
    id!: number;
    safetyRecordID!: number;
    category?: string | undefined;
    description?: string | undefined;
    score!: SafetyAuditScore;
    comment?: string | undefined;
    correctedBy?: string | undefined;
    dateCorrected?: string | undefined;

    constructor(data?: ISafetyAuditDetail2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.safetyRecordID = _data["safetyRecordID"];
            this.category = _data["category"];
            this.description = _data["description"];
            this.score = _data["score"];
            this.comment = _data["comment"];
            this.correctedBy = _data["correctedBy"];
            this.dateCorrected = _data["dateCorrected"];
        }
    }

    static fromJS(data: any): SafetyAuditDetail2 {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyAuditDetail2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["safetyRecordID"] = this.safetyRecordID;
        data["category"] = this.category;
        data["description"] = this.description;
        data["score"] = this.score;
        data["comment"] = this.comment;
        data["correctedBy"] = this.correctedBy;
        data["dateCorrected"] = this.dateCorrected;
        return data;
    }
}

export interface ISafetyAuditDetail2 {
    id: number;
    safetyRecordID: number;
    category?: string | undefined;
    description?: string | undefined;
    score: SafetyAuditScore;
    comment?: string | undefined;
    correctedBy?: string | undefined;
    dateCorrected?: string | undefined;
}

export enum SafetyAuditScore {
    Null = "Null",
    Pass = "Pass",
    Fail = "Fail",
}

export class SafetyAuditAreaViewModel implements ISafetyAuditAreaViewModel {
    category?: string | undefined;

    constructor(data?: ISafetyAuditAreaViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.category = _data["category"];
        }
    }

    static fromJS(data: any): SafetyAuditAreaViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyAuditAreaViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["category"] = this.category;
        return data;
    }
}

export interface ISafetyAuditAreaViewModel {
    category?: string | undefined;
}

export enum CostCenterType {
    Retail = "Retail",
    Outlet = "Outlet",
    Boutique = "Boutique",
    Ecommerce = "Ecommerce",
}

export class QueryResultsOfSafetyAuditAreaSort implements IQueryResultsOfSafetyAuditAreaSort {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: SafetyAuditAreaSort[] | undefined;

    constructor(data?: IQueryResultsOfSafetyAuditAreaSort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SafetyAuditAreaSort.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfSafetyAuditAreaSort {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfSafetyAuditAreaSort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfSafetyAuditAreaSort {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: SafetyAuditAreaSort[] | undefined;
}

export class SafetyAuditAreaSort implements ISafetyAuditAreaSort {
    id!: number;
    category?: string | undefined;
    description?: string | undefined;
    sort!: number;

    constructor(data?: ISafetyAuditAreaSort) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.category = _data["category"];
            this.description = _data["description"];
            this.sort = _data["sort"];
        }
    }

    static fromJS(data: any): SafetyAuditAreaSort {
        data = typeof data === 'object' ? data : {};
        let result = new SafetyAuditAreaSort();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["category"] = this.category;
        data["description"] = this.description;
        data["sort"] = this.sort;
        return data;
    }
}

export interface ISafetyAuditAreaSort {
    id: number;
    category?: string | undefined;
    description?: string | undefined;
    sort: number;
}

export class QueryResultsOfServiceDescriptionViewModel implements IQueryResultsOfServiceDescriptionViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ServiceDescriptionViewModel[] | undefined;

    constructor(data?: IQueryResultsOfServiceDescriptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ServiceDescriptionViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfServiceDescriptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfServiceDescriptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfServiceDescriptionViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ServiceDescriptionViewModel[] | undefined;
}

export class ServiceDescriptionViewModel implements IServiceDescriptionViewModel {
    id?: string | undefined;
    serviceType?: string | undefined;
    serviceDescription1?: string | undefined;
    sortType?: number | undefined;
    sortDescription?: number | undefined;

    constructor(data?: IServiceDescriptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.serviceType = _data["serviceType"];
            this.serviceDescription1 = _data["serviceDescription1"];
            this.sortType = _data["sortType"];
            this.sortDescription = _data["sortDescription"];
        }
    }

    static fromJS(data: any): ServiceDescriptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDescriptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["serviceType"] = this.serviceType;
        data["serviceDescription1"] = this.serviceDescription1;
        data["sortType"] = this.sortType;
        data["sortDescription"] = this.sortDescription;
        return data;
    }
}

export interface IServiceDescriptionViewModel {
    id?: string | undefined;
    serviceType?: string | undefined;
    serviceDescription1?: string | undefined;
    sortType?: number | undefined;
    sortDescription?: number | undefined;
}

export class ServicePeriodViewModel implements IServicePeriodViewModel {
    serviceID!: number;
    serviceStartDate!: string;
    interruptComment?: string | undefined;
    serviceEndDate?: string | undefined;
    esprovidingService?: number | undefined;
    _ID!: number;
    enteredBy?: string | undefined;
    dateEntered?: string | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: string | undefined;

    constructor(data?: IServicePeriodViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceID = _data["serviceID"];
            this.serviceStartDate = _data["serviceStartDate"];
            this.interruptComment = _data["interruptComment"];
            this.serviceEndDate = _data["serviceEndDate"];
            this.esprovidingService = _data["esprovidingService"];
            this._ID = _data["_ID"];
            this.enteredBy = _data["enteredBy"];
            this.dateEntered = _data["dateEntered"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"];
        }
    }

    static fromJS(data: any): ServicePeriodViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePeriodViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceID"] = this.serviceID;
        data["serviceStartDate"] = this.serviceStartDate;
        data["interruptComment"] = this.interruptComment;
        data["serviceEndDate"] = this.serviceEndDate;
        data["esprovidingService"] = this.esprovidingService;
        data["_ID"] = this._ID;
        data["enteredBy"] = this.enteredBy;
        data["dateEntered"] = this.dateEntered;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate;
        return data;
    }
}

export interface IServicePeriodViewModel {
    serviceID: number;
    serviceStartDate: string;
    interruptComment?: string | undefined;
    serviceEndDate?: string | undefined;
    esprovidingService?: number | undefined;
    _ID: number;
    enteredBy?: string | undefined;
    dateEntered?: string | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: string | undefined;
}

export class QueryResultsOfServicePeriodViewModel implements IQueryResultsOfServicePeriodViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ServicePeriodViewModel2[] | undefined;

    constructor(data?: IQueryResultsOfServicePeriodViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ServicePeriodViewModel2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfServicePeriodViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfServicePeriodViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfServicePeriodViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ServicePeriodViewModel2[] | undefined;
}

export class ServicePeriodViewModel2 implements IServicePeriodViewModel2 {
    serviceID!: number;
    serviceStartDate!: string;
    interruptComment?: string | undefined;
    serviceEndDate?: string | undefined;
    esprovidingService?: number | undefined;
    _ID!: number;
    enteredBy?: string | undefined;
    dateEntered?: string | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: string | undefined;

    constructor(data?: IServicePeriodViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceID = _data["serviceID"];
            this.serviceStartDate = _data["serviceStartDate"];
            this.interruptComment = _data["interruptComment"];
            this.serviceEndDate = _data["serviceEndDate"];
            this.esprovidingService = _data["esprovidingService"];
            this._ID = _data["_ID"];
            this.enteredBy = _data["enteredBy"];
            this.dateEntered = _data["dateEntered"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"];
        }
    }

    static fromJS(data: any): ServicePeriodViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePeriodViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceID"] = this.serviceID;
        data["serviceStartDate"] = this.serviceStartDate;
        data["interruptComment"] = this.interruptComment;
        data["serviceEndDate"] = this.serviceEndDate;
        data["esprovidingService"] = this.esprovidingService;
        data["_ID"] = this._ID;
        data["enteredBy"] = this.enteredBy;
        data["dateEntered"] = this.dateEntered;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate;
        return data;
    }
}

export interface IServicePeriodViewModel2 {
    serviceID: number;
    serviceStartDate: string;
    interruptComment?: string | undefined;
    serviceEndDate?: string | undefined;
    esprovidingService?: number | undefined;
    _ID: number;
    enteredBy?: string | undefined;
    dateEntered?: string | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: string | undefined;
}

export class QueryResultsOfServicePeriodViewModel2 implements IQueryResultsOfServicePeriodViewModel2 {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ServicePeriodViewModel[] | undefined;

    constructor(data?: IQueryResultsOfServicePeriodViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ServicePeriodViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfServicePeriodViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfServicePeriodViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfServicePeriodViewModel2 {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ServicePeriodViewModel[] | undefined;
}

export class ServicePeriodSavingModel implements IServicePeriodSavingModel {
    serviceID!: number;
    serviceStartDate!: string;
    interruptComment?: string | undefined;
    serviceEndDate?: string | undefined;
    esprovidingService?: number | undefined;
    _ID!: number;
    enteredBy?: string | undefined;
    dateEntered?: string | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: string | undefined;

    constructor(data?: IServicePeriodSavingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceID = _data["serviceID"];
            this.serviceStartDate = _data["serviceStartDate"];
            this.interruptComment = _data["interruptComment"];
            this.serviceEndDate = _data["serviceEndDate"];
            this.esprovidingService = _data["esprovidingService"];
            this._ID = _data["_ID"];
            this.enteredBy = _data["enteredBy"];
            this.dateEntered = _data["dateEntered"];
            this.lastModifiedBy = _data["lastModifiedBy"];
            this.lastModifiedDate = _data["lastModifiedDate"];
        }
    }

    static fromJS(data: any): ServicePeriodSavingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServicePeriodSavingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceID"] = this.serviceID;
        data["serviceStartDate"] = this.serviceStartDate;
        data["interruptComment"] = this.interruptComment;
        data["serviceEndDate"] = this.serviceEndDate;
        data["esprovidingService"] = this.esprovidingService;
        data["_ID"] = this._ID;
        data["enteredBy"] = this.enteredBy;
        data["dateEntered"] = this.dateEntered;
        data["lastModifiedBy"] = this.lastModifiedBy;
        data["lastModifiedDate"] = this.lastModifiedDate;
        return data;
    }
}

export interface IServicePeriodSavingModel {
    serviceID: number;
    serviceStartDate: string;
    interruptComment?: string | undefined;
    serviceEndDate?: string | undefined;
    esprovidingService?: number | undefined;
    _ID: number;
    enteredBy?: string | undefined;
    dateEntered?: string | undefined;
    lastModifiedBy?: string | undefined;
    lastModifiedDate?: string | undefined;
}

export class ServiceProvidedViewModel implements IServiceProvidedViewModel {
    id!: number;
    gicwId!: number;
    staffId!: number;
    locationId!: number;
    serviceProvided1?: string | undefined;
    serviceProvidedDate!: string;
    quantity!: number;
    serviceDescriptionId!: number;
    dataEntryDate!: string;
    enteredBy?: string | undefined;
    clothingCardNumber?: string | undefined;
    staff?: StaffViewModel | undefined;
    jcentityLocation?: JcentityLocationViewModel | undefined;
    serviceDescription?: ServiceDescriptionViewModel | undefined;

    constructor(data?: IServiceProvidedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gicwId = _data["gicwId"];
            this.staffId = _data["staffId"];
            this.locationId = _data["locationId"];
            this.serviceProvided1 = _data["serviceProvided1"];
            this.serviceProvidedDate = _data["serviceProvidedDate"];
            this.quantity = _data["quantity"];
            this.serviceDescriptionId = _data["serviceDescriptionId"];
            this.dataEntryDate = _data["dataEntryDate"];
            this.enteredBy = _data["enteredBy"];
            this.clothingCardNumber = _data["clothingCardNumber"];
            this.staff = _data["staff"] ? StaffViewModel.fromJS(_data["staff"]) : <any>undefined;
            this.jcentityLocation = _data["jcentityLocation"] ? JcentityLocationViewModel.fromJS(_data["jcentityLocation"]) : <any>undefined;
            this.serviceDescription = _data["serviceDescription"] ? ServiceDescriptionViewModel.fromJS(_data["serviceDescription"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ServiceProvidedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceProvidedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gicwId"] = this.gicwId;
        data["staffId"] = this.staffId;
        data["locationId"] = this.locationId;
        data["serviceProvided1"] = this.serviceProvided1;
        data["serviceProvidedDate"] = this.serviceProvidedDate;
        data["quantity"] = this.quantity;
        data["serviceDescriptionId"] = this.serviceDescriptionId;
        data["dataEntryDate"] = this.dataEntryDate;
        data["enteredBy"] = this.enteredBy;
        data["clothingCardNumber"] = this.clothingCardNumber;
        data["staff"] = this.staff ? this.staff.toJSON() : <any>undefined;
        data["jcentityLocation"] = this.jcentityLocation ? this.jcentityLocation.toJSON() : <any>undefined;
        data["serviceDescription"] = this.serviceDescription ? this.serviceDescription.toJSON() : <any>undefined;
        return data;
    }
}

export interface IServiceProvidedViewModel {
    id: number;
    gicwId: number;
    staffId: number;
    locationId: number;
    serviceProvided1?: string | undefined;
    serviceProvidedDate: string;
    quantity: number;
    serviceDescriptionId: number;
    dataEntryDate: string;
    enteredBy?: string | undefined;
    clothingCardNumber?: string | undefined;
    staff?: StaffViewModel | undefined;
    jcentityLocation?: JcentityLocationViewModel | undefined;
    serviceDescription?: ServiceDescriptionViewModel | undefined;
}

export class ServiceProvided2 implements IServiceProvided2 {
    id!: number;
    gicwId!: number;
    staffId!: number;
    locationId!: number;
    serviceProvided1?: string | undefined;
    serviceProvidedDate!: string;
    quantity!: number;
    serviceDescriptionId!: number;
    dataEntryDate!: string;
    enteredBy?: string | undefined;
    clothingCardNumber?: string | undefined;

    constructor(data?: IServiceProvided2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gicwId = _data["gicwId"];
            this.staffId = _data["staffId"];
            this.locationId = _data["locationId"];
            this.serviceProvided1 = _data["serviceProvided1"];
            this.serviceProvidedDate = _data["serviceProvidedDate"];
            this.quantity = _data["quantity"];
            this.serviceDescriptionId = _data["serviceDescriptionId"];
            this.dataEntryDate = _data["dataEntryDate"];
            this.enteredBy = _data["enteredBy"];
            this.clothingCardNumber = _data["clothingCardNumber"];
        }
    }

    static fromJS(data: any): ServiceProvided2 {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceProvided2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gicwId"] = this.gicwId;
        data["staffId"] = this.staffId;
        data["locationId"] = this.locationId;
        data["serviceProvided1"] = this.serviceProvided1;
        data["serviceProvidedDate"] = this.serviceProvidedDate;
        data["quantity"] = this.quantity;
        data["serviceDescriptionId"] = this.serviceDescriptionId;
        data["dataEntryDate"] = this.dataEntryDate;
        data["enteredBy"] = this.enteredBy;
        data["clothingCardNumber"] = this.clothingCardNumber;
        return data;
    }
}

export interface IServiceProvided2 {
    id: number;
    gicwId: number;
    staffId: number;
    locationId: number;
    serviceProvided1?: string | undefined;
    serviceProvidedDate: string;
    quantity: number;
    serviceDescriptionId: number;
    dataEntryDate: string;
    enteredBy?: string | undefined;
    clothingCardNumber?: string | undefined;
}

export class QueryResultsOfServiceProvidedViewModel implements IQueryResultsOfServiceProvidedViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ServiceProvidedViewModel[] | undefined;

    constructor(data?: IQueryResultsOfServiceProvidedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ServiceProvidedViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfServiceProvidedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfServiceProvidedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfServiceProvidedViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ServiceProvidedViewModel[] | undefined;
}

export class QueryResultsOfShoplifterSummary implements IQueryResultsOfShoplifterSummary {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ShoplifterSummary[] | undefined;

    constructor(data?: IQueryResultsOfShoplifterSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ShoplifterSummary.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfShoplifterSummary {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfShoplifterSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfShoplifterSummary {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ShoplifterSummary[] | undefined;
}

export class ShoplifterSummary implements IShoplifterSummary {
    id!: number;
    storeId?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    date!: string;
    timeOfViolation!: string;
    timeReleased!: string;
    address?: string | undefined;
    city?: string | undefined;
    state!: number;
    zipCode?: string | undefined;
    phone?: string | undefined;
    identificationNumber?: string | undefined;
    dateOfBirth!: string;
    adultJunvenile?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    height?: string | undefined;
    weight?: string | undefined;
    hairColor?: string | undefined;
    hairLength?: string | undefined;
    eyeColor?: string | undefined;
    identifyingMarks?: string | undefined;
    prosecuted!: boolean;
    caseNumber?: string | undefined;
    charges?: string | undefined;
    agencyId?: string | undefined;
    result?: string | undefined;
    stateId!: number;
    reasonForTresspass?: string | undefined;
    vehicleMakeModel?: string | undefined;
    vehiclePlateNumber?: string | undefined;
    clothingDescription?: string | undefined;
    invoiceNumber?: string | undefined;
    purchaseAmt!: number;
    registerNumber!: number;
    moneyOnPerson!: number;
    changeReceived!: number;
    howLong!: number;
    amountTendered!: number;
    locked!: boolean;
    startTime!: string;
    enteredby?: string | undefined;
    type?: string | undefined;
    store?: Store5 | undefined;
    shoplifterDetails?: ShoplifterDetail[] | undefined;
    shoplifterItemsTakens?: ShoplifterItemsTaken[] | undefined;

    constructor(data?: IShoplifterSummary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.firstName = _data["firstName"];
            this.middleName = _data["middleName"];
            this.lastName = _data["lastName"];
            this.date = _data["date"];
            this.timeOfViolation = _data["timeOfViolation"];
            this.timeReleased = _data["timeReleased"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zipCode = _data["zipCode"];
            this.phone = _data["phone"];
            this.identificationNumber = _data["identificationNumber"];
            this.dateOfBirth = _data["dateOfBirth"];
            this.adultJunvenile = _data["adultJunvenile"];
            this.gender = _data["gender"];
            this.race = _data["race"];
            this.height = _data["height"];
            this.weight = _data["weight"];
            this.hairColor = _data["hairColor"];
            this.hairLength = _data["hairLength"];
            this.eyeColor = _data["eyeColor"];
            this.identifyingMarks = _data["identifyingMarks"];
            this.prosecuted = _data["prosecuted"];
            this.caseNumber = _data["caseNumber"];
            this.charges = _data["charges"];
            this.agencyId = _data["agencyId"];
            this.result = _data["result"];
            this.stateId = _data["stateId"];
            this.reasonForTresspass = _data["reasonForTresspass"];
            this.vehicleMakeModel = _data["vehicleMakeModel"];
            this.vehiclePlateNumber = _data["vehiclePlateNumber"];
            this.clothingDescription = _data["clothingDescription"];
            this.invoiceNumber = _data["invoiceNumber"];
            this.purchaseAmt = _data["purchaseAmt"];
            this.registerNumber = _data["registerNumber"];
            this.moneyOnPerson = _data["moneyOnPerson"];
            this.changeReceived = _data["changeReceived"];
            this.howLong = _data["howLong"];
            this.amountTendered = _data["amountTendered"];
            this.locked = _data["locked"];
            this.startTime = _data["startTime"];
            this.enteredby = _data["enteredby"];
            this.type = _data["type"];
            this.store = _data["store"] ? Store5.fromJS(_data["store"]) : <any>undefined;
            if (Array.isArray(_data["shoplifterDetails"])) {
                this.shoplifterDetails = [] as any;
                for (let item of _data["shoplifterDetails"])
                    this.shoplifterDetails!.push(ShoplifterDetail.fromJS(item));
            }
            if (Array.isArray(_data["shoplifterItemsTakens"])) {
                this.shoplifterItemsTakens = [] as any;
                for (let item of _data["shoplifterItemsTakens"])
                    this.shoplifterItemsTakens!.push(ShoplifterItemsTaken.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ShoplifterSummary {
        data = typeof data === 'object' ? data : {};
        let result = new ShoplifterSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["firstName"] = this.firstName;
        data["middleName"] = this.middleName;
        data["lastName"] = this.lastName;
        data["date"] = this.date;
        data["timeOfViolation"] = this.timeOfViolation;
        data["timeReleased"] = this.timeReleased;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zipCode"] = this.zipCode;
        data["phone"] = this.phone;
        data["identificationNumber"] = this.identificationNumber;
        data["dateOfBirth"] = this.dateOfBirth;
        data["adultJunvenile"] = this.adultJunvenile;
        data["gender"] = this.gender;
        data["race"] = this.race;
        data["height"] = this.height;
        data["weight"] = this.weight;
        data["hairColor"] = this.hairColor;
        data["hairLength"] = this.hairLength;
        data["eyeColor"] = this.eyeColor;
        data["identifyingMarks"] = this.identifyingMarks;
        data["prosecuted"] = this.prosecuted;
        data["caseNumber"] = this.caseNumber;
        data["charges"] = this.charges;
        data["agencyId"] = this.agencyId;
        data["result"] = this.result;
        data["stateId"] = this.stateId;
        data["reasonForTresspass"] = this.reasonForTresspass;
        data["vehicleMakeModel"] = this.vehicleMakeModel;
        data["vehiclePlateNumber"] = this.vehiclePlateNumber;
        data["clothingDescription"] = this.clothingDescription;
        data["invoiceNumber"] = this.invoiceNumber;
        data["purchaseAmt"] = this.purchaseAmt;
        data["registerNumber"] = this.registerNumber;
        data["moneyOnPerson"] = this.moneyOnPerson;
        data["changeReceived"] = this.changeReceived;
        data["howLong"] = this.howLong;
        data["amountTendered"] = this.amountTendered;
        data["locked"] = this.locked;
        data["startTime"] = this.startTime;
        data["enteredby"] = this.enteredby;
        data["type"] = this.type;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        if (Array.isArray(this.shoplifterDetails)) {
            data["shoplifterDetails"] = [];
            for (let item of this.shoplifterDetails)
                data["shoplifterDetails"].push(item.toJSON());
        }
        if (Array.isArray(this.shoplifterItemsTakens)) {
            data["shoplifterItemsTakens"] = [];
            for (let item of this.shoplifterItemsTakens)
                data["shoplifterItemsTakens"].push(item.toJSON());
        }
        return data;
    }
}

export interface IShoplifterSummary {
    id: number;
    storeId?: string | undefined;
    firstName?: string | undefined;
    middleName?: string | undefined;
    lastName?: string | undefined;
    date: string;
    timeOfViolation: string;
    timeReleased: string;
    address?: string | undefined;
    city?: string | undefined;
    state: number;
    zipCode?: string | undefined;
    phone?: string | undefined;
    identificationNumber?: string | undefined;
    dateOfBirth: string;
    adultJunvenile?: string | undefined;
    gender?: string | undefined;
    race?: string | undefined;
    height?: string | undefined;
    weight?: string | undefined;
    hairColor?: string | undefined;
    hairLength?: string | undefined;
    eyeColor?: string | undefined;
    identifyingMarks?: string | undefined;
    prosecuted: boolean;
    caseNumber?: string | undefined;
    charges?: string | undefined;
    agencyId?: string | undefined;
    result?: string | undefined;
    stateId: number;
    reasonForTresspass?: string | undefined;
    vehicleMakeModel?: string | undefined;
    vehiclePlateNumber?: string | undefined;
    clothingDescription?: string | undefined;
    invoiceNumber?: string | undefined;
    purchaseAmt: number;
    registerNumber: number;
    moneyOnPerson: number;
    changeReceived: number;
    howLong: number;
    amountTendered: number;
    locked: boolean;
    startTime: string;
    enteredby?: string | undefined;
    type?: string | undefined;
    store?: Store5 | undefined;
    shoplifterDetails?: ShoplifterDetail[] | undefined;
    shoplifterItemsTakens?: ShoplifterItemsTaken[] | undefined;
}

export class ShoplifterDetail implements IShoplifterDetail {
    id!: number;
    gicwCaseNumber!: number;
    photo?: string | undefined;
    noticeOfExclusion?: string | undefined;
    statementOfTheft?: string | undefined;

    constructor(data?: IShoplifterDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gicwCaseNumber = _data["gicwCaseNumber"];
            this.photo = _data["photo"];
            this.noticeOfExclusion = _data["noticeOfExclusion"];
            this.statementOfTheft = _data["statementOfTheft"];
        }
    }

    static fromJS(data: any): ShoplifterDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ShoplifterDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gicwCaseNumber"] = this.gicwCaseNumber;
        data["photo"] = this.photo;
        data["noticeOfExclusion"] = this.noticeOfExclusion;
        data["statementOfTheft"] = this.statementOfTheft;
        return data;
    }
}

export interface IShoplifterDetail {
    id: number;
    gicwCaseNumber: number;
    photo?: string | undefined;
    noticeOfExclusion?: string | undefined;
    statementOfTheft?: string | undefined;
}

export class ShoplifterItemsTaken implements IShoplifterItemsTaken {
    id!: number;
    gicW_Case_Number!: number;
    quantity!: number;
    description?: string | undefined;
    price!: number;
    weight!: number;

    constructor(data?: IShoplifterItemsTaken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.gicW_Case_Number = _data["gicW_Case_Number"];
            this.quantity = _data["quantity"];
            this.description = _data["description"];
            this.price = _data["price"];
            this.weight = _data["weight"];
        }
    }

    static fromJS(data: any): ShoplifterItemsTaken {
        data = typeof data === 'object' ? data : {};
        let result = new ShoplifterItemsTaken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["gicW_Case_Number"] = this.gicW_Case_Number;
        data["quantity"] = this.quantity;
        data["description"] = this.description;
        data["price"] = this.price;
        data["weight"] = this.weight;
        return data;
    }
}

export interface IShoplifterItemsTaken {
    id: number;
    gicW_Case_Number: number;
    quantity: number;
    description?: string | undefined;
    price: number;
    weight: number;
}

export class QueryResultsOfShoplifterDetail implements IQueryResultsOfShoplifterDetail {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: ShoplifterDetail[] | undefined;

    constructor(data?: IQueryResultsOfShoplifterDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(ShoplifterDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfShoplifterDetail {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfShoplifterDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfShoplifterDetail {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: ShoplifterDetail[] | undefined;
}

export class QueryResultsOfSiteViewModel implements IQueryResultsOfSiteViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: SiteViewModel[] | undefined;

    constructor(data?: IQueryResultsOfSiteViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SiteViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfSiteViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfSiteViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfSiteViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: SiteViewModel[] | undefined;
}

export class QueryResultsOfSiteViewModel2 implements IQueryResultsOfSiteViewModel2 {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: SiteViewModel2[] | undefined;

    constructor(data?: IQueryResultsOfSiteViewModel2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SiteViewModel2.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfSiteViewModel2 {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfSiteViewModel2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfSiteViewModel2 {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: SiteViewModel2[] | undefined;
}

export class QueryResultsOfSite implements IQueryResultsOfSite {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Site[] | undefined;

    constructor(data?: IQueryResultsOfSite) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Site.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfSite {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfSite();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfSite {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Site[] | undefined;
}

export class Site extends EntityBase implements ISite {
    name?: string | undefined;
    division?: string | undefined;
    type?: string | undefined;
    number?: number | undefined;
    annualGoalPounds?: number | undefined;
    trailer?: string | undefined;
    upsizeTs?: string | undefined;
    siteDescription?: string | undefined;
    statusId?: number | undefined;
    storeId?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: ISite) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.name = _data["name"];
            this.division = _data["division"];
            this.type = _data["type"];
            this.number = _data["number"];
            this.annualGoalPounds = _data["annualGoalPounds"];
            this.trailer = _data["trailer"];
            this.upsizeTs = _data["upsizeTs"];
            this.siteDescription = _data["siteDescription"];
            this.statusId = _data["statusId"];
            this.storeId = _data["storeId"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): Site {
        data = typeof data === 'object' ? data : {};
        let result = new Site();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["division"] = this.division;
        data["type"] = this.type;
        data["number"] = this.number;
        data["annualGoalPounds"] = this.annualGoalPounds;
        data["trailer"] = this.trailer;
        data["upsizeTs"] = this.upsizeTs;
        data["siteDescription"] = this.siteDescription;
        data["statusId"] = this.statusId;
        data["storeId"] = this.storeId;
        data["active"] = this.active;
        super.toJSON(data);
        return data;
    }
}

export interface ISite extends IEntityBase {
    name?: string | undefined;
    division?: string | undefined;
    type?: string | undefined;
    number?: number | undefined;
    annualGoalPounds?: number | undefined;
    trailer?: string | undefined;
    upsizeTs?: string | undefined;
    siteDescription?: string | undefined;
    statusId?: number | undefined;
    storeId?: string | undefined;
    active?: boolean | undefined;
}

export class Site2 implements ISite2 {
    id!: number;
    name?: string | undefined;
    division?: string | undefined;
    type?: string | undefined;
    number?: number | undefined;
    annualGoalPounds?: number | undefined;
    trailer?: string | undefined;
    upsizeTs?: string | undefined;
    siteDescription?: string | undefined;
    statusId?: number | undefined;
    storeId?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: ISite2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.division = _data["division"];
            this.type = _data["type"];
            this.number = _data["number"];
            this.annualGoalPounds = _data["annualGoalPounds"];
            this.trailer = _data["trailer"];
            this.upsizeTs = _data["upsizeTs"];
            this.siteDescription = _data["siteDescription"];
            this.statusId = _data["statusId"];
            this.storeId = _data["storeId"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): Site2 {
        data = typeof data === 'object' ? data : {};
        let result = new Site2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["division"] = this.division;
        data["type"] = this.type;
        data["number"] = this.number;
        data["annualGoalPounds"] = this.annualGoalPounds;
        data["trailer"] = this.trailer;
        data["upsizeTs"] = this.upsizeTs;
        data["siteDescription"] = this.siteDescription;
        data["statusId"] = this.statusId;
        data["storeId"] = this.storeId;
        data["active"] = this.active;
        return data;
    }
}

export interface ISite2 {
    id: number;
    name?: string | undefined;
    division?: string | undefined;
    type?: string | undefined;
    number?: number | undefined;
    annualGoalPounds?: number | undefined;
    trailer?: string | undefined;
    upsizeTs?: string | undefined;
    siteDescription?: string | undefined;
    statusId?: number | undefined;
    storeId?: string | undefined;
    active?: boolean | undefined;
}

export class QueryResultsOfStaff implements IQueryResultsOfStaff {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Staff[] | undefined;

    constructor(data?: IQueryResultsOfStaff) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Staff.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfStaff {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfStaff();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfStaff {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Staff[] | undefined;
}

export enum BooleanEnum {
    False = "False",
    True = "True",
    All = "All",
    Null = "Null",
}

export class FindStaffOutputViewModel implements IFindStaffOutputViewModel {
    id!: number;
    name?: string | undefined;
    phone?: string | undefined;
    employeeNumber?: string | undefined;

    constructor(data?: IFindStaffOutputViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.phone = _data["phone"];
            this.employeeNumber = _data["employeeNumber"];
        }
    }

    static fromJS(data: any): FindStaffOutputViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FindStaffOutputViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["phone"] = this.phone;
        data["employeeNumber"] = this.employeeNumber;
        return data;
    }
}

export interface IFindStaffOutputViewModel {
    id: number;
    name?: string | undefined;
    phone?: string | undefined;
    employeeNumber?: string | undefined;
}

export class QueryResultsOfStaffGoalViewModel implements IQueryResultsOfStaffGoalViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: StaffGoalViewModel[] | undefined;

    constructor(data?: IQueryResultsOfStaffGoalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(StaffGoalViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfStaffGoalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfStaffGoalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfStaffGoalViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: StaffGoalViewModel[] | undefined;
}

export class StaffGoalViewModel implements IStaffGoalViewModel {
    id!: number;
    staffID?: string | undefined;
    region?: string | undefined;
    manager?: string | undefined;
    ses?: string | undefined;
    serviceGoal!: number;
    placementGoal!: number;
    enrollmentGoal!: number;
    staffName?: string | undefined;
    sesName?: string | undefined;
    managerName?: string | undefined;

    constructor(data?: IStaffGoalViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.staffID = _data["staffID"];
            this.region = _data["region"];
            this.manager = _data["manager"];
            this.ses = _data["ses"];
            this.serviceGoal = _data["serviceGoal"];
            this.placementGoal = _data["placementGoal"];
            this.enrollmentGoal = _data["enrollmentGoal"];
            this.staffName = _data["staffName"];
            this.sesName = _data["sesName"];
            this.managerName = _data["managerName"];
        }
    }

    static fromJS(data: any): StaffGoalViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StaffGoalViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffID"] = this.staffID;
        data["region"] = this.region;
        data["manager"] = this.manager;
        data["ses"] = this.ses;
        data["serviceGoal"] = this.serviceGoal;
        data["placementGoal"] = this.placementGoal;
        data["enrollmentGoal"] = this.enrollmentGoal;
        data["staffName"] = this.staffName;
        data["sesName"] = this.sesName;
        data["managerName"] = this.managerName;
        return data;
    }
}

export interface IStaffGoalViewModel {
    id: number;
    staffID?: string | undefined;
    region?: string | undefined;
    manager?: string | undefined;
    ses?: string | undefined;
    serviceGoal: number;
    placementGoal: number;
    enrollmentGoal: number;
    staffName?: string | undefined;
    sesName?: string | undefined;
    managerName?: string | undefined;
}

export class QueryResultsOfEmployeeNameViewModel implements IQueryResultsOfEmployeeNameViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: EmployeeNameViewModel[] | undefined;

    constructor(data?: IQueryResultsOfEmployeeNameViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(EmployeeNameViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfEmployeeNameViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfEmployeeNameViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfEmployeeNameViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: EmployeeNameViewModel[] | undefined;
}

export class EmployeeNameViewModel implements IEmployeeNameViewModel {
    employeeNumber?: string | undefined;
    name?: string | undefined;

    constructor(data?: IEmployeeNameViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeNumber = _data["employeeNumber"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EmployeeNameViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new EmployeeNameViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeNumber"] = this.employeeNumber;
        data["name"] = this.name;
        return data;
    }
}

export interface IEmployeeNameViewModel {
    employeeNumber?: string | undefined;
    name?: string | undefined;
}

export class StaffGoalSavingModel implements IStaffGoalSavingModel {
    id!: number;
    staffID?: string | undefined;
    region?: string | undefined;
    manager?: string | undefined;
    ses?: string | undefined;
    serviceGoal!: number;
    placementGoal!: number;
    enrollmentGoal!: number;

    constructor(data?: IStaffGoalSavingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.staffID = _data["staffID"];
            this.region = _data["region"];
            this.manager = _data["manager"];
            this.ses = _data["ses"];
            this.serviceGoal = _data["serviceGoal"];
            this.placementGoal = _data["placementGoal"];
            this.enrollmentGoal = _data["enrollmentGoal"];
        }
    }

    static fromJS(data: any): StaffGoalSavingModel {
        data = typeof data === 'object' ? data : {};
        let result = new StaffGoalSavingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["staffID"] = this.staffID;
        data["region"] = this.region;
        data["manager"] = this.manager;
        data["ses"] = this.ses;
        data["serviceGoal"] = this.serviceGoal;
        data["placementGoal"] = this.placementGoal;
        data["enrollmentGoal"] = this.enrollmentGoal;
        return data;
    }
}

export interface IStaffGoalSavingModel {
    id: number;
    staffID?: string | undefined;
    region?: string | undefined;
    manager?: string | undefined;
    ses?: string | undefined;
    serviceGoal: number;
    placementGoal: number;
    enrollmentGoal: number;
}

export class QueryResultsOfState implements IQueryResultsOfState {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: State[] | undefined;

    constructor(data?: IQueryResultsOfState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(State.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfState {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfState {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: State[] | undefined;
}

export class State implements IState {
    id!: number;
    name?: string | undefined;
    abbreviation?: string | undefined;

    constructor(data?: IState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.abbreviation = _data["abbreviation"];
        }
    }

    static fromJS(data: any): State {
        data = typeof data === 'object' ? data : {};
        let result = new State();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["abbreviation"] = this.abbreviation;
        return data;
    }
}

export interface IState {
    id: number;
    name?: string | undefined;
    abbreviation?: string | undefined;
}

export class QueryResultsOfStatus implements IQueryResultsOfStatus {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Status[] | undefined;

    constructor(data?: IQueryResultsOfStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Status.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfStatus {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfStatus {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Status[] | undefined;
}

export class Status implements IStatus {
    id!: number;
    description?: string | undefined;

    constructor(data?: IStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): Status {
        data = typeof data === 'object' ? data : {};
        let result = new Status();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["description"] = this.description;
        return data;
    }
}

export interface IStatus {
    id: number;
    description?: string | undefined;
}

export class StoreMessageViewModel implements IStoreMessageViewModel {
    id!: number;
    storeId?: string | undefined;
    storeName?: string | undefined;
    message?: string | undefined;

    constructor(data?: IStoreMessageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.storeName = _data["storeName"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): StoreMessageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoreMessageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["storeName"] = this.storeName;
        data["message"] = this.message;
        return data;
    }
}

export interface IStoreMessageViewModel {
    id: number;
    storeId?: string | undefined;
    storeName?: string | undefined;
    message?: string | undefined;
}

export class QueryResultsOfStoreMessageViewModel implements IQueryResultsOfStoreMessageViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: StoreMessageViewModel[] | undefined;

    constructor(data?: IQueryResultsOfStoreMessageViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(StoreMessageViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfStoreMessageViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfStoreMessageViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfStoreMessageViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: StoreMessageViewModel[] | undefined;
}

export class StoreMessageUpdatingRequest implements IStoreMessageUpdatingRequest {
    id!: number;
    storeId?: string | undefined;
    message?: string | undefined;

    constructor(data?: IStoreMessageUpdatingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeId = _data["storeId"];
            this.message = _data["message"];
        }
    }

    static fromJS(data: any): StoreMessageUpdatingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StoreMessageUpdatingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeId"] = this.storeId;
        data["message"] = this.message;
        return data;
    }
}

export interface IStoreMessageUpdatingRequest {
    id: number;
    storeId?: string | undefined;
    message?: string | undefined;
}

export class UspStoreMessages_ViewModel implements IUspStoreMessages_ViewModel {
    id!: number;
    storeID?: string | undefined;
    message?: string | undefined;
    storeName?: string | undefined;

    constructor(data?: IUspStoreMessages_ViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeID = _data["storeID"];
            this.message = _data["message"];
            this.storeName = _data["storeName"];
        }
    }

    static fromJS(data: any): UspStoreMessages_ViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UspStoreMessages_ViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeID"] = this.storeID;
        data["message"] = this.message;
        data["storeName"] = this.storeName;
        return data;
    }
}

export interface IUspStoreMessages_ViewModel {
    id: number;
    storeID?: string | undefined;
    message?: string | undefined;
    storeName?: string | undefined;
}

export class QueryResultsOfStoreViewModel implements IQueryResultsOfStoreViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: StoreViewModel4[] | undefined;

    constructor(data?: IQueryResultsOfStoreViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(StoreViewModel4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfStoreViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfStoreViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfStoreViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: StoreViewModel4[] | undefined;
}

export class StoreViewModel4 implements IStoreViewModel4 {
    id?: string | undefined;
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed!: boolean;
    isGRERunning!: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    costCenterType?: string | undefined;
    status?: string | undefined;
    retailSQFeet?: number | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    milesFromCorporate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;
    rowguid!: string;

    constructor(data?: IStoreViewModel4) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.storeMnemonic = _data["storeMnemonic"];
            this.storeMnemonic2 = _data["storeMnemonic2"];
            this.serverName = _data["serverName"];
            this.gredbName = _data["gredbName"];
            this.isClosed = _data["isClosed"];
            this.isGRERunning = _data["isGRERunning"];
            this.storeLogin = _data["storeLogin"];
            this.district = _data["district"];
            this.costCenterType = _data["costCenterType"];
            this.status = _data["status"];
            this.retailSQFeet = _data["retailSQFeet"];
            this.glNumber = _data["glNumber"];
            this.glCash = _data["glCash"];
            this.glNumber2 = _data["glNumber2"];
            this.sort = _data["sort"];
            this.locationId = _data["locationId"];
            this.milesFromCorporate = _data["milesFromCorporate"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.regionId = _data["regionId"];
            this.email = _data["email"];
            this.dmEmail = _data["dmEmail"];
            this.districtEmail = _data["districtEmail"];
            this.prefix = _data["prefix"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.aaExtension = _data["aaExtension"];
            this.rowguid = _data["rowguid"];
        }
    }

    static fromJS(data: any): StoreViewModel4 {
        data = typeof data === 'object' ? data : {};
        let result = new StoreViewModel4();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["storeMnemonic"] = this.storeMnemonic;
        data["storeMnemonic2"] = this.storeMnemonic2;
        data["serverName"] = this.serverName;
        data["gredbName"] = this.gredbName;
        data["isClosed"] = this.isClosed;
        data["isGRERunning"] = this.isGRERunning;
        data["storeLogin"] = this.storeLogin;
        data["district"] = this.district;
        data["costCenterType"] = this.costCenterType;
        data["status"] = this.status;
        data["retailSQFeet"] = this.retailSQFeet;
        data["glNumber"] = this.glNumber;
        data["glCash"] = this.glCash;
        data["glNumber2"] = this.glNumber2;
        data["sort"] = this.sort;
        data["locationId"] = this.locationId;
        data["milesFromCorporate"] = this.milesFromCorporate;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["regionId"] = this.regionId;
        data["email"] = this.email;
        data["dmEmail"] = this.dmEmail;
        data["districtEmail"] = this.districtEmail;
        data["prefix"] = this.prefix;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["aaExtension"] = this.aaExtension;
        data["rowguid"] = this.rowguid;
        return data;
    }
}

export interface IStoreViewModel4 {
    id?: string | undefined;
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed: boolean;
    isGRERunning: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    costCenterType?: string | undefined;
    status?: string | undefined;
    retailSQFeet?: number | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    milesFromCorporate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;
    rowguid: string;
}

export class QueryResultsOfStoreGroupedViewModel implements IQueryResultsOfStoreGroupedViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: StoreGroupedViewModel[] | undefined;

    constructor(data?: IQueryResultsOfStoreGroupedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(StoreGroupedViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfStoreGroupedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfStoreGroupedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfStoreGroupedViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: StoreGroupedViewModel[] | undefined;
}

export class StoreGroupedViewModel implements IStoreGroupedViewModel {
    id?: string | undefined;
    storeName?: string | undefined;

    constructor(data?: IStoreGroupedViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeName = _data["storeName"];
        }
    }

    static fromJS(data: any): StoreGroupedViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new StoreGroupedViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeName"] = this.storeName;
        return data;
    }
}

export interface IStoreGroupedViewModel {
    id?: string | undefined;
    storeName?: string | undefined;
}

export class QueryResultsOfSiteListViewModel implements IQueryResultsOfSiteListViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: SiteListViewModel[] | undefined;

    constructor(data?: IQueryResultsOfSiteListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(SiteListViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfSiteListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfSiteListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfSiteListViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: SiteListViewModel[] | undefined;
}

export class SiteListViewModel implements ISiteListViewModel {
    id?: string | undefined;
    storeName?: string | undefined;
    area?: string | undefined;
    district?: string | undefined;
    hub?: string | undefined;
    isDiscontinued!: boolean;

    constructor(data?: ISiteListViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeName = _data["storeName"];
            this.area = _data["area"];
            this.district = _data["district"];
            this.hub = _data["hub"];
            this.isDiscontinued = _data["isDiscontinued"];
        }
    }

    static fromJS(data: any): SiteListViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SiteListViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeName"] = this.storeName;
        data["area"] = this.area;
        data["district"] = this.district;
        data["hub"] = this.hub;
        data["isDiscontinued"] = this.isDiscontinued;
        return data;
    }
}

export interface ISiteListViewModel {
    id?: string | undefined;
    storeName?: string | undefined;
    area?: string | undefined;
    district?: string | undefined;
    hub?: string | undefined;
    isDiscontinued: boolean;
}

export class QueryResultsOfStore implements IQueryResultsOfStore {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Store4[] | undefined;

    constructor(data?: IQueryResultsOfStore) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Store4.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfStore {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfStore();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfStore {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Store4[] | undefined;
}

export class TargetInvoice implements ITargetInvoice {
    id!: number;
    invoice!: number;
    credit!: number;
    date!: string;

    constructor(data?: ITargetInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.invoice = _data["invoice"];
            this.credit = _data["credit"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): TargetInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new TargetInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["invoice"] = this.invoice;
        data["credit"] = this.credit;
        data["date"] = this.date;
        return data;
    }
}

export interface ITargetInvoice {
    id: number;
    invoice: number;
    credit: number;
    date: string;
}

export class QueryResultsOfTargetInvoice implements IQueryResultsOfTargetInvoice {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: TargetInvoice[] | undefined;

    constructor(data?: IQueryResultsOfTargetInvoice) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TargetInvoice.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfTargetInvoice {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfTargetInvoice();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfTargetInvoice {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: TargetInvoice[] | undefined;
}

export class TargetReceived implements ITargetReceived {
    id!: number;
    targetTruck?: string | undefined;
    qty!: number;
    date!: string;

    constructor(data?: ITargetReceived) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.targetTruck = _data["targetTruck"];
            this.qty = _data["qty"];
            this.date = _data["date"];
        }
    }

    static fromJS(data: any): TargetReceived {
        data = typeof data === 'object' ? data : {};
        let result = new TargetReceived();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["targetTruck"] = this.targetTruck;
        data["qty"] = this.qty;
        data["date"] = this.date;
        return data;
    }
}

export interface ITargetReceived {
    id: number;
    targetTruck?: string | undefined;
    qty: number;
    date: string;
}

export class QueryResultsOfTargetReceived implements IQueryResultsOfTargetReceived {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: TargetReceived[] | undefined;

    constructor(data?: IQueryResultsOfTargetReceived) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TargetReceived.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfTargetReceived {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfTargetReceived();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfTargetReceived {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: TargetReceived[] | undefined;
}

export class TargetRotation implements ITargetRotation {
    id!: number;
    storeName?: string | undefined;
    rotation?: string | undefined;
    pallets!: number;
    date!: string;
    store?: Store6 | undefined;

    constructor(data?: ITargetRotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.storeName = _data["storeName"];
            this.rotation = _data["rotation"];
            this.pallets = _data["pallets"];
            this.date = _data["date"];
            this.store = _data["store"] ? Store6.fromJS(_data["store"]) : <any>undefined;
        }
    }

    static fromJS(data: any): TargetRotation {
        data = typeof data === 'object' ? data : {};
        let result = new TargetRotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["storeName"] = this.storeName;
        data["rotation"] = this.rotation;
        data["pallets"] = this.pallets;
        data["date"] = this.date;
        data["store"] = this.store ? this.store.toJSON() : <any>undefined;
        return data;
    }
}

export interface ITargetRotation {
    id: number;
    storeName?: string | undefined;
    rotation?: string | undefined;
    pallets: number;
    date: string;
    store?: Store6 | undefined;
}

export class Store6 implements IStore6 {
    id?: string | undefined;
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed!: boolean;
    isGRERunning!: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    status?: string | undefined;
    retailSQFeet?: number | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    milesFromCorporate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;

    constructor(data?: IStore6) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.storeMnemonic = _data["storeMnemonic"];
            this.storeMnemonic2 = _data["storeMnemonic2"];
            this.serverName = _data["serverName"];
            this.gredbName = _data["gredbName"];
            this.isClosed = _data["isClosed"];
            this.isGRERunning = _data["isGRERunning"];
            this.storeLogin = _data["storeLogin"];
            this.district = _data["district"];
            this.status = _data["status"];
            this.retailSQFeet = _data["retailSQFeet"];
            this.glNumber = _data["glNumber"];
            this.glCash = _data["glCash"];
            this.glNumber2 = _data["glNumber2"];
            this.sort = _data["sort"];
            this.locationId = _data["locationId"];
            this.milesFromCorporate = _data["milesFromCorporate"];
            this.address = _data["address"];
            this.city = _data["city"];
            this.state = _data["state"];
            this.zip = _data["zip"];
            this.regionId = _data["regionId"];
            this.email = _data["email"];
            this.dmEmail = _data["dmEmail"];
            this.districtEmail = _data["districtEmail"];
            this.prefix = _data["prefix"];
            this.phone = _data["phone"];
            this.cellPhone = _data["cellPhone"];
            this.aaExtension = _data["aaExtension"];
        }
    }

    static fromJS(data: any): Store6 {
        data = typeof data === 'object' ? data : {};
        let result = new Store6();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["storeMnemonic"] = this.storeMnemonic;
        data["storeMnemonic2"] = this.storeMnemonic2;
        data["serverName"] = this.serverName;
        data["gredbName"] = this.gredbName;
        data["isClosed"] = this.isClosed;
        data["isGRERunning"] = this.isGRERunning;
        data["storeLogin"] = this.storeLogin;
        data["district"] = this.district;
        data["status"] = this.status;
        data["retailSQFeet"] = this.retailSQFeet;
        data["glNumber"] = this.glNumber;
        data["glCash"] = this.glCash;
        data["glNumber2"] = this.glNumber2;
        data["sort"] = this.sort;
        data["locationId"] = this.locationId;
        data["milesFromCorporate"] = this.milesFromCorporate;
        data["address"] = this.address;
        data["city"] = this.city;
        data["state"] = this.state;
        data["zip"] = this.zip;
        data["regionId"] = this.regionId;
        data["email"] = this.email;
        data["dmEmail"] = this.dmEmail;
        data["districtEmail"] = this.districtEmail;
        data["prefix"] = this.prefix;
        data["phone"] = this.phone;
        data["cellPhone"] = this.cellPhone;
        data["aaExtension"] = this.aaExtension;
        return data;
    }
}

export interface IStore6 {
    id?: string | undefined;
    name?: string | undefined;
    storeMnemonic?: string | undefined;
    storeMnemonic2?: string | undefined;
    serverName?: string | undefined;
    gredbName?: string | undefined;
    isClosed: boolean;
    isGRERunning: boolean;
    storeLogin?: string | undefined;
    district?: string | undefined;
    status?: string | undefined;
    retailSQFeet?: number | undefined;
    glNumber?: string | undefined;
    glCash?: string | undefined;
    glNumber2?: string | undefined;
    sort?: number | undefined;
    locationId?: number | undefined;
    milesFromCorporate?: number | undefined;
    address?: string | undefined;
    city?: string | undefined;
    state?: string | undefined;
    zip?: string | undefined;
    regionId?: number | undefined;
    email?: string | undefined;
    dmEmail?: string | undefined;
    districtEmail?: string | undefined;
    prefix?: string | undefined;
    phone?: string | undefined;
    cellPhone?: string | undefined;
    aaExtension?: string | undefined;
}

export class QueryResultsOfTargetRotation implements IQueryResultsOfTargetRotation {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: TargetRotation[] | undefined;

    constructor(data?: IQueryResultsOfTargetRotation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TargetRotation.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfTargetRotation {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfTargetRotation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfTargetRotation {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: TargetRotation[] | undefined;
}

export class TblClassName implements ITblClassName {
    id!: number;
    class?: string | undefined;
    individual!: boolean;
    active!: boolean;
    asrtype?: string | undefined;
    program?: string | undefined;
    classType?: string | undefined;
    serviceHours?: number | undefined;
    programType?: string | undefined;

    constructor(data?: ITblClassName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.class = _data["class"];
            this.individual = _data["individual"];
            this.active = _data["active"];
            this.asrtype = _data["asrtype"];
            this.program = _data["program"];
            this.classType = _data["classType"];
            this.serviceHours = _data["serviceHours"];
            this.programType = _data["programType"];
        }
    }

    static fromJS(data: any): TblClassName {
        data = typeof data === 'object' ? data : {};
        let result = new TblClassName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["class"] = this.class;
        data["individual"] = this.individual;
        data["active"] = this.active;
        data["asrtype"] = this.asrtype;
        data["program"] = this.program;
        data["classType"] = this.classType;
        data["serviceHours"] = this.serviceHours;
        data["programType"] = this.programType;
        return data;
    }
}

export interface ITblClassName {
    id: number;
    class?: string | undefined;
    individual: boolean;
    active: boolean;
    asrtype?: string | undefined;
    program?: string | undefined;
    classType?: string | undefined;
    serviceHours?: number | undefined;
    programType?: string | undefined;
}

export class QueryResultsOfTblClassName implements IQueryResultsOfTblClassName {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: TblClassName[] | undefined;

    constructor(data?: IQueryResultsOfTblClassName) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TblClassName.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfTblClassName {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfTblClassName();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfTblClassName {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: TblClassName[] | undefined;
}

export class QueryResultsOfTeacher implements IQueryResultsOfTeacher {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: Teacher[] | undefined;

    constructor(data?: IQueryResultsOfTeacher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(Teacher.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfTeacher {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfTeacher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfTeacher {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: Teacher[] | undefined;
}

export class Teacher implements ITeacher {
    id!: number;
    teacherName?: string | undefined;
    type?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: ITeacher) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teacherName = _data["teacherName"];
            this.type = _data["type"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): Teacher {
        data = typeof data === 'object' ? data : {};
        let result = new Teacher();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teacherName"] = this.teacherName;
        data["type"] = this.type;
        data["active"] = this.active;
        return data;
    }
}

export interface ITeacher {
    id: number;
    teacherName?: string | undefined;
    type?: string | undefined;
    active?: boolean | undefined;
}

export class QueryResultsOfTraineeNameViewModel implements IQueryResultsOfTraineeNameViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: TraineeNameViewModel[] | undefined;

    constructor(data?: IQueryResultsOfTraineeNameViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TraineeNameViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfTraineeNameViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfTraineeNameViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfTraineeNameViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: TraineeNameViewModel[] | undefined;
}

export class TraineeNameViewModel implements ITraineeNameViewModel {
    id!: number;
    communityID?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: ITraineeNameViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.communityID = _data["communityID"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): TraineeNameViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TraineeNameViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["communityID"] = this.communityID;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface ITraineeNameViewModel {
    id: number;
    communityID?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class QueryResultsOfTrainingSummaryViewModel implements IQueryResultsOfTrainingSummaryViewModel {
    resultCount!: number;
    pageNumber!: number;
    pageSize!: number;
    rows?: TrainingSummaryViewModel[] | undefined;

    constructor(data?: IQueryResultsOfTrainingSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.resultCount = _data["resultCount"];
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(TrainingSummaryViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): QueryResultsOfTrainingSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new QueryResultsOfTrainingSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["resultCount"] = this.resultCount;
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IQueryResultsOfTrainingSummaryViewModel {
    resultCount: number;
    pageNumber: number;
    pageSize: number;
    rows?: TrainingSummaryViewModel[] | undefined;
}

export class TrainingSummaryViewModel implements ITrainingSummaryViewModel {
    id!: number;
    teacherId!: number;
    classId!: number;
    classDate!: string;
    locationId!: number;
    creditHrs?: number | undefined;
    cost?: number | undefined;
    entryDate!: string;
    serviceHours!: number;
    classWorkshopId?: number | undefined;
    teacher?: TeacherViewModel | undefined;
    location?: Location | undefined;
    class?: TblClassName | undefined;
    tblTrainingDetails?: TrainingDetailViewModel[] | undefined;

    constructor(data?: ITrainingSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teacherId = _data["teacherId"];
            this.classId = _data["classId"];
            this.classDate = _data["classDate"];
            this.locationId = _data["locationId"];
            this.creditHrs = _data["creditHrs"];
            this.cost = _data["cost"];
            this.entryDate = _data["entryDate"];
            this.serviceHours = _data["serviceHours"];
            this.classWorkshopId = _data["classWorkshopId"];
            this.teacher = _data["teacher"] ? TeacherViewModel.fromJS(_data["teacher"]) : <any>undefined;
            this.location = _data["location"] ? Location.fromJS(_data["location"]) : <any>undefined;
            this.class = _data["class"] ? TblClassName.fromJS(_data["class"]) : <any>undefined;
            if (Array.isArray(_data["tblTrainingDetails"])) {
                this.tblTrainingDetails = [] as any;
                for (let item of _data["tblTrainingDetails"])
                    this.tblTrainingDetails!.push(TrainingDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainingSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teacherId"] = this.teacherId;
        data["classId"] = this.classId;
        data["classDate"] = this.classDate;
        data["locationId"] = this.locationId;
        data["creditHrs"] = this.creditHrs;
        data["cost"] = this.cost;
        data["entryDate"] = this.entryDate;
        data["serviceHours"] = this.serviceHours;
        data["classWorkshopId"] = this.classWorkshopId;
        data["teacher"] = this.teacher ? this.teacher.toJSON() : <any>undefined;
        data["location"] = this.location ? this.location.toJSON() : <any>undefined;
        data["class"] = this.class ? this.class.toJSON() : <any>undefined;
        if (Array.isArray(this.tblTrainingDetails)) {
            data["tblTrainingDetails"] = [];
            for (let item of this.tblTrainingDetails)
                data["tblTrainingDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrainingSummaryViewModel {
    id: number;
    teacherId: number;
    classId: number;
    classDate: string;
    locationId: number;
    creditHrs?: number | undefined;
    cost?: number | undefined;
    entryDate: string;
    serviceHours: number;
    classWorkshopId?: number | undefined;
    teacher?: TeacherViewModel | undefined;
    location?: Location | undefined;
    class?: TblClassName | undefined;
    tblTrainingDetails?: TrainingDetailViewModel[] | undefined;
}

export class TeacherViewModel implements ITeacherViewModel {
    id!: number;
    teacherName?: string | undefined;
    type?: string | undefined;
    active?: boolean | undefined;

    constructor(data?: ITeacherViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teacherName = _data["teacherName"];
            this.type = _data["type"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): TeacherViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TeacherViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teacherName"] = this.teacherName;
        data["type"] = this.type;
        data["active"] = this.active;
        return data;
    }
}

export interface ITeacherViewModel {
    id: number;
    teacherName?: string | undefined;
    type?: string | undefined;
    active?: boolean | undefined;
}

export class TrainingDetailViewModel implements ITrainingDetailViewModel {
    id!: number;
    traineeId?: string | undefined;
    trainingSummaryId!: number;
    firstName?: string | undefined;
    lastName?: string | undefined;

    constructor(data?: ITrainingDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.traineeId = _data["traineeId"];
            this.trainingSummaryId = _data["trainingSummaryId"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
        }
    }

    static fromJS(data: any): TrainingDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["traineeId"] = this.traineeId;
        data["trainingSummaryId"] = this.trainingSummaryId;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        return data;
    }
}

export interface ITrainingDetailViewModel {
    id: number;
    traineeId?: string | undefined;
    trainingSummaryId: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export class TrainingSummarySavingModel implements ITrainingSummarySavingModel {
    id!: number;
    teacherId!: number;
    classId!: number;
    classDate!: string;
    locationId!: number;
    creditHrs?: number | undefined;
    cost?: number | undefined;
    entryDate!: string;
    serviceHours!: number;
    classWorkshopId?: number | undefined;
    teacher?: TeacherViewModel | undefined;
    tblTrainingDetails?: TrainingDetailViewModel[] | undefined;

    constructor(data?: ITrainingSummarySavingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.teacherId = _data["teacherId"];
            this.classId = _data["classId"];
            this.classDate = _data["classDate"];
            this.locationId = _data["locationId"];
            this.creditHrs = _data["creditHrs"];
            this.cost = _data["cost"];
            this.entryDate = _data["entryDate"];
            this.serviceHours = _data["serviceHours"];
            this.classWorkshopId = _data["classWorkshopId"];
            this.teacher = _data["teacher"] ? TeacherViewModel.fromJS(_data["teacher"]) : <any>undefined;
            if (Array.isArray(_data["tblTrainingDetails"])) {
                this.tblTrainingDetails = [] as any;
                for (let item of _data["tblTrainingDetails"])
                    this.tblTrainingDetails!.push(TrainingDetailViewModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): TrainingSummarySavingModel {
        data = typeof data === 'object' ? data : {};
        let result = new TrainingSummarySavingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["teacherId"] = this.teacherId;
        data["classId"] = this.classId;
        data["classDate"] = this.classDate;
        data["locationId"] = this.locationId;
        data["creditHrs"] = this.creditHrs;
        data["cost"] = this.cost;
        data["entryDate"] = this.entryDate;
        data["serviceHours"] = this.serviceHours;
        data["classWorkshopId"] = this.classWorkshopId;
        data["teacher"] = this.teacher ? this.teacher.toJSON() : <any>undefined;
        if (Array.isArray(this.tblTrainingDetails)) {
            data["tblTrainingDetails"] = [];
            for (let item of this.tblTrainingDetails)
                data["tblTrainingDetails"].push(item.toJSON());
        }
        return data;
    }
}

export interface ITrainingSummarySavingModel {
    id: number;
    teacherId: number;
    classId: number;
    classDate: string;
    locationId: number;
    creditHrs?: number | undefined;
    cost?: number | undefined;
    entryDate: string;
    serviceHours: number;
    classWorkshopId?: number | undefined;
    teacher?: TeacherViewModel | undefined;
    tblTrainingDetails?: TrainingDetailViewModel[] | undefined;
}

export class TransferRequestSavingModel implements ITransferRequestSavingModel {
    transferRequestId!: number;
    employeeNumber?: string | undefined;
    requestDate!: string;
    costCenterCurrent?: string | undefined;
    locationCurrent?: string | undefined;
    reasonForChange?: string | undefined;
    costCenterOne?: string | undefined;
    costCenterTwo?: string | undefined;
    jobTitleCurrent?: string | undefined;
    jobTitleOne?: string | undefined;
    jobTitleTwo?: string | undefined;
    reasonQualified?: string | undefined;
    entryDate!: string;
    enteredBy?: string | undefined;

    constructor(data?: ITransferRequestSavingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transferRequestId = _data["transferRequestId"];
            this.employeeNumber = _data["employeeNumber"];
            this.requestDate = _data["requestDate"];
            this.costCenterCurrent = _data["costCenterCurrent"];
            this.locationCurrent = _data["locationCurrent"];
            this.reasonForChange = _data["reasonForChange"];
            this.costCenterOne = _data["costCenterOne"];
            this.costCenterTwo = _data["costCenterTwo"];
            this.jobTitleCurrent = _data["jobTitleCurrent"];
            this.jobTitleOne = _data["jobTitleOne"];
            this.jobTitleTwo = _data["jobTitleTwo"];
            this.reasonQualified = _data["reasonQualified"];
            this.entryDate = _data["entryDate"];
            this.enteredBy = _data["enteredBy"];
        }
    }

    static fromJS(data: any): TransferRequestSavingModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransferRequestSavingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transferRequestId"] = this.transferRequestId;
        data["employeeNumber"] = this.employeeNumber;
        data["requestDate"] = this.requestDate;
        data["costCenterCurrent"] = this.costCenterCurrent;
        data["locationCurrent"] = this.locationCurrent;
        data["reasonForChange"] = this.reasonForChange;
        data["costCenterOne"] = this.costCenterOne;
        data["costCenterTwo"] = this.costCenterTwo;
        data["jobTitleCurrent"] = this.jobTitleCurrent;
        data["jobTitleOne"] = this.jobTitleOne;
        data["jobTitleTwo"] = this.jobTitleTwo;
        data["reasonQualified"] = this.reasonQualified;
        data["entryDate"] = this.entryDate;
        data["enteredBy"] = this.enteredBy;
        return data;
    }
}

export interface ITransferRequestSavingModel {
    transferRequestId: number;
    employeeNumber?: string | undefined;
    requestDate: string;
    costCenterCurrent?: string | undefined;
    locationCurrent?: string | undefined;
    reasonForChange?: string | undefined;
    costCenterOne?: string | undefined;
    costCenterTwo?: string | undefined;
    jobTitleCurrent?: string | undefined;
    jobTitleOne?: string | undefined;
    jobTitleTwo?: string | undefined;
    reasonQualified?: string | undefined;
    entryDate: string;
    enteredBy?: string | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}